import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  GoogleRecaptchaResponse: { input: any; output: any; }
  OpeningSearchTagValueType: { input: any; output: any; }
  SearchTagValue: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type ActivityFeedTalentRecruiterStateType = {
  __typename?: 'ActivityFeedTalentRecruiterStateType';
  hasMessaged: Scalars['Boolean']['output'];
  hasSeen: Scalars['Boolean']['output'];
};

export type ActivityFeedTalentType = {
  __typename?: 'ActivityFeedTalentType';
  messageThread?: Maybe<MessageThreadType>;
  recruiterState: ActivityFeedTalentRecruiterStateType;
  user: UserType;
  userVerification?: Maybe<UserVerificationType>;
};

export type ApplicantInterface = {
  hasMessaged: Scalars['Boolean']['output'];
  recruiterState: ApplicantRecruiterStateEnum;
  user: UserType;
  userState: ApplicantUserStateEnum;
};

export enum ApplicantRecruiterStateEnum {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum ApplicantUserStateEnum {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type ApplicantsPaginationOptionsInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  maxCursor?: InputMaybe<Scalars['String']['input']>;
  minCursor?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ApplicantsSortOptionEnum>;
  sortOrder?: InputMaybe<PaginationSortOrderEnum>;
};

export enum ApplicantsSortOptionEnum {
  LATEST_MESSAGE = 'LATEST_MESSAGE',
  LOCATION = 'LOCATION',
  NAME = 'NAME',
  SALARY = 'SALARY',
  SENIORITIES = 'SENIORITIES',
  USER_APPLIED_AT = 'USER_APPLIED_AT'
}

export type ApplicationNotificationType = NotificationInterface & {
  __typename?: 'ApplicationNotificationType';
  application?: Maybe<ApplicationType>;
  icons: NotificationIconType;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt: Scalars['DateTime']['output'];
  type: NotificationTypeEnum;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ApplicationSourceEnum {
  OPENING = 'OPENING',
  USER_VERIFICATION = 'USER_VERIFICATION'
}

export type ApplicationType = {
  __typename?: 'ApplicationType';
  availabilityRequest?: Maybe<AvailabilityRequestType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  messageThread?: Maybe<MessageThreadType>;
  opening?: Maybe<OpeningType>;
  recruiterState?: Maybe<RecruiterApplicationStateType>;
  user: UserType;
  userMatchingProfile: UserMatchingProfileType;
  userState?: Maybe<UserApplicationStateType>;
};

export type AreaType = PlaceEntityInterface & {
  __typename?: 'AreaType';
  countries: Array<CountryType>;
  id: Scalars['ID']['output'];
  longName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AvailabilityRequestType = {
  __typename?: 'AvailabilityRequestType';
  application?: Maybe<ApplicationType>;
  id: Scalars['ID']['output'];
  user: UserType;
  userMatchingProfile: UserMatchingProfileType;
};

export type AvailableCompanyType = {
  __typename?: 'AvailableCompanyType';
  company: CompanyType;
  isCurrent: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
};

export type AwardCountType = {
  __typename?: 'AwardCountType';
  award: AwardType;
  count: Scalars['Int']['output'];
};

export type AwardType = {
  __typename?: 'AwardType';
  id: Scalars['ID']['output'];
  logo: ImageType;
  name: Scalars['String']['output'];
};

export type BookmarkInterface = {
  id: Scalars['ID']['output'];
  type: BookmarkTypeEnum;
};

export type BookmarkOpeningType = BookmarkInterface & {
  __typename?: 'BookmarkOpeningType';
  id: Scalars['ID']['output'];
  opening: OpeningType;
  type: BookmarkTypeEnum;
};

export enum BookmarkTypeEnum {
  OPENING = 'OPENING',
  USER = 'USER'
}

export type BookmarkUserType = BookmarkInterface & {
  __typename?: 'BookmarkUserType';
  id: Scalars['ID']['output'];
  type: BookmarkTypeEnum;
  user: UserType;
};

export type BraintreePaymentMethodType = {
  __typename?: 'BraintreePaymentMethodType';
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  masked: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BulkCreateVerifiedUserApplicantsInput = {
  input: CreateVerifiedUserApplicantInput;
  openingId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type CombinedSearchPatternInput = {
  pattern: Scalars['String']['input'];
  tag: CombinedSearchTagNameEnum;
};

export type CombinedSearchTagInput = {
  tag: CombinedSearchTagNameEnum;
  value: Scalars['SearchTagValue']['input'];
};

export enum CombinedSearchTagNameEnum {
  COMPANY_BENEFIT = 'COMPANY_BENEFIT',
  COMPANY_BENEFITS_COUNT = 'COMPANY_BENEFITS_COUNT',
  COMPANY_COUNTRY = 'COMPANY_COUNTRY',
  COMPANY_FEATURED = 'COMPANY_FEATURED',
  COMPANY_FOUNDED = 'COMPANY_FOUNDED',
  COMPANY_FUNDING = 'COMPANY_FUNDING',
  COMPANY_HAS_PUBLISHED_PROFILE = 'COMPANY_HAS_PUBLISHED_PROFILE',
  COMPANY_HAS_SCRAPER_CONFIGURATIONS = 'COMPANY_HAS_SCRAPER_CONFIGURATIONS',
  COMPANY_ID = 'COMPANY_ID',
  COMPANY_INDUSTRY = 'COMPANY_INDUSTRY',
  COMPANY_IS_DELETED = 'COMPANY_IS_DELETED',
  COMPANY_MARKET_AREA = 'COMPANY_MARKET_AREA',
  COMPANY_MARKET_AREAS_COUNT = 'COMPANY_MARKET_AREAS_COUNT',
  COMPANY_MARKET_COUNTRY = 'COMPANY_MARKET_COUNTRY',
  COMPANY_NAME = 'COMPANY_NAME',
  COMPANY_OFFICE_COUNTRY = 'COMPANY_OFFICE_COUNTRY',
  COMPANY_OFFICE_LOCATION = 'COMPANY_OFFICE_LOCATION',
  COMPANY_OFFICE_LOCATIONS_COUNT = 'COMPANY_OFFICE_LOCATIONS_COUNT',
  COMPANY_REVENUE = 'COMPANY_REVENUE',
  COMPANY_SCRAPER_CONFIGURATION_TYPE = 'COMPANY_SCRAPER_CONFIGURATION_TYPE',
  COMPANY_SIZE = 'COMPANY_SIZE',
  COMPANY_TYPE = 'COMPANY_TYPE',
  OPENING_CANDIDATE_DESTINATION_TYPE = 'OPENING_CANDIDATE_DESTINATION_TYPE',
  OPENING_COMPANY = 'OPENING_COMPANY',
  OPENING_COMPANY_INDUSTRY = 'OPENING_COMPANY_INDUSTRY',
  OPENING_COMPANY_MARKET_AREA = 'OPENING_COMPANY_MARKET_AREA',
  OPENING_COMPANY_MARKET_AREAS_COUNT = 'OPENING_COMPANY_MARKET_AREAS_COUNT',
  OPENING_COMPANY_MARKET_COUNTRY = 'OPENING_COMPANY_MARKET_COUNTRY',
  OPENING_COMPANY_NAME = 'OPENING_COMPANY_NAME',
  OPENING_COMPANY_OFFICE_COUNTRY = 'OPENING_COMPANY_OFFICE_COUNTRY',
  OPENING_COMPANY_OFFICE_LOCATION = 'OPENING_COMPANY_OFFICE_LOCATION',
  OPENING_COMPANY_SIZE = 'OPENING_COMPANY_SIZE',
  OPENING_COMPANY_TYPE = 'OPENING_COMPANY_TYPE',
  OPENING_EMPLOYMENT_TYPE = 'OPENING_EMPLOYMENT_TYPE',
  OPENING_MAX_SALARY = 'OPENING_MAX_SALARY',
  OPENING_MIN_SALARY = 'OPENING_MIN_SALARY',
  OPENING_PAID_ADDON_TYPE = 'OPENING_PAID_ADDON_TYPE',
  OPENING_POSITION_COUNTRY = 'OPENING_POSITION_COUNTRY',
  OPENING_POSITION_LOCATION = 'OPENING_POSITION_LOCATION',
  OPENING_PUBLISHED_AT = 'OPENING_PUBLISHED_AT',
  OPENING_RECRUITER = 'OPENING_RECRUITER',
  OPENING_RELOCATION = 'OPENING_RELOCATION',
  OPENING_REMOTE = 'OPENING_REMOTE',
  OPENING_SALARY_CURRENCY = 'OPENING_SALARY_CURRENCY',
  OPENING_SALARY_PERIOD = 'OPENING_SALARY_PERIOD',
  OPENING_SENIORITY = 'OPENING_SENIORITY',
  OPENING_SKILL = 'OPENING_SKILL',
  OPENING_SOURCE_TYPE = 'OPENING_SOURCE_TYPE',
  OPENING_SPECIALITY = 'OPENING_SPECIALITY',
  OPENING_STATE = 'OPENING_STATE',
  OPENING_TARGET_COUNTRY = 'OPENING_TARGET_COUNTRY',
  OPENING_TARGET_LOCATION = 'OPENING_TARGET_LOCATION',
  OPENING_TITLE = 'OPENING_TITLE',
  OPENING_VISIBILITY = 'OPENING_VISIBILITY',
  TYPE = 'TYPE',
  USER_COUNTRY = 'USER_COUNTRY',
  USER_HAS_VERIFICATION_CHATS = 'USER_HAS_VERIFICATION_CHATS',
  USER_LOCATION = 'USER_LOCATION',
  USER_MATCHING_PROFILE_COUNTRY = 'USER_MATCHING_PROFILE_COUNTRY',
  USER_MATCHING_PROFILE_LOCATION = 'USER_MATCHING_PROFILE_LOCATION',
  USER_MATCHING_PROFILE_PROFILE_TYPE = 'USER_MATCHING_PROFILE_PROFILE_TYPE',
  USER_MATCHING_PROFILE_REQUEST_CREATED_AT = 'USER_MATCHING_PROFILE_REQUEST_CREATED_AT',
  USER_MATCHING_PROFILE_SALARY_CURRENCY = 'USER_MATCHING_PROFILE_SALARY_CURRENCY',
  USER_MATCHING_PROFILE_SALARY_MONTHLY_EUR = 'USER_MATCHING_PROFILE_SALARY_MONTHLY_EUR',
  USER_MATCHING_PROFILE_SALARY_PERIOD = 'USER_MATCHING_PROFILE_SALARY_PERIOD',
  USER_MATCHING_PROFILE_SALARY_VALUE = 'USER_MATCHING_PROFILE_SALARY_VALUE',
  USER_MATCHING_PROFILE_SENIORITY = 'USER_MATCHING_PROFILE_SENIORITY',
  USER_MATCHING_PROFILE_SKILL = 'USER_MATCHING_PROFILE_SKILL',
  USER_MATCHING_PROFILE_SPECIALITY = 'USER_MATCHING_PROFILE_SPECIALITY',
  USER_MATCHING_PROFILE_STATE = 'USER_MATCHING_PROFILE_STATE',
  USER_NAME = 'USER_NAME',
  USER_ONBOARDED = 'USER_ONBOARDED',
  USER_PUSH_ENABLED = 'USER_PUSH_ENABLED',
  USER_RELOCATION = 'USER_RELOCATION',
  USER_REMOTE = 'USER_REMOTE',
  USER_SALARY_CURRENCY = 'USER_SALARY_CURRENCY',
  USER_SALARY_MONTHLY_EUR = 'USER_SALARY_MONTHLY_EUR',
  USER_SALARY_PERIOD = 'USER_SALARY_PERIOD',
  USER_SALARY_VALUE = 'USER_SALARY_VALUE',
  USER_SENIORITY = 'USER_SENIORITY',
  USER_SKILL = 'USER_SKILL',
  USER_SPECIALITY = 'USER_SPECIALITY',
  USER_STATE = 'USER_STATE',
  USER_VERIFICATION_BLACKLISTED_COMPANY = 'USER_VERIFICATION_BLACKLISTED_COMPANY',
  USER_VERIFICATION_STATE = 'USER_VERIFICATION_STATE'
}

export type CompanyBenefitType = OpeningCategoryEntityInterface & {
  __typename?: 'CompanyBenefitType';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CompanyClientType = {
  __typename?: 'CompanyClientType';
  id: Scalars['ID']['output'];
  logo: ImageType;
  name?: Maybe<Scalars['String']['output']>;
};

export enum CompanyFeatureFlagTypeEnum {
  SOURCING_PAGE = 'SOURCING_PAGE'
}

export type CompanyFundingType = {
  __typename?: 'CompanyFundingType';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

export enum CompanyProfileFundingRoundTypeEnum {
  ACQUISITION = 'ACQUISITION',
  ANGEL = 'ANGEL',
  BUYOUT = 'BUYOUT',
  CONVERTIBLE = 'CONVERTIBLE',
  CORPORATE_SPINOUT = 'CORPORATE_SPINOUT',
  DEBT = 'DEBT',
  EARLY_VC = 'EARLY_VC',
  GRANT = 'GRANT',
  GROWTH_EQUITY_NON_VC = 'GROWTH_EQUITY_NON_VC',
  GROWTH_EQUITY_VC = 'GROWTH_EQUITY_VC',
  ICO = 'ICO',
  IPO = 'IPO',
  LATE_VC = 'LATE_VC',
  LENDING_CAPITAL = 'LENDING_CAPITAL',
  MEDIA_FOR_EQUITY = 'MEDIA_FOR_EQUITY',
  MERGER = 'MERGER',
  POST_IPO_CONVERTIBLE = 'POST_IPO_CONVERTIBLE',
  POST_IPO_DEBT = 'POST_IPO_DEBT',
  POST_IPO_EQUITY = 'POST_IPO_EQUITY',
  POST_IPO_SECONDARY = 'POST_IPO_SECONDARY',
  PRIVATE_PLACEMENT_NON_VC = 'PRIVATE_PLACEMENT_NON_VC',
  PRIVATE_PLACEMENT_VC = 'PRIVATE_PLACEMENT_VC',
  PROJECT_AND_REAL_ESTATE_AND_INFRASTRUCTURE_FINANCE = 'PROJECT_AND_REAL_ESTATE_AND_INFRASTRUCTURE_FINANCE',
  SECONDARY = 'SECONDARY',
  SEED = 'SEED',
  SERIES_A = 'SERIES_A',
  SERIES_B = 'SERIES_B',
  SERIES_C = 'SERIES_C',
  SERIES_D = 'SERIES_D',
  SERIES_E = 'SERIES_E',
  SERIES_F = 'SERIES_F',
  SERIES_G = 'SERIES_G',
  SERIES_H = 'SERIES_H',
  SERIES_I = 'SERIES_I',
  SPAC_IPO = 'SPAC_IPO',
  SPAC_PRIVATE_PLACEMENT = 'SPAC_PRIVATE_PLACEMENT',
  SPINOUT = 'SPINOUT',
  SUPPORT_PROGRAM = 'SUPPORT_PROGRAM'
}

export type CompanyProfileFundingType = {
  __typename?: 'CompanyProfileFundingType';
  currency: CurrencyType;
  fundedAt: Scalars['DateTime']['output'];
  round: CompanyProfileFundingRoundTypeEnum;
  value: Scalars['BigInt']['output'];
};

export type CompanyProfileOfficeType = {
  __typename?: 'CompanyProfileOfficeType';
  isFoundingLocation: Scalars['Boolean']['output'];
  isHeadquarter: Scalars['Boolean']['output'];
  location: LocationType;
};

export enum CompanyProfileStateEnum {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type CompanyProfileType = {
  __typename?: 'CompanyProfileType';
  benefits: Array<CompanyBenefitType>;
  clients: Array<CompanyClientType>;
  clientsDescription?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<CompanySizeType>;
  completeness: Scalars['Float']['output'];
  employeesCount?: Maybe<Scalars['Int']['output']>;
  founded?: Maybe<Scalars['Float']['output']>;
  funding?: Maybe<CompanyFundingType>;
  headerImage?: Maybe<ImageType>;
  id: Scalars['ID']['output'];
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  isPublished: Scalars['Boolean']['output'];
  latestFunding?: Maybe<CompanyProfileFundingType>;
  latestValuation?: Maybe<CompanyProfileValuationType>;
  /** @deprecated Use offices instead */
  locations: Array<LocationType>;
  logo?: Maybe<ImageType>;
  marketAreas: Array<AreaType>;
  marketCountries: Array<CountryType>;
  marketsDescription?: Maybe<Scalars['String']['output']>;
  media: Array<LinkType>;
  missionStatement?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  officeDescription?: Maybe<Scalars['String']['output']>;
  officeImages: Array<ImageType>;
  officeVideo?: Maybe<VideoType>;
  offices: Array<CompanyProfileOfficeType>;
  productImages: Array<ImageType>;
  revenue?: Maybe<CompanyRevenueType>;
  serviceDescription?: Maybe<Scalars['String']['output']>;
  socialMedia: Array<SocialMediaType>;
  state: CompanyProfileStateEnum;
  totalFunding?: Maybe<Scalars['BigInt']['output']>;
  video?: Maybe<VideoType>;
};

export type CompanyProfileValuationType = {
  __typename?: 'CompanyProfileValuationType';
  currency: CurrencyType;
  max: Scalars['BigInt']['output'];
  min?: Maybe<Scalars['BigInt']['output']>;
  round: CompanyProfileFundingRoundTypeEnum;
  valuedAt: Scalars['DateTime']['output'];
};

export type CompanyRatingReviewRatingsType = {
  __typename?: 'CompanyRatingReviewRatingsType';
  companyCulture: Scalars['Int']['output'];
  compensationBenefits: Scalars['Int']['output'];
  management: Scalars['Int']['output'];
  product: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  workLifeBalance: Scalars['Int']['output'];
};

export type CompanyRatingReviewType = ReviewInterface & {
  __typename?: 'CompanyRatingReviewType';
  actor: ReviewActorType;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  negativeFeedback?: Maybe<Scalars['String']['output']>;
  positiveFeedback?: Maybe<Scalars['String']['output']>;
  ratings: CompanyRatingReviewRatingsType;
  reply?: Maybe<ReviewReplyType>;
  title?: Maybe<Scalars['String']['output']>;
  type: ReviewTypeEnum;
  userAssociation?: Maybe<UserCompanyAssociationTypeEnum>;
};

export type CompanyRatingsType = {
  __typename?: 'CompanyRatingsType';
  companyCulture: Scalars['Float']['output'];
  compensationBenefits: Scalars['Float']['output'];
  management: Scalars['Float']['output'];
  product: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  workLifeBalance: Scalars['Float']['output'];
};

export type CompanyRevenueType = {
  __typename?: 'CompanyRevenueType';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

export type CompanyReviewType = ReviewInterface & {
  __typename?: 'CompanyReviewType';
  actor: ReviewActorType;
  awards: PaginatedAwardsType;
  comment?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reply?: Maybe<ReviewReplyType>;
  type: ReviewTypeEnum;
  userAssociation: Array<UserCompanyAssociationTypeEnum>;
};


export type CompanyReviewTypeAwardsArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};

export type CompanySearchPatternInput = {
  pattern: Scalars['String']['input'];
  tag: CompanySearchTagNameEnum;
};

export enum CompanySearchTagNameEnum {
  COMPANY_TYPE = 'COMPANY_TYPE',
  HAS_PUBLISHED_PROFILE = 'HAS_PUBLISHED_PROFILE',
  HAS_SCRAPER_CONFIGURATIONS = 'HAS_SCRAPER_CONFIGURATIONS',
  ID = 'ID',
  INDUSTRY = 'INDUSTRY',
  IS_DELETED = 'IS_DELETED',
  MARKET_AREA = 'MARKET_AREA',
  MARKET_COUNTRY = 'MARKET_COUNTRY',
  NAME = 'NAME',
  OFFICE_COUNTRY = 'OFFICE_COUNTRY',
  OFFICE_LOCATION = 'OFFICE_LOCATION',
  REVENUE = 'REVENUE',
  SCRAPER_CONFIGURATION_TYPE = 'SCRAPER_CONFIGURATION_TYPE',
  SIZE = 'SIZE',
  TYPE = 'TYPE'
}

export type CompanySearchTagType = {
  tag: CompanySearchTagNameEnum;
  value: Scalars['SearchTagValue']['input'];
};

export type CompanySizeType = {
  __typename?: 'CompanySizeType';
  id: Scalars['ID']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type CompanyType = OpeningCategoryEntityInterface & {
  __typename?: 'CompanyType';
  callBookingUrl: Scalars['String']['output'];
  companyTypes: Array<CompanyType>;
  country?: Maybe<CountryType>;
  deepLinkUrl?: Maybe<Scalars['String']['output']>;
  featureFlags: Array<CompanyFeatureFlagTypeEnum>;
  hasPublishedProfile: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  industries: Array<IndustryType>;
  invoicingDetails?: Maybe<InvoicingDetailsType>;
  isAuthCodeRequired: Scalars['Boolean']['output'];
  /** @deprecated All salaries are publicly visible now */
  isSalaryPubliclyVisible: Scalars['Boolean']['output'];
  lastSeen: Scalars['DateTime']['output'];
  latestProfile?: Maybe<CompanyProfileType>;
  name: Scalars['String']['output'];
  operationsEmail: Scalars['String']['output'];
  profile: CompanyProfileType;
  ratings: CompanyRatingsType;
  responseRate: Scalars['Float']['output'];
  reviews: PaginatedReviewsType;
  teamMembers: Array<RecruiterType>;
};


export type CompanyTypeLatestProfileArgs = {
  state?: InputMaybe<CompanyProfileStateEnum>;
};


export type CompanyTypeProfileArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTypeReviewsArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};

export type CompanyTypeType = OpeningCategoryEntityInterface & {
  __typename?: 'CompanyTypeType';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountryType = OpeningCategoryEntityInterface & PlaceEntityInterface & {
  __typename?: 'CountryType';
  VAT?: Maybe<Scalars['Float']['output']>;
  continent: AreaType;
  /** @deprecated Use the fullCurrency field */
  currency: Scalars['String']['output'];
  dialCode: Scalars['String']['output'];
  fullCurrency: CurrencyType;
  id: Scalars['ID']['output'];
  longName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type CreateMessageTemplateInput = {
  message: Scalars['String']['input'];
};

export type CreatePaymentMethodInput = {
  deviceData?: InputMaybe<Scalars['String']['input']>;
  paymentMethodNonce: Scalars['String']['input'];
};

export enum CreatePaymentMethodStatusEnum {
  ERROR = 'ERROR',
  PRESSED_SUBMIT = 'PRESSED_SUBMIT'
}

export type CreateVerifiedUserApplicantInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  recruiterState: ApplicantRecruiterStateEnum;
};

export type CurrencyType = {
  __typename?: 'CurrencyType';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  symbol: Scalars['String']['output'];
};

export enum CustomerCalculatedSubscriptionStateEnum {
  SUBSCRIPTION_ACTIVE = 'SUBSCRIPTION_ACTIVE',
  SUBSCRIPTION_INACTIVE = 'SUBSCRIPTION_INACTIVE',
  TRIAL_ACTIVE = 'TRIAL_ACTIVE',
  TRIAL_ENDED = 'TRIAL_ENDED'
}

export enum CustomerPlanEnum {
  CANDIDATE_PLAN_190407 = 'CANDIDATE_PLAN_190407',
  ENTERPRISE = 'ENTERPRISE',
  FREEMIUM = 'FREEMIUM',
  SUBSCRIPTION_BASIC = 'SUBSCRIPTION_BASIC',
  SUBSCRIPTION_HIGH_BASE = 'SUBSCRIPTION_HIGH_BASE',
  SUBSCRIPTION_LIMITED_HIGH_BASE = 'SUBSCRIPTION_LIMITED_HIGH_BASE',
  SUBSCRIPTION_LIMITED_LOW_BASE = 'SUBSCRIPTION_LIMITED_LOW_BASE',
  SUBSCRIPTION_LOW_BASE = 'SUBSCRIPTION_LOW_BASE',
  SUBSCRIPTION_STARTER = 'SUBSCRIPTION_STARTER',
  SUBSCRIPTION_UNLIMITED = 'SUBSCRIPTION_UNLIMITED'
}

export enum CustomerSubscriptionCycleEnum {
  HALF_YEARLY = 'HALF_YEARLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY'
}

export type CustomerSubscriptionPlanInfoType = {
  __typename?: 'CustomerSubscriptionPlanInfoType';
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  openingSlots?: Maybe<Scalars['Int']['output']>;
  planType: CustomerPlanEnum;
  variants: Array<CustomerSubscriptionPlanVariantType>;
};

export type CustomerSubscriptionPlanVariantType = {
  __typename?: 'CustomerSubscriptionPlanVariantType';
  currency: Scalars['String']['output'];
  cycle?: Maybe<CustomerSubscriptionCycleEnum>;
  discountedMonthlyPrice: Scalars['Float']['output'];
  discountedSlotPrice?: Maybe<Scalars['Float']['output']>;
  freeMonths: Scalars['Int']['output'];
  openingActivationPrice?: Maybe<Scalars['Float']['output']>;
  openingRepublishingPrice?: Maybe<Scalars['Float']['output']>;
  openingSlots?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  savings: Scalars['Float']['output'];
  slotPrice?: Maybe<Scalars['Float']['output']>;
};

export enum CustomerSubscriptionStateEnum {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  INACTIVE = 'INACTIVE',
  TRIAL = 'TRIAL'
}

export type CustomerType = {
  __typename?: 'CustomerType';
  hasActivePaymentMethod: Scalars['Boolean']['output'];
  hidePaymentDetails?: Maybe<Scalars['Boolean']['output']>;
  hidePricingDetails?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isPayByInvoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentMethods?: Maybe<Array<BraintreePaymentMethodType>>;
  paysByInvoice?: Maybe<Scalars['Boolean']['output']>;
  planInfo?: Maybe<PlanTypeInterface>;
  planType?: Maybe<CustomerPlanEnum>;
};

export type DateRangeInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmbeddedOpeningPaidAddonType = {
  __typename?: 'EmbeddedOpeningPaidAddonType';
  priceInEur: Scalars['Float']['output'];
  type: OpeningPaidAddonEnum;
};

export type EnterprisePlanType = PlanTypeInterface & {
  __typename?: 'EnterprisePlanType';
  currency?: Maybe<CurrencyType>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type ExternalUrlOpeningCandidateDestinationType = OpeningCandidateDestinationInterface & {
  __typename?: 'ExternalUrlOpeningCandidateDestinationType';
  type: OpeningCandidateDestinationTypeEnum;
  url: Scalars['String']['output'];
};

export enum FilterApplicantsByGeographicalLimitEnum {
  COUNTRY = 'COUNTRY',
  LOCATION = 'LOCATION',
  OPENING_COUNTRY = 'OPENING_COUNTRY',
  OPENING_NEARBY_LOCATIONS = 'OPENING_NEARBY_LOCATIONS'
}

export type FilterOpeningApplicantsInput = {
  hasUnreadMessages?: InputMaybe<Scalars['Boolean']['input']>;
  recruiterMessageThreadStates?: InputMaybe<Array<MessageThreadStateEnum>>;
  recruiterStates?: InputMaybe<Array<RecruiterApplicationStateEnum>>;
  sources?: InputMaybe<Array<ApplicationSourceEnum>>;
  userStates?: InputMaybe<Array<UserApplicationStateEnum>>;
};

export type FreemiumPlanType = PlanTypeInterface & {
  __typename?: 'FreemiumPlanType';
  currency?: Maybe<CurrencyType>;
  price?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<CustomerSubscriptionStateEnum>;
};

export type ImageFocusPointBoundaryType = {
  __typename?: 'ImageFocusPointBoundaryType';
  bottom: Scalars['Int']['output'];
  left: Scalars['Int']['output'];
  right: Scalars['Int']['output'];
  top: Scalars['Int']['output'];
};

export type ImageFocusPointType = {
  __typename?: 'ImageFocusPointType';
  boundary: ImageFocusPointBoundaryType;
  gravity: ImageGravityEnum;
};

export enum ImageFormatEnum {
  AVIF = 'AVIF',
  JPEG = 'JPEG',
  PNG = 'PNG',
  WEBP = 'WEBP'
}

export enum ImageGravityEnum {
  CENTER = 'CENTER',
  EAST = 'EAST',
  NORTH = 'NORTH',
  SOUTH = 'SOUTH',
  WEST = 'WEST'
}

export type ImageType = {
  __typename?: 'ImageType';
  createdAt: Scalars['DateTime']['output'];
  focusPoint?: Maybe<ImageFocusPointType>;
  fullUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type ImageTypeFullUrlArgs = {
  dpi?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<ImageFormatEnum>;
  gravity?: InputMaybe<ImageGravityEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum IncludeWithinGeographicalLimitsEnum {
  OPENING_COUNTRY = 'OPENING_COUNTRY',
  OPENING_NEARBY_LOCATIONS = 'OPENING_NEARBY_LOCATIONS'
}

export type IndustryType = OpeningCategoryEntityInterface & {
  __typename?: 'IndustryType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InvoicingDetailsCountryInput = {
  countryCode: Scalars['String']['input'];
  iso: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InvoicingDetailsInput = {
  addressLine1: Scalars['String']['input'];
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  businessName: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: InvoicingDetailsCountryInput;
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicingDetailsType = {
  __typename?: 'InvoicingDetailsType';
  addressLine1?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export type IpDetailsType = {
  __typename?: 'IpDetailsType';
  isBot: Scalars['Boolean']['output'];
  isDataCenter: Scalars['Boolean']['output'];
  isRealUser: Scalars['Boolean']['output'];
};

export enum JobStartTimeEnum {
  FEW_MONTHS = 'FEW_MONTHS',
  FEW_WEEKS = 'FEW_WEEKS',
  HALF_YEAR = 'HALF_YEAR',
  IMMEDIATELY = 'IMMEDIATELY',
  NOT_SURE = 'NOT_SURE',
  ONE_MONTH = 'ONE_MONTH'
}

export enum LanguageCodeEnum {
  AF = 'AF',
  AR = 'AR',
  AZ = 'AZ',
  BE = 'BE',
  BG = 'BG',
  BH = 'BH',
  BN = 'BN',
  BS = 'BS',
  CA = 'CA',
  CS = 'CS',
  CY = 'CY',
  DA = 'DA',
  DE = 'DE',
  EL = 'EL',
  EN = 'EN',
  ES = 'ES',
  ET = 'ET',
  EU = 'EU',
  FA = 'FA',
  FI = 'FI',
  FR = 'FR',
  GA = 'GA',
  GD = 'GD',
  GL = 'GL',
  HA = 'HA',
  HI = 'HI',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IG = 'IG',
  IS = 'IS',
  IT = 'IT',
  JA = 'JA',
  JW = 'JW',
  KO = 'KO',
  LG = 'LG',
  LT = 'LT',
  LV = 'LV',
  MK = 'MK',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  NE = 'NE',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  SK = 'SK',
  SL = 'SL',
  SO = 'SO',
  SQ = 'SQ',
  SR = 'SR',
  SV = 'SV',
  SW = 'SW',
  TH = 'TH',
  TL = 'TL',
  TR = 'TR',
  UK = 'UK',
  UR = 'UR',
  VI = 'VI',
  YI = 'YI',
  YO = 'YO',
  ZH = 'ZH',
  ZU = 'ZU'
}

export type LegacyPlanType = PlanTypeInterface & {
  __typename?: 'LegacyPlanType';
  currency?: Maybe<CurrencyType>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type LinkImageInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  url: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type LinkImageType = {
  __typename?: 'LinkImageType';
  height?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type LinkType = {
  __typename?: 'LinkType';
  description?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<LinkImageType>;
  logo?: Maybe<LinkImageType>;
  /** @deprecated Use domain instead */
  siteName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LinkTypeEnum>;
  url: Scalars['String']['output'];
};

export enum LinkTypeEnum {
  ARTICLE = 'ARTICLE',
  BLOG = 'BLOG',
  ECOMMERCE = 'ECOMMERCE',
  EVENT = 'EVENT',
  EVENT_CALENDAR = 'EVENT_CALENDAR',
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  LINKEDIN = 'LINKEDIN',
  MEDIUM = 'MEDIUM',
  TWITTER = 'TWITTER',
  VIDEO = 'VIDEO',
  VIMEO = 'VIMEO',
  WEBSITE = 'WEBSITE',
  YOUTUBE = 'YOUTUBE'
}

export type LocationType = OpeningCategoryEntityInterface & PlaceEntityInterface & {
  __typename?: 'LocationType';
  coord: Array<Scalars['Float']['output']>;
  country?: Maybe<CountryType>;
  /** @deprecated Replaced with longName */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  longName: Scalars['String']['output'];
  /** @deprecated Replaced with shortName */
  main: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type LoginCredentialsInput = {
  email: Scalars['String']['input'];
  googleRecaptchaResponse: Scalars['GoogleRecaptchaResponse']['input'];
  password: Scalars['String']['input'];
};

export type LoginInput = {
  credentials?: InputMaybe<LoginCredentialsInput>;
  loginToken?: InputMaybe<Scalars['String']['input']>;
};

export enum LoginState {
  MAGIC_LINK_REQUIRED = 'MAGIC_LINK_REQUIRED',
  SUCCESSFUL = 'SUCCESSFUL'
}

export type MediaImageType = {
  __typename?: 'MediaImageType';
  focusPoint?: Maybe<ImageFocusPointType>;
  fullUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};


export type MediaImageTypeFullUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MeetFrankOpeningCandidateDestinationType = OpeningCandidateDestinationInterface & {
  __typename?: 'MeetFrankOpeningCandidateDestinationType';
  type: OpeningCandidateDestinationTypeEnum;
};

export enum MessageSenderEnum {
  BOT = 'BOT',
  RECRUITER = 'RECRUITER',
  USER = 'USER'
}

export type MessageTemplateType = {
  __typename?: 'MessageTemplateType';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type MessageThreadFilterInput = {
  isUnread?: InputMaybe<Scalars['Boolean']['input']>;
  openings?: InputMaybe<Array<Scalars['ID']['input']>>;
  recruiterApplicationStates?: InputMaybe<Array<RecruiterApplicationStateEnum>>;
  recruiters?: InputMaybe<Array<Scalars['ID']['input']>>;
  states?: InputMaybe<Array<MessageThreadStateEnum>>;
  userApplicationStates?: InputMaybe<Array<UserApplicationStateEnum>>;
};

export enum MessageThreadStateEnum {
  ARCHIVED = 'ARCHIVED',
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export type MessageThreadType = {
  __typename?: 'MessageThreadType';
  application?: Maybe<ApplicationType>;
  id: Scalars['ID']['output'];
  isInitiatedByMeetFrank: Scalars['Boolean']['output'];
  isUnread: Scalars['Boolean']['output'];
  latestMessageSentAt?: Maybe<Scalars['DateTime']['output']>;
  messages: PaginatedMessagesType;
  opening?: Maybe<OpeningType>;
  recruiter: RecruiterType;
  recruiterState: MessageThreadStateEnum;
  type: MessageThreadTypeEnum;
  user: UserType;
  userState: MessageThreadStateEnum;
};


export type MessageThreadTypeMessagesArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};

export enum MessageThreadTypeEnum {
  DIRECT = 'DIRECT',
  FRANK_AGENT = 'FRANK_AGENT',
  OPENING = 'OPENING',
  VERIFICATION = 'VERIFICATION'
}

export type MessageThreadUpdatedEventType = {
  __typename?: 'MessageThreadUpdatedEventType';
  unreadCount: Scalars['Int']['output'];
  updatedMessageThread: MessageThreadType;
};

export type MessageType = {
  __typename?: 'MessageType';
  id: Scalars['ID']['output'];
  readByRecruiterAt?: Maybe<Scalars['DateTime']['output']>;
  readByUserAt?: Maybe<Scalars['DateTime']['output']>;
  recruiter?: Maybe<RecruiterType>;
  sender: MessageSenderEnum;
  sentAt: Scalars['DateTime']['output'];
  text: Scalars['String']['output'];
  user?: Maybe<UserType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptApplication: ApplicationType;
  activateSubscription: CustomerType;
  archiveOpening: OpeningType;
  bulkCreateVerifiedUserApplicants: Array<VerifiedUserApplicantType>;
  cancelSubscription: CustomerType;
  cancelTeamInvite: Scalars['Boolean']['output'];
  createMessageTemplate: MessageTemplateType;
  createPaymentMethod?: Maybe<CustomerType>;
  createVerifiedUserApplicant: VerifiedUserApplicantType;
  duplicateOpening: OpeningType;
  generateOpeningAutomatedResponse?: Maybe<Scalars['String']['output']>;
  generateOpeningComment?: Maybe<Scalars['String']['output']>;
  generateOpeningMessage?: Maybe<Scalars['String']['output']>;
  generateOpeningPitch?: Maybe<Scalars['String']['output']>;
  logCreatePaymentMethodStatus?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use logCreatePaymentMethodStatus instead */
  logPaymentMethodError?: Maybe<Scalars['Boolean']['output']>;
  login: LoginState;
  logout: Scalars['Boolean']['output'];
  markAllNotificationsAsRead: Scalars['Boolean']['output'];
  markMessageThreadAsRead: MessageThreadType;
  markMessageThreadAsUnread: MessageThreadType;
  markNotificationAsRead: NotificationInterface;
  markNotificationCenterAsRead: Scalars['Boolean']['output'];
  pauseOpening: OpeningType;
  publishCompanyProfile: CompanyProfileType;
  publishOpening: OpeningType;
  recordSignals: Scalars['Boolean']['output'];
  rejectApplication: ApplicationType;
  removeBookmark: Scalars['Boolean']['output'];
  removeCollaborator: Scalars['Boolean']['output'];
  removePaymentMethod: CustomerType;
  replyToReview: ReviewInterface;
  republishOpening: OpeningType;
  requestAuthCode: Scalars['Boolean']['output'];
  requestPasswordReset: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  resumeOpening: OpeningType;
  saveBookmark: BookmarkInterface;
  saveCompanyProfile: CompanyProfileType;
  saveLink: LinkType;
  saveOpening: OpeningType;
  sendMessage: MessageThreadType;
  setDefaultPaymentMethod?: Maybe<CustomerType>;
  setPaymentMethodType?: Maybe<Scalars['Boolean']['output']>;
  setTotalSlotsCount?: Maybe<CustomerType>;
  signUp: Scalars['Boolean']['output'];
  stopOpening: OpeningType;
  updateCompany: CompanyType;
  updateInvoicingDetails: InvoicingDetailsType;
  updateLink: LinkType;
  updateMessageThread: MessageThreadType;
  updateRecruiter: RecruiterType;
  updateRecruiterPassword?: Maybe<Scalars['Boolean']['output']>;
  upgradeSubscription: CustomerType;
  uploadImage: ImageType;
  verifyAuthCode: Scalars['Boolean']['output'];
};


export type MutationAcceptApplicationArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  openingId: Scalars['String']['input'];
  userMatchingProfileId: Scalars['String']['input'];
};


export type MutationActivateSubscriptionArgs = {
  planType: CustomerPlanEnum;
  subscriptionCycle: CustomerSubscriptionCycleEnum;
};


export type MutationArchiveOpeningArgs = {
  openingId: Scalars['ID']['input'];
};


export type MutationBulkCreateVerifiedUserApplicantsArgs = {
  bulkCreateInputs: Array<BulkCreateVerifiedUserApplicantsInput>;
};


export type MutationCancelTeamInviteArgs = {
  teamInviteId: Scalars['ID']['input'];
};


export type MutationCreateMessageTemplateArgs = {
  createInput: CreateMessageTemplateInput;
};


export type MutationCreatePaymentMethodArgs = {
  paymentMethodInput?: InputMaybe<CreatePaymentMethodInput>;
};


export type MutationCreateVerifiedUserApplicantArgs = {
  input: CreateVerifiedUserApplicantInput;
  openingId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationDuplicateOpeningArgs = {
  openingId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationGenerateOpeningAutomatedResponseArgs = {
  openingId: Scalars['ID']['input'];
};


export type MutationGenerateOpeningCommentArgs = {
  openingId: Scalars['ID']['input'];
};


export type MutationGenerateOpeningMessageArgs = {
  openingId: Scalars['ID']['input'];
};


export type MutationGenerateOpeningPitchArgs = {
  openingId: Scalars['ID']['input'];
};


export type MutationLogCreatePaymentMethodStatusArgs = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  status: CreatePaymentMethodStatusEnum;
};


export type MutationLogPaymentMethodErrorArgs = {
  statusCode: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  loginInput: LoginInput;
};


export type MutationMarkMessageThreadAsReadArgs = {
  messageThreadId: Scalars['ID']['input'];
};


export type MutationMarkMessageThreadAsUnreadArgs = {
  messageThreadId: Scalars['ID']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationPauseOpeningArgs = {
  openingId: Scalars['ID']['input'];
  pauseOpeningInput: PauseOpeningInput;
};


export type MutationPublishCompanyProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationPublishOpeningArgs = {
  openingId: Scalars['ID']['input'];
};


export type MutationRecordSignalsArgs = {
  signals: Array<RecordSignalInput>;
};


export type MutationRejectApplicationArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  openingId: Scalars['String']['input'];
  userMatchingProfileId: Scalars['String']['input'];
};


export type MutationRemoveBookmarkArgs = {
  entityId: Scalars['ID']['input'];
  type: BookmarkTypeEnum;
};


export type MutationRemoveCollaboratorArgs = {
  openingId: Scalars['ID']['input'];
  recruiterId: Scalars['ID']['input'];
};


export type MutationRemovePaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationReplyToReviewArgs = {
  replyToReviewInput: ReplyToReviewInput;
  reviewId: Scalars['ID']['input'];
};


export type MutationRepublishOpeningArgs = {
  openingId: Scalars['ID']['input'];
};


export type MutationRequestAuthCodeArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestPasswordResetArgs = {
  requestInput: RequestPasswordResetInput;
};


export type MutationResetPasswordArgs = {
  resetInput: ResetPasswordInput;
};


export type MutationResumeOpeningArgs = {
  openingId: Scalars['ID']['input'];
};


export type MutationSaveBookmarkArgs = {
  entityId: Scalars['ID']['input'];
  type: BookmarkTypeEnum;
};


export type MutationSaveCompanyProfileArgs = {
  changes: SaveCompanyProfileInput;
  profileId: Scalars['String']['input'];
};


export type MutationSaveLinkArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveOpeningArgs = {
  openingId?: InputMaybe<Scalars['String']['input']>;
  openingInput: OpeningInput;
};


export type MutationSendMessageArgs = {
  messageInput: SendMessageInput;
  messageThreadId: Scalars['ID']['input'];
};


export type MutationSetDefaultPaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationSetPaymentMethodTypeArgs = {
  methodType: PaymentMethodTypeEnum;
};


export type MutationSetTotalSlotsCountArgs = {
  totalSlotsCount: Scalars['Int']['input'];
};


export type MutationSignUpArgs = {
  signUpInput: SignUpInput;
};


export type MutationStopOpeningArgs = {
  openingId: Scalars['ID']['input'];
  stopOpeningInput: StopOpeningInput;
};


export type MutationUpdateCompanyArgs = {
  companyId: Scalars['ID']['input'];
  updateInput: UpdateCompanyInput;
};


export type MutationUpdateInvoicingDetailsArgs = {
  customerId: Scalars['ID']['input'];
  invoicingDetailsInput: InvoicingDetailsInput;
};


export type MutationUpdateLinkArgs = {
  id: Scalars['ID']['input'];
  updateInput: UpdateLinkInput;
};


export type MutationUpdateMessageThreadArgs = {
  messageThreadId: Scalars['ID']['input'];
  updateInput: UpdateMessageThreadInput;
};


export type MutationUpdateRecruiterArgs = {
  updateInput: UpdateRecruiterInput;
};


export type MutationUpdateRecruiterPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpgradeSubscriptionArgs = {
  planType: CustomerPlanEnum;
  subscriptionCycle: CustomerSubscriptionCycleEnum;
};


export type MutationUploadImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationVerifyAuthCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type NestedSkillType = {
  __typename?: 'NestedSkillType';
  skill?: Maybe<SkillType>;
};

export type NotificationCenterType = {
  __typename?: 'NotificationCenterType';
  newNotificationsCount: Scalars['Int']['output'];
  readNotificationsCount: Scalars['Int']['output'];
  totalNotificationsCount: Scalars['Int']['output'];
  unreadNotificationsCount: Scalars['Int']['output'];
};

export type NotificationGroupType = {
  __typename?: 'NotificationGroupType';
  notifications: Array<NotificationInterface>;
};

export type NotificationIconType = {
  __typename?: 'NotificationIconType';
  primary: ImageType;
  secondary?: Maybe<ImageType>;
};

export type NotificationInterface = {
  icons: NotificationIconType;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt: Scalars['DateTime']['output'];
  type: NotificationTypeEnum;
  url?: Maybe<Scalars['String']['output']>;
};

export enum NotificationTypeEnum {
  APPLICATION_NEW_CANDIDATE = 'APPLICATION_NEW_CANDIDATE',
  BATCH = 'BATCH',
  OPENING_PUBLISHED = 'OPENING_PUBLISHED'
}

export type OpeningApplicantCountsType = {
  __typename?: 'OpeningApplicantCountsType';
  newMessaged: Scalars['Int']['output'];
  newUnanswered: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalMessaged: Scalars['Int']['output'];
  totalRejected: Scalars['Int']['output'];
  totalUnanswered: Scalars['Int']['output'];
};

export type OpeningApplicantType = ApplicantInterface & {
  __typename?: 'OpeningApplicantType';
  application: ApplicationType;
  hasMessaged: Scalars['Boolean']['output'];
  messageThread: MessageThreadType;
  recruiterState: ApplicantRecruiterStateEnum;
  user: UserType;
  userState: ApplicantUserStateEnum;
  userVerification?: Maybe<UserVerificationType>;
};

export type OpeningCandidateDestinationInput = {
  type: OpeningCandidateDestinationTypeEnum;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type OpeningCandidateDestinationInterface = {
  type: OpeningCandidateDestinationTypeEnum;
};

export enum OpeningCandidateDestinationTypeEnum {
  EXTERNAL_URL = 'EXTERNAL_URL',
  MEETFRANK = 'MEETFRANK'
}

export type OpeningCategoryEntityInterface = {
  id: Scalars['ID']['output'];
};

export type OpeningCategoryType = {
  __typename?: 'OpeningCategoryType';
  entity?: Maybe<OpeningCategoryEntityInterface>;
  openingsCount: Scalars['Int']['output'];
  searchTag: SearchOpeningEntityTagType;
};

export enum OpeningEmploymentTypeEnum {
  FULL_TIME = 'FULL_TIME',
  INTERNSHIP = 'INTERNSHIP',
  PART_TIME = 'PART_TIME',
  PROJECT = 'PROJECT'
}

export type OpeningInput = {
  allowDistribution?: InputMaybe<Scalars['Boolean']['input']>;
  automatedResponse?: InputMaybe<Scalars['String']['input']>;
  candidateDestination?: InputMaybe<OpeningCandidateDestinationInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<OpeningEmploymentTypeEnum>;
  interviewQuestions?: InputMaybe<Array<OpeningInterviewQuestionInput>>;
  isRelocation?: InputMaybe<Scalars['Boolean']['input']>;
  isRemote?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  openingPaidAddons?: InputMaybe<Array<OpeningPaidAddonInput>>;
  pitch?: InputMaybe<Scalars['String']['input']>;
  positionLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  relocationBenefits?: InputMaybe<Array<Scalars['ID']['input']>>;
  remote?: InputMaybe<OpeningRemoteInput>;
  salaryRange?: InputMaybe<OpeningSalaryRangeInput>;
  seniorities?: InputMaybe<Array<Scalars['ID']['input']>>;
  skills?: InputMaybe<Array<OpeningSkillInput>>;
  speciality?: InputMaybe<Scalars['ID']['input']>;
  targetLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<OpeningVisibilityEnum>;
  workload?: InputMaybe<OpeningWorkloadInput>;
};

export type OpeningInterviewQuestionInput = {
  existingId?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  question: Scalars['String']['input'];
};

export type OpeningInterviewQuestionType = {
  __typename?: 'OpeningInterviewQuestionType';
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type OpeningNotificationType = NotificationInterface & {
  __typename?: 'OpeningNotificationType';
  icons: NotificationIconType;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  opening?: Maybe<OpeningType>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt: Scalars['DateTime']['output'];
  type: NotificationTypeEnum;
  url?: Maybe<Scalars['String']['output']>;
};

export enum OpeningPaidAddonEnum {
  AUTOMATED_REPUBLISH = 'AUTOMATED_REPUBLISH',
  BEST_OF_MEETFRANK = 'BEST_OF_MEETFRANK',
  BLOG_INTERVIEW = 'BLOG_INTERVIEW',
  BRANDING_BASIC = 'BRANDING_BASIC',
  BRANDING_PREMIUM = 'BRANDING_PREMIUM',
  FEATURED_OPENING = 'FEATURED_OPENING',
  PREMIUM_PUSH = 'PREMIUM_PUSH',
  PUBLIC_OPENING = 'PUBLIC_OPENING',
  SOCIAL_MEDIA_BASIC = 'SOCIAL_MEDIA_BASIC',
  SOCIAL_MEDIA_PREMIUM = 'SOCIAL_MEDIA_PREMIUM',
  VIRTUAL_RECRUITER = 'VIRTUAL_RECRUITER'
}

export type OpeningPaidAddonInput = {
  isRecurring: Scalars['Boolean']['input'];
  priceInEur: Scalars['Float']['input'];
  type: OpeningPaidAddonEnum;
};

export type OpeningReachType = {
  __typename?: 'OpeningReachType';
  global: Scalars['Int']['output'];
  local: Scalars['Int']['output'];
  remote: Scalars['Int']['output'];
};

export type OpeningRemoteInput = {
  allowedPlaces: Array<Scalars['ID']['input']>;
  type: OpeningRemoteTypeEnum;
};

export type OpeningRemoteType = {
  __typename?: 'OpeningRemoteType';
  allowedPlaces: Array<PlaceType>;
  type: OpeningRemoteTypeEnum;
};

export enum OpeningRemoteTypeEnum {
  FULLY = 'FULLY',
  HYBRID = 'HYBRID',
  ONSITE = 'ONSITE'
}

export type OpeningSalaryRangeInput = {
  currency: Scalars['ID']['input'];
  from: Scalars['Float']['input'];
  increase?: InputMaybe<Scalars['Int']['input']>;
  offerSalary?: InputMaybe<Scalars['Float']['input']>;
  period: SalaryPeriodEnum;
  to: Scalars['Float']['input'];
};

export type OpeningSalaryRangeType = {
  __typename?: 'OpeningSalaryRangeType';
  currency?: Maybe<CurrencyType>;
  from?: Maybe<Scalars['Float']['output']>;
  increase?: Maybe<Scalars['Float']['output']>;
  offerSalary?: Maybe<Scalars['Float']['output']>;
  period?: Maybe<SalaryPeriodEnum>;
  to?: Maybe<Scalars['Float']['output']>;
};

export type OpeningSearchEntityPaginationOptionsInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  maxCursor?: InputMaybe<Scalars['String']['input']>;
  minCursor?: InputMaybe<Scalars['String']['input']>;
  randomSeed?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<OpeningSearchEntitySortOptionEnum>;
  sortOrder?: InputMaybe<PaginationSortOrderEnum>;
};

export type OpeningSearchEntitySearchParamsInput = {
  groupSearchTagsWithOrCondition?: InputMaybe<Array<SearchOpeningEntityTagInput>>;
  searchPattern?: InputMaybe<Scalars['String']['input']>;
  searchTagsWithAndCondition?: InputMaybe<Array<SearchOpeningEntityTagInput>>;
  searchTagsWithNegatedAndCondition?: InputMaybe<Array<SearchOpeningEntityTagInput>>;
  searchTagsWithOrCondition?: InputMaybe<Array<SearchOpeningEntityTagInput>>;
};

export enum OpeningSearchEntitySortOptionEnum {
  RANDOM = 'RANDOM',
  RECENCY = 'RECENCY',
  RECENCY_AND_RELEVANCY = 'RECENCY_AND_RELEVANCY',
  RELEVANCY = 'RELEVANCY'
}

export type OpeningSearchPatternInput = {
  pattern: Scalars['String']['input'];
  tag: OpeningSearchTagNameEnum;
};

export enum OpeningSearchTagNameEnum {
  CANDIDATE_DESTINATION_TYPE = 'CANDIDATE_DESTINATION_TYPE',
  COMPANY = 'COMPANY',
  COMPANY_INDUSTRY = 'COMPANY_INDUSTRY',
  COMPANY_MARKET_AREA = 'COMPANY_MARKET_AREA',
  COMPANY_MARKET_COUNTRY = 'COMPANY_MARKET_COUNTRY',
  COMPANY_NAME = 'COMPANY_NAME',
  COMPANY_OFFICE_COUNTRY = 'COMPANY_OFFICE_COUNTRY',
  COMPANY_OFFICE_LOCATION = 'COMPANY_OFFICE_LOCATION',
  COMPANY_SIZE = 'COMPANY_SIZE',
  COMPANY_TYPE = 'COMPANY_TYPE',
  EMPLOYMENT_TYPE = 'EMPLOYMENT_TYPE',
  MAX_SALARY = 'MAX_SALARY',
  MIN_SALARY = 'MIN_SALARY',
  PAID_ADDON_TYPE = 'PAID_ADDON_TYPE',
  POSITION_COUNTRY = 'POSITION_COUNTRY',
  POSITION_LOCATION = 'POSITION_LOCATION',
  PUBLISHED_AT = 'PUBLISHED_AT',
  RECRUITER = 'RECRUITER',
  RELOCATION = 'RELOCATION',
  REMOTE = 'REMOTE',
  SALARY_CURRENCY = 'SALARY_CURRENCY',
  SALARY_PERIOD = 'SALARY_PERIOD',
  SENIORITY = 'SENIORITY',
  SKILL = 'SKILL',
  SOURCE_TYPE = 'SOURCE_TYPE',
  SPECIALITY = 'SPECIALITY',
  STATE = 'STATE',
  TARGET_COUNTRY = 'TARGET_COUNTRY',
  TARGET_LOCATION = 'TARGET_LOCATION',
  TITLE = 'TITLE',
  TYPE = 'TYPE',
  VISIBILITY = 'VISIBILITY'
}

export type OpeningSearchTagType = {
  tag: OpeningSearchTagNameEnum;
  value: Scalars['SearchTagValue']['input'];
};

export enum OpeningSignalTypeEnum {
  DISCARD_OPENING = 'DISCARD_OPENING',
  UNDISCARD_OPENING = 'UNDISCARD_OPENING',
  VIEW_DETAILS = 'VIEW_DETAILS',
  VIEW_FEED_ITEM = 'VIEW_FEED_ITEM',
  VIEW_STORY_ITEM = 'VIEW_STORY_ITEM'
}

export type OpeningSkillInput = {
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  skill: Scalars['ID']['input'];
};

export type OpeningSkillType = {
  __typename?: 'OpeningSkillType';
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isMandatory instead. */
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  skill: SkillType;
};

export enum OpeningSourceEnum {
  MEETFRANK = 'MEETFRANK',
  SCRAPER = 'SCRAPER'
}

export enum OpeningStateEnum {
  ACTIVE = 'ACTIVE',
  ADMIN_REVIEW = 'ADMIN_REVIEW',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE',
  PAUSED = 'PAUSED',
  SUPPORT = 'SUPPORT'
}

export type OpeningType = SignalEntityInterface & {
  __typename?: 'OpeningType';
  allowDistribution?: Maybe<Scalars['Boolean']['output']>;
  applicantCounts: OpeningApplicantCountsType;
  applicants: PaginatedApplicantsType;
  applications: Array<ApplicationType>;
  automatedResponse?: Maybe<Scalars['String']['output']>;
  candidateDestination: OpeningCandidateDestinationInterface;
  collaborators: PaginatedRecruitersType;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyType>;
  deepLinkUrl?: Maybe<Scalars['String']['output']>;
  depersonalizedMessage?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<OpeningEmploymentTypeEnum>;
  id: Scalars['ID']['output'];
  interviewQuestions: Array<OpeningInterviewQuestionType>;
  isFeatured: Scalars['Boolean']['output'];
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isRelocation?: Maybe<Scalars['Boolean']['output']>;
  isRemote?: Maybe<Scalars['Boolean']['output']>;
  marketSalaries: SalaryDistributionType;
  message?: Maybe<Scalars['String']['output']>;
  paidAddons: Array<Maybe<EmbeddedOpeningPaidAddonType>>;
  pitch?: Maybe<Scalars['String']['output']>;
  positionLocations?: Maybe<Array<LocationType>>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reach: OpeningReachType;
  recommendedUsers: PaginatedVerifiedUserType;
  recruiter?: Maybe<RecruiterType>;
  relocationBenefits?: Maybe<Array<RelocationBenefitType>>;
  remote?: Maybe<OpeningRemoteType>;
  salaryRange?: Maybe<OpeningSalaryRangeType>;
  seniorities?: Maybe<Array<SeniorityType>>;
  signalCountsByTypes: SignalCountsType;
  skills?: Maybe<Array<OpeningSkillType>>;
  source: OpeningSourceEnum;
  sourcingStatistics: OpeningsSourcingStatisticsType;
  speciality?: Maybe<SpecialityType>;
  state: OpeningStateEnum;
  targetLocations?: Maybe<Array<LocationType>>;
  title?: Maybe<Scalars['String']['output']>;
  visibility: OpeningVisibilityEnum;
  workload?: Maybe<OpeningWorkloadType>;
};


export type OpeningTypeApplicantsArgs = {
  filterInput?: InputMaybe<FilterOpeningApplicantsInput>;
  paginationOptions?: InputMaybe<ApplicantsPaginationOptionsInput>;
};


export type OpeningTypeCollaboratorsArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};


export type OpeningTypeMarketSalariesArgs = {
  resolution: Scalars['Int']['input'];
};


export type OpeningTypePublicUrlArgs = {
  includeBaseUrl?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OpeningTypeRecommendedUsersArgs = {
  excludedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterInput?: InputMaybe<RecommendedUsersFiltersInput>;
  paginationOptions?: InputMaybe<RecommendedUsersPaginationOptionsInput>;
};


export type OpeningTypeSignalCountsByTypesArgs = {
  signalTypes: Array<OpeningSignalTypeEnum>;
};

export enum OpeningVisibilityEnum {
  PUBLIC = 'PUBLIC',
  UNLISTED = 'UNLISTED'
}

export type OpeningWorkloadInput = {
  hours: Scalars['Int']['input'];
  period: OpeningWorkloadPeriodEnum;
};

export enum OpeningWorkloadPeriodEnum {
  TOTAL = 'TOTAL',
  WEEK = 'WEEK'
}

export type OpeningWorkloadType = {
  __typename?: 'OpeningWorkloadType';
  hours?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<OpeningWorkloadPeriodEnum>;
};

export type OpeningsSourcingStatisticsType = {
  __typename?: 'OpeningsSourcingStatisticsType';
  acceptedApplications: Scalars['Int']['output'];
  rejectedApplications: Scalars['Int']['output'];
};

export type PaginatedApplicantsType = {
  __typename?: 'PaginatedApplicantsType';
  pagination: PaginationInfoType;
  result: Array<ApplicantInterface>;
};

export type PaginatedAutoCompleteUsersSearchPatternType = {
  __typename?: 'PaginatedAutoCompleteUsersSearchPatternType';
  pagination: PaginationInfoType;
  result: Array<Scalars['String']['output']>;
};

export type PaginatedAwardsType = {
  __typename?: 'PaginatedAwardsType';
  pagination: PaginationInfoType;
  result: Array<Maybe<AwardType>>;
};

export type PaginatedBookmarksType = {
  __typename?: 'PaginatedBookmarksType';
  pagination: PaginationInfoType;
  result: Array<BookmarkInterface>;
};

export type PaginatedCompaniesType = {
  __typename?: 'PaginatedCompaniesType';
  pagination: PaginationInfoType;
  result: Array<Maybe<CompanyType>>;
};

export type PaginatedCountryType = {
  __typename?: 'PaginatedCountryType';
  pagination: PaginationInfoType;
  result: Array<CountryType>;
};

export type PaginatedLocationType = {
  __typename?: 'PaginatedLocationType';
  pagination: PaginationInfoType;
  result: Array<LocationType>;
};

export type PaginatedMessageThreadsType = {
  __typename?: 'PaginatedMessageThreadsType';
  pagination: PaginationInfoType;
  result: Array<MessageThreadType>;
};

export type PaginatedMessagesType = {
  __typename?: 'PaginatedMessagesType';
  pagination: PaginationInfoType;
  result: Array<Maybe<MessageType>>;
};

export type PaginatedNotificationGroupType = {
  __typename?: 'PaginatedNotificationGroupType';
  pagination: PaginationInfoType;
  result: Array<NotificationGroupType>;
};

export type PaginatedOpeningsType = {
  __typename?: 'PaginatedOpeningsType';
  pagination: PaginationInfoType;
  result: Array<OpeningType>;
};

export type PaginatedPlaceType = {
  __typename?: 'PaginatedPlaceType';
  pagination: PaginationInfoType;
  result: Array<PlaceType>;
};

export type PaginatedRecruitersType = {
  __typename?: 'PaginatedRecruitersType';
  pagination: PaginationInfoType;
  result: Array<RecruiterType>;
};

export type PaginatedReviewsType = {
  __typename?: 'PaginatedReviewsType';
  pagination: PaginationInfoType;
  result: Array<ReviewInterface>;
};

export type PaginatedTalentActivityFeedResultType = {
  __typename?: 'PaginatedTalentActivityFeedResultType';
  pagination: PaginationInfoType;
  result: Array<TalentActivityType>;
};

export type PaginatedUsersType = {
  __typename?: 'PaginatedUsersType';
  pagination: PaginationInfoType;
  result: Array<Maybe<UserType>>;
};

export type PaginatedVerifiedUserType = {
  __typename?: 'PaginatedVerifiedUserType';
  pagination: PaginationInfoType;
  result: Array<VerifiedUserType>;
};

export type PaginationInfoType = {
  __typename?: 'PaginationInfoType';
  hasMoreResults: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  maxCursor?: Maybe<Scalars['String']['output']>;
  minCursor?: Maybe<Scalars['String']['output']>;
  sortOrder: PaginationSortOrderEnum;
  totalCount: Scalars['Int']['output'];
};

export type PaginationOptionsInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  maxCursor?: InputMaybe<Scalars['String']['input']>;
  minCursor?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<PaginationSortOrderEnum>;
};

export enum PaginationSortOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type PauseOpeningInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export enum PaymentMethodTypeEnum {
  CREDITCARD = 'CREDITCARD',
  INVOICE = 'INVOICE'
}

export type PlaceEntityInterface = {
  id: Scalars['ID']['output'];
};

export type PlaceType = {
  __typename?: 'PlaceType';
  entity?: Maybe<PlaceEntityInterface>;
  type: PlaceTypeEnum;
};

export enum PlaceTypeEnum {
  AREA = 'AREA',
  COUNTRY = 'COUNTRY',
  LOCATION = 'LOCATION',
  RELOCATION = 'RELOCATION',
  REMOTE = 'REMOTE'
}

export type PlanTypeInterface = {
  currency?: Maybe<CurrencyType>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  applicant: ApplicantInterface;
  application: ApplicationType;
  area?: Maybe<AreaType>;
  areas: Array<AreaType>;
  autoCompleteUsersSearchPattern: PaginatedAutoCompleteUsersSearchPatternType;
  availableCurrencies?: Maybe<Array<CurrencyType>>;
  bookmarkedVerifiedUsers: PaginatedVerifiedUserType;
  bookmarks: PaginatedBookmarksType;
  company: CompanyType;
  companyBenefits: Array<CompanyBenefitType>;
  companyById: CompanyType;
  companyByProfile: CompanyType;
  companyFundings: Array<Maybe<CompanyFundingType>>;
  companyRevenues: Array<Maybe<CompanyRevenueType>>;
  companySizes: Array<Maybe<CompanySizeType>>;
  companyTypes: Array<Maybe<CompanyTypeType>>;
  countries: PaginatedCountryType;
  country?: Maybe<CountryType>;
  currentRecruiter: RecruiterType;
  customer: CustomerType;
  googleLocations: PaginatedLocationType;
  industries: Array<Maybe<IndustryType>>;
  ipDetails: IpDetailsType;
  location: LocationType;
  locations: PaginatedLocationType;
  messageThread: MessageThreadType;
  messageThreads: PaginatedMessageThreadsType;
  messagedOpenings: PaginatedOpeningsType;
  notificationCenter: NotificationCenterType;
  notificationGroups: PaginatedNotificationGroupType;
  opening: OpeningType;
  openings: PaginatedOpeningsType;
  places: PaginatedPlaceType;
  recentlySeenCompanies: PaginatedCompaniesType;
  rejectedVerifiedUsers: PaginatedVerifiedUserType;
  relocationBenefits: Array<RelocationBenefitType>;
  salaryPeriods: Array<SalaryPeriodType>;
  salarySteps: Array<Maybe<SalaryStepType>>;
  searchVerifiedUsers: PaginatedVerifiedUserType;
  seniorities: Array<Maybe<SeniorityType>>;
  seniority: SeniorityType;
  skill: SkillType;
  skills: Array<Maybe<SkillType>>;
  specialities: Array<SpecialityType>;
  subscriptionPlans: Array<CustomerSubscriptionPlanInfoType>;
  talentActivityFeed: PaginatedTalentActivityFeedResultType;
  talentActivityStatistics: TalentActivityStatisticsType;
  verifiedUser: VerifiedUserType;
  verifiedUsers: PaginatedVerifiedUserType;
};


export type QueryApplicantArgs = {
  openingId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAreaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutoCompleteUsersSearchPatternArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  searchPattern?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookmarkedVerifiedUsersArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};


export type QueryBookmarksArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  type: BookmarkTypeEnum;
};


export type QueryCompanyByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyByProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type QueryCountriesArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  searchPattern?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoogleLocationsArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  searchPattern: Scalars['String']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationsArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  searchPattern: Scalars['String']['input'];
};


export type QueryMessageThreadArgs = {
  messageThreadId: Scalars['ID']['input'];
};


export type QueryMessageThreadsArgs = {
  filterInput?: InputMaybe<MessageThreadFilterInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};


export type QueryMessagedOpeningsArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  recruiterId: Scalars['ID']['input'];
};


export type QueryNotificationGroupsArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};


export type QueryOpeningArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpeningsArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  searchPatterns?: InputMaybe<Array<OpeningSearchPatternInput>>;
  searchTags?: InputMaybe<Array<OpeningSearchTagType>>;
};


export type QueryPlacesArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  placeTypes?: InputMaybe<Array<PlaceTypeEnum>>;
  searchPattern?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecentlySeenCompaniesArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};


export type QueryRejectedVerifiedUsersArgs = {
  dateRangeInput?: InputMaybe<DateRangeInput>;
  openingId?: InputMaybe<Scalars['ID']['input']>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};


export type QuerySalaryStepsArgs = {
  currencyCode: Scalars['String']['input'];
  period: SalaryStepPeriodEnum;
};


export type QuerySearchVerifiedUsersArgs = {
  excludedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  searchParams?: InputMaybe<UserSearchEntitySearchParamsInput>;
  sortedPaginationOptions?: InputMaybe<SearchVerifiedUsersPaginationOptionsInput>;
};


export type QuerySeniorityArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkillArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkillsArgs = {
  specialityId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySubscriptionPlansArgs = {
  excludeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTalentActivityFeedArgs = {
  filterInput?: InputMaybe<TalentActivityFeedFilterInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};


export type QueryTalentActivityStatisticsArgs = {
  filterInput?: InputMaybe<TalentActivityFeedFilterInput>;
};


export type QueryVerifiedUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryVerifiedUsersArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  searchTags?: InputMaybe<Array<UserSearchTagType>>;
};

export type RecommendedUsersFiltersGeographicalLimitInput = {
  country?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<FilterApplicantsByGeographicalLimitEnum>;
};

export type RecommendedUsersFiltersInput = {
  geographicalLimit?: InputMaybe<RecommendedUsersFiltersGeographicalLimitInput>;
  isRelocation?: InputMaybe<Scalars['Boolean']['input']>;
  isRemote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecommendedUsersPaginationOptionsInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  maxCursor?: InputMaybe<Scalars['String']['input']>;
  minCursor?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<RecommendedUsersSortOptionEnum>;
  sortOrder?: InputMaybe<PaginationSortOrderEnum>;
};

export enum RecommendedUsersSortOptionEnum {
  JOINED_AT = 'JOINED_AT',
  LAST_SEEN = 'LAST_SEEN',
  RELEVANCE = 'RELEVANCE'
}

export type RecordSignalInput = {
  entityId: Scalars['ID']['input'];
  entityType: SignalEntityTypeEnum;
  type: SignalTypeEnum;
};

export enum RecruiterApplicationStateEnum {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type RecruiterApplicationStateType = {
  __typename?: 'RecruiterApplicationStateType';
  createdAt: Scalars['DateTime']['output'];
  recruiter: RecruiterType;
  state: RecruiterApplicationStateEnum;
};

export type RecruiterRightsType = {
  __typename?: 'RecruiterRightsType';
  billing: Scalars['Boolean']['output'];
  company: Scalars['Boolean']['output'];
  companyProfile: Scalars['Boolean']['output'];
  inviteCollaborator: Scalars['Boolean']['output'];
  inviteTeam: Scalars['Boolean']['output'];
  openings: Scalars['Boolean']['output'];
  requests: Scalars['Boolean']['output'];
  toggle2FA: Scalars['Boolean']['output'];
};

export enum RecruiterRoleEnum {
  ADMIN = 'ADMIN',
  COLLABORATOR = 'COLLABORATOR',
  RECRUITER = 'RECRUITER'
}

export type RecruiterType = {
  __typename?: 'RecruiterType';
  availableCompanies: Array<AvailableCompanyType>;
  avatar?: Maybe<ImageType>;
  avatarColor?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryType>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intercomHash: Scalars['String']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isFrankAgent?: Maybe<Scalars['Boolean']['output']>;
  isIncomplete?: Maybe<Scalars['Boolean']['output']>;
  isSiteAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
  nameInitials?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rights: RecruiterRightsType;
  role: RecruiterRoleEnum;
  title?: Maybe<Scalars['String']['output']>;
};

export type RelocationBenefitType = {
  __typename?: 'RelocationBenefitType';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReplyToReviewInput = {
  comment: Scalars['String']['input'];
};

export type RequestPasswordResetInput = {
  email: Scalars['String']['input'];
  googleRecaptchaResponse: Scalars['GoogleRecaptchaResponse']['input'];
};

export type ResetPasswordInput = {
  password: Scalars['String']['input'];
  passwordResetToken: Scalars['String']['input'];
};

export type ReviewActorEntityInterface = {
  id: Scalars['ID']['output'];
};

export enum ReviewActorEnum {
  USER = 'USER'
}

export type ReviewActorType = {
  __typename?: 'ReviewActorType';
  entity: ReviewActorEntityInterface;
  type: ReviewActorEnum;
};

export type ReviewInterface = {
  actor: ReviewActorType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reply?: Maybe<ReviewReplyType>;
  type: ReviewTypeEnum;
};

export type ReviewReplyType = {
  __typename?: 'ReviewReplyType';
  comment: Scalars['String']['output'];
  repliedBy: RecruiterType;
};

export enum ReviewTypeEnum {
  COMPANY_AWARDS = 'COMPANY_AWARDS',
  COMPANY_RATINGS = 'COMPANY_RATINGS'
}

export type SalaryDistributionDataPointType = {
  __typename?: 'SalaryDistributionDataPointType';
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  step: Scalars['Int']['output'];
};

export type SalaryDistributionType = {
  __typename?: 'SalaryDistributionType';
  currency: CurrencyType;
  openingSalaries?: Maybe<Array<SalaryDistributionDataPointType>>;
  userSalaries?: Maybe<Array<SalaryDistributionDataPointType>>;
};

export enum SalaryPeriodEnum {
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  TOTAL = 'TOTAL',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type SalaryPeriodType = {
  __typename?: 'SalaryPeriodType';
  label: Scalars['String']['output'];
  value: SalaryPeriodEnum;
};

export enum SalaryStepPeriodEnum {
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}

export type SalaryStepType = {
  __typename?: 'SalaryStepType';
  step: Scalars['Int']['output'];
};

export type SaveCompanyProfileFundingInput = {
  currencyId: Scalars['ID']['input'];
  fundedAt?: InputMaybe<Scalars['DateTime']['input']>;
  round?: InputMaybe<CompanyProfileFundingRoundTypeEnum>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveCompanyProfileInput = {
  /** A list of company benefit ids */
  benefitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of image ids which will be used to create new company clients */
  clientLogoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A description of the company clients */
  clientsDescription?: InputMaybe<Scalars['String']['input']>;
  /** The id of the company size type */
  companySizeId?: InputMaybe<Scalars['String']['input']>;
  /** The total number of employees */
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  /** The year when the company got founded */
  founded?: InputMaybe<Scalars['Float']['input']>;
  /** The id of the company funding type */
  fundingId?: InputMaybe<Scalars['String']['input']>;
  /** The id of an uploaded image */
  headerImageId?: InputMaybe<Scalars['String']['input']>;
  /** The latest funding of the company */
  latestFunding?: InputMaybe<SaveCompanyProfileFundingInput>;
  /** The latest valuation of the company */
  latestValuation?: InputMaybe<SaveCompanyProfileValuationInput>;
  /** A list of Google Maps place ids */
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The id of an uploaded image */
  logoId?: InputMaybe<Scalars['String']['input']>;
  /** A list of area ids that the company operates in */
  marketAreaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of country ids that the company operates in */
  marketCountryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A description of the makets the company operates in */
  marketsDescription?: InputMaybe<Scalars['String']['input']>;
  /** A list of media article ids */
  mediaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The mission statement of the company */
  missionStatement?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The office description of the company */
  officeDescription?: InputMaybe<Scalars['String']['input']>;
  /** A list of uploaded image ids. */
  officeImageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A url linking to a office video resource */
  officeVideo?: InputMaybe<Scalars['String']['input']>;
  /** A list of offices. */
  offices?: InputMaybe<Array<SaveCompanyProfileOfficeInput>>;
  /** A list of uploaded image ids. */
  productImageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The id of the company revenue type */
  revenueId?: InputMaybe<Scalars['String']['input']>;
  /** The service description of the company */
  serviceDescription?: InputMaybe<Scalars['String']['input']>;
  /** A list of social media links */
  socialMedia?: InputMaybe<Array<SocialMediaInput>>;
  /** The total funding of the company */
  totalFunding?: InputMaybe<Scalars['Int']['input']>;
  /** A url linking to a video resource */
  video?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCompanyProfileOfficeInput = {
  isFoundingLocation: Scalars['Boolean']['input'];
  isHeadquarter: Scalars['Boolean']['input'];
  locationId: Scalars['ID']['input'];
};

export type SaveCompanyProfileValuationInput = {
  currencyId: Scalars['ID']['input'];
  max: Scalars['Int']['input'];
  min?: InputMaybe<Scalars['Int']['input']>;
  round: CompanyProfileFundingRoundTypeEnum;
  valuedAt: Scalars['DateTime']['input'];
};

export enum SearchEntityTagOperatorEnum {
  EXISTS = 'EXISTS',
  GT = 'GT',
  GTE = 'GTE',
  IN_ARRAY = 'IN_ARRAY',
  LT = 'LT',
  LTE = 'LTE',
  SEARCH_PHRASE = 'SEARCH_PHRASE'
}

export type SearchOpeningEntityTagInput = {
  operator?: InputMaybe<SearchEntityTagOperatorEnum>;
  tag: SearchOpeningEntityTagNameEnum;
  value: Scalars['SearchTagValue']['input'];
};

export enum SearchOpeningEntityTagNameEnum {
  COMPANY = 'COMPANY',
  COMPANY_BENEFIT = 'COMPANY_BENEFIT',
  COMPANY_COUNTRY = 'COMPANY_COUNTRY',
  COMPANY_HAS_ACTIVE_SUBSCRIPTION = 'COMPANY_HAS_ACTIVE_SUBSCRIPTION',
  COMPANY_INDUSTRY = 'COMPANY_INDUSTRY',
  COMPANY_TYPE = 'COMPANY_TYPE',
  EMPLOYMENT_TYPE = 'EMPLOYMENT_TYPE',
  ID = 'ID',
  LANGUAGE = 'LANGUAGE',
  MANDATORY_SKILL = 'MANDATORY_SKILL',
  MONTHLY_TARGET_SALARY_IN_EUR_FROM = 'MONTHLY_TARGET_SALARY_IN_EUR_FROM',
  MONTHLY_TARGET_SALARY_IN_EUR_TO = 'MONTHLY_TARGET_SALARY_IN_EUR_TO',
  PAID_ADDON_TYPE = 'PAID_ADDON_TYPE',
  POSITION_AREA = 'POSITION_AREA',
  POSITION_COUNTRY = 'POSITION_COUNTRY',
  POSITION_LOCATION = 'POSITION_LOCATION',
  RELOCATION = 'RELOCATION',
  REMOTE = 'REMOTE',
  REMOTE_ALLOWED_AREA = 'REMOTE_ALLOWED_AREA',
  REMOTE_ALLOWED_COUNTRY = 'REMOTE_ALLOWED_COUNTRY',
  REMOTE_ALLOWED_LOCATION = 'REMOTE_ALLOWED_LOCATION',
  REMOTE_AREA = 'REMOTE_AREA',
  REMOTE_COUNTRY = 'REMOTE_COUNTRY',
  REMOTE_LOCATION = 'REMOTE_LOCATION',
  REMOTE_TYPE = 'REMOTE_TYPE',
  SENIORITY = 'SENIORITY',
  SKILL = 'SKILL',
  SOURCE_TYPE = 'SOURCE_TYPE',
  SPECIALITY = 'SPECIALITY',
  STATE = 'STATE',
  VISIBILITY = 'VISIBILITY'
}

export type SearchOpeningEntityTagType = {
  __typename?: 'SearchOpeningEntityTagType';
  tag: SearchOpeningEntityTagNameEnum;
  value?: Maybe<Scalars['SearchTagValue']['output']>;
};

export type SearchUserEntityTagInput = {
  operator?: InputMaybe<SearchEntityTagOperatorEnum>;
  tag: UserSearchEntityTagNameEnum;
  value?: InputMaybe<Scalars['SearchTagValue']['input']>;
};

export type SearchVerifiedUsersPaginationOptionsInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  maxCursor?: InputMaybe<Scalars['String']['input']>;
  minCursor?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<VerifiedUsersSortOptionEnum>;
  sortOrder?: InputMaybe<PaginationSortOrderEnum>;
};

export type SendMessageInput = {
  message: Scalars['String']['input'];
  messageTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type SeniorityType = OpeningCategoryEntityInterface & {
  __typename?: 'SeniorityType';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SignUpInput = {
  companyName: Scalars['String']['input'];
  companySize: Scalars['ID']['input'];
  country: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  googleRecaptchaResponse: Scalars['GoogleRecaptchaResponse']['input'];
  marketingChannel?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  positionTitle: Scalars['String']['input'];
};

export type SignalCountsType = {
  __typename?: 'SignalCountsType';
  total: Scalars['Int']['output'];
  unique: Scalars['Int']['output'];
};

export type SignalEntityInterface = {
  id: Scalars['ID']['output'];
};

export enum SignalEntityTypeEnum {
  LINK = 'LINK',
  OPENING = 'OPENING',
  USER = 'USER',
  USER_VERIFICATION = 'USER_VERIFICATION'
}

export type SignalType = {
  __typename?: 'SignalType';
  createdAt: Scalars['DateTime']['output'];
  entity: SignalEntityInterface;
  id: Scalars['ID']['output'];
  type: SignalTypeEnum;
};

export enum SignalTypeEnum {
  OPEN_LINK = 'OPEN_LINK',
  START_APPLY = 'START_APPLY',
  VERIFIED_TALENT_TERMS_ACCEPTED = 'VERIFIED_TALENT_TERMS_ACCEPTED',
  VIEW_DETAILS = 'VIEW_DETAILS',
  VIEW_FEED_ITEM = 'VIEW_FEED_ITEM',
  VIEW_STORY_ITEM = 'VIEW_STORY_ITEM',
  VIEW_TALENT_ACTIVITY_FEED_USER = 'VIEW_TALENT_ACTIVITY_FEED_USER',
  VIEW_USER_VERIFICATION = 'VIEW_USER_VERIFICATION',
  VIEW_USER_VERIFICATION_LIST_ITEM = 'VIEW_USER_VERIFICATION_LIST_ITEM'
}

export type SimpleNotificationType = NotificationInterface & {
  __typename?: 'SimpleNotificationType';
  icons: NotificationIconType;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt: Scalars['DateTime']['output'];
  type: NotificationTypeEnum;
  url?: Maybe<Scalars['String']['output']>;
};

export type SkillType = OpeningCategoryEntityInterface & {
  __typename?: 'SkillType';
  children: Array<SkillType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  tags: Array<Maybe<Scalars['String']['output']>>;
};

export type SocialMediaInput = {
  source: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SocialMediaType = {
  __typename?: 'SocialMediaType';
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SpecialityType = OpeningCategoryEntityInterface & {
  __typename?: 'SpecialityType';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  skillTags: Array<Maybe<Scalars['String']['output']>>;
  sort: Scalars['Float']['output'];
};

export type StopOpeningInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  messageAdded: MessageType;
  messageThreadUpdated: MessageThreadUpdatedEventType;
  notificationCenterUpdated: Scalars['Boolean']['output'];
  switchedWorkspace: WorkspaceSwitchedResultType;
};


export type SubscriptionMessageAddedArgs = {
  messageThreadId: Scalars['ID']['input'];
};

export type SubscriptionPlanType = PlanTypeInterface & {
  __typename?: 'SubscriptionPlanType';
  currency?: Maybe<CurrencyType>;
  cycle?: Maybe<CustomerSubscriptionCycleEnum>;
  hasOpeningsLimitReached: Scalars['Boolean']['output'];
  nextPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  occupiedOpeningSlots: Scalars['Int']['output'];
  openingActivationPrice?: Maybe<Scalars['Float']['output']>;
  openingRepublishingPrice?: Maybe<Scalars['Float']['output']>;
  openingSlots?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  slotPrice?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<CustomerCalculatedSubscriptionStateEnum>;
  subscriptionStartedAt?: Maybe<Scalars['DateTime']['output']>;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SubscriptionPlanTypeNextPaymentDateArgs = {
  subscriptionCycle?: InputMaybe<CustomerSubscriptionCycleEnum>;
};

export type TalentActivityFeedFilterInput = {
  includeNonVerifiedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  openingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  signals?: InputMaybe<Array<TalentActivityFeedSignalEnum>>;
};

export enum TalentActivityFeedSignalEnum {
  START_APPLY = 'START_APPLY',
  VIEW_DETAILS = 'VIEW_DETAILS'
}

export type TalentActivityStatisticsType = {
  __typename?: 'TalentActivityStatisticsType';
  applications: Scalars['Int']['output'];
  offerViews: Scalars['Int']['output'];
};

export type TalentActivityType = {
  __typename?: 'TalentActivityType';
  signal: SignalType;
  talent: ActivityFeedTalentType;
};

export enum TextFormatEnum {
  HTML = 'HTML',
  MARKDOWN = 'MARKDOWN',
  PLAIN = 'PLAIN'
}

export type UpdateCompanyInput = {
  companyTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featureFlags?: InputMaybe<Array<CompanyFeatureFlagTypeEnum>>;
  industryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isAuthCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLinkInput = {
  image?: InputMaybe<LinkImageInput>;
};

export type UpdateMessageThreadInput = {
  state?: InputMaybe<MessageThreadStateEnum>;
};

export type UpdateRecruiterInput = {
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  positionTitle?: InputMaybe<Scalars['String']['input']>;
};

export enum UserApplicationStateEnum {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type UserApplicationStateType = {
  __typename?: 'UserApplicationStateType';
  createdAt: Scalars['DateTime']['output'];
  state: UserApplicationStateEnum;
};

export enum UserCompanyAssociationTypeEnum {
  WORKED = 'WORKED',
  WORKING = 'WORKING'
}

export type UserMatchingProfileSalaryType = {
  __typename?: 'UserMatchingProfileSalaryType';
  currency?: Maybe<CurrencyType>;
  period?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type UserMatchingProfileType = {
  __typename?: 'UserMatchingProfileType';
  id?: Maybe<Scalars['ID']['output']>;
  salary?: Maybe<UserMatchingProfileSalaryType>;
  seniorities: Array<SeniorityType>;
  skills: Array<SkillType>;
  speciality?: Maybe<SpecialityType>;
};

export type UserPhoneType = {
  __typename?: 'UserPhoneType';
  country?: Maybe<CountryType>;
  number: Scalars['String']['output'];
};

export type UserProfileLinkType = {
  __typename?: 'UserProfileLinkType';
  type: UserProfileLinkTypeEnum;
  value: Scalars['String']['output'];
};

export enum UserProfileLinkTypeEnum {
  BEHANCE = 'BEHANCE',
  BITBUCKET = 'BITBUCKET',
  DRIBBBLE = 'DRIBBBLE',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  LINKEDIN = 'LINKEDIN',
  OTHER = 'OTHER',
  PORTFOLIO = 'PORTFOLIO'
}

export type UserProfileSalaryType = {
  __typename?: 'UserProfileSalaryType';
  currency: CurrencyType;
  period: SalaryPeriodEnum;
  value: Scalars['Float']['output'];
};

export type UserProfileType = {
  __typename?: 'UserProfileType';
  isLocal: Scalars['Boolean']['output'];
  isRelocation: Scalars['Boolean']['output'];
  isRemote: Scalars['Boolean']['output'];
  links: Array<UserProfileLinkType>;
  location: LocationType;
  salary: UserProfileSalaryType;
  seniorities: Array<SeniorityType>;
  skills: Array<SkillType>;
  speciality: SpecialityType;
  workHistory: Array<UserProfileWorkHistoryItemType>;
};


export type UserProfileTypeSalaryArgs = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileWorkHistoryDateType = {
  __typename?: 'UserProfileWorkHistoryDateType';
  day?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type UserProfileWorkHistoryItemType = {
  __typename?: 'UserProfileWorkHistoryItemType';
  company?: Maybe<CompanyType>;
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<UserProfileWorkHistoryDateType>;
  startsAt?: Maybe<UserProfileWorkHistoryDateType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UserSearchEntitySearchParamsInput = {
  groupSearchTagsWithOrCondition?: InputMaybe<Array<SearchUserEntityTagInput>>;
  searchPattern?: InputMaybe<Scalars['String']['input']>;
  searchTagsWithAndCondition?: InputMaybe<Array<SearchUserEntityTagInput>>;
  searchTagsWithNegatedAndCondition?: InputMaybe<Array<SearchUserEntityTagInput>>;
  searchTagsWithOrCondition?: InputMaybe<Array<SearchUserEntityTagInput>>;
};

export enum UserSearchEntityTagNameEnum {
  COUNTRY = 'COUNTRY',
  HAS_VERIFICATION_CHATS = 'HAS_VERIFICATION_CHATS',
  ID = 'ID',
  LOCATION = 'LOCATION',
  NAME = 'NAME',
  ONBOARDED = 'ONBOARDED',
  POSITION = 'POSITION',
  PUSH_ENABLED = 'PUSH_ENABLED',
  RELOCATION = 'RELOCATION',
  REMOTE = 'REMOTE',
  SALARY_CURRENCY = 'SALARY_CURRENCY',
  SALARY_MONTHLY_EUR = 'SALARY_MONTHLY_EUR',
  SALARY_PERIOD = 'SALARY_PERIOD',
  SALARY_VALUE = 'SALARY_VALUE',
  SENIORITY = 'SENIORITY',
  SESSION_STARTED_AT = 'SESSION_STARTED_AT',
  SKILL = 'SKILL',
  SPECIALITY = 'SPECIALITY',
  STATE = 'STATE',
  TIMEZONE = 'TIMEZONE',
  VERIFICATION_BLACKLISTED_COMPANY = 'VERIFICATION_BLACKLISTED_COMPANY',
  VERIFICATION_CANCELLED_AT = 'VERIFICATION_CANCELLED_AT',
  VERIFICATION_PUBLISHED_AT = 'VERIFICATION_PUBLISHED_AT',
  VERIFICATION_STATE = 'VERIFICATION_STATE'
}

export type UserSearchPatternInput = {
  pattern: Scalars['String']['input'];
  tag: UserSearchTagNameEnum;
};

export enum UserSearchTagNameEnum {
  COUNTRY = 'COUNTRY',
  HAS_VERIFICATION_CHATS = 'HAS_VERIFICATION_CHATS',
  LOCATION = 'LOCATION',
  MOTIVATION = 'MOTIVATION',
  NAME = 'NAME',
  ONBOARDED = 'ONBOARDED',
  POSITION = 'POSITION',
  RELOCATION = 'RELOCATION',
  REMOTE = 'REMOTE',
  SALARY_CURRENCY = 'SALARY_CURRENCY',
  SALARY_MONTHLY_EUR = 'SALARY_MONTHLY_EUR',
  SALARY_PERIOD = 'SALARY_PERIOD',
  SALARY_VALUE = 'SALARY_VALUE',
  SENIORITY = 'SENIORITY',
  SKILL = 'SKILL',
  SPECIALITY = 'SPECIALITY',
  STATE = 'STATE',
  TYPE = 'TYPE',
  VERIFICATION_BLACKLISTED_COMPANY = 'VERIFICATION_BLACKLISTED_COMPANY',
  VERIFICATION_STATE = 'VERIFICATION_STATE'
}

export type UserSearchTagType = {
  tag: UserSearchTagNameEnum;
  value: Scalars['SearchTagValue']['input'];
};

export type UserType = ReviewActorEntityInterface & {
  __typename?: 'UserType';
  avatar?: Maybe<MediaImageType>;
  avatarColor?: Maybe<Scalars['String']['output']>;
  averageResponseTimeInMs: Scalars['BigInt']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasBookmarked: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  location?: Maybe<LocationType>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<UserPhoneType>;
  position?: Maybe<Scalars['String']['output']>;
  profile: UserProfileType;
  state: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type UserVerificationPhoneType = {
  __typename?: 'UserVerificationPhoneType';
  country?: Maybe<CountryType>;
  number: Scalars['String']['output'];
};

export enum UserVerificationStateEnum {
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED'
}

export type UserVerificationType = {
  __typename?: 'UserVerificationType';
  achievements?: Maybe<Scalars['String']['output']>;
  canStartIn: JobStartTimeEnum;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  connectedWithCompanies: PaginatedCompaniesType;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  messagedByCompanies: PaginatedCompaniesType;
  phone: UserVerificationPhoneType;
  positionExpectations: Scalars['String']['output'];
  publishedAt: Scalars['DateTime']['output'];
  state: UserVerificationStateEnum;
  summary?: Maybe<Scalars['String']['output']>;
  viewedByCompanies: PaginatedCompaniesType;
  workExperience: Scalars['String']['output'];
};


export type UserVerificationTypeConnectedWithCompaniesArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};


export type UserVerificationTypeMessagedByCompaniesArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};


export type UserVerificationTypeViewedByCompaniesArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};

export type VerifiedUserApplicantType = ApplicantInterface & {
  __typename?: 'VerifiedUserApplicantType';
  application: ApplicationType;
  hasMessaged: Scalars['Boolean']['output'];
  messageThread: MessageThreadType;
  recruiterState: ApplicantRecruiterStateEnum;
  user: UserType;
  userState: ApplicantUserStateEnum;
  userVerification: UserVerificationType;
};

export type VerifiedUserRecruiterStateType = {
  __typename?: 'VerifiedUserRecruiterStateType';
  hasMessaged: Scalars['Boolean']['output'];
  /** @deprecated Unused on the frontend */
  hasSeen: Scalars['Boolean']['output'];
};

export type VerifiedUserType = {
  __typename?: 'VerifiedUserType';
  availableOpeningsForApplication: PaginatedOpeningsType;
  messageThread?: Maybe<MessageThreadType>;
  recruiterState: VerifiedUserRecruiterStateType;
  user: UserType;
  userVerification: UserVerificationType;
  virtualRecruiterActivity: PaginatedApplicantsType;
};


export type VerifiedUserTypeAvailableOpeningsForApplicationArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  searchParams?: InputMaybe<OpeningSearchEntitySearchParamsInput>;
};


export type VerifiedUserTypeVirtualRecruiterActivityArgs = {
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
};

export enum VerifiedUsersSortOptionEnum {
  JOINED_AT = 'JOINED_AT',
  LAST_SEEN = 'LAST_SEEN',
  RELEVANCE = 'RELEVANCE'
}

export enum VideoSourceEnum {
  VIMEO = 'VIMEO',
  YOUTUBE = 'YOUTUBE'
}

export type VideoType = {
  __typename?: 'VideoType';
  embedUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rawUrl: Scalars['String']['output'];
  source: Scalars['String']['output'];
  videoId: Scalars['String']['output'];
};

export type WorkspaceSwitchedResultType = {
  __typename?: 'WorkspaceSwitchedResultType';
  fromCompany: CompanyType;
  toCompany: CompanyType;
};

export type CurrentRecruiterQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentRecruiterQuery = { __typename?: 'Query', currentRecruiter: { __typename?: 'RecruiterType', id: string, availableCompanies: Array<{ __typename?: 'AvailableCompanyType', isCurrent: boolean, isVisible: boolean, company: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string } } }> } };

export type UserFragment = { __typename?: 'UserType', hasBookmarked: boolean };

export type NotificationCenterUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationCenterUpdatedSubscription = { __typename?: 'Subscription', notificationCenterUpdated: boolean };

export type TalentUserFieldsFragment = { __typename?: 'TalentActivityType', signal: { __typename?: 'SignalType', id: string, type: SignalTypeEnum, createdAt: string, entity: { __typename?: 'OpeningType', title?: string | null, id: string } }, talent: { __typename?: 'ActivityFeedTalentType', messageThread?: { __typename?: 'MessageThreadType', id: string } | null, recruiterState: { __typename?: 'ActivityFeedTalentRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, userVerification?: { __typename?: 'UserVerificationType', id: string, positionExpectations: string, workExperience: string, achievements?: string | null, canStartIn: JobStartTimeEnum, publishedAt: string } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, salary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } } } };

export type GetTalentActivityFeedQueryVariables = Exact<{
  filterInput: TalentActivityFeedFilterInput;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type GetTalentActivityFeedQuery = { __typename?: 'Query', talentActivityFeed: { __typename?: 'PaginatedTalentActivityFeedResultType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'TalentActivityType', signal: { __typename?: 'SignalType', id: string, type: SignalTypeEnum, createdAt: string, entity: { __typename?: 'OpeningType', title?: string | null, id: string } }, talent: { __typename?: 'ActivityFeedTalentType', messageThread?: { __typename?: 'MessageThreadType', id: string } | null, recruiterState: { __typename?: 'ActivityFeedTalentRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, userVerification?: { __typename?: 'UserVerificationType', id: string, positionExpectations: string, workExperience: string, achievements?: string | null, canStartIn: JobStartTimeEnum, publishedAt: string } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, salary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } } } }> } };

export type GetTalentActivityStatisticsQueryVariables = Exact<{
  filterInput: TalentActivityFeedFilterInput;
}>;


export type GetTalentActivityStatisticsQuery = { __typename?: 'Query', talentActivityStatistics: { __typename?: 'TalentActivityStatisticsType', offerViews: number, applications: number } };

export type AcceptApplicationMutationVariables = Exact<{
  userMatchingProfileId: Scalars['String']['input'];
  openingId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type AcceptApplicationMutation = { __typename?: 'Mutation', acceptApplication: { __typename?: 'ApplicationType', id: string, user: { __typename?: 'UserType', id: string, name?: string | null, avatarColor?: string | null }, messageThread?: { __typename?: 'MessageThreadType', id: string, userState: MessageThreadStateEnum, recruiterState: MessageThreadStateEnum } | null, recruiterState?: { __typename?: 'RecruiterApplicationStateType', state: RecruiterApplicationStateEnum } | null } };

export type RejectApplicationMutationVariables = Exact<{
  userMatchingProfileId: Scalars['String']['input'];
  openingId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectApplicationMutation = { __typename?: 'Mutation', rejectApplication: { __typename?: 'ApplicationType', id: string, user: { __typename?: 'UserType', id: string, name?: string | null, avatarColor?: string | null }, messageThread?: { __typename?: 'MessageThreadType', id: string, userState: MessageThreadStateEnum, recruiterState: MessageThreadStateEnum } | null, recruiterState?: { __typename?: 'RecruiterApplicationStateType', state: RecruiterApplicationStateEnum } | null } };

export type GetOpeningCandidateProfileApplicationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  messagesPaginationOptions?: InputMaybe<PaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetOpeningCandidateProfileApplicationQuery = { __typename?: 'Query', application: { __typename?: 'ApplicationType', id: string, userState?: { __typename?: 'UserApplicationStateType', createdAt: string, state: UserApplicationStateEnum } | null, recruiterState?: { __typename?: 'RecruiterApplicationStateType', createdAt: string, state: RecruiterApplicationStateEnum } | null, user: { __typename?: 'UserType', id: string, name?: string | null, avatarColor?: string | null, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null }, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null }, messageThread?: { __typename?: 'MessageThreadType', id: string, type: MessageThreadTypeEnum, userState: MessageThreadStateEnum, recruiterState: MessageThreadStateEnum, latestMessageSentAt?: string | null, isUnread: boolean, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, application?: { __typename?: 'ApplicationType', id: string, recruiterState?: { __typename?: 'RecruiterApplicationStateType', createdAt: string, state: RecruiterApplicationStateEnum } | null, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null } } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }>, location: { __typename?: 'LocationType', id: string, shortName: string }, speciality: { __typename?: 'SpecialityType', id: string, name: string, skillTags: Array<string | null> }, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, skills: Array<{ __typename?: 'SkillType', id: string, name: string, tags: Array<string | null> }> } }, messages: { __typename?: 'PaginatedMessagesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'MessageType', id: string, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null, sender: MessageSenderEnum, recruiter?: { __typename?: 'RecruiterType', id: string, fullName?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } | null } | null> } } | null } };

export type ApplicationForCandidateProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApplicationForCandidateProfileQuery = { __typename?: 'Query', application: { __typename?: 'ApplicationType', id: string, user: { __typename?: 'UserType', id: string, name?: string | null, avatarColor?: string | null }, messageThread?: { __typename?: 'MessageThreadType', id: string, userState: MessageThreadStateEnum, recruiterState: MessageThreadStateEnum } | null, recruiterState?: { __typename?: 'RecruiterApplicationStateType', createdAt: string, state: RecruiterApplicationStateEnum } | null, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null, speciality?: { __typename?: 'SpecialityType', id: string, key: string } | null } } };

export type ApplicationForCandidateProfileDataItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApplicationForCandidateProfileDataItemsQuery = { __typename?: 'Query', application: { __typename?: 'ApplicationType', id: string, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null, speciality?: { __typename?: 'SpecialityType', id: string, name: string, skillTags: Array<string | null> } | null, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, salary?: { __typename?: 'UserMatchingProfileSalaryType', value?: number | null, period?: string | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | null, skills: Array<{ __typename?: 'SkillType', id: string, name: string, tags: Array<string | null> }> } } };

export type ApplicationForCandidateProfileHeaderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApplicationForCandidateProfileHeaderQuery = { __typename?: 'Query', application: { __typename?: 'ApplicationType', id: string, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, location?: { __typename?: 'LocationType', id: string, shortName: string } | null, profile: { __typename?: 'UserProfileType', links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } }, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null } } };

export type GetTaModalApplicantQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  openingId: Scalars['ID']['input'];
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetTaModalApplicantQuery = { __typename?: 'Query', applicant: { __typename?: 'OpeningApplicantType', user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, lastSeenAt: string, averageResponseTimeInMs: any, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } } } | { __typename?: 'VerifiedUserApplicantType', user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, lastSeenAt: string, averageResponseTimeInMs: any, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } } } };

export type SignUpMutationVariables = Exact<{
  signUpInput: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: boolean };

export type LoginMutationVariables = Exact<{
  loginInput: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: LoginState };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type RequestAuthCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestAuthCodeMutation = { __typename?: 'Mutation', requestAuthCode: boolean };

export type VerifyAuthCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyAuthCodeMutation = { __typename?: 'Mutation', verifyAuthCode: boolean };

export type RequestPasswordResetMutationVariables = Exact<{
  requestInput: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: boolean };

export type ResetPasswordMutationVariables = Exact<{
  resetInput: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type GetAutoCompleteUsersSearchPatternNoPaginationQueryVariables = Exact<{
  searchPattern?: InputMaybe<Scalars['String']['input']>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type GetAutoCompleteUsersSearchPatternNoPaginationQuery = { __typename?: 'Query', autoCompleteUsersSearchPattern: { __typename?: 'PaginatedAutoCompleteUsersSearchPatternType', result: Array<string> } };

export type SaveBookmarkMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  type: BookmarkTypeEnum;
}>;


export type SaveBookmarkMutation = { __typename?: 'Mutation', saveBookmark: { __typename?: 'BookmarkOpeningType', id: string } | { __typename?: 'BookmarkUserType', id: string, user: { __typename?: 'UserType', id: string, hasBookmarked: boolean } } };

export type RemoveBookmarkMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  type: BookmarkTypeEnum;
}>;


export type RemoveBookmarkMutation = { __typename?: 'Mutation', removeBookmark: boolean };

export type GetBookmarksQueryVariables = Exact<{
  type: BookmarkTypeEnum;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type GetBookmarksQuery = { __typename?: 'Query', bookmarks: { __typename?: 'PaginatedBookmarksType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'BookmarkOpeningType', id: string } | { __typename?: 'BookmarkUserType', id: string, user: { __typename?: 'UserType', id: string } }> } };

export type CompanyRatingsFragmentFragment = { __typename?: 'CompanyRatingsType', companyCulture: number, compensationBenefits: number, management: number, product: number, workLifeBalance: number, total: number };

export type CompanyReviewRatingsFragmentFragment = { __typename?: 'CompanyRatingReviewRatingsType', companyCulture: number, compensationBenefits: number, management: number, product: number, workLifeBalance: number, total: number };

export type ReviewActorFragmentFragment = { __typename?: 'ReviewActorType', type: ReviewActorEnum, entity: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, location?: { __typename?: 'LocationType', id: string, shortName: string } | null } };

export type UpdateCompanyMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  updateInput: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyType', id: string, featureFlags: Array<CompanyFeatureFlagTypeEnum> } };

export type PublishCompanyProfileForPublicProfileMutationVariables = Exact<{
  profileId: Scalars['String']['input'];
}>;


export type PublishCompanyProfileForPublicProfileMutation = { __typename?: 'Mutation', companyProfile: { __typename?: 'CompanyProfileType', id: string, isPublished: boolean, isComplete?: boolean | null, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } };

export type SaveCompanyProfileMutationVariables = Exact<{
  profileId: Scalars['String']['input'];
  changes: SaveCompanyProfileInput;
}>;


export type SaveCompanyProfileMutation = { __typename?: 'Mutation', saveCompanyProfile: { __typename?: 'CompanyProfileType', id: string, name: string, missionStatement?: string | null, founded?: number | null, serviceDescription?: string | null, officeDescription?: string | null, marketsDescription?: string | null, clientsDescription?: string | null, isPublished: boolean, isComplete?: boolean | null, completeness: number, latestFunding?: { __typename?: 'CompanyProfileFundingType', value: any, round: CompanyProfileFundingRoundTypeEnum, fundedAt: string, currency: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } } | null, video?: { __typename?: 'VideoType', videoId: string, rawUrl: string, embedUrl: string, source: string } | null } };

export type UpdateCompanyAuthCodeToggleMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  updateInput: UpdateCompanyInput;
}>;


export type UpdateCompanyAuthCodeToggleMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyType', id: string, isAuthCodeRequired: boolean } };

export type ReplyToReviewMutationVariables = Exact<{
  reviewId: Scalars['ID']['input'];
  replyToReviewInput: ReplyToReviewInput;
}>;


export type ReplyToReviewMutation = { __typename?: 'Mutation', replyToReview: { __typename?: 'CompanyRatingReviewType', id: string, reply?: { __typename?: 'ReviewReplyType', comment: string, repliedBy: { __typename?: 'RecruiterType', id: string, fullName?: string | null, title?: string | null, availableCompanies: Array<{ __typename?: 'AvailableCompanyType', isCurrent: boolean, company: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } }> } } | null } | { __typename?: 'CompanyReviewType', id: string, reply?: { __typename?: 'ReviewReplyType', comment: string, repliedBy: { __typename?: 'RecruiterType', id: string, fullName?: string | null, title?: string | null, availableCompanies: Array<{ __typename?: 'AvailableCompanyType', isCurrent: boolean, company: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } }> } } | null } };

export type RelocationBenefitsQueryVariables = Exact<{ [key: string]: never; }>;


export type RelocationBenefitsQuery = { __typename?: 'Query', relocationBenefits: Array<{ __typename?: 'RelocationBenefitType', id: string, key: string, value: string }> };

export type TeamMembersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamMembersQueryQuery = { __typename?: 'Query', company: { __typename?: 'CompanyType', id: string, teamMembers: Array<{ __typename?: 'RecruiterType', id: string, nameInitials?: string | null, fullName?: string | null, avatar?: { __typename?: 'ImageType', id: string, fullUrl: string } | null }> } };

export type CompanyReviewsQueryVariables = Exact<{
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type CompanyReviewsQuery = { __typename?: 'Query', company: { __typename?: 'CompanyType', id: string, ratings: { __typename?: 'CompanyRatingsType', companyCulture: number, compensationBenefits: number, management: number, product: number, workLifeBalance: number, total: number }, reviews: { __typename?: 'PaginatedReviewsType', pagination: { __typename?: 'PaginationInfoType', minCursor?: string | null, maxCursor?: string | null, limit?: number | null, hasMoreResults: boolean, totalCount: number }, result: Array<{ __typename?: 'CompanyRatingReviewType', userAssociation?: UserCompanyAssociationTypeEnum | null, positiveFeedback?: string | null, negativeFeedback?: string | null, title?: string | null, isAnonymous?: boolean | null, id: string, createdAt: string, type: ReviewTypeEnum, ratings: { __typename?: 'CompanyRatingReviewRatingsType', companyCulture: number, compensationBenefits: number, management: number, product: number, workLifeBalance: number, total: number }, actor: { __typename?: 'ReviewActorType', type: ReviewActorEnum, entity: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, location?: { __typename?: 'LocationType', id: string, shortName: string } | null } }, reply?: { __typename?: 'ReviewReplyType', comment: string, repliedBy: { __typename?: 'RecruiterType', id: string, fullName?: string | null, title?: string | null, availableCompanies: Array<{ __typename?: 'AvailableCompanyType', isCurrent: boolean, company: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } }> } } | null } | { __typename?: 'CompanyReviewType', comment?: string | null, id: string, createdAt: string, type: ReviewTypeEnum, userAssociations: Array<UserCompanyAssociationTypeEnum>, actor: { __typename?: 'ReviewActorType', type: ReviewActorEnum, entity: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, location?: { __typename?: 'LocationType', id: string, shortName: string } | null } }, reply?: { __typename?: 'ReviewReplyType', comment: string, repliedBy: { __typename?: 'RecruiterType', id: string, fullName?: string | null, title?: string | null, availableCompanies: Array<{ __typename?: 'AvailableCompanyType', isCurrent: boolean, company: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } }> } } | null }> } } };

export type CompanyNameQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyNameQuery = { __typename?: 'Query', company: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string } } };

export type CompanyByProfileQueryVariables = Exact<{
  companyProfileId: Scalars['String']['input'];
}>;


export type CompanyByProfileQuery = { __typename?: 'Query', company: { __typename?: 'CompanyType', id: string, featureFlags: Array<CompanyFeatureFlagTypeEnum>, hasPublishedProfile: boolean, companyTypes: Array<{ __typename?: 'CompanyType', id: string, name: string }>, industries: Array<{ __typename?: 'IndustryType', id: string, name: string }>, profile: { __typename?: 'CompanyProfileType', id: string, state: CompanyProfileStateEnum, name: string, missionStatement?: string | null, serviceDescription?: string | null, officeDescription?: string | null, marketsDescription?: string | null, clientsDescription?: string | null, isPublished: boolean, isComplete?: boolean | null, completeness: number, founded?: number | null, funding?: { __typename?: 'CompanyFundingType', id: string, value: string } | null, latestFunding?: { __typename?: 'CompanyProfileFundingType', value: any, round: CompanyProfileFundingRoundTypeEnum, fundedAt: string, currency: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } } | null, video?: { __typename?: 'VideoType', id: string, videoId: string, rawUrl: string, embedUrl: string, source: string } | null, revenue?: { __typename?: 'CompanyRevenueType', id: string, value: string } | null, locations: Array<{ __typename?: 'LocationType', id: string, description: string, longName: string, shortName: string, placeId: string, main: string }>, marketAreas: Array<{ __typename?: 'AreaType', id: string, type: string, longName: string }>, marketCountries: Array<{ __typename?: 'CountryType', id: string, longName: string, continent: { __typename?: 'AreaType', id: string, longName: string } }>, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null, headerImage?: { __typename?: 'ImageType', id: string, fullUrl: string } | null, productImages: Array<{ __typename?: 'ImageType', id: string, fullUrl: string }>, officeVideo?: { __typename?: 'VideoType', id: string, rawUrl: string, source: string } | null, officeImages: Array<{ __typename?: 'ImageType', id: string, fullUrl: string }>, companySize?: { __typename?: 'CompanySizeType', id: string, name: string } | null, benefits: Array<{ __typename?: 'CompanyBenefitType', id: string, key: string, value: string }>, clients: Array<{ __typename?: 'CompanyClientType', id: string, name?: string | null, logo: { __typename?: 'ImageType', id: string, fullUrl: string } }>, socialMedia: Array<{ __typename?: 'SocialMediaType', source: string, url: string }>, media: Array<{ __typename?: 'LinkType', id: string, title?: string | null, url: string, siteName?: string | null, image?: { __typename?: 'LinkImageType', url?: string | null, width?: number | null, height?: number | null } | null }> } } };

export type CompanyQueryVariables = Exact<{
  companyProfileState?: InputMaybe<CompanyProfileStateEnum>;
}>;


export type CompanyQuery = { __typename?: 'Query', company: { __typename?: 'CompanyType', id: string, featureFlags: Array<CompanyFeatureFlagTypeEnum>, hasPublishedProfile: boolean, companyTypes: Array<{ __typename?: 'CompanyType', id: string, name: string }>, industries: Array<{ __typename?: 'IndustryType', id: string, name: string }>, profile?: { __typename?: 'CompanyProfileType', id: string, state: CompanyProfileStateEnum, name: string, missionStatement?: string | null, serviceDescription?: string | null, officeDescription?: string | null, marketsDescription?: string | null, clientsDescription?: string | null, isPublished: boolean, isComplete?: boolean | null, completeness: number, founded?: number | null, funding?: { __typename?: 'CompanyFundingType', id: string, value: string } | null, video?: { __typename?: 'VideoType', id: string, videoId: string, rawUrl: string, embedUrl: string, source: string } | null, revenue?: { __typename?: 'CompanyRevenueType', id: string, value: string } | null, locations: Array<{ __typename?: 'LocationType', id: string, description: string, shortName: string, longName: string, placeId: string, main: string }>, marketAreas: Array<{ __typename?: 'AreaType', id: string, type: string, longName: string }>, marketCountries: Array<{ __typename?: 'CountryType', id: string, longName: string, continent: { __typename?: 'AreaType', id: string, longName: string } }>, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null, headerImage?: { __typename?: 'ImageType', id: string, fullUrl: string } | null, productImages: Array<{ __typename?: 'ImageType', id: string, fullUrl: string }>, officeVideo?: { __typename?: 'VideoType', id: string, rawUrl: string, source: string } | null, officeImages: Array<{ __typename?: 'ImageType', id: string, fullUrl: string }>, companySize?: { __typename?: 'CompanySizeType', id: string, name: string } | null, benefits: Array<{ __typename?: 'CompanyBenefitType', id: string, key: string, value: string }>, clients: Array<{ __typename?: 'CompanyClientType', id: string, name?: string | null, logo: { __typename?: 'ImageType', id: string, fullUrl: string } }>, socialMedia: Array<{ __typename?: 'SocialMediaType', source: string, url: string }>, media: Array<{ __typename?: 'LinkType', id: string, title?: string | null, url: string, siteName?: string | null, image?: { __typename?: 'LinkImageType', url?: string | null, width?: number | null, height?: number | null } | null }> } | null } };

export type CompanyPublicProfileListDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyPublicProfileListDataQuery = { __typename?: 'Query', companyBenefits: Array<{ __typename?: 'CompanyBenefitType', id: string, key: string, value: string }>, companyTypes: Array<{ __typename?: 'CompanyTypeType', id: string, key: string, name: string } | null>, companySizes: Array<{ __typename?: 'CompanySizeType', id: string, name: string, min: number, max?: number | null } | null>, companyFundings: Array<{ __typename?: 'CompanyFundingType', id: string, key: string, value: string, min: number, max: number } | null>, companyRevenues: Array<{ __typename?: 'CompanyRevenueType', id: string, key: string, value: string, min: number, max?: number | null } | null> };

export type CompanySizesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanySizesQuery = { __typename?: 'Query', companySizes: Array<{ __typename?: 'CompanySizeType', id: string, name: string, min: number, max?: number | null } | null> };

export type CompanyTeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyTeamMembersQuery = { __typename?: 'Query', company: { __typename?: 'CompanyType', id: string, teamMembers: Array<{ __typename?: 'RecruiterType', id: string, fullName?: string | null, email?: string | null, avatarUrl?: string | null, avatarColor?: string | null, nameInitials?: string | null, lastSeen?: string | null, role: RecruiterRoleEnum }> } };

export type CompanyAuthCodeToggleQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyAuthCodeToggleQuery = { __typename?: 'Query', company: { __typename?: 'CompanyType', id: string, isAuthCodeRequired: boolean } };

export type GetRecentlySeenCompaniesQueryVariables = Exact<{
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type GetRecentlySeenCompaniesQuery = { __typename?: 'Query', recentlySeenCompanies: { __typename?: 'PaginatedCompaniesType', pagination: { __typename?: 'PaginationInfoType', minCursor?: string | null, maxCursor?: string | null, limit?: number | null, hasMoreResults: boolean, totalCount: number }, result: Array<{ __typename?: 'CompanyType', id: string, lastSeen: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null, offices: Array<{ __typename?: 'CompanyProfileOfficeType', isFoundingLocation: boolean, isHeadquarter: boolean, location: { __typename?: 'LocationType', id: string, shortName: string } }> } } | null> } };

export type AvailableCurrenciesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableCurrenciesQueryQuery = { __typename?: 'Query', availableCurrencies?: Array<{ __typename?: 'CurrencyType', id: string, code: string, symbol: string }> | null };

export type CustomerForActivateSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerForActivateSubscriptionQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, isPayByInvoiceEnabled?: boolean | null, paysByInvoice?: boolean | null, paymentMethods?: Array<{ __typename?: 'BraintreePaymentMethodType', id: string }> | null, planInfo?: { __typename?: 'EnterprisePlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | { __typename?: 'FreemiumPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | { __typename?: 'LegacyPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | { __typename?: 'SubscriptionPlanType', trialEndsAt?: string | null, state?: CustomerCalculatedSubscriptionStateEnum | null, occupiedOpeningSlots: number, hasOpeningsLimitReached: boolean, nextPaymentDate?: string | null, price?: number | null, nextPaymentDateMonthly?: string | null, nextPaymentDateHalfYearly?: string | null, nextPaymentDateYearly?: string | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | null } };

export type PublishOpeningDataQueryVariables = Exact<{ [key: string]: never; }>;


export type PublishOpeningDataQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, planInfo?: { __typename?: 'EnterprisePlanType' } | { __typename?: 'FreemiumPlanType' } | { __typename?: 'LegacyPlanType' } | { __typename?: 'SubscriptionPlanType', openingActivationPrice?: number | null, nextPaymentDate?: string | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | null } };

export type RepublishOpeningDataQueryVariables = Exact<{ [key: string]: never; }>;


export type RepublishOpeningDataQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, planInfo?: { __typename?: 'EnterprisePlanType' } | { __typename?: 'FreemiumPlanType' } | { __typename?: 'LegacyPlanType' } | { __typename?: 'SubscriptionPlanType', openingRepublishingPrice?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | null } };

export type CustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, hidePaymentDetails?: boolean | null, hidePricingDetails?: boolean | null, planInfo?: { __typename?: 'EnterprisePlanType' } | { __typename?: 'FreemiumPlanType' } | { __typename?: 'LegacyPlanType' } | { __typename?: 'SubscriptionPlanType', state?: CustomerCalculatedSubscriptionStateEnum | null, hasOpeningsLimitReached: boolean } | null } };

export type CustomerForTrialsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerForTrialsQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string, planInfo?: { __typename?: 'EnterprisePlanType' } | { __typename?: 'FreemiumPlanType' } | { __typename?: 'LegacyPlanType' } | { __typename?: 'SubscriptionPlanType', trialEndsAt?: string | null } | null } };

export type CustomerForBillingHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerForBillingHistoryQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string } };

export type CustomerForCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerForCardsQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string, paysByInvoice?: boolean | null, paymentMethods?: Array<{ __typename?: 'BraintreePaymentMethodType', id: string, type: string, default: boolean, last4: string, masked: string, imageUrl: string }> | null } };

export type UploadMediaMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  width: Scalars['Int']['input'];
  height: Scalars['Int']['input'];
}>;


export type UploadMediaMutation = { __typename?: 'Mutation', uploadImage: { __typename?: 'ImageType', id: string, fullUrl: string } };

export type IndustriesQueryVariables = Exact<{ [key: string]: never; }>;


export type IndustriesQuery = { __typename?: 'Query', industries: Array<{ __typename?: 'IndustryType', id: string, name: string } | null> };

export type IpDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type IpDetailsQuery = { __typename?: 'Query', ipDetails: { __typename?: 'IpDetailsType', isRealUser: boolean } };

export type SaveLinkForCompanyProfileMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveLinkForCompanyProfileMutation = { __typename?: 'Mutation', saveLink: { __typename?: 'LinkType', id: string, type?: LinkTypeEnum | null, url: string, title?: string | null, description?: string | null, siteName?: string | null, image?: { __typename?: 'LinkImageType', url?: string | null, width?: number | null, height?: number | null } | null } };

export type CreateMessageTemplateMutationMutationVariables = Exact<{
  createInput: CreateMessageTemplateInput;
}>;


export type CreateMessageTemplateMutationMutation = { __typename?: 'Mutation', createMessageTemplate: { __typename?: 'MessageTemplateType', id: string, message: string } };

export type InboxMessageThreadMessagesItemFragment = { __typename?: 'MessageType', id: string, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null, sender: MessageSenderEnum, recruiter?: { __typename?: 'RecruiterType', id: string, fullName?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } | null };

export type InboxMessageThreadListItemFragment = { __typename?: 'MessageThreadType', id: string, latestMessageSentAt?: string | null, isUnread: boolean, recruiterState: MessageThreadStateEnum, userState: MessageThreadStateEnum, application?: { __typename?: 'ApplicationType', id: string } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null }, recruiter: { __typename?: 'RecruiterType', id: string }, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, messages: { __typename?: 'PaginatedMessagesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'MessageType', id: string, sender: MessageSenderEnum, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null } | null> } };

export type InboxMessageThreadFragment = { __typename?: 'MessageThreadType', id: string, type: MessageThreadTypeEnum, userState: MessageThreadStateEnum, recruiterState: MessageThreadStateEnum, latestMessageSentAt?: string | null, isUnread: boolean, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, application?: { __typename?: 'ApplicationType', id: string, recruiterState?: { __typename?: 'RecruiterApplicationStateType', createdAt: string, state: RecruiterApplicationStateEnum } | null, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null } } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }>, location: { __typename?: 'LocationType', id: string, shortName: string }, speciality: { __typename?: 'SpecialityType', id: string, name: string, skillTags: Array<string | null> }, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, skills: Array<{ __typename?: 'SkillType', id: string, name: string, tags: Array<string | null> }> } }, messages: { __typename?: 'PaginatedMessagesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'MessageType', id: string, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null, sender: MessageSenderEnum, recruiter?: { __typename?: 'RecruiterType', id: string, fullName?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } | null } | null> } };

export type MarkInboxMessageThreadAsUnreadMutationVariables = Exact<{
  messageThreadId: Scalars['ID']['input'];
}>;


export type MarkInboxMessageThreadAsUnreadMutation = { __typename?: 'Mutation', markMessageThreadAsUnread: { __typename?: 'MessageThreadType', id: string, latestMessageSentAt?: string | null, isUnread: boolean, recruiterState: MessageThreadStateEnum, userState: MessageThreadStateEnum, application?: { __typename?: 'ApplicationType', id: string } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null }, recruiter: { __typename?: 'RecruiterType', id: string }, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, messages: { __typename?: 'PaginatedMessagesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'MessageType', id: string, sender: MessageSenderEnum, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null } | null> } } };

export type UpdateInboxMessageThreadMutationVariables = Exact<{
  messageThreadId: Scalars['ID']['input'];
  updateInput: UpdateMessageThreadInput;
}>;


export type UpdateInboxMessageThreadMutation = { __typename?: 'Mutation', updateMessageThread: { __typename?: 'MessageThreadType', id: string, latestMessageSentAt?: string | null, isUnread: boolean, recruiterState: MessageThreadStateEnum, userState: MessageThreadStateEnum, application?: { __typename?: 'ApplicationType', id: string } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null }, recruiter: { __typename?: 'RecruiterType', id: string }, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, messages: { __typename?: 'PaginatedMessagesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'MessageType', id: string, sender: MessageSenderEnum, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null } | null> } } };

export type SendInboxMessageMutationVariables = Exact<{
  messageThreadId: Scalars['ID']['input'];
  messageInput: SendMessageInput;
}>;


export type SendInboxMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'MessageThreadType', id: string, latestMessageSentAt?: string | null, isUnread: boolean, recruiterState: MessageThreadStateEnum, userState: MessageThreadStateEnum, application?: { __typename?: 'ApplicationType', id: string } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null }, recruiter: { __typename?: 'RecruiterType', id: string }, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, messages: { __typename?: 'PaginatedMessagesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'MessageType', id: string, sender: MessageSenderEnum, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null } | null> } } };

export type MarkInboxMessageThreadAsReadMutationVariables = Exact<{
  messageThreadId: Scalars['ID']['input'];
}>;


export type MarkInboxMessageThreadAsReadMutation = { __typename?: 'Mutation', markMessageThreadAsRead: { __typename?: 'MessageThreadType', id: string, latestMessageSentAt?: string | null, isUnread: boolean, recruiterState: MessageThreadStateEnum, userState: MessageThreadStateEnum, application?: { __typename?: 'ApplicationType', id: string } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null }, recruiter: { __typename?: 'RecruiterType', id: string }, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, messages: { __typename?: 'PaginatedMessagesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'MessageType', id: string, sender: MessageSenderEnum, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null } | null> } } };

export type GetInboxMessageThreadsQueryVariables = Exact<{
  filterInput?: InputMaybe<MessageThreadFilterInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type GetInboxMessageThreadsQuery = { __typename?: 'Query', messageThreads: { __typename?: 'PaginatedMessageThreadsType', pagination: { __typename?: 'PaginationInfoType', minCursor?: string | null, maxCursor?: string | null, totalCount: number, limit?: number | null, hasMoreResults: boolean }, result: Array<{ __typename?: 'MessageThreadType', id: string, latestMessageSentAt?: string | null, isUnread: boolean, recruiterState: MessageThreadStateEnum, userState: MessageThreadStateEnum, application?: { __typename?: 'ApplicationType', id: string } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null }, recruiter: { __typename?: 'RecruiterType', id: string }, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, messages: { __typename?: 'PaginatedMessagesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'MessageType', id: string, sender: MessageSenderEnum, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null } | null> } }> } };

export type GetInboxMessageThreadQueryVariables = Exact<{
  messageThreadId: Scalars['ID']['input'];
  messagesPaginationOptions?: InputMaybe<PaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetInboxMessageThreadQuery = { __typename?: 'Query', messageThread: { __typename?: 'MessageThreadType', id: string, type: MessageThreadTypeEnum, userState: MessageThreadStateEnum, recruiterState: MessageThreadStateEnum, latestMessageSentAt?: string | null, isUnread: boolean, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, application?: { __typename?: 'ApplicationType', id: string, recruiterState?: { __typename?: 'RecruiterApplicationStateType', createdAt: string, state: RecruiterApplicationStateEnum } | null, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null } } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }>, location: { __typename?: 'LocationType', id: string, shortName: string }, speciality: { __typename?: 'SpecialityType', id: string, name: string, skillTags: Array<string | null> }, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, skills: Array<{ __typename?: 'SkillType', id: string, name: string, tags: Array<string | null> }> } }, messages: { __typename?: 'PaginatedMessagesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'MessageType', id: string, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null, sender: MessageSenderEnum, recruiter?: { __typename?: 'RecruiterType', id: string, fullName?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } | null } | null> } } };

export type InboxMessageAddedSubscriptionVariables = Exact<{
  messageThreadId: Scalars['ID']['input'];
}>;


export type InboxMessageAddedSubscription = { __typename?: 'Subscription', messageAdded: { __typename?: 'MessageType', id: string, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null, sender: MessageSenderEnum, recruiter?: { __typename?: 'RecruiterType', id: string, fullName?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } | null } };

export type InboxMessageThreadUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type InboxMessageThreadUpdatedSubscription = { __typename?: 'Subscription', messageThreadUpdated: { __typename?: 'MessageThreadUpdatedEventType', unreadCount: number, updatedMessageThread: { __typename?: 'MessageThreadType', id: string, latestMessageSentAt?: string | null, isUnread: boolean, recruiterState: MessageThreadStateEnum, userState: MessageThreadStateEnum, application?: { __typename?: 'ApplicationType', id: string } | null, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null }, recruiter: { __typename?: 'RecruiterType', id: string }, opening?: { __typename?: 'OpeningType', id: string, title?: string | null } | null, messages: { __typename?: 'PaginatedMessagesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number }, result: Array<{ __typename?: 'MessageType', id: string, sender: MessageSenderEnum, sentAt: string, text: string, readByUserAt?: string | null, readByRecruiterAt?: string | null } | null> } } } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: boolean };

export type MarkNotificationAsReadMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: { __typename?: 'ApplicationNotificationType', id: string, readAt?: string | null } | { __typename?: 'OpeningNotificationType', id: string, readAt?: string | null } | { __typename?: 'SimpleNotificationType', id: string, readAt?: string | null } };

export type MarkNotificationCenterAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkNotificationCenterAsReadMutation = { __typename?: 'Mutation', markNotificationCenterAsRead: boolean };

export type NotificationGroupsQueryVariables = Exact<{
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type NotificationGroupsQuery = { __typename?: 'Query', notificationGroups: { __typename?: 'PaginatedNotificationGroupType', pagination: { __typename?: 'PaginationInfoType', minCursor?: string | null, maxCursor?: string | null, sortOrder: PaginationSortOrderEnum, limit?: number | null, hasMoreResults: boolean }, result: Array<{ __typename?: 'NotificationGroupType', notifications: Array<{ __typename?: 'ApplicationNotificationType', id: string, type: NotificationTypeEnum, message: string, url?: string | null, sentAt: string, readAt?: string | null, application?: { __typename?: 'ApplicationType', opening?: { __typename?: 'OpeningType', id: string } | null } | null, icons: { __typename?: 'NotificationIconType', primary: { __typename?: 'ImageType', id: string, fullUrl: string }, secondary?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | { __typename?: 'OpeningNotificationType', id: string, type: NotificationTypeEnum, message: string, url?: string | null, sentAt: string, readAt?: string | null, opening?: { __typename?: 'OpeningType', id: string } | null, icons: { __typename?: 'NotificationIconType', primary: { __typename?: 'ImageType', id: string, fullUrl: string }, secondary?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | { __typename?: 'SimpleNotificationType', id: string, type: NotificationTypeEnum, message: string, url?: string | null, sentAt: string, readAt?: string | null, icons: { __typename?: 'NotificationIconType', primary: { __typename?: 'ImageType', id: string, fullUrl: string }, secondary?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } }> }> } };

export type CustomerForSubscriptionModalQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerForSubscriptionModalQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, planInfo?: { __typename?: 'EnterprisePlanType' } | { __typename?: 'FreemiumPlanType' } | { __typename?: 'LegacyPlanType' } | { __typename?: 'SubscriptionPlanType', occupiedOpeningSlots: number, openingSlots?: number | null } | null } };

export type NotificationCenterQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationCenterQuery = { __typename?: 'Query', notificationCenter: { __typename?: 'NotificationCenterType', totalNotificationsCount: number, newNotificationsCount: number, unreadNotificationsCount: number, readNotificationsCount: number } };

export type SalaryDistributionDataPointTypeFragment = { __typename?: 'SalaryDistributionDataPointType', percentage: number, count: number, step: number };

export type CandidateUserFieldsFragment = { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isRemote: boolean, isRelocation: boolean, speciality: { __typename?: 'SpecialityType', id: string, name: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }>, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, salary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } };

export type FunnelOpeningFragment = { __typename?: 'OpeningType', id: string, employmentType?: OpeningEmploymentTypeEnum | null, state: OpeningStateEnum, title?: string | null, message?: string | null, depersonalizedMessage?: string | null, comment?: string | null, publicUrl?: string | null, automatedResponse?: string | null, source: OpeningSourceEnum, pitch?: string | null, visibility: OpeningVisibilityEnum, isRemote?: boolean | null, isPublic?: boolean | null, isRelocation?: boolean | null, allowDistribution?: boolean | null, publishedAt?: string | null, targetLocations?: Array<{ __typename?: 'LocationType', id: string, shortName: string, longName: string, placeId: string, coord: Array<number>, country?: { __typename?: 'CountryType', id: string, shortName: string } | null }> | null, positionLocations?: Array<{ __typename?: 'LocationType', id: string, shortName: string, longName: string, placeId: string, coord: Array<number> }> | null, relocationBenefits?: Array<{ __typename?: 'RelocationBenefitType', id: string, key: string, value: string }> | null, speciality?: { __typename?: 'SpecialityType', id: string, name: string, key: string, skillTags: Array<string | null>, sort: number } | null, skills?: Array<{ __typename?: 'OpeningSkillType', isMandatory?: boolean | null, mandatory?: boolean | null, skill: { __typename?: 'SkillType', id: string, name: string, tag?: string | null, tags: Array<string | null> } }> | null, seniorities?: Array<{ __typename?: 'SeniorityType', id: string, name: string, key: string }> | null, workload?: { __typename?: 'OpeningWorkloadType', period?: OpeningWorkloadPeriodEnum | null, hours?: number | null } | null, salaryRange?: { __typename?: 'OpeningSalaryRangeType', from?: number | null, to?: number | null, offerSalary?: number | null, increase?: number | null, period?: SalaryPeriodEnum | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | null, candidateDestination: { __typename?: 'ExternalUrlOpeningCandidateDestinationType', url: string, type: OpeningCandidateDestinationTypeEnum } | { __typename?: 'MeetFrankOpeningCandidateDestinationType', type: OpeningCandidateDestinationTypeEnum }, recruiter?: { __typename?: 'RecruiterType', id: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string } | null, applications: Array<{ __typename?: 'ApplicationType', id: string }>, paidAddons: Array<{ __typename?: 'EmbeddedOpeningPaidAddonType', type: OpeningPaidAddonEnum, priceInEur: number } | null>, interviewQuestions: Array<{ __typename?: 'OpeningInterviewQuestionType', id: string, order: number, question: string }> };

export type RepublishOpeningMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type RepublishOpeningMutation = { __typename?: 'Mutation', republishOpening: { __typename?: 'OpeningType', id: string } };

export type SaveOpeningMutationVariables = Exact<{
  openingInput: OpeningInput;
  openingId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveOpeningMutation = { __typename?: 'Mutation', saveOpening: { __typename?: 'OpeningType', id: string, employmentType?: OpeningEmploymentTypeEnum | null, state: OpeningStateEnum, title?: string | null, message?: string | null, depersonalizedMessage?: string | null, comment?: string | null, publicUrl?: string | null, automatedResponse?: string | null, source: OpeningSourceEnum, pitch?: string | null, visibility: OpeningVisibilityEnum, isRemote?: boolean | null, isPublic?: boolean | null, isRelocation?: boolean | null, allowDistribution?: boolean | null, publishedAt?: string | null, targetLocations?: Array<{ __typename?: 'LocationType', id: string, shortName: string, longName: string, placeId: string, coord: Array<number>, country?: { __typename?: 'CountryType', id: string, shortName: string } | null }> | null, positionLocations?: Array<{ __typename?: 'LocationType', id: string, shortName: string, longName: string, placeId: string, coord: Array<number> }> | null, relocationBenefits?: Array<{ __typename?: 'RelocationBenefitType', id: string, key: string, value: string }> | null, speciality?: { __typename?: 'SpecialityType', id: string, name: string, key: string, skillTags: Array<string | null>, sort: number } | null, skills?: Array<{ __typename?: 'OpeningSkillType', isMandatory?: boolean | null, mandatory?: boolean | null, skill: { __typename?: 'SkillType', id: string, name: string, tag?: string | null, tags: Array<string | null> } }> | null, seniorities?: Array<{ __typename?: 'SeniorityType', id: string, name: string, key: string }> | null, workload?: { __typename?: 'OpeningWorkloadType', period?: OpeningWorkloadPeriodEnum | null, hours?: number | null } | null, salaryRange?: { __typename?: 'OpeningSalaryRangeType', from?: number | null, to?: number | null, offerSalary?: number | null, increase?: number | null, period?: SalaryPeriodEnum | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | null, candidateDestination: { __typename?: 'ExternalUrlOpeningCandidateDestinationType', url: string, type: OpeningCandidateDestinationTypeEnum } | { __typename?: 'MeetFrankOpeningCandidateDestinationType', type: OpeningCandidateDestinationTypeEnum }, recruiter?: { __typename?: 'RecruiterType', id: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string } | null, applications: Array<{ __typename?: 'ApplicationType', id: string }>, paidAddons: Array<{ __typename?: 'EmbeddedOpeningPaidAddonType', type: OpeningPaidAddonEnum, priceInEur: number } | null>, interviewQuestions: Array<{ __typename?: 'OpeningInterviewQuestionType', id: string, order: number, question: string }> } };

export type DuplicateOpeningMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type DuplicateOpeningMutation = { __typename?: 'Mutation', duplicateOpening: { __typename?: 'OpeningType', id: string, state: OpeningStateEnum, source: OpeningSourceEnum, title?: string | null } };

export type PublishOpeningMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type PublishOpeningMutation = { __typename?: 'Mutation', publishOpening: { __typename?: 'OpeningType', id: string, state: OpeningStateEnum, source: OpeningSourceEnum, title?: string | null } };

export type ResumeOpeningMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type ResumeOpeningMutation = { __typename?: 'Mutation', resumeOpening: { __typename?: 'OpeningType', id: string, state: OpeningStateEnum, source: OpeningSourceEnum, title?: string | null } };

export type ArchiveOpeningMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type ArchiveOpeningMutation = { __typename?: 'Mutation', archiveOpening: { __typename?: 'OpeningType', id: string, state: OpeningStateEnum, source: OpeningSourceEnum } };

export type PauseOpeningMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
  pauseOpeningInput: PauseOpeningInput;
}>;


export type PauseOpeningMutation = { __typename?: 'Mutation', pauseOpening: { __typename?: 'OpeningType', id: string, state: OpeningStateEnum, source: OpeningSourceEnum, title?: string | null } };

export type StopOpeningMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
  stopOpeningInput: StopOpeningInput;
}>;


export type StopOpeningMutation = { __typename?: 'Mutation', stopOpening: { __typename?: 'OpeningType', id: string, state: OpeningStateEnum, source: OpeningSourceEnum, title?: string | null } };

export type CreateVerifiedUserApplicantMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  openingId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateVerifiedUserApplicantMutation = { __typename?: 'Mutation', createVerifiedUserApplicant: { __typename?: 'VerifiedUserApplicantType', application: { __typename?: 'ApplicationType', id: string } } };

export type BulkCreateVerifiedUserApplicantsMutationVariables = Exact<{
  bulkCreateInputs: Array<BulkCreateVerifiedUserApplicantsInput> | BulkCreateVerifiedUserApplicantsInput;
}>;


export type BulkCreateVerifiedUserApplicantsMutation = { __typename?: 'Mutation', bulkCreateVerifiedUserApplicants: Array<{ __typename?: 'VerifiedUserApplicantType', application: { __typename?: 'ApplicationType', id: string } }> };

export type RejectVerifiedUserMutationVariables = Exact<{
  openingId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
}>;


export type RejectVerifiedUserMutation = { __typename?: 'Mutation', createVerifiedUserApplicant: { __typename?: 'VerifiedUserApplicantType', application: { __typename?: 'ApplicationType', id: string } } };

export type GenerateOpeningCommentMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type GenerateOpeningCommentMutation = { __typename?: 'Mutation', generateOpeningComment?: string | null };

export type GenerateOpeningMessageMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type GenerateOpeningMessageMutation = { __typename?: 'Mutation', generateOpeningMessage?: string | null };

export type GenerateOpeningAutomatedResponseMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type GenerateOpeningAutomatedResponseMutation = { __typename?: 'Mutation', generateOpeningAutomatedResponse?: string | null };

export type GenerateOpeningPitchMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type GenerateOpeningPitchMutation = { __typename?: 'Mutation', generateOpeningPitch?: string | null };

export type GetOpeningReachQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOpeningReachQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, reach: { __typename?: 'OpeningReachType', local: number, global: number, remote: number } } };

export type OpeningQueryQueryVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type OpeningQueryQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, employmentType?: OpeningEmploymentTypeEnum | null, state: OpeningStateEnum, title?: string | null, message?: string | null, depersonalizedMessage?: string | null, comment?: string | null, publicUrl?: string | null, automatedResponse?: string | null, source: OpeningSourceEnum, pitch?: string | null, visibility: OpeningVisibilityEnum, isRemote?: boolean | null, isPublic?: boolean | null, isRelocation?: boolean | null, allowDistribution?: boolean | null, publishedAt?: string | null, targetLocations?: Array<{ __typename?: 'LocationType', id: string, shortName: string, longName: string, placeId: string, coord: Array<number>, country?: { __typename?: 'CountryType', id: string, shortName: string } | null }> | null, positionLocations?: Array<{ __typename?: 'LocationType', id: string, shortName: string, longName: string, placeId: string, coord: Array<number> }> | null, relocationBenefits?: Array<{ __typename?: 'RelocationBenefitType', id: string, key: string, value: string }> | null, speciality?: { __typename?: 'SpecialityType', id: string, name: string, key: string, skillTags: Array<string | null>, sort: number } | null, skills?: Array<{ __typename?: 'OpeningSkillType', isMandatory?: boolean | null, mandatory?: boolean | null, skill: { __typename?: 'SkillType', id: string, name: string, tag?: string | null, tags: Array<string | null> } }> | null, seniorities?: Array<{ __typename?: 'SeniorityType', id: string, name: string, key: string }> | null, workload?: { __typename?: 'OpeningWorkloadType', period?: OpeningWorkloadPeriodEnum | null, hours?: number | null } | null, salaryRange?: { __typename?: 'OpeningSalaryRangeType', from?: number | null, to?: number | null, offerSalary?: number | null, increase?: number | null, period?: SalaryPeriodEnum | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | null, candidateDestination: { __typename?: 'ExternalUrlOpeningCandidateDestinationType', url: string, type: OpeningCandidateDestinationTypeEnum } | { __typename?: 'MeetFrankOpeningCandidateDestinationType', type: OpeningCandidateDestinationTypeEnum }, recruiter?: { __typename?: 'RecruiterType', id: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string } | null, applications: Array<{ __typename?: 'ApplicationType', id: string }>, paidAddons: Array<{ __typename?: 'EmbeddedOpeningPaidAddonType', type: OpeningPaidAddonEnum, priceInEur: number } | null>, interviewQuestions: Array<{ __typename?: 'OpeningInterviewQuestionType', id: string, order: number, question: string }> } };

export type PostStepOpeningQueryVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type PostStepOpeningQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, comment?: string | null, paidAddons: Array<{ __typename?: 'EmbeddedOpeningPaidAddonType', type: OpeningPaidAddonEnum, priceInEur: number } | null> } };

export type OpeningMarketSalariesQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OpeningMarketSalariesQueryQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, marketSalaries: { __typename?: 'SalaryDistributionType', currency: { __typename?: 'CurrencyType', id: string, code: string, symbol: string }, userSalaries?: Array<{ __typename?: 'SalaryDistributionDataPointType', percentage: number, count: number, step: number }> | null } } };

export type OpeningForConnectButtonQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OpeningForConnectButtonQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, title?: string | null, pitch?: string | null } };

export type OpeningsQueryVariables = Exact<{
  searchTags?: InputMaybe<Array<OpeningSearchTagType> | OpeningSearchTagType>;
  searchPatterns?: InputMaybe<Array<OpeningSearchPatternInput> | OpeningSearchPatternInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  recommendedUsersPagination?: InputMaybe<RecommendedUsersPaginationOptionsInput>;
  recommendedUsersFilter?: InputMaybe<RecommendedUsersFiltersInput>;
}>;


export type OpeningsQuery = { __typename?: 'Query', openings: { __typename?: 'PaginatedOpeningsType', pagination: { __typename?: 'PaginationInfoType', maxCursor?: string | null, totalCount: number, hasMoreResults: boolean }, result: Array<{ __typename?: 'OpeningType', id: string, title?: string | null, state: OpeningStateEnum, employmentType?: OpeningEmploymentTypeEnum | null, publicUrl?: string | null, source: OpeningSourceEnum, visibility: OpeningVisibilityEnum, remote?: { __typename?: 'OpeningRemoteType', type: OpeningRemoteTypeEnum } | null, candidateDestination: { __typename?: 'ExternalUrlOpeningCandidateDestinationType', url: string, type: OpeningCandidateDestinationTypeEnum } | { __typename?: 'MeetFrankOpeningCandidateDestinationType', type: OpeningCandidateDestinationTypeEnum }, speciality?: { __typename?: 'SpecialityType', id: string, name: string } | null, signalCountsByTypes: { __typename?: 'SignalCountsType', total: number }, paidAddons: Array<{ __typename?: 'EmbeddedOpeningPaidAddonType', type: OpeningPaidAddonEnum, priceInEur: number } | null>, recruiter?: { __typename?: 'RecruiterType', id: string, isFrankAgent?: boolean | null, fullName?: string | null, avatar?: { __typename?: 'ImageType', fullUrl: string } | null } | null, pendingApplicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, shortlistApplicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, unreadShortlistApplicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, inConversationApplicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, unreadInConversationApplicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, recommendedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number } } }> } };

export type GetOpeningNamesQueryVariables = Exact<{
  searchTags?: InputMaybe<Array<OpeningSearchTagType> | OpeningSearchTagType>;
  searchPatterns?: InputMaybe<Array<OpeningSearchPatternInput> | OpeningSearchPatternInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type GetOpeningNamesQuery = { __typename?: 'Query', openings: { __typename?: 'PaginatedOpeningsType', pagination: { __typename?: 'PaginationInfoType', maxCursor?: string | null, totalCount: number, hasMoreResults: boolean }, result: Array<{ __typename?: 'OpeningType', id: string, title?: string | null, pitch?: string | null, state: OpeningStateEnum }> } };

export type GetInboxMessagedOpeningsQueryVariables = Exact<{
  recruiterId: Scalars['ID']['input'];
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type GetInboxMessagedOpeningsQuery = { __typename?: 'Query', messagedOpenings: { __typename?: 'PaginatedOpeningsType', result: Array<{ __typename?: 'OpeningType', id: string, title?: string | null, state: OpeningStateEnum }> } };

export type OpeningRecommendedUsersCountQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OpeningRecommendedUsersCountQueryQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', recommendedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } } } };

export type OpeningsCountQueryVariables = Exact<{
  searchTags?: InputMaybe<Array<OpeningSearchTagType> | OpeningSearchTagType>;
}>;


export type OpeningsCountQuery = { __typename?: 'Query', openings: { __typename?: 'PaginatedOpeningsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } } };

export type OpeningOverviewQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OpeningOverviewQueryQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, state: OpeningStateEnum, publicUrl?: string | null, title?: string | null, employmentType?: OpeningEmploymentTypeEnum | null, source: OpeningSourceEnum, isRemote?: boolean | null, isRelocation?: boolean | null, message?: string | null, comment?: string | null, isFeatured: boolean, visibility: OpeningVisibilityEnum, company?: { __typename?: 'CompanyType', id: string, name: string } | null, skills?: Array<{ __typename?: 'OpeningSkillType', skill: { __typename?: 'SkillType', id: string, name: string, tags: Array<string | null> } }> | null, seniorities?: Array<{ __typename?: 'SeniorityType', id: string, name: string }> | null, speciality?: { __typename?: 'SpecialityType', id: string, name: string } | null, targetLocations?: Array<{ __typename?: 'LocationType', id: string, shortName: string }> | null, positionLocations?: Array<{ __typename?: 'LocationType', id: string, shortName: string }> | null, workload?: { __typename?: 'OpeningWorkloadType', period?: OpeningWorkloadPeriodEnum | null, hours?: number | null } | null, salaryRange?: { __typename?: 'OpeningSalaryRangeType', from?: number | null, to?: number | null, period?: SalaryPeriodEnum | null, currency?: { __typename?: 'CurrencyType', id: string, code: string } | null } | null, candidateDestination: { __typename?: 'ExternalUrlOpeningCandidateDestinationType', url: string, type: OpeningCandidateDestinationTypeEnum } | { __typename?: 'MeetFrankOpeningCandidateDestinationType', type: OpeningCandidateDestinationTypeEnum }, recruiter?: { __typename?: 'RecruiterType', id: string, isSiteAdmin?: boolean | null, rights: { __typename?: 'RecruiterRightsType', inviteCollaborator: boolean } } | null, paidAddons: Array<{ __typename?: 'EmbeddedOpeningPaidAddonType', type: OpeningPaidAddonEnum } | null> } };

export type OpeningPotentialCandidatesQueryVariables = Exact<{
  openingId: Scalars['ID']['input'];
  filters?: InputMaybe<RecommendedUsersFiltersInput>;
  paginationOptions?: InputMaybe<RecommendedUsersPaginationOptionsInput>;
}>;


export type OpeningPotentialCandidatesQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, recommendedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isRemote: boolean, isRelocation: boolean, speciality: { __typename?: 'SpecialityType', id: string, name: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }>, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, salary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, positionExpectations: string } }> } } };

export type OpeningActivePotentialCandidatesQueryVariables = Exact<{
  openingId: Scalars['ID']['input'];
}>;


export type OpeningActivePotentialCandidatesQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, title?: string | null, state: OpeningStateEnum, applicantCounts: { __typename?: 'OpeningApplicantCountsType', totalUnanswered: number } } };

export type GetRecentGroupedOpeningTalentsQueryVariables = Exact<{
  openingId: Scalars['ID']['input'];
  excludedUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filters?: InputMaybe<RecommendedUsersFiltersInput>;
  paginationOptions?: InputMaybe<RecommendedUsersPaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetRecentGroupedOpeningTalentsQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, sourcingStatistics: { __typename?: 'OpeningsSourcingStatisticsType', acceptedApplications: number, rejectedApplications: number }, recommendedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string } }> } } };

export type OpeningPotentialCandidatesForSourcePageCarouselQueryVariables = Exact<{
  openingId: Scalars['ID']['input'];
  excludedUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filters?: InputMaybe<RecommendedUsersFiltersInput>;
  paginationOptions?: InputMaybe<RecommendedUsersPaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type OpeningPotentialCandidatesForSourcePageCarouselQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, sourcingStatistics: { __typename?: 'OpeningsSourcingStatisticsType', acceptedApplications: number, rejectedApplications: number }, recommendedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string } }> } } };

export type PublishedOpeningCandidatesQueryVariables = Exact<{
  openingId: Scalars['ID']['input'];
  excludedUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filters?: InputMaybe<RecommendedUsersFiltersInput>;
  paginationOptions?: InputMaybe<RecommendedUsersPaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type PublishedOpeningCandidatesQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, recommendedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string, canStartIn: JobStartTimeEnum } }> } } };

export type OpeningsForTalentActivityFilterQueryVariables = Exact<{
  searchTags?: InputMaybe<Array<OpeningSearchTagType> | OpeningSearchTagType>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type OpeningsForTalentActivityFilterQuery = { __typename?: 'Query', openings: { __typename?: 'PaginatedOpeningsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number, minCursor?: string | null, maxCursor?: string | null, hasMoreResults: boolean }, result: Array<{ __typename?: 'OpeningType', id: string, title?: string | null }> } };

export type GetTaActiveOpeningQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaActiveOpeningQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, state: OpeningStateEnum, title?: string | null, source: OpeningSourceEnum, pitch?: string | null, positionLocations?: Array<{ __typename?: 'LocationType', id: string, shortName: string }> | null, sourcingStatistics: { __typename?: 'OpeningsSourcingStatisticsType', acceptedApplications: number, rejectedApplications: number }, applicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } } } };

export type GetOpeningApplicantCountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOpeningApplicantCountsQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, title?: string | null, pitch?: string | null, state: OpeningStateEnum, pendingApplicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, shortlistApplicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, unreadShortlistApplicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, inConversationApplicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, unreadInConversationApplicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, recommendedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } } } };

export type GetOpeningRecommendedUserCardsQueryVariables = Exact<{
  openingId: Scalars['ID']['input'];
  excludedUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filters?: InputMaybe<RecommendedUsersFiltersInput>;
  paginationOptions?: InputMaybe<RecommendedUsersPaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetOpeningRecommendedUserCardsQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, state: OpeningStateEnum, recommendedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string, canStartIn: JobStartTimeEnum } }> } } };

export type GetOpeningApplicantCardsQueryVariables = Exact<{
  openingId: Scalars['ID']['input'];
  filterInput?: InputMaybe<FilterOpeningApplicantsInput>;
  paginationOptions?: InputMaybe<ApplicantsPaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetOpeningApplicantCardsQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, applicants: { __typename?: 'PaginatedApplicantsType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'OpeningApplicantType', application: { __typename?: 'ApplicationType', id: string, createdAt: string, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null }, messageThread?: { __typename?: 'MessageThreadType', id: string, isUnread: boolean, isInitiatedByMeetFrank: boolean, userState: MessageThreadStateEnum } | null }, user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null }>, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }>, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } } } | { __typename?: 'VerifiedUserApplicantType', userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string }, application: { __typename?: 'ApplicationType', id: string, createdAt: string, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null }, userState?: { __typename?: 'UserApplicationStateType', state: UserApplicationStateEnum, createdAt: string } | null, messageThread?: { __typename?: 'MessageThreadType', id: string, isUnread: boolean, isInitiatedByMeetFrank: boolean, userState: MessageThreadStateEnum } | null }, user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null }>, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }>, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } } }> } } };

export type CreatePaymentMethodMutationMutationVariables = Exact<{
  paymentMethodInput: CreatePaymentMethodInput;
}>;


export type CreatePaymentMethodMutationMutation = { __typename?: 'Mutation', createPaymentMethod?: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, paysByInvoice?: boolean | null, paymentMethods?: Array<{ __typename?: 'BraintreePaymentMethodType', id: string, type: string, default: boolean, last4: string, masked: string, imageUrl: string }> | null, planInfo?: { __typename?: 'EnterprisePlanType', price?: number | null } | { __typename?: 'FreemiumPlanType', price?: number | null } | { __typename?: 'LegacyPlanType', price?: number | null } | { __typename?: 'SubscriptionPlanType', cycle?: CustomerSubscriptionCycleEnum | null, state?: CustomerCalculatedSubscriptionStateEnum | null, trialEndsAt?: string | null, nextPaymentDate?: string | null, price?: number | null } | null } | null };

export type LogCreatePaymentMethodStatusMutationMutationVariables = Exact<{
  status: CreatePaymentMethodStatusEnum;
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogCreatePaymentMethodStatusMutationMutation = { __typename?: 'Mutation', logCreatePaymentMethodStatus?: boolean | null };

export type GetPlacesQueryVariables = Exact<{
  searchPattern?: InputMaybe<Scalars['String']['input']>;
  placeTypes?: InputMaybe<Array<PlaceTypeEnum> | PlaceTypeEnum>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type GetPlacesQuery = { __typename?: 'Query', places: { __typename?: 'PaginatedPlaceType', result: Array<{ __typename?: 'PlaceType', type: PlaceTypeEnum, entity?: { __typename?: 'AreaType', id: string, longName: string } | { __typename?: 'CountryType', id: string, longName: string, shortName: string } | { __typename?: 'LocationType', id: string, longName: string, country?: { __typename?: 'CountryType', id: string, shortName: string } | null } | null }> } };

export type GetGoogleLocationsQueryVariables = Exact<{
  searchPattern: Scalars['String']['input'];
}>;


export type GetGoogleLocationsQuery = { __typename?: 'Query', googleLocations: { __typename?: 'PaginatedLocationType', result: Array<{ __typename?: 'LocationType', id: string, placeId: string, longName: string, shortName: string }> } };

export type GetCountriesQueryVariables = Exact<{
  searchPattern?: InputMaybe<Scalars['String']['input']>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type GetCountriesQuery = { __typename?: 'Query', countries: { __typename?: 'PaginatedCountryType', result: Array<{ __typename?: 'CountryType', id: string, longName: string, shortName: string, dialCode: string }> } };

export type RemoveCollaboratorMutationVariables = Exact<{
  openingId: Scalars['ID']['input'];
  recruiterId: Scalars['ID']['input'];
}>;


export type RemoveCollaboratorMutation = { __typename?: 'Mutation', removeCollaborator: boolean };

export type UpdateRecruiterMutationVariables = Exact<{
  updateInput: UpdateRecruiterInput;
}>;


export type UpdateRecruiterMutation = { __typename?: 'Mutation', updateRecruiter: { __typename?: 'RecruiterType', id: string, fullName?: string | null, phone?: string | null, title?: string | null, isDraft?: boolean | null, avatar?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } };

export type UpdateRecruiterPasswordMutationVariables = Exact<{
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
}>;


export type UpdateRecruiterPasswordMutation = { __typename?: 'Mutation', updateRecruiterPassword?: boolean | null };

export type CurrentRecruiterForProfileFinishQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentRecruiterForProfileFinishQuery = { __typename?: 'Query', currentRecruiter: { __typename?: 'RecruiterType', id: string, fullName?: string | null, email?: string | null, phone?: string | null, title?: string | null, isDraft?: boolean | null, isIncomplete?: boolean | null, country?: { __typename?: 'CountryType', id: string, longName: string, shortName: string } | null } };

export type CurrentRecruiterForEditProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentRecruiterForEditProfileQuery = { __typename?: 'Query', currentRecruiter: { __typename?: 'RecruiterType', id: string, fullName?: string | null, phone?: string | null, title?: string | null, avatar?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } };

export type CurrentRecruiterForOpeningQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentRecruiterForOpeningQuery = { __typename?: 'Query', currentRecruiter: { __typename?: 'RecruiterType', id: string, rights: { __typename?: 'RecruiterRightsType', inviteCollaborator: boolean } } };

export type CollaboratorsForOpeningQueryVariables = Exact<{
  openingId: Scalars['ID']['input'];
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type CollaboratorsForOpeningQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', collaborators: { __typename?: 'PaginatedRecruitersType', result: Array<{ __typename?: 'RecruiterType', id: string, email?: string | null, fullName?: string | null, avatarColor?: string | null }> } } };

export type GetRelocationBenefitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRelocationBenefitsQuery = { __typename?: 'Query', relocationBenefits: Array<{ __typename?: 'RelocationBenefitType', id: string, key: string, value: string }> };

export type GetSalaryPeriodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalaryPeriodsQuery = { __typename?: 'Query', salaryPeriods: Array<{ __typename?: 'SalaryPeriodType', label: string, value: SalaryPeriodEnum }> };

export type SenioritiesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SenioritiesQueryQuery = { __typename?: 'Query', seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string, key: string } | null> };

export type SessionQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionQuery = { __typename?: 'Query', company: { __typename?: 'CompanyType', id: string, name: string, operationsEmail: string, callBookingUrl: string, featureFlags: Array<CompanyFeatureFlagTypeEnum>, profile: { __typename?: 'CompanyProfileType', id: string, name: string, state: CompanyProfileStateEnum, isPublished: boolean, isComplete?: boolean | null, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null, companySize?: { __typename?: 'CompanySizeType', id: string, name: string } | null }, country?: { __typename?: 'CountryType', id: string, longName: string, shortName: string, currency: string, continent: { __typename?: 'AreaType', id: string } } | null }, currentRecruiter: { __typename?: 'RecruiterType', id: string, email?: string | null, phone?: string | null, title?: string | null, fullName?: string | null, firstName?: string | null, lastName?: string | null, nameInitials?: string | null, avatarColor?: string | null, avatarUrl?: string | null, intercomHash: string, lastSeen?: string | null, isSiteAdmin?: boolean | null, isDraft?: boolean | null, isIncomplete?: boolean | null, avatar?: { __typename?: 'ImageType', id: string, fullUrl: string } | null, rights: { __typename?: 'RecruiterRightsType', billing: boolean, inviteTeam: boolean, inviteCollaborator: boolean, openings: boolean, companyProfile: boolean, company: boolean, requests: boolean, toggle2FA: boolean }, availableCompanies: Array<{ __typename?: 'AvailableCompanyType', isDefault: boolean, isCurrent: boolean, isVisible: boolean, company: { __typename?: 'CompanyType', id: string, name: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string } } }>, country?: { __typename?: 'CountryType', id: string, shortName: string, longName: string, currency: string } | null }, customer: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, paysByInvoice?: boolean | null, hidePaymentDetails?: boolean | null, hidePricingDetails?: boolean | null, hasActivePaymentMethod: boolean, planInfo?: { __typename?: 'EnterprisePlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | { __typename?: 'FreemiumPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | { __typename?: 'LegacyPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | { __typename?: 'SubscriptionPlanType', trialEndsAt?: string | null, state?: CustomerCalculatedSubscriptionStateEnum | null, cycle?: CustomerSubscriptionCycleEnum | null, hasOpeningsLimitReached: boolean, occupiedOpeningSlots: number, nextPaymentDate?: string | null, price?: number | null, nextPaymentDateMonthly?: string | null, nextPaymentDateHalfYearly?: string | null, nextPaymentDateYearly?: string | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | null }, subscriptionPlans: Array<{ __typename?: 'CustomerSubscriptionPlanInfoType', name: string, planType: CustomerPlanEnum, openingSlots?: number | null, isAvailable?: boolean | null, variants: Array<{ __typename?: 'CustomerSubscriptionPlanVariantType', cycle?: CustomerSubscriptionCycleEnum | null, price: number, savings: number, freeMonths: number, openingRepublishingPrice?: number | null, currency: string }> }> };

export type RecordSignalsMutationVariables = Exact<{
  signals: Array<RecordSignalInput> | RecordSignalInput;
}>;


export type RecordSignalsMutation = { __typename?: 'Mutation', recordSignals: boolean };

export type GetSpecialitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpecialitiesQuery = { __typename?: 'Query', specialities: Array<{ __typename?: 'SpecialityType', id: string, name: string, key: string, skillTags: Array<string | null>, sort: number }> };

export type ActivateSubscriptionMutationVariables = Exact<{
  planType: CustomerPlanEnum;
  subscriptionCycle: CustomerSubscriptionCycleEnum;
}>;


export type ActivateSubscriptionMutation = { __typename?: 'Mutation', activateSubscription: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, paysByInvoice?: boolean | null, planInfo?: { __typename?: 'EnterprisePlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | { __typename?: 'FreemiumPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | { __typename?: 'LegacyPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | { __typename?: 'SubscriptionPlanType', trialEndsAt?: string | null, state?: CustomerCalculatedSubscriptionStateEnum | null, occupiedOpeningSlots: number, hasOpeningsLimitReached: boolean, nextPaymentDate?: string | null, price?: number | null, nextPaymentDateMonthly?: string | null, nextPaymentDateHalfYearly?: string | null, nextPaymentDateYearly?: string | null, currency?: { __typename?: 'CurrencyType', id: string, code: string, symbol: string } | null } | null } };

export type UpdateInvoicingDetailsMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  invoicingDetailsInput: InvoicingDetailsInput;
}>;


export type UpdateInvoicingDetailsMutation = { __typename?: 'Mutation', updateInvoicingDetails: { __typename?: 'InvoicingDetailsType', id: string, vatId?: string | null, region?: string | null, postalCode?: string | null, city?: string | null, addressLine1?: string | null, businessName?: string | null, countryName?: string | null } };

export type SetTotalSlotsCountMutationVariables = Exact<{
  totalSlotsCount: Scalars['Int']['input'];
}>;


export type SetTotalSlotsCountMutation = { __typename?: 'Mutation', setTotalSlotsCount?: { __typename?: 'CustomerType', id: string, planInfo?: { __typename?: 'EnterprisePlanType' } | { __typename?: 'FreemiumPlanType' } | { __typename?: 'LegacyPlanType' } | { __typename?: 'SubscriptionPlanType', openingSlots?: number | null } | null } | null };

export type UpgradeSubscriptionMutationVariables = Exact<{
  planType: CustomerPlanEnum;
  subscriptionCycle: CustomerSubscriptionCycleEnum;
}>;


export type UpgradeSubscriptionMutation = { __typename?: 'Mutation', upgradeSubscription: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, planInfo?: { __typename?: 'EnterprisePlanType', price?: number | null } | { __typename?: 'FreemiumPlanType', price?: number | null } | { __typename?: 'LegacyPlanType', price?: number | null } | { __typename?: 'SubscriptionPlanType', cycle?: CustomerSubscriptionCycleEnum | null, nextPaymentDate?: string | null, hasOpeningsLimitReached: boolean, occupiedOpeningSlots: number, price?: number | null } | null } };

export type SetDefaultPaymentMethodMutationMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
}>;


export type SetDefaultPaymentMethodMutationMutation = { __typename?: 'Mutation', setDefaultPaymentMethod?: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, paysByInvoice?: boolean | null, paymentMethods?: Array<{ __typename?: 'BraintreePaymentMethodType', id: string, type: string, default: boolean, last4: string, masked: string, imageUrl: string }> | null, planInfo?: { __typename?: 'EnterprisePlanType', price?: number | null } | { __typename?: 'FreemiumPlanType', price?: number | null } | { __typename?: 'LegacyPlanType', price?: number | null } | { __typename?: 'SubscriptionPlanType', cycle?: CustomerSubscriptionCycleEnum | null, state?: CustomerCalculatedSubscriptionStateEnum | null, trialEndsAt?: string | null, nextPaymentDate?: string | null, price?: number | null } | null } | null };

export type RemovePaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, paysByInvoice?: boolean | null, paymentMethods?: Array<{ __typename?: 'BraintreePaymentMethodType', id: string, type: string, default: boolean, last4: string, masked: string, imageUrl: string }> | null, planInfo?: { __typename?: 'EnterprisePlanType', price?: number | null } | { __typename?: 'FreemiumPlanType', price?: number | null } | { __typename?: 'LegacyPlanType', price?: number | null } | { __typename?: 'SubscriptionPlanType', cycle?: CustomerSubscriptionCycleEnum | null, state?: CustomerCalculatedSubscriptionStateEnum | null, trialEndsAt?: string | null, nextPaymentDate?: string | null, price?: number | null } | null } };

export type ActivateSubscriptionForPlansMutationVariables = Exact<{
  planType: CustomerPlanEnum;
  subscriptionCycle: CustomerSubscriptionCycleEnum;
}>;


export type ActivateSubscriptionForPlansMutation = { __typename?: 'Mutation', activateSubscription: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, planInfo?: { __typename?: 'EnterprisePlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | { __typename?: 'FreemiumPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | { __typename?: 'LegacyPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | { __typename?: 'SubscriptionPlanType', trialEndsAt?: string | null, state?: CustomerCalculatedSubscriptionStateEnum | null, cycle?: CustomerSubscriptionCycleEnum | null, hasOpeningsLimitReached: boolean, occupiedOpeningSlots: number, nextPaymentDate?: string | null, price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | null } };

export type SubscriptionAndCurrenciesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionAndCurrenciesQueryQuery = { __typename?: 'Query', subscriptionPlans: Array<{ __typename?: 'CustomerSubscriptionPlanInfoType', name: string, planType: CustomerPlanEnum, openingSlots?: number | null, isAvailable?: boolean | null, variants: Array<{ __typename?: 'CustomerSubscriptionPlanVariantType', openingActivationPrice?: number | null, openingRepublishingPrice?: number | null, cycle?: CustomerSubscriptionCycleEnum | null, price: number, currency: string, openingSlots?: number | null, savings: number, freeMonths: number }> }>, availableCurrencies?: Array<{ __typename?: 'CurrencyType', id: string, code: string, symbol: string }> | null };

export type SetPaymentMethodTypeMutationVariables = Exact<{
  methodType: PaymentMethodTypeEnum;
}>;


export type SetPaymentMethodTypeMutation = { __typename?: 'Mutation', setPaymentMethodType?: boolean | null };

export type InvoicingDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvoicingDetailsQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string }, company: { __typename?: 'CompanyType', id: string, invoicingDetails?: { __typename?: 'InvoicingDetailsType', id: string, vatId?: string | null, region?: string | null, postalCode?: string | null, city?: string | null, addressLine1?: string | null, businessName?: string | null, billingEmail?: string | null, countryName?: string | null } | null } };

export type UpgradeSubscriptionDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UpgradeSubscriptionDataQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, planInfo?: { __typename?: 'EnterprisePlanType' } | { __typename?: 'FreemiumPlanType' } | { __typename?: 'LegacyPlanType' } | { __typename?: 'SubscriptionPlanType', price?: number | null, occupiedOpeningSlots: number, openingSlots?: number | null, slotPrice?: number | null, cycle?: CustomerSubscriptionCycleEnum | null, nextPaymentDate?: string | null, trialEndsAt?: string | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | null }, subscriptionPlans: Array<{ __typename?: 'CustomerSubscriptionPlanInfoType', planType: CustomerPlanEnum, name: string, isAvailable?: boolean | null, variants: Array<{ __typename?: 'CustomerSubscriptionPlanVariantType', cycle?: CustomerSubscriptionCycleEnum | null, price: number, freeMonths: number, savings: number, currency: string, openingActivationPrice?: number | null }> }>, availableCurrencies?: Array<{ __typename?: 'CurrencyType', id: string, code: string, symbol: string }> | null };

export type BillingPricingAndNextPaymentQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingPricingAndNextPaymentQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, planInfo?: { __typename?: 'EnterprisePlanType' } | { __typename?: 'FreemiumPlanType' } | { __typename?: 'LegacyPlanType' } | { __typename?: 'SubscriptionPlanType', cycle?: CustomerSubscriptionCycleEnum | null, nextPaymentDate?: string | null } | null }, subscriptionPlans: Array<{ __typename?: 'CustomerSubscriptionPlanInfoType', planType: CustomerPlanEnum, variants: Array<{ __typename?: 'CustomerSubscriptionPlanVariantType', cycle?: CustomerSubscriptionCycleEnum | null, price: number, currency: string, savings: number }> }>, availableCurrencies?: Array<{ __typename?: 'CurrencyType', id: string, code: string, symbol: string }> | null };

export type BillingSettingsSubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingSettingsSubscriptionPlansQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, planInfo?: { __typename?: 'EnterprisePlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | { __typename?: 'FreemiumPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | { __typename?: 'LegacyPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | { __typename?: 'SubscriptionPlanType', slotPrice?: number | null, openingSlots?: number | null, trialEndsAt?: string | null, state?: CustomerCalculatedSubscriptionStateEnum | null, cycle?: CustomerSubscriptionCycleEnum | null, occupiedOpeningSlots: number, openingActivationPrice?: number | null, nextPaymentDate?: string | null, price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | null }, subscriptionPlans: Array<{ __typename?: 'CustomerSubscriptionPlanInfoType', name: string, planType: CustomerPlanEnum, openingSlots?: number | null, isAvailable?: boolean | null, variants: Array<{ __typename?: 'CustomerSubscriptionPlanVariantType', cycle?: CustomerSubscriptionCycleEnum | null, price: number, currency: string, freeMonths: number }> }>, availableCurrencies?: Array<{ __typename?: 'CurrencyType', id: string, code: string, symbol: string }> | null };

export type CancelTeamInviteMutationVariables = Exact<{
  teamInviteId: Scalars['ID']['input'];
}>;


export type CancelTeamInviteMutation = { __typename?: 'Mutation', cancelTeamInvite: boolean };

export type TaModalUserFragment = { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, lastSeenAt: string, averageResponseTimeInMs: any, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } };

export type VerifiedUserFeedFragment = { __typename?: 'VerifiedUserType', messageThread?: { __typename?: 'MessageThreadType', id: string } | null, recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, userVerification: { __typename?: 'UserVerificationType', id: string, positionExpectations: string, workExperience: string, publishedAt: string }, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, lastSeenAt: string, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } } };

export type VerifiedUserCarouselCardFragment = { __typename?: 'VerifiedUserType', messageThread?: { __typename?: 'MessageThreadType', id: string } | null, recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, userVerification: { __typename?: 'UserVerificationType', id: string, positionExpectations: string, workExperience: string, achievements?: string | null, canStartIn: JobStartTimeEnum, publishedAt: string, cancelledAt?: string | null, state: UserVerificationStateEnum, connectedWithCompanies: { __typename?: 'PaginatedCompaniesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, messagedByCompanies: { __typename?: 'PaginatedCompaniesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } } }, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, lastSeenAt: string, averageResponseTimeInMs: any, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } } };

export type GroupedTalentFragment = { __typename?: 'VerifiedUserType', user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string } };

export type FeaturedTalentCardFragment = { __typename?: 'VerifiedUserType', recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string, canStartIn: JobStartTimeEnum } };

type OpeningApplicantCard_OpeningApplicantType_Fragment = { __typename?: 'OpeningApplicantType', application: { __typename?: 'ApplicationType', id: string, createdAt: string, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null }, messageThread?: { __typename?: 'MessageThreadType', id: string, isUnread: boolean, isInitiatedByMeetFrank: boolean, userState: MessageThreadStateEnum } | null }, user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null }>, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }>, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } } };

type OpeningApplicantCard_VerifiedUserApplicantType_Fragment = { __typename?: 'VerifiedUserApplicantType', userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string }, application: { __typename?: 'ApplicationType', id: string, createdAt: string, userMatchingProfile: { __typename?: 'UserMatchingProfileType', id?: string | null }, userState?: { __typename?: 'UserApplicationStateType', state: UserApplicationStateEnum, createdAt: string } | null, messageThread?: { __typename?: 'MessageThreadType', id: string, isUnread: boolean, isInitiatedByMeetFrank: boolean, userState: MessageThreadStateEnum } | null }, user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null }>, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }>, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } } };

export type OpeningApplicantCardFragment = OpeningApplicantCard_OpeningApplicantType_Fragment | OpeningApplicantCard_VerifiedUserApplicantType_Fragment;

export type GetSearchVerifiedUsersQueryVariables = Exact<{
  searchParams?: InputMaybe<UserSearchEntitySearchParamsInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  sortedPaginationOptions?: InputMaybe<SearchVerifiedUsersPaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetSearchVerifiedUsersQuery = { __typename?: 'Query', searchVerifiedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', messageThread?: { __typename?: 'MessageThreadType', id: string } | null, recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, userVerification: { __typename?: 'UserVerificationType', id: string, positionExpectations: string, workExperience: string, publishedAt: string }, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, lastSeenAt: string, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } } }> } };

export type GetVerifiedUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetVerifiedUserQuery = { __typename?: 'Query', verifiedUser: { __typename?: 'VerifiedUserType', messageThread?: { __typename?: 'MessageThreadType', id: string } | null, recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, userVerification: { __typename?: 'UserVerificationType', id: string, positionExpectations: string, workExperience: string, achievements?: string | null, canStartIn: JobStartTimeEnum, publishedAt: string, cancelledAt?: string | null, state: UserVerificationStateEnum, connectedWithCompanies: { __typename?: 'PaginatedCompaniesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, messagedByCompanies: { __typename?: 'PaginatedCompaniesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } } }, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, lastSeenAt: string, averageResponseTimeInMs: any, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } } } };

export type GetVerifiedUserAvailableOpeningsForApplicationQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  openingSearchParams?: InputMaybe<OpeningSearchEntitySearchParamsInput>;
  openingPaginationOptions?: InputMaybe<PaginationOptionsInput>;
}>;


export type GetVerifiedUserAvailableOpeningsForApplicationQuery = { __typename?: 'Query', verifiedUser: { __typename?: 'VerifiedUserType', user: { __typename?: 'UserType', id: string }, availableOpeningsForApplication: { __typename?: 'PaginatedOpeningsType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'OpeningType', id: string, title?: string | null, publishedAt?: string | null, pitch?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, positionLocations?: Array<{ __typename?: 'LocationType', id: string, shortName: string, country?: { __typename?: 'CountryType', id: string, shortName: string } | null }> | null, salaryRange?: { __typename?: 'OpeningSalaryRangeType', period?: SalaryPeriodEnum | null, offerSalary?: number | null, from?: number | null, to?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | null }> } } };

export type GetSearchVerifiedUsersForSourceQueryVariables = Exact<{
  searchParams?: InputMaybe<UserSearchEntitySearchParamsInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  sortedPaginationOptions?: InputMaybe<SearchVerifiedUsersPaginationOptionsInput>;
  excludedUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetSearchVerifiedUsersForSourceQuery = { __typename?: 'Query', searchVerifiedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string } }> } };

export type GetBookmarkedVerifiedUsersQueryVariables = Exact<{
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetBookmarkedVerifiedUsersQuery = { __typename?: 'Query', bookmarkedVerifiedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string } }> } };

export type GetRejectedSearchVerifiedUsersForSourceQueryVariables = Exact<{
  openingId?: InputMaybe<Scalars['ID']['input']>;
  dateRangeInput?: InputMaybe<DateRangeInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetRejectedSearchVerifiedUsersForSourceQuery = { __typename?: 'Query', rejectedVerifiedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string } }> } };

export type GetVerifiedUserForSourceQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetVerifiedUserForSourceQuery = { __typename?: 'Query', verifiedUser: { __typename?: 'VerifiedUserType', messageThread?: { __typename?: 'MessageThreadType', id: string } | null, recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, userVerification: { __typename?: 'UserVerificationType', id: string, positionExpectations: string, workExperience: string, achievements?: string | null, canStartIn: JobStartTimeEnum, publishedAt: string, cancelledAt?: string | null, state: UserVerificationStateEnum, connectedWithCompanies: { __typename?: 'PaginatedCompaniesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, messagedByCompanies: { __typename?: 'PaginatedCompaniesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } } }, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, lastSeenAt: string, averageResponseTimeInMs: any, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } } } };

export type GetVerifiedUserForChatPageQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetVerifiedUserForChatPageQuery = { __typename?: 'Query', verifiedUser: { __typename?: 'VerifiedUserType', messageThread?: { __typename?: 'MessageThreadType', id: string } | null, recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, userVerification: { __typename?: 'UserVerificationType', id: string, positionExpectations: string, workExperience: string, achievements?: string | null, canStartIn: JobStartTimeEnum, publishedAt: string, cancelledAt?: string | null, state: UserVerificationStateEnum, connectedWithCompanies: { __typename?: 'PaginatedCompaniesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } }, messagedByCompanies: { __typename?: 'PaginatedCompaniesType', pagination: { __typename?: 'PaginationInfoType', totalCount: number } } }, user: { __typename?: 'UserType', id: string, name?: string | null, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, lastSeenAt: string, averageResponseTimeInMs: any, state: string, email?: string | null, phone?: { __typename?: 'UserPhoneType', number: string, country?: { __typename?: 'CountryType', id: string, dialCode: string } | null } | null, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, speciality: { __typename?: 'SpecialityType', id: string, name: string }, skills: Array<{ __typename?: 'SkillType', id: string, name: string }>, seniorities: Array<{ __typename?: 'SeniorityType', id: string, name: string }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string }, links: Array<{ __typename?: 'UserProfileLinkType', type: UserProfileLinkTypeEnum, value: string }> } } } };

export type GetRecentGroupedTalentsQueryVariables = Exact<{
  searchParams?: InputMaybe<UserSearchEntitySearchParamsInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  sortedPaginationOptions?: InputMaybe<SearchVerifiedUsersPaginationOptionsInput>;
  excludedUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetRecentGroupedTalentsQuery = { __typename?: 'Query', searchVerifiedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string } }> } };

export type GetRejectedGroupedTalentsQueryVariables = Exact<{
  openingId?: InputMaybe<Scalars['ID']['input']>;
  dateRangeInput?: InputMaybe<DateRangeInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetRejectedGroupedTalentsQuery = { __typename?: 'Query', rejectedVerifiedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', title?: string | null, companyName?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null, startsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null, endsAt?: { __typename?: 'UserProfileWorkHistoryDateType', day?: number | null, month?: number | null, year?: number | null } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string } }> } };

export type GetSearchVerifiedUsersForFeaturedTalentsFeedQueryVariables = Exact<{
  searchParams?: InputMaybe<UserSearchEntitySearchParamsInput>;
  paginationOptions?: InputMaybe<PaginationOptionsInput>;
  sortedPaginationOptions?: InputMaybe<SearchVerifiedUsersPaginationOptionsInput>;
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetSearchVerifiedUsersForFeaturedTalentsFeedQuery = { __typename?: 'Query', searchVerifiedUsers: { __typename?: 'PaginatedVerifiedUserType', pagination: { __typename?: 'PaginationInfoType', hasMoreResults: boolean, minCursor?: string | null, maxCursor?: string | null, limit?: number | null, totalCount: number }, result: Array<{ __typename?: 'VerifiedUserType', recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string, canStartIn: JobStartTimeEnum } }> } };

export type GetVerifiedUserForFeaturedTalentQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  recruiterCurrencyCode: Scalars['String']['input'];
}>;


export type GetVerifiedUserForFeaturedTalentQuery = { __typename?: 'Query', verifiedUser: { __typename?: 'VerifiedUserType', recruiterState: { __typename?: 'VerifiedUserRecruiterStateType', hasSeen: boolean, hasMessaged: boolean }, user: { __typename?: 'UserType', id: string, name?: string | null, lastSeenAt: string, position?: string | null, avatarColor?: string | null, hasBookmarked: boolean, avatar?: { __typename?: 'MediaImageType', id: string, fullUrl: string } | null, profile: { __typename?: 'UserProfileType', isLocal: boolean, isRemote: boolean, isRelocation: boolean, workHistory: Array<{ __typename?: 'UserProfileWorkHistoryItemType', company?: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string, logo?: { __typename?: 'ImageType', id: string, fullUrl: string } | null } } | null }>, originalSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, convertedSalary: { __typename?: 'UserProfileSalaryType', value: number, period: SalaryPeriodEnum, currency: { __typename?: 'CurrencyType', id: string, symbol: string } }, location: { __typename?: 'LocationType', id: string, shortName: string } } }, userVerification: { __typename?: 'UserVerificationType', id: string, publishedAt: string, positionExpectations: string, canStartIn: JobStartTimeEnum } } };

export type SwitchedWorkspaceSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SwitchedWorkspaceSubscription = { __typename?: 'Subscription', switchedWorkspace: { __typename?: 'WorkspaceSwitchedResultType', fromCompany: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string } }, toCompany: { __typename?: 'CompanyType', id: string, profile: { __typename?: 'CompanyProfileType', id: string, name: string } } } };

export type OpeningQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OpeningQuery = { __typename?: 'Query', opening: { __typename?: 'OpeningType', id: string, reach: { __typename?: 'OpeningReachType', local: number, global: number, remote: number } } };

export type UpgradeSubscriptionForPlansMutationVariables = Exact<{
  planType: CustomerPlanEnum;
  subscriptionCycle: CustomerSubscriptionCycleEnum;
}>;


export type UpgradeSubscriptionForPlansMutation = { __typename?: 'Mutation', upgradeSubscription: { __typename?: 'CustomerType', id: string, planType?: CustomerPlanEnum | null, planInfo?: { __typename?: 'EnterprisePlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | { __typename?: 'FreemiumPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | { __typename?: 'LegacyPlanType', price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | { __typename?: 'SubscriptionPlanType', trialEndsAt?: string | null, state?: CustomerCalculatedSubscriptionStateEnum | null, cycle?: CustomerSubscriptionCycleEnum | null, hasOpeningsLimitReached: boolean, occupiedOpeningSlots: number, nextPaymentDate?: string | null, price?: number | null, currency?: { __typename?: 'CurrencyType', id: string, symbol: string } | null } | null } };

export const UserFragmentDoc = gql`
    fragment User on UserType {
  hasBookmarked
}
    `;
export const TalentUserFieldsFragmentDoc = gql`
    fragment TalentUserFields on TalentActivityType {
  signal {
    id
    type
    createdAt
    entity {
      id
      ... on OpeningType {
        title
      }
    }
  }
  talent {
    messageThread {
      id
    }
    recruiterState {
      hasSeen
      hasMessaged
    }
    userVerification {
      id
      positionExpectations
      workExperience
      achievements
      canStartIn
      publishedAt
    }
    user {
      id
      name
      position
      avatarColor
      avatar {
        id
        fullUrl
      }
      profile {
        workHistory {
          title
          companyName
          description
          startsAt {
            day
            month
            year
          }
          endsAt {
            day
            month
            year
          }
        }
        speciality {
          id
          name
        }
        skills {
          id
          name
        }
        seniorities {
          id
          name
        }
        salary {
          value
          currency {
            id
            symbol
          }
          period
        }
        location {
          id
          shortName
        }
        isLocal
        isRemote
        isRelocation
        links {
          type
          value
        }
      }
    }
  }
}
    `;
export const CompanyRatingsFragmentFragmentDoc = gql`
    fragment companyRatingsFragment on CompanyRatingsType {
  companyCulture
  compensationBenefits
  management
  product
  workLifeBalance
  total
}
    `;
export const CompanyReviewRatingsFragmentFragmentDoc = gql`
    fragment companyReviewRatingsFragment on CompanyRatingReviewRatingsType {
  companyCulture
  compensationBenefits
  management
  product
  workLifeBalance
  total
}
    `;
export const ReviewActorFragmentFragmentDoc = gql`
    fragment reviewActorFragment on ReviewActorType {
  type
  entity {
    ... on UserType {
      id
      name
      position
      avatar {
        id
        fullUrl
      }
      avatarColor
      location {
        id
        shortName
      }
    }
  }
}
    `;
export const InboxMessageThreadListItemFragmentDoc = gql`
    fragment InboxMessageThreadListItem on MessageThreadType {
  id
  latestMessageSentAt
  isUnread
  recruiterState
  userState
  application {
    id
  }
  user {
    id
    name
    position
    avatarColor
    avatar {
      id
      fullUrl
    }
  }
  recruiter {
    id
  }
  opening {
    id
    title
  }
  isUnread
  messages(paginationOptions: {limit: 1}) {
    pagination {
      totalCount
    }
    result {
      id
      sender
      sentAt
      text
      readByUserAt
      readByRecruiterAt
    }
  }
}
    `;
export const InboxMessageThreadMessagesItemFragmentDoc = gql`
    fragment InboxMessageThreadMessagesItem on MessageType {
  id
  sentAt
  text
  readByUserAt
  readByRecruiterAt
  sender
  recruiter {
    id
    fullName
    avatarColor
    avatar {
      id
      fullUrl
    }
  }
}
    `;
export const InboxMessageThreadFragmentDoc = gql`
    fragment InboxMessageThread on MessageThreadType {
  id
  type
  userState
  recruiterState
  latestMessageSentAt
  isUnread
  opening {
    id
    title
  }
  application {
    id
    recruiterState {
      createdAt
      state
    }
    userMatchingProfile {
      id
    }
  }
  user {
    id
    name
    position
    avatarColor
    state
    email
    phone {
      number
      country {
        id
        dialCode
      }
    }
    avatar {
      id
      fullUrl
    }
    profile {
      links {
        type
        value
      }
      location {
        id
        shortName
      }
      speciality {
        id
        name
        skillTags
      }
      seniorities {
        id
        name
      }
      originalSalary: salary {
        value
        currency {
          id
          symbol
        }
        period
      }
      convertedSalary: salary(currencyCode: $recruiterCurrencyCode) {
        value
        currency {
          id
          symbol
        }
        period
      }
      skills {
        id
        name
        tags
      }
    }
  }
  messages(paginationOptions: $messagesPaginationOptions) {
    pagination {
      totalCount
    }
    result {
      ...InboxMessageThreadMessagesItem
    }
  }
}
    ${InboxMessageThreadMessagesItemFragmentDoc}`;
export const SalaryDistributionDataPointTypeFragmentDoc = gql`
    fragment SalaryDistributionDataPointType on SalaryDistributionDataPointType {
  percentage
  count
  step
}
    `;
export const CandidateUserFieldsFragmentDoc = gql`
    fragment candidateUserFields on UserType {
  id
  name
  position
  avatarColor
  avatar {
    id
    fullUrl
  }
  profile {
    isRemote
    isRelocation
    speciality {
      id
      name
    }
    links {
      type
      value
    }
    skills {
      id
      name
    }
    seniorities {
      id
      name
    }
    salary {
      value
      currency {
        id
        symbol
      }
      period
    }
    location {
      id
      shortName
    }
  }
}
    `;
export const FunnelOpeningFragmentDoc = gql`
    fragment FunnelOpening on OpeningType {
  id
  employmentType
  state
  title
  message
  depersonalizedMessage
  comment
  publicUrl(includeBaseUrl: true)
  automatedResponse
  source
  pitch
  targetLocations {
    id
    shortName
    longName
    placeId
    coord
    country {
      id
      shortName
    }
  }
  visibility
  positionLocations {
    id
    shortName
    longName
    placeId
    coord
  }
  isRemote
  isPublic
  isRelocation
  relocationBenefits {
    id
    key
    value
  }
  allowDistribution
  speciality {
    id
    name
    key
    skillTags
    sort
  }
  skills {
    skill {
      id
      name
      tag
      tags
    }
    isMandatory
    mandatory
  }
  seniorities {
    id
    name
    key
  }
  workload {
    period
    hours
  }
  salaryRange {
    from
    to
    offerSalary
    increase
    currency {
      id
      code
      symbol
    }
    period
  }
  candidateDestination {
    type
    ... on ExternalUrlOpeningCandidateDestinationType {
      url
    }
  }
  recruiter {
    id
  }
  company {
    id
    name
  }
  publishedAt
  applications {
    id
  }
  paidAddons {
    type
    priceInEur
  }
  interviewQuestions {
    id
    order
    question
  }
}
    `;
export const VerifiedUserFeedFragmentDoc = gql`
    fragment verifiedUserFeed on VerifiedUserType {
  messageThread {
    id
  }
  recruiterState {
    hasSeen
    hasMessaged
  }
  userVerification {
    id
    positionExpectations
    workExperience
    publishedAt
  }
  user {
    id
    name
    position
    avatarColor
    lastSeenAt
    avatar {
      id
      fullUrl
    }
    profile {
      workHistory {
        title
        companyName
        endsAt {
          day
          month
          year
        }
      }
      skills {
        id
        name
      }
      originalSalary: salary {
        value
        currency {
          id
          symbol
        }
        period
      }
      convertedSalary: salary(currencyCode: $recruiterCurrencyCode) {
        value
        currency {
          id
          symbol
        }
        period
      }
      location {
        id
        shortName
      }
      isLocal
      isRemote
      isRelocation
      links {
        type
        value
      }
    }
  }
}
    `;
export const TaModalUserFragmentDoc = gql`
    fragment taModalUser on UserType {
  id
  name
  position
  avatarColor
  hasBookmarked
  lastSeenAt
  averageResponseTimeInMs
  state
  email
  phone {
    number
    country {
      id
      dialCode
    }
  }
  avatar {
    id
    fullUrl
  }
  profile {
    workHistory {
      title
      companyName
      description
      company {
        id
        profile {
          id
          logo {
            id
            fullUrl
          }
        }
      }
      startsAt {
        day
        month
        year
      }
      endsAt {
        day
        month
        year
      }
    }
    speciality {
      id
      name
    }
    skills {
      id
      name
    }
    seniorities {
      id
      name
    }
    originalSalary: salary {
      value
      currency {
        id
        symbol
      }
      period
    }
    convertedSalary: salary(currencyCode: $recruiterCurrencyCode) {
      value
      currency {
        id
        symbol
      }
      period
    }
    location {
      id
      shortName
    }
    isLocal
    isRemote
    isRelocation
    links {
      type
      value
    }
  }
}
    `;
export const VerifiedUserCarouselCardFragmentDoc = gql`
    fragment verifiedUserCarouselCard on VerifiedUserType {
  messageThread {
    id
  }
  recruiterState {
    hasSeen
    hasMessaged
  }
  userVerification {
    id
    positionExpectations
    workExperience
    achievements
    canStartIn
    publishedAt
    cancelledAt
    state
    connectedWithCompanies(paginationOptions: {limit: 1}) {
      pagination {
        totalCount
      }
    }
    messagedByCompanies(paginationOptions: {limit: 1}) {
      pagination {
        totalCount
      }
    }
  }
  user {
    ...taModalUser
  }
}
    ${TaModalUserFragmentDoc}`;
export const GroupedTalentFragmentDoc = gql`
    fragment groupedTalent on VerifiedUserType {
  user {
    id
    name
    lastSeenAt
    position
    avatarColor
    hasBookmarked
    avatar {
      id
      fullUrl
    }
    profile {
      workHistory {
        title
        companyName
        description
        company {
          id
          profile {
            id
            logo {
              id
              fullUrl
            }
          }
        }
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
      }
      originalSalary: salary {
        value
        currency {
          id
          symbol
        }
        period
      }
      convertedSalary: salary(currencyCode: $recruiterCurrencyCode) {
        value
        currency {
          id
          symbol
        }
        period
      }
      location {
        id
        shortName
      }
      isLocal
      isRemote
    }
  }
  userVerification {
    id
    publishedAt
    positionExpectations
  }
}
    `;
export const FeaturedTalentCardFragmentDoc = gql`
    fragment featuredTalentCard on VerifiedUserType {
  recruiterState {
    hasSeen
    hasMessaged
  }
  user {
    id
    name
    lastSeenAt
    position
    avatarColor
    hasBookmarked
    avatar {
      id
      fullUrl
    }
    profile {
      isLocal
      isRemote
      isRelocation
      workHistory {
        company {
          id
          profile {
            id
            name
            logo {
              id
              fullUrl
            }
          }
        }
      }
      originalSalary: salary {
        value
        currency {
          id
          symbol
        }
        period
      }
      convertedSalary: salary(currencyCode: $recruiterCurrencyCode) {
        value
        currency {
          id
          symbol
        }
        period
      }
      location {
        id
        shortName
      }
    }
  }
  userVerification {
    id
    publishedAt
    positionExpectations
    canStartIn
  }
}
    `;
export const OpeningApplicantCardFragmentDoc = gql`
    fragment openingApplicantCard on ApplicantInterface {
  user {
    id
    name
    lastSeenAt
    position
    avatarColor
    hasBookmarked
    avatar {
      id
      fullUrl
    }
    profile {
      isLocal
      isRemote
      isRelocation
      workHistory {
        company {
          id
          profile {
            id
            name
            logo {
              id
              fullUrl
            }
          }
        }
      }
      links {
        type
        value
      }
      skills {
        id
        name
      }
      seniorities {
        id
        name
      }
      speciality {
        id
        name
      }
      originalSalary: salary {
        value
        currency {
          id
          symbol
        }
        period
      }
      convertedSalary: salary(currencyCode: $recruiterCurrencyCode) {
        value
        currency {
          id
          symbol
        }
        period
      }
      location {
        id
        shortName
      }
    }
  }
  ... on VerifiedUserApplicantType {
    userVerification {
      id
      publishedAt
      positionExpectations
    }
    application {
      id
      createdAt
      userMatchingProfile {
        id
      }
      userState {
        state
        createdAt
      }
      messageThread {
        id
        isUnread
        isInitiatedByMeetFrank
        userState
      }
    }
  }
  ... on OpeningApplicantType {
    application {
      id
      createdAt
      userMatchingProfile {
        id
      }
      messageThread {
        id
        isUnread
        isInitiatedByMeetFrank
        userState
      }
    }
  }
}
    `;
export const CurrentRecruiterDocument = gql`
    query currentRecruiter {
  currentRecruiter {
    id
    availableCompanies {
      company {
        id
        profile {
          id
          name
        }
      }
      isCurrent
      isVisible
    }
  }
}
    `;

/**
 * __useCurrentRecruiterQuery__
 *
 * To run a query within a React component, call `useCurrentRecruiterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentRecruiterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentRecruiterQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentRecruiterQuery(baseOptions?: Apollo.QueryHookOptions<CurrentRecruiterQuery, CurrentRecruiterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentRecruiterQuery, CurrentRecruiterQueryVariables>(CurrentRecruiterDocument, options);
      }
export function useCurrentRecruiterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentRecruiterQuery, CurrentRecruiterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentRecruiterQuery, CurrentRecruiterQueryVariables>(CurrentRecruiterDocument, options);
        }
export function useCurrentRecruiterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentRecruiterQuery, CurrentRecruiterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentRecruiterQuery, CurrentRecruiterQueryVariables>(CurrentRecruiterDocument, options);
        }
export type CurrentRecruiterQueryHookResult = ReturnType<typeof useCurrentRecruiterQuery>;
export type CurrentRecruiterLazyQueryHookResult = ReturnType<typeof useCurrentRecruiterLazyQuery>;
export type CurrentRecruiterSuspenseQueryHookResult = ReturnType<typeof useCurrentRecruiterSuspenseQuery>;
export type CurrentRecruiterQueryResult = Apollo.QueryResult<CurrentRecruiterQuery, CurrentRecruiterQueryVariables>;
export const NotificationCenterUpdatedDocument = gql`
    subscription notificationCenterUpdated {
  notificationCenterUpdated
}
    `;

/**
 * __useNotificationCenterUpdatedSubscription__
 *
 * To run a query within a React component, call `useNotificationCenterUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCenterUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCenterUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationCenterUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NotificationCenterUpdatedSubscription, NotificationCenterUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotificationCenterUpdatedSubscription, NotificationCenterUpdatedSubscriptionVariables>(NotificationCenterUpdatedDocument, options);
      }
export type NotificationCenterUpdatedSubscriptionHookResult = ReturnType<typeof useNotificationCenterUpdatedSubscription>;
export type NotificationCenterUpdatedSubscriptionResult = Apollo.SubscriptionResult<NotificationCenterUpdatedSubscription>;
export const GetTalentActivityFeedDocument = gql`
    query getTalentActivityFeed($filterInput: TalentActivityFeedFilterInput!, $paginationOptions: PaginationOptionsInput) {
  talentActivityFeed(
    filterInput: $filterInput
    paginationOptions: $paginationOptions
  ) {
    pagination {
      hasMoreResults
      minCursor
      maxCursor
      limit
      totalCount
    }
    result {
      ...TalentUserFields
    }
  }
}
    ${TalentUserFieldsFragmentDoc}`;

/**
 * __useGetTalentActivityFeedQuery__
 *
 * To run a query within a React component, call `useGetTalentActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTalentActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTalentActivityFeedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useGetTalentActivityFeedQuery(baseOptions: Apollo.QueryHookOptions<GetTalentActivityFeedQuery, GetTalentActivityFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTalentActivityFeedQuery, GetTalentActivityFeedQueryVariables>(GetTalentActivityFeedDocument, options);
      }
export function useGetTalentActivityFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTalentActivityFeedQuery, GetTalentActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTalentActivityFeedQuery, GetTalentActivityFeedQueryVariables>(GetTalentActivityFeedDocument, options);
        }
export function useGetTalentActivityFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTalentActivityFeedQuery, GetTalentActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTalentActivityFeedQuery, GetTalentActivityFeedQueryVariables>(GetTalentActivityFeedDocument, options);
        }
export type GetTalentActivityFeedQueryHookResult = ReturnType<typeof useGetTalentActivityFeedQuery>;
export type GetTalentActivityFeedLazyQueryHookResult = ReturnType<typeof useGetTalentActivityFeedLazyQuery>;
export type GetTalentActivityFeedSuspenseQueryHookResult = ReturnType<typeof useGetTalentActivityFeedSuspenseQuery>;
export type GetTalentActivityFeedQueryResult = Apollo.QueryResult<GetTalentActivityFeedQuery, GetTalentActivityFeedQueryVariables>;
export const GetTalentActivityStatisticsDocument = gql`
    query getTalentActivityStatistics($filterInput: TalentActivityFeedFilterInput!) {
  talentActivityStatistics(filterInput: $filterInput) {
    offerViews
    applications
  }
}
    `;

/**
 * __useGetTalentActivityStatisticsQuery__
 *
 * To run a query within a React component, call `useGetTalentActivityStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTalentActivityStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTalentActivityStatisticsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetTalentActivityStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetTalentActivityStatisticsQuery, GetTalentActivityStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTalentActivityStatisticsQuery, GetTalentActivityStatisticsQueryVariables>(GetTalentActivityStatisticsDocument, options);
      }
export function useGetTalentActivityStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTalentActivityStatisticsQuery, GetTalentActivityStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTalentActivityStatisticsQuery, GetTalentActivityStatisticsQueryVariables>(GetTalentActivityStatisticsDocument, options);
        }
export function useGetTalentActivityStatisticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTalentActivityStatisticsQuery, GetTalentActivityStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTalentActivityStatisticsQuery, GetTalentActivityStatisticsQueryVariables>(GetTalentActivityStatisticsDocument, options);
        }
export type GetTalentActivityStatisticsQueryHookResult = ReturnType<typeof useGetTalentActivityStatisticsQuery>;
export type GetTalentActivityStatisticsLazyQueryHookResult = ReturnType<typeof useGetTalentActivityStatisticsLazyQuery>;
export type GetTalentActivityStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetTalentActivityStatisticsSuspenseQuery>;
export type GetTalentActivityStatisticsQueryResult = Apollo.QueryResult<GetTalentActivityStatisticsQuery, GetTalentActivityStatisticsQueryVariables>;
export const AcceptApplicationDocument = gql`
    mutation acceptApplication($userMatchingProfileId: String!, $openingId: String!, $message: String) {
  acceptApplication(
    userMatchingProfileId: $userMatchingProfileId
    openingId: $openingId
    message: $message
  ) {
    id
    user {
      id
      name
      avatarColor
    }
    messageThread {
      id
      userState
      recruiterState
    }
    recruiterState {
      state
    }
  }
}
    `;
export type AcceptApplicationMutationFn = Apollo.MutationFunction<AcceptApplicationMutation, AcceptApplicationMutationVariables>;

/**
 * __useAcceptApplicationMutation__
 *
 * To run a mutation, you first call `useAcceptApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptApplicationMutation, { data, loading, error }] = useAcceptApplicationMutation({
 *   variables: {
 *      userMatchingProfileId: // value for 'userMatchingProfileId'
 *      openingId: // value for 'openingId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useAcceptApplicationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptApplicationMutation, AcceptApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptApplicationMutation, AcceptApplicationMutationVariables>(AcceptApplicationDocument, options);
      }
export type AcceptApplicationMutationHookResult = ReturnType<typeof useAcceptApplicationMutation>;
export type AcceptApplicationMutationResult = Apollo.MutationResult<AcceptApplicationMutation>;
export type AcceptApplicationMutationOptions = Apollo.BaseMutationOptions<AcceptApplicationMutation, AcceptApplicationMutationVariables>;
export const RejectApplicationDocument = gql`
    mutation rejectApplication($userMatchingProfileId: String!, $openingId: String!, $message: String) {
  rejectApplication(
    userMatchingProfileId: $userMatchingProfileId
    openingId: $openingId
    message: $message
  ) {
    id
    user {
      id
      name
      avatarColor
    }
    messageThread {
      id
      userState
      recruiterState
    }
    recruiterState {
      state
    }
  }
}
    `;
export type RejectApplicationMutationFn = Apollo.MutationFunction<RejectApplicationMutation, RejectApplicationMutationVariables>;

/**
 * __useRejectApplicationMutation__
 *
 * To run a mutation, you first call `useRejectApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectApplicationMutation, { data, loading, error }] = useRejectApplicationMutation({
 *   variables: {
 *      userMatchingProfileId: // value for 'userMatchingProfileId'
 *      openingId: // value for 'openingId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useRejectApplicationMutation(baseOptions?: Apollo.MutationHookOptions<RejectApplicationMutation, RejectApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectApplicationMutation, RejectApplicationMutationVariables>(RejectApplicationDocument, options);
      }
export type RejectApplicationMutationHookResult = ReturnType<typeof useRejectApplicationMutation>;
export type RejectApplicationMutationResult = Apollo.MutationResult<RejectApplicationMutation>;
export type RejectApplicationMutationOptions = Apollo.BaseMutationOptions<RejectApplicationMutation, RejectApplicationMutationVariables>;
export const GetOpeningCandidateProfileApplicationDocument = gql`
    query getOpeningCandidateProfileApplication($id: ID!, $messagesPaginationOptions: PaginationOptionsInput, $recruiterCurrencyCode: String!) {
  application(id: $id) {
    id
    userState {
      createdAt
      state
    }
    recruiterState {
      createdAt
      state
    }
    user {
      id
      name
      avatarColor
      state
      email
      phone {
        number
        country {
          id
          dialCode
        }
      }
      avatar {
        id
        fullUrl
      }
    }
    opening {
      id
      title
    }
    userMatchingProfile {
      id
    }
    messageThread {
      ...InboxMessageThread
    }
  }
}
    ${InboxMessageThreadFragmentDoc}`;

/**
 * __useGetOpeningCandidateProfileApplicationQuery__
 *
 * To run a query within a React component, call `useGetOpeningCandidateProfileApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpeningCandidateProfileApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpeningCandidateProfileApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      messagesPaginationOptions: // value for 'messagesPaginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetOpeningCandidateProfileApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetOpeningCandidateProfileApplicationQuery, GetOpeningCandidateProfileApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpeningCandidateProfileApplicationQuery, GetOpeningCandidateProfileApplicationQueryVariables>(GetOpeningCandidateProfileApplicationDocument, options);
      }
export function useGetOpeningCandidateProfileApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpeningCandidateProfileApplicationQuery, GetOpeningCandidateProfileApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpeningCandidateProfileApplicationQuery, GetOpeningCandidateProfileApplicationQueryVariables>(GetOpeningCandidateProfileApplicationDocument, options);
        }
export function useGetOpeningCandidateProfileApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOpeningCandidateProfileApplicationQuery, GetOpeningCandidateProfileApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpeningCandidateProfileApplicationQuery, GetOpeningCandidateProfileApplicationQueryVariables>(GetOpeningCandidateProfileApplicationDocument, options);
        }
export type GetOpeningCandidateProfileApplicationQueryHookResult = ReturnType<typeof useGetOpeningCandidateProfileApplicationQuery>;
export type GetOpeningCandidateProfileApplicationLazyQueryHookResult = ReturnType<typeof useGetOpeningCandidateProfileApplicationLazyQuery>;
export type GetOpeningCandidateProfileApplicationSuspenseQueryHookResult = ReturnType<typeof useGetOpeningCandidateProfileApplicationSuspenseQuery>;
export type GetOpeningCandidateProfileApplicationQueryResult = Apollo.QueryResult<GetOpeningCandidateProfileApplicationQuery, GetOpeningCandidateProfileApplicationQueryVariables>;
export const ApplicationForCandidateProfileDocument = gql`
    query applicationForCandidateProfile($id: ID!) {
  application(id: $id) {
    id
    user {
      id
      name
      avatarColor
    }
    messageThread {
      id
      userState
      recruiterState
    }
    recruiterState {
      createdAt
      state
    }
    userMatchingProfile {
      id
      speciality {
        id
        key
      }
    }
  }
}
    `;

/**
 * __useApplicationForCandidateProfileQuery__
 *
 * To run a query within a React component, call `useApplicationForCandidateProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationForCandidateProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationForCandidateProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationForCandidateProfileQuery(baseOptions: Apollo.QueryHookOptions<ApplicationForCandidateProfileQuery, ApplicationForCandidateProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationForCandidateProfileQuery, ApplicationForCandidateProfileQueryVariables>(ApplicationForCandidateProfileDocument, options);
      }
export function useApplicationForCandidateProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationForCandidateProfileQuery, ApplicationForCandidateProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationForCandidateProfileQuery, ApplicationForCandidateProfileQueryVariables>(ApplicationForCandidateProfileDocument, options);
        }
export function useApplicationForCandidateProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationForCandidateProfileQuery, ApplicationForCandidateProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationForCandidateProfileQuery, ApplicationForCandidateProfileQueryVariables>(ApplicationForCandidateProfileDocument, options);
        }
export type ApplicationForCandidateProfileQueryHookResult = ReturnType<typeof useApplicationForCandidateProfileQuery>;
export type ApplicationForCandidateProfileLazyQueryHookResult = ReturnType<typeof useApplicationForCandidateProfileLazyQuery>;
export type ApplicationForCandidateProfileSuspenseQueryHookResult = ReturnType<typeof useApplicationForCandidateProfileSuspenseQuery>;
export type ApplicationForCandidateProfileQueryResult = Apollo.QueryResult<ApplicationForCandidateProfileQuery, ApplicationForCandidateProfileQueryVariables>;
export const ApplicationForCandidateProfileDataItemsDocument = gql`
    query applicationForCandidateProfileDataItems($id: ID!) {
  application(id: $id) {
    id
    userMatchingProfile {
      id
      speciality {
        id
        name
        skillTags
      }
      seniorities {
        id
        name
      }
      salary {
        value
        period
        currency {
          id
          symbol
        }
      }
      skills {
        id
        name
        tags
      }
    }
  }
}
    `;

/**
 * __useApplicationForCandidateProfileDataItemsQuery__
 *
 * To run a query within a React component, call `useApplicationForCandidateProfileDataItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationForCandidateProfileDataItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationForCandidateProfileDataItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationForCandidateProfileDataItemsQuery(baseOptions: Apollo.QueryHookOptions<ApplicationForCandidateProfileDataItemsQuery, ApplicationForCandidateProfileDataItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationForCandidateProfileDataItemsQuery, ApplicationForCandidateProfileDataItemsQueryVariables>(ApplicationForCandidateProfileDataItemsDocument, options);
      }
export function useApplicationForCandidateProfileDataItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationForCandidateProfileDataItemsQuery, ApplicationForCandidateProfileDataItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationForCandidateProfileDataItemsQuery, ApplicationForCandidateProfileDataItemsQueryVariables>(ApplicationForCandidateProfileDataItemsDocument, options);
        }
export function useApplicationForCandidateProfileDataItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationForCandidateProfileDataItemsQuery, ApplicationForCandidateProfileDataItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationForCandidateProfileDataItemsQuery, ApplicationForCandidateProfileDataItemsQueryVariables>(ApplicationForCandidateProfileDataItemsDocument, options);
        }
export type ApplicationForCandidateProfileDataItemsQueryHookResult = ReturnType<typeof useApplicationForCandidateProfileDataItemsQuery>;
export type ApplicationForCandidateProfileDataItemsLazyQueryHookResult = ReturnType<typeof useApplicationForCandidateProfileDataItemsLazyQuery>;
export type ApplicationForCandidateProfileDataItemsSuspenseQueryHookResult = ReturnType<typeof useApplicationForCandidateProfileDataItemsSuspenseQuery>;
export type ApplicationForCandidateProfileDataItemsQueryResult = Apollo.QueryResult<ApplicationForCandidateProfileDataItemsQuery, ApplicationForCandidateProfileDataItemsQueryVariables>;
export const ApplicationForCandidateProfileHeaderDocument = gql`
    query applicationForCandidateProfileHeader($id: ID!) {
  application(id: $id) {
    id
    user {
      id
      name
      position
      avatarColor
      location {
        id
        shortName
      }
      profile {
        links {
          type
          value
        }
      }
    }
    userMatchingProfile {
      id
    }
  }
}
    `;

/**
 * __useApplicationForCandidateProfileHeaderQuery__
 *
 * To run a query within a React component, call `useApplicationForCandidateProfileHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationForCandidateProfileHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationForCandidateProfileHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationForCandidateProfileHeaderQuery(baseOptions: Apollo.QueryHookOptions<ApplicationForCandidateProfileHeaderQuery, ApplicationForCandidateProfileHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationForCandidateProfileHeaderQuery, ApplicationForCandidateProfileHeaderQueryVariables>(ApplicationForCandidateProfileHeaderDocument, options);
      }
export function useApplicationForCandidateProfileHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationForCandidateProfileHeaderQuery, ApplicationForCandidateProfileHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationForCandidateProfileHeaderQuery, ApplicationForCandidateProfileHeaderQueryVariables>(ApplicationForCandidateProfileHeaderDocument, options);
        }
export function useApplicationForCandidateProfileHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationForCandidateProfileHeaderQuery, ApplicationForCandidateProfileHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationForCandidateProfileHeaderQuery, ApplicationForCandidateProfileHeaderQueryVariables>(ApplicationForCandidateProfileHeaderDocument, options);
        }
export type ApplicationForCandidateProfileHeaderQueryHookResult = ReturnType<typeof useApplicationForCandidateProfileHeaderQuery>;
export type ApplicationForCandidateProfileHeaderLazyQueryHookResult = ReturnType<typeof useApplicationForCandidateProfileHeaderLazyQuery>;
export type ApplicationForCandidateProfileHeaderSuspenseQueryHookResult = ReturnType<typeof useApplicationForCandidateProfileHeaderSuspenseQuery>;
export type ApplicationForCandidateProfileHeaderQueryResult = Apollo.QueryResult<ApplicationForCandidateProfileHeaderQuery, ApplicationForCandidateProfileHeaderQueryVariables>;
export const GetTaModalApplicantDocument = gql`
    query getTaModalApplicant($userId: ID!, $openingId: ID!, $recruiterCurrencyCode: String!) {
  applicant(userId: $userId, openingId: $openingId) {
    user {
      ...taModalUser
    }
  }
}
    ${TaModalUserFragmentDoc}`;

/**
 * __useGetTaModalApplicantQuery__
 *
 * To run a query within a React component, call `useGetTaModalApplicantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaModalApplicantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaModalApplicantQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      openingId: // value for 'openingId'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetTaModalApplicantQuery(baseOptions: Apollo.QueryHookOptions<GetTaModalApplicantQuery, GetTaModalApplicantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaModalApplicantQuery, GetTaModalApplicantQueryVariables>(GetTaModalApplicantDocument, options);
      }
export function useGetTaModalApplicantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaModalApplicantQuery, GetTaModalApplicantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaModalApplicantQuery, GetTaModalApplicantQueryVariables>(GetTaModalApplicantDocument, options);
        }
export function useGetTaModalApplicantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaModalApplicantQuery, GetTaModalApplicantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaModalApplicantQuery, GetTaModalApplicantQueryVariables>(GetTaModalApplicantDocument, options);
        }
export type GetTaModalApplicantQueryHookResult = ReturnType<typeof useGetTaModalApplicantQuery>;
export type GetTaModalApplicantLazyQueryHookResult = ReturnType<typeof useGetTaModalApplicantLazyQuery>;
export type GetTaModalApplicantSuspenseQueryHookResult = ReturnType<typeof useGetTaModalApplicantSuspenseQuery>;
export type GetTaModalApplicantQueryResult = Apollo.QueryResult<GetTaModalApplicantQuery, GetTaModalApplicantQueryVariables>;
export const SignUpDocument = gql`
    mutation signUp($signUpInput: SignUpInput!) {
  signUp(signUpInput: $signUpInput)
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      signUpInput: // value for 'signUpInput'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const LoginDocument = gql`
    mutation login($loginInput: LoginInput!) {
  login(loginInput: $loginInput)
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      loginInput: // value for 'loginInput'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RequestAuthCodeDocument = gql`
    mutation requestAuthCode($email: String!) {
  requestAuthCode(email: $email)
}
    `;
export type RequestAuthCodeMutationFn = Apollo.MutationFunction<RequestAuthCodeMutation, RequestAuthCodeMutationVariables>;

/**
 * __useRequestAuthCodeMutation__
 *
 * To run a mutation, you first call `useRequestAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAuthCodeMutation, { data, loading, error }] = useRequestAuthCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<RequestAuthCodeMutation, RequestAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAuthCodeMutation, RequestAuthCodeMutationVariables>(RequestAuthCodeDocument, options);
      }
export type RequestAuthCodeMutationHookResult = ReturnType<typeof useRequestAuthCodeMutation>;
export type RequestAuthCodeMutationResult = Apollo.MutationResult<RequestAuthCodeMutation>;
export type RequestAuthCodeMutationOptions = Apollo.BaseMutationOptions<RequestAuthCodeMutation, RequestAuthCodeMutationVariables>;
export const VerifyAuthCodeDocument = gql`
    mutation verifyAuthCode($email: String!, $code: String!) {
  verifyAuthCode(email: $email, code: $code)
}
    `;
export type VerifyAuthCodeMutationFn = Apollo.MutationFunction<VerifyAuthCodeMutation, VerifyAuthCodeMutationVariables>;

/**
 * __useVerifyAuthCodeMutation__
 *
 * To run a mutation, you first call `useVerifyAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthCodeMutation, { data, loading, error }] = useVerifyAuthCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAuthCodeMutation, VerifyAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAuthCodeMutation, VerifyAuthCodeMutationVariables>(VerifyAuthCodeDocument, options);
      }
export type VerifyAuthCodeMutationHookResult = ReturnType<typeof useVerifyAuthCodeMutation>;
export type VerifyAuthCodeMutationResult = Apollo.MutationResult<VerifyAuthCodeMutation>;
export type VerifyAuthCodeMutationOptions = Apollo.BaseMutationOptions<VerifyAuthCodeMutation, VerifyAuthCodeMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation requestPasswordReset($requestInput: RequestPasswordResetInput!) {
  requestPasswordReset(requestInput: $requestInput)
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      requestInput: // value for 'requestInput'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($resetInput: ResetPasswordInput!) {
  resetPassword(resetInput: $resetInput)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetInput: // value for 'resetInput'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const GetAutoCompleteUsersSearchPatternNoPaginationDocument = gql`
    query getAutoCompleteUsersSearchPatternNoPagination($searchPattern: String, $paginationOptions: PaginationOptionsInput) {
  autoCompleteUsersSearchPattern(
    searchPattern: $searchPattern
    paginationOptions: $paginationOptions
  ) {
    result
  }
}
    `;

/**
 * __useGetAutoCompleteUsersSearchPatternNoPaginationQuery__
 *
 * To run a query within a React component, call `useGetAutoCompleteUsersSearchPatternNoPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoCompleteUsersSearchPatternNoPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoCompleteUsersSearchPatternNoPaginationQuery({
 *   variables: {
 *      searchPattern: // value for 'searchPattern'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useGetAutoCompleteUsersSearchPatternNoPaginationQuery(baseOptions?: Apollo.QueryHookOptions<GetAutoCompleteUsersSearchPatternNoPaginationQuery, GetAutoCompleteUsersSearchPatternNoPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutoCompleteUsersSearchPatternNoPaginationQuery, GetAutoCompleteUsersSearchPatternNoPaginationQueryVariables>(GetAutoCompleteUsersSearchPatternNoPaginationDocument, options);
      }
export function useGetAutoCompleteUsersSearchPatternNoPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutoCompleteUsersSearchPatternNoPaginationQuery, GetAutoCompleteUsersSearchPatternNoPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutoCompleteUsersSearchPatternNoPaginationQuery, GetAutoCompleteUsersSearchPatternNoPaginationQueryVariables>(GetAutoCompleteUsersSearchPatternNoPaginationDocument, options);
        }
export function useGetAutoCompleteUsersSearchPatternNoPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAutoCompleteUsersSearchPatternNoPaginationQuery, GetAutoCompleteUsersSearchPatternNoPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAutoCompleteUsersSearchPatternNoPaginationQuery, GetAutoCompleteUsersSearchPatternNoPaginationQueryVariables>(GetAutoCompleteUsersSearchPatternNoPaginationDocument, options);
        }
export type GetAutoCompleteUsersSearchPatternNoPaginationQueryHookResult = ReturnType<typeof useGetAutoCompleteUsersSearchPatternNoPaginationQuery>;
export type GetAutoCompleteUsersSearchPatternNoPaginationLazyQueryHookResult = ReturnType<typeof useGetAutoCompleteUsersSearchPatternNoPaginationLazyQuery>;
export type GetAutoCompleteUsersSearchPatternNoPaginationSuspenseQueryHookResult = ReturnType<typeof useGetAutoCompleteUsersSearchPatternNoPaginationSuspenseQuery>;
export type GetAutoCompleteUsersSearchPatternNoPaginationQueryResult = Apollo.QueryResult<GetAutoCompleteUsersSearchPatternNoPaginationQuery, GetAutoCompleteUsersSearchPatternNoPaginationQueryVariables>;
export const SaveBookmarkDocument = gql`
    mutation saveBookmark($entityId: ID!, $type: BookmarkTypeEnum!) {
  saveBookmark(entityId: $entityId, type: $type) {
    id
    ... on BookmarkUserType {
      user {
        id
        hasBookmarked
      }
    }
  }
}
    `;
export type SaveBookmarkMutationFn = Apollo.MutationFunction<SaveBookmarkMutation, SaveBookmarkMutationVariables>;

/**
 * __useSaveBookmarkMutation__
 *
 * To run a mutation, you first call `useSaveBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookmarkMutation, { data, loading, error }] = useSaveBookmarkMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSaveBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookmarkMutation, SaveBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookmarkMutation, SaveBookmarkMutationVariables>(SaveBookmarkDocument, options);
      }
export type SaveBookmarkMutationHookResult = ReturnType<typeof useSaveBookmarkMutation>;
export type SaveBookmarkMutationResult = Apollo.MutationResult<SaveBookmarkMutation>;
export type SaveBookmarkMutationOptions = Apollo.BaseMutationOptions<SaveBookmarkMutation, SaveBookmarkMutationVariables>;
export const RemoveBookmarkDocument = gql`
    mutation removeBookmark($entityId: ID!, $type: BookmarkTypeEnum!) {
  removeBookmark(entityId: $entityId, type: $type)
}
    `;
export type RemoveBookmarkMutationFn = Apollo.MutationFunction<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;

/**
 * __useRemoveBookmarkMutation__
 *
 * To run a mutation, you first call `useRemoveBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookmarkMutation, { data, loading, error }] = useRemoveBookmarkMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRemoveBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>(RemoveBookmarkDocument, options);
      }
export type RemoveBookmarkMutationHookResult = ReturnType<typeof useRemoveBookmarkMutation>;
export type RemoveBookmarkMutationResult = Apollo.MutationResult<RemoveBookmarkMutation>;
export type RemoveBookmarkMutationOptions = Apollo.BaseMutationOptions<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;
export const GetBookmarksDocument = gql`
    query getBookmarks($type: BookmarkTypeEnum!, $paginationOptions: PaginationOptionsInput) {
  bookmarks(type: $type, paginationOptions: $paginationOptions) {
    pagination {
      totalCount
    }
    result {
      id
      ... on BookmarkUserType {
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookmarksQuery__
 *
 * To run a query within a React component, call `useGetBookmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarksQuery({
 *   variables: {
 *      type: // value for 'type'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useGetBookmarksQuery(baseOptions: Apollo.QueryHookOptions<GetBookmarksQuery, GetBookmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookmarksQuery, GetBookmarksQueryVariables>(GetBookmarksDocument, options);
      }
export function useGetBookmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookmarksQuery, GetBookmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookmarksQuery, GetBookmarksQueryVariables>(GetBookmarksDocument, options);
        }
export function useGetBookmarksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookmarksQuery, GetBookmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookmarksQuery, GetBookmarksQueryVariables>(GetBookmarksDocument, options);
        }
export type GetBookmarksQueryHookResult = ReturnType<typeof useGetBookmarksQuery>;
export type GetBookmarksLazyQueryHookResult = ReturnType<typeof useGetBookmarksLazyQuery>;
export type GetBookmarksSuspenseQueryHookResult = ReturnType<typeof useGetBookmarksSuspenseQuery>;
export type GetBookmarksQueryResult = Apollo.QueryResult<GetBookmarksQuery, GetBookmarksQueryVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($companyId: ID!, $updateInput: UpdateCompanyInput!) {
  updateCompany(companyId: $companyId, updateInput: $updateInput) {
    id
    featureFlags
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const PublishCompanyProfileForPublicProfileDocument = gql`
    mutation publishCompanyProfileForPublicProfile($profileId: String!) {
  companyProfile: publishCompanyProfile(profileId: $profileId) {
    id
    isPublished
    isComplete
    name
    logo {
      id
      fullUrl(width: 500, height: 500)
    }
  }
}
    `;
export type PublishCompanyProfileForPublicProfileMutationFn = Apollo.MutationFunction<PublishCompanyProfileForPublicProfileMutation, PublishCompanyProfileForPublicProfileMutationVariables>;

/**
 * __usePublishCompanyProfileForPublicProfileMutation__
 *
 * To run a mutation, you first call `usePublishCompanyProfileForPublicProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCompanyProfileForPublicProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCompanyProfileForPublicProfileMutation, { data, loading, error }] = usePublishCompanyProfileForPublicProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function usePublishCompanyProfileForPublicProfileMutation(baseOptions?: Apollo.MutationHookOptions<PublishCompanyProfileForPublicProfileMutation, PublishCompanyProfileForPublicProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishCompanyProfileForPublicProfileMutation, PublishCompanyProfileForPublicProfileMutationVariables>(PublishCompanyProfileForPublicProfileDocument, options);
      }
export type PublishCompanyProfileForPublicProfileMutationHookResult = ReturnType<typeof usePublishCompanyProfileForPublicProfileMutation>;
export type PublishCompanyProfileForPublicProfileMutationResult = Apollo.MutationResult<PublishCompanyProfileForPublicProfileMutation>;
export type PublishCompanyProfileForPublicProfileMutationOptions = Apollo.BaseMutationOptions<PublishCompanyProfileForPublicProfileMutation, PublishCompanyProfileForPublicProfileMutationVariables>;
export const SaveCompanyProfileDocument = gql`
    mutation saveCompanyProfile($profileId: String!, $changes: SaveCompanyProfileInput!) {
  saveCompanyProfile(profileId: $profileId, changes: $changes) {
    id
    name
    missionStatement
    founded
    serviceDescription
    officeDescription
    marketsDescription
    clientsDescription
    latestFunding {
      currency {
        id
        code
        symbol
      }
      value
      round
      fundedAt
    }
    video {
      videoId
      rawUrl
      embedUrl
      source
    }
    isPublished
    isComplete
    completeness
  }
}
    `;
export type SaveCompanyProfileMutationFn = Apollo.MutationFunction<SaveCompanyProfileMutation, SaveCompanyProfileMutationVariables>;

/**
 * __useSaveCompanyProfileMutation__
 *
 * To run a mutation, you first call `useSaveCompanyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompanyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCompanyProfileMutation, { data, loading, error }] = useSaveCompanyProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useSaveCompanyProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveCompanyProfileMutation, SaveCompanyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCompanyProfileMutation, SaveCompanyProfileMutationVariables>(SaveCompanyProfileDocument, options);
      }
export type SaveCompanyProfileMutationHookResult = ReturnType<typeof useSaveCompanyProfileMutation>;
export type SaveCompanyProfileMutationResult = Apollo.MutationResult<SaveCompanyProfileMutation>;
export type SaveCompanyProfileMutationOptions = Apollo.BaseMutationOptions<SaveCompanyProfileMutation, SaveCompanyProfileMutationVariables>;
export const UpdateCompanyAuthCodeToggleDocument = gql`
    mutation updateCompanyAuthCodeToggle($companyId: ID!, $updateInput: UpdateCompanyInput!) {
  updateCompany(companyId: $companyId, updateInput: $updateInput) {
    id
    isAuthCodeRequired
  }
}
    `;
export type UpdateCompanyAuthCodeToggleMutationFn = Apollo.MutationFunction<UpdateCompanyAuthCodeToggleMutation, UpdateCompanyAuthCodeToggleMutationVariables>;

/**
 * __useUpdateCompanyAuthCodeToggleMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyAuthCodeToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyAuthCodeToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyAuthCodeToggleMutation, { data, loading, error }] = useUpdateCompanyAuthCodeToggleMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateCompanyAuthCodeToggleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyAuthCodeToggleMutation, UpdateCompanyAuthCodeToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyAuthCodeToggleMutation, UpdateCompanyAuthCodeToggleMutationVariables>(UpdateCompanyAuthCodeToggleDocument, options);
      }
export type UpdateCompanyAuthCodeToggleMutationHookResult = ReturnType<typeof useUpdateCompanyAuthCodeToggleMutation>;
export type UpdateCompanyAuthCodeToggleMutationResult = Apollo.MutationResult<UpdateCompanyAuthCodeToggleMutation>;
export type UpdateCompanyAuthCodeToggleMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyAuthCodeToggleMutation, UpdateCompanyAuthCodeToggleMutationVariables>;
export const ReplyToReviewDocument = gql`
    mutation replyToReview($reviewId: ID!, $replyToReviewInput: ReplyToReviewInput!) {
  replyToReview(reviewId: $reviewId, replyToReviewInput: $replyToReviewInput) {
    id
    reply {
      comment
      repliedBy {
        id
        fullName
        title
        availableCompanies {
          isCurrent
          company {
            id
            profile {
              id
              logo {
                id
                fullUrl(width: 400, height: 400)
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type ReplyToReviewMutationFn = Apollo.MutationFunction<ReplyToReviewMutation, ReplyToReviewMutationVariables>;

/**
 * __useReplyToReviewMutation__
 *
 * To run a mutation, you first call `useReplyToReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyToReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyToReviewMutation, { data, loading, error }] = useReplyToReviewMutation({
 *   variables: {
 *      reviewId: // value for 'reviewId'
 *      replyToReviewInput: // value for 'replyToReviewInput'
 *   },
 * });
 */
export function useReplyToReviewMutation(baseOptions?: Apollo.MutationHookOptions<ReplyToReviewMutation, ReplyToReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplyToReviewMutation, ReplyToReviewMutationVariables>(ReplyToReviewDocument, options);
      }
export type ReplyToReviewMutationHookResult = ReturnType<typeof useReplyToReviewMutation>;
export type ReplyToReviewMutationResult = Apollo.MutationResult<ReplyToReviewMutation>;
export type ReplyToReviewMutationOptions = Apollo.BaseMutationOptions<ReplyToReviewMutation, ReplyToReviewMutationVariables>;
export const RelocationBenefitsDocument = gql`
    query relocationBenefits {
  relocationBenefits {
    id
    key
    value
  }
}
    `;

/**
 * __useRelocationBenefitsQuery__
 *
 * To run a query within a React component, call `useRelocationBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelocationBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelocationBenefitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRelocationBenefitsQuery(baseOptions?: Apollo.QueryHookOptions<RelocationBenefitsQuery, RelocationBenefitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelocationBenefitsQuery, RelocationBenefitsQueryVariables>(RelocationBenefitsDocument, options);
      }
export function useRelocationBenefitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelocationBenefitsQuery, RelocationBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelocationBenefitsQuery, RelocationBenefitsQueryVariables>(RelocationBenefitsDocument, options);
        }
export function useRelocationBenefitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RelocationBenefitsQuery, RelocationBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelocationBenefitsQuery, RelocationBenefitsQueryVariables>(RelocationBenefitsDocument, options);
        }
export type RelocationBenefitsQueryHookResult = ReturnType<typeof useRelocationBenefitsQuery>;
export type RelocationBenefitsLazyQueryHookResult = ReturnType<typeof useRelocationBenefitsLazyQuery>;
export type RelocationBenefitsSuspenseQueryHookResult = ReturnType<typeof useRelocationBenefitsSuspenseQuery>;
export type RelocationBenefitsQueryResult = Apollo.QueryResult<RelocationBenefitsQuery, RelocationBenefitsQueryVariables>;
export const TeamMembersQueryDocument = gql`
    query teamMembersQuery {
  company {
    id
    teamMembers {
      id
      nameInitials
      fullName
      avatar {
        id
        fullUrl(width: 100, height: 100)
      }
    }
  }
}
    `;

/**
 * __useTeamMembersQueryQuery__
 *
 * To run a query within a React component, call `useTeamMembersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamMembersQueryQuery(baseOptions?: Apollo.QueryHookOptions<TeamMembersQueryQuery, TeamMembersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMembersQueryQuery, TeamMembersQueryQueryVariables>(TeamMembersQueryDocument, options);
      }
export function useTeamMembersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMembersQueryQuery, TeamMembersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMembersQueryQuery, TeamMembersQueryQueryVariables>(TeamMembersQueryDocument, options);
        }
export function useTeamMembersQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamMembersQueryQuery, TeamMembersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamMembersQueryQuery, TeamMembersQueryQueryVariables>(TeamMembersQueryDocument, options);
        }
export type TeamMembersQueryQueryHookResult = ReturnType<typeof useTeamMembersQueryQuery>;
export type TeamMembersQueryLazyQueryHookResult = ReturnType<typeof useTeamMembersQueryLazyQuery>;
export type TeamMembersQuerySuspenseQueryHookResult = ReturnType<typeof useTeamMembersQuerySuspenseQuery>;
export type TeamMembersQueryQueryResult = Apollo.QueryResult<TeamMembersQueryQuery, TeamMembersQueryQueryVariables>;
export const CompanyReviewsDocument = gql`
    query companyReviews($paginationOptions: PaginationOptionsInput) {
  company {
    id
    ratings {
      ...companyRatingsFragment
    }
    reviews(paginationOptions: $paginationOptions) {
      pagination {
        minCursor
        maxCursor
        limit
        hasMoreResults
        totalCount
      }
      result {
        id
        createdAt
        actor {
          ...reviewActorFragment
        }
        type
        reply {
          comment
          repliedBy {
            id
            fullName
            title
            availableCompanies {
              isCurrent
              company {
                id
                profile {
                  id
                  logo {
                    id
                    fullUrl(width: 400, height: 400)
                  }
                }
              }
            }
          }
        }
        ... on CompanyReviewType {
          comment
          userAssociations: userAssociation
        }
        ... on CompanyRatingReviewType {
          userAssociation
          positiveFeedback
          negativeFeedback
          title
          isAnonymous
          ratings {
            ...companyReviewRatingsFragment
          }
        }
      }
    }
  }
}
    ${CompanyRatingsFragmentFragmentDoc}
${ReviewActorFragmentFragmentDoc}
${CompanyReviewRatingsFragmentFragmentDoc}`;

/**
 * __useCompanyReviewsQuery__
 *
 * To run a query within a React component, call `useCompanyReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyReviewsQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useCompanyReviewsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyReviewsQuery, CompanyReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyReviewsQuery, CompanyReviewsQueryVariables>(CompanyReviewsDocument, options);
      }
export function useCompanyReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyReviewsQuery, CompanyReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyReviewsQuery, CompanyReviewsQueryVariables>(CompanyReviewsDocument, options);
        }
export function useCompanyReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyReviewsQuery, CompanyReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyReviewsQuery, CompanyReviewsQueryVariables>(CompanyReviewsDocument, options);
        }
export type CompanyReviewsQueryHookResult = ReturnType<typeof useCompanyReviewsQuery>;
export type CompanyReviewsLazyQueryHookResult = ReturnType<typeof useCompanyReviewsLazyQuery>;
export type CompanyReviewsSuspenseQueryHookResult = ReturnType<typeof useCompanyReviewsSuspenseQuery>;
export type CompanyReviewsQueryResult = Apollo.QueryResult<CompanyReviewsQuery, CompanyReviewsQueryVariables>;
export const CompanyNameDocument = gql`
    query companyName {
  company {
    id
    profile {
      id
      name
    }
  }
}
    `;

/**
 * __useCompanyNameQuery__
 *
 * To run a query within a React component, call `useCompanyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyNameQuery(baseOptions?: Apollo.QueryHookOptions<CompanyNameQuery, CompanyNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyNameQuery, CompanyNameQueryVariables>(CompanyNameDocument, options);
      }
export function useCompanyNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyNameQuery, CompanyNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyNameQuery, CompanyNameQueryVariables>(CompanyNameDocument, options);
        }
export function useCompanyNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyNameQuery, CompanyNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyNameQuery, CompanyNameQueryVariables>(CompanyNameDocument, options);
        }
export type CompanyNameQueryHookResult = ReturnType<typeof useCompanyNameQuery>;
export type CompanyNameLazyQueryHookResult = ReturnType<typeof useCompanyNameLazyQuery>;
export type CompanyNameSuspenseQueryHookResult = ReturnType<typeof useCompanyNameSuspenseQuery>;
export type CompanyNameQueryResult = Apollo.QueryResult<CompanyNameQuery, CompanyNameQueryVariables>;
export const CompanyByProfileDocument = gql`
    query companyByProfile($companyProfileId: String!) {
  company: companyByProfile(profileId: $companyProfileId) {
    id
    companyTypes {
      id
      name
    }
    industries {
      id
      name
    }
    featureFlags
    hasPublishedProfile
    profile(id: $companyProfileId) {
      id
      state
      name
      missionStatement
      serviceDescription
      officeDescription
      marketsDescription
      clientsDescription
      isPublished
      isComplete
      completeness
      founded
      funding {
        id
        value
      }
      latestFunding {
        currency {
          id
          code
          symbol
        }
        value
        round
        fundedAt
      }
      video {
        id
        videoId
        rawUrl
        embedUrl
        source
      }
      revenue {
        id
        value
      }
      locations {
        id
        description
        longName
        shortName
        placeId
        main
      }
      marketAreas {
        id
        type
        longName
      }
      marketCountries {
        id
        longName
        continent {
          id
          longName
        }
      }
      logo {
        id
        fullUrl(width: 500, height: 500)
      }
      headerImage {
        id
        fullUrl(width: 1024, height: 500)
      }
      productImages {
        id
        fullUrl(width: 900, height: 540)
      }
      officeVideo {
        id
        rawUrl
        source
      }
      officeImages {
        id
        fullUrl(width: 900, height: 540)
      }
      companySize {
        id
        name
      }
      benefits {
        id
        key
        value
      }
      clients {
        id
        name
        logo {
          id
          fullUrl(width: 500, height: 500)
        }
      }
      socialMedia {
        source
        url
      }
      media {
        id
        title
        url
        siteName
        image {
          url
          width
          height
        }
      }
    }
  }
}
    `;

/**
 * __useCompanyByProfileQuery__
 *
 * To run a query within a React component, call `useCompanyByProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyByProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyByProfileQuery({
 *   variables: {
 *      companyProfileId: // value for 'companyProfileId'
 *   },
 * });
 */
export function useCompanyByProfileQuery(baseOptions: Apollo.QueryHookOptions<CompanyByProfileQuery, CompanyByProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyByProfileQuery, CompanyByProfileQueryVariables>(CompanyByProfileDocument, options);
      }
export function useCompanyByProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyByProfileQuery, CompanyByProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyByProfileQuery, CompanyByProfileQueryVariables>(CompanyByProfileDocument, options);
        }
export function useCompanyByProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyByProfileQuery, CompanyByProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyByProfileQuery, CompanyByProfileQueryVariables>(CompanyByProfileDocument, options);
        }
export type CompanyByProfileQueryHookResult = ReturnType<typeof useCompanyByProfileQuery>;
export type CompanyByProfileLazyQueryHookResult = ReturnType<typeof useCompanyByProfileLazyQuery>;
export type CompanyByProfileSuspenseQueryHookResult = ReturnType<typeof useCompanyByProfileSuspenseQuery>;
export type CompanyByProfileQueryResult = Apollo.QueryResult<CompanyByProfileQuery, CompanyByProfileQueryVariables>;
export const CompanyDocument = gql`
    query company($companyProfileState: CompanyProfileStateEnum) {
  company {
    id
    companyTypes {
      id
      name
    }
    industries {
      id
      name
    }
    featureFlags
    hasPublishedProfile
    profile: latestProfile(state: $companyProfileState) {
      id
      state
      name
      missionStatement
      serviceDescription
      officeDescription
      marketsDescription
      clientsDescription
      isPublished
      isComplete
      completeness
      founded
      funding {
        id
        value
      }
      video {
        id
        videoId
        rawUrl
        embedUrl
        source
      }
      revenue {
        id
        value
      }
      locations {
        id
        description
        shortName
        longName
        placeId
        main
      }
      marketAreas {
        id
        type
        longName
      }
      marketCountries {
        id
        longName
        continent {
          id
          longName
        }
      }
      logo {
        id
        fullUrl(width: 500, height: 500)
      }
      headerImage {
        id
        fullUrl(width: 1024, height: 500)
      }
      productImages {
        id
        fullUrl(width: 900, height: 540)
      }
      officeVideo {
        id
        rawUrl
        source
      }
      officeImages {
        id
        fullUrl(width: 900, height: 540)
      }
      companySize {
        id
        name
      }
      benefits {
        id
        key
        value
      }
      clients {
        id
        name
        logo {
          id
          fullUrl(width: 500, height: 500)
        }
      }
      socialMedia {
        source
        url
      }
      media {
        id
        title
        url
        siteName
        image {
          url
          width
          height
        }
      }
    }
  }
}
    `;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      companyProfileState: // value for 'companyProfileState'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions?: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export function useCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanySuspenseQueryHookResult = ReturnType<typeof useCompanySuspenseQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const CompanyPublicProfileListDataDocument = gql`
    query companyPublicProfileListData {
  companyBenefits {
    id
    key
    value
  }
  companyTypes {
    id
    key
    name
  }
  companySizes {
    id
    name
    min
    max
  }
  companyFundings {
    id
    key
    value
    min
    max
  }
  companyRevenues {
    id
    key
    value
    min
    max
  }
}
    `;

/**
 * __useCompanyPublicProfileListDataQuery__
 *
 * To run a query within a React component, call `useCompanyPublicProfileListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyPublicProfileListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyPublicProfileListDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyPublicProfileListDataQuery(baseOptions?: Apollo.QueryHookOptions<CompanyPublicProfileListDataQuery, CompanyPublicProfileListDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyPublicProfileListDataQuery, CompanyPublicProfileListDataQueryVariables>(CompanyPublicProfileListDataDocument, options);
      }
export function useCompanyPublicProfileListDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyPublicProfileListDataQuery, CompanyPublicProfileListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyPublicProfileListDataQuery, CompanyPublicProfileListDataQueryVariables>(CompanyPublicProfileListDataDocument, options);
        }
export function useCompanyPublicProfileListDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyPublicProfileListDataQuery, CompanyPublicProfileListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyPublicProfileListDataQuery, CompanyPublicProfileListDataQueryVariables>(CompanyPublicProfileListDataDocument, options);
        }
export type CompanyPublicProfileListDataQueryHookResult = ReturnType<typeof useCompanyPublicProfileListDataQuery>;
export type CompanyPublicProfileListDataLazyQueryHookResult = ReturnType<typeof useCompanyPublicProfileListDataLazyQuery>;
export type CompanyPublicProfileListDataSuspenseQueryHookResult = ReturnType<typeof useCompanyPublicProfileListDataSuspenseQuery>;
export type CompanyPublicProfileListDataQueryResult = Apollo.QueryResult<CompanyPublicProfileListDataQuery, CompanyPublicProfileListDataQueryVariables>;
export const CompanySizesDocument = gql`
    query companySizes {
  companySizes {
    id
    name
    min
    max
  }
}
    `;

/**
 * __useCompanySizesQuery__
 *
 * To run a query within a React component, call `useCompanySizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySizesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanySizesQuery(baseOptions?: Apollo.QueryHookOptions<CompanySizesQuery, CompanySizesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySizesQuery, CompanySizesQueryVariables>(CompanySizesDocument, options);
      }
export function useCompanySizesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySizesQuery, CompanySizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySizesQuery, CompanySizesQueryVariables>(CompanySizesDocument, options);
        }
export function useCompanySizesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanySizesQuery, CompanySizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanySizesQuery, CompanySizesQueryVariables>(CompanySizesDocument, options);
        }
export type CompanySizesQueryHookResult = ReturnType<typeof useCompanySizesQuery>;
export type CompanySizesLazyQueryHookResult = ReturnType<typeof useCompanySizesLazyQuery>;
export type CompanySizesSuspenseQueryHookResult = ReturnType<typeof useCompanySizesSuspenseQuery>;
export type CompanySizesQueryResult = Apollo.QueryResult<CompanySizesQuery, CompanySizesQueryVariables>;
export const CompanyTeamMembersDocument = gql`
    query companyTeamMembers {
  company {
    id
    teamMembers {
      id
      fullName
      email
      avatarUrl
      avatarColor
      nameInitials
      lastSeen
      role
    }
  }
}
    `;

/**
 * __useCompanyTeamMembersQuery__
 *
 * To run a query within a React component, call `useCompanyTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<CompanyTeamMembersQuery, CompanyTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyTeamMembersQuery, CompanyTeamMembersQueryVariables>(CompanyTeamMembersDocument, options);
      }
export function useCompanyTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyTeamMembersQuery, CompanyTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyTeamMembersQuery, CompanyTeamMembersQueryVariables>(CompanyTeamMembersDocument, options);
        }
export function useCompanyTeamMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyTeamMembersQuery, CompanyTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyTeamMembersQuery, CompanyTeamMembersQueryVariables>(CompanyTeamMembersDocument, options);
        }
export type CompanyTeamMembersQueryHookResult = ReturnType<typeof useCompanyTeamMembersQuery>;
export type CompanyTeamMembersLazyQueryHookResult = ReturnType<typeof useCompanyTeamMembersLazyQuery>;
export type CompanyTeamMembersSuspenseQueryHookResult = ReturnType<typeof useCompanyTeamMembersSuspenseQuery>;
export type CompanyTeamMembersQueryResult = Apollo.QueryResult<CompanyTeamMembersQuery, CompanyTeamMembersQueryVariables>;
export const CompanyAuthCodeToggleDocument = gql`
    query companyAuthCodeToggle {
  company {
    id
    isAuthCodeRequired
  }
}
    `;

/**
 * __useCompanyAuthCodeToggleQuery__
 *
 * To run a query within a React component, call `useCompanyAuthCodeToggleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAuthCodeToggleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAuthCodeToggleQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyAuthCodeToggleQuery(baseOptions?: Apollo.QueryHookOptions<CompanyAuthCodeToggleQuery, CompanyAuthCodeToggleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAuthCodeToggleQuery, CompanyAuthCodeToggleQueryVariables>(CompanyAuthCodeToggleDocument, options);
      }
export function useCompanyAuthCodeToggleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAuthCodeToggleQuery, CompanyAuthCodeToggleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAuthCodeToggleQuery, CompanyAuthCodeToggleQueryVariables>(CompanyAuthCodeToggleDocument, options);
        }
export function useCompanyAuthCodeToggleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyAuthCodeToggleQuery, CompanyAuthCodeToggleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyAuthCodeToggleQuery, CompanyAuthCodeToggleQueryVariables>(CompanyAuthCodeToggleDocument, options);
        }
export type CompanyAuthCodeToggleQueryHookResult = ReturnType<typeof useCompanyAuthCodeToggleQuery>;
export type CompanyAuthCodeToggleLazyQueryHookResult = ReturnType<typeof useCompanyAuthCodeToggleLazyQuery>;
export type CompanyAuthCodeToggleSuspenseQueryHookResult = ReturnType<typeof useCompanyAuthCodeToggleSuspenseQuery>;
export type CompanyAuthCodeToggleQueryResult = Apollo.QueryResult<CompanyAuthCodeToggleQuery, CompanyAuthCodeToggleQueryVariables>;
export const GetRecentlySeenCompaniesDocument = gql`
    query getRecentlySeenCompanies($paginationOptions: PaginationOptionsInput) {
  recentlySeenCompanies(paginationOptions: $paginationOptions) {
    pagination {
      minCursor
      maxCursor
      limit
      hasMoreResults
      totalCount
    }
    result {
      id
      lastSeen
      profile {
        id
        name
        logo {
          id
          fullUrl(width: 500, height: 500)
        }
        offices {
          isFoundingLocation
          isHeadquarter
          location {
            id
            shortName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecentlySeenCompaniesQuery__
 *
 * To run a query within a React component, call `useGetRecentlySeenCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentlySeenCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentlySeenCompaniesQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useGetRecentlySeenCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentlySeenCompaniesQuery, GetRecentlySeenCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentlySeenCompaniesQuery, GetRecentlySeenCompaniesQueryVariables>(GetRecentlySeenCompaniesDocument, options);
      }
export function useGetRecentlySeenCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentlySeenCompaniesQuery, GetRecentlySeenCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentlySeenCompaniesQuery, GetRecentlySeenCompaniesQueryVariables>(GetRecentlySeenCompaniesDocument, options);
        }
export function useGetRecentlySeenCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentlySeenCompaniesQuery, GetRecentlySeenCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentlySeenCompaniesQuery, GetRecentlySeenCompaniesQueryVariables>(GetRecentlySeenCompaniesDocument, options);
        }
export type GetRecentlySeenCompaniesQueryHookResult = ReturnType<typeof useGetRecentlySeenCompaniesQuery>;
export type GetRecentlySeenCompaniesLazyQueryHookResult = ReturnType<typeof useGetRecentlySeenCompaniesLazyQuery>;
export type GetRecentlySeenCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetRecentlySeenCompaniesSuspenseQuery>;
export type GetRecentlySeenCompaniesQueryResult = Apollo.QueryResult<GetRecentlySeenCompaniesQuery, GetRecentlySeenCompaniesQueryVariables>;
export const AvailableCurrenciesQueryDocument = gql`
    query availableCurrenciesQuery {
  availableCurrencies {
    id
    code
    symbol
  }
}
    `;

/**
 * __useAvailableCurrenciesQueryQuery__
 *
 * To run a query within a React component, call `useAvailableCurrenciesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCurrenciesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableCurrenciesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableCurrenciesQueryQuery(baseOptions?: Apollo.QueryHookOptions<AvailableCurrenciesQueryQuery, AvailableCurrenciesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCurrenciesQueryQuery, AvailableCurrenciesQueryQueryVariables>(AvailableCurrenciesQueryDocument, options);
      }
export function useAvailableCurrenciesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCurrenciesQueryQuery, AvailableCurrenciesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCurrenciesQueryQuery, AvailableCurrenciesQueryQueryVariables>(AvailableCurrenciesQueryDocument, options);
        }
export function useAvailableCurrenciesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableCurrenciesQueryQuery, AvailableCurrenciesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableCurrenciesQueryQuery, AvailableCurrenciesQueryQueryVariables>(AvailableCurrenciesQueryDocument, options);
        }
export type AvailableCurrenciesQueryQueryHookResult = ReturnType<typeof useAvailableCurrenciesQueryQuery>;
export type AvailableCurrenciesQueryLazyQueryHookResult = ReturnType<typeof useAvailableCurrenciesQueryLazyQuery>;
export type AvailableCurrenciesQuerySuspenseQueryHookResult = ReturnType<typeof useAvailableCurrenciesQuerySuspenseQuery>;
export type AvailableCurrenciesQueryQueryResult = Apollo.QueryResult<AvailableCurrenciesQueryQuery, AvailableCurrenciesQueryQueryVariables>;
export const CustomerForActivateSubscriptionDocument = gql`
    query customerForActivateSubscription {
  customer {
    id
    planType
    isPayByInvoiceEnabled
    paysByInvoice
    paymentMethods {
      id
    }
    planInfo {
      price
      currency {
        id
        code
        symbol
      }
      ... on SubscriptionPlanType {
        trialEndsAt
        state
        occupiedOpeningSlots
        hasOpeningsLimitReached
        nextPaymentDate
        nextPaymentDateMonthly: nextPaymentDate(subscriptionCycle: MONTHLY)
        nextPaymentDateHalfYearly: nextPaymentDate(subscriptionCycle: HALF_YEARLY)
        nextPaymentDateYearly: nextPaymentDate(subscriptionCycle: YEARLY)
      }
    }
  }
}
    `;

/**
 * __useCustomerForActivateSubscriptionQuery__
 *
 * To run a query within a React component, call `useCustomerForActivateSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerForActivateSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerForActivateSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerForActivateSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<CustomerForActivateSubscriptionQuery, CustomerForActivateSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerForActivateSubscriptionQuery, CustomerForActivateSubscriptionQueryVariables>(CustomerForActivateSubscriptionDocument, options);
      }
export function useCustomerForActivateSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerForActivateSubscriptionQuery, CustomerForActivateSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerForActivateSubscriptionQuery, CustomerForActivateSubscriptionQueryVariables>(CustomerForActivateSubscriptionDocument, options);
        }
export function useCustomerForActivateSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerForActivateSubscriptionQuery, CustomerForActivateSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerForActivateSubscriptionQuery, CustomerForActivateSubscriptionQueryVariables>(CustomerForActivateSubscriptionDocument, options);
        }
export type CustomerForActivateSubscriptionQueryHookResult = ReturnType<typeof useCustomerForActivateSubscriptionQuery>;
export type CustomerForActivateSubscriptionLazyQueryHookResult = ReturnType<typeof useCustomerForActivateSubscriptionLazyQuery>;
export type CustomerForActivateSubscriptionSuspenseQueryHookResult = ReturnType<typeof useCustomerForActivateSubscriptionSuspenseQuery>;
export type CustomerForActivateSubscriptionQueryResult = Apollo.QueryResult<CustomerForActivateSubscriptionQuery, CustomerForActivateSubscriptionQueryVariables>;
export const PublishOpeningDataDocument = gql`
    query publishOpeningData {
  customer {
    id
    planType
    planInfo {
      ... on SubscriptionPlanType {
        openingActivationPrice
        nextPaymentDate
        currency {
          id
          symbol
        }
      }
    }
  }
}
    `;

/**
 * __usePublishOpeningDataQuery__
 *
 * To run a query within a React component, call `usePublishOpeningDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishOpeningDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishOpeningDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublishOpeningDataQuery(baseOptions?: Apollo.QueryHookOptions<PublishOpeningDataQuery, PublishOpeningDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishOpeningDataQuery, PublishOpeningDataQueryVariables>(PublishOpeningDataDocument, options);
      }
export function usePublishOpeningDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishOpeningDataQuery, PublishOpeningDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishOpeningDataQuery, PublishOpeningDataQueryVariables>(PublishOpeningDataDocument, options);
        }
export function usePublishOpeningDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublishOpeningDataQuery, PublishOpeningDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishOpeningDataQuery, PublishOpeningDataQueryVariables>(PublishOpeningDataDocument, options);
        }
export type PublishOpeningDataQueryHookResult = ReturnType<typeof usePublishOpeningDataQuery>;
export type PublishOpeningDataLazyQueryHookResult = ReturnType<typeof usePublishOpeningDataLazyQuery>;
export type PublishOpeningDataSuspenseQueryHookResult = ReturnType<typeof usePublishOpeningDataSuspenseQuery>;
export type PublishOpeningDataQueryResult = Apollo.QueryResult<PublishOpeningDataQuery, PublishOpeningDataQueryVariables>;
export const RepublishOpeningDataDocument = gql`
    query republishOpeningData {
  customer {
    id
    planType
    planInfo {
      ... on SubscriptionPlanType {
        openingRepublishingPrice
        currency {
          id
          symbol
        }
      }
    }
  }
}
    `;

/**
 * __useRepublishOpeningDataQuery__
 *
 * To run a query within a React component, call `useRepublishOpeningDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepublishOpeningDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepublishOpeningDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useRepublishOpeningDataQuery(baseOptions?: Apollo.QueryHookOptions<RepublishOpeningDataQuery, RepublishOpeningDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepublishOpeningDataQuery, RepublishOpeningDataQueryVariables>(RepublishOpeningDataDocument, options);
      }
export function useRepublishOpeningDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepublishOpeningDataQuery, RepublishOpeningDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepublishOpeningDataQuery, RepublishOpeningDataQueryVariables>(RepublishOpeningDataDocument, options);
        }
export function useRepublishOpeningDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RepublishOpeningDataQuery, RepublishOpeningDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RepublishOpeningDataQuery, RepublishOpeningDataQueryVariables>(RepublishOpeningDataDocument, options);
        }
export type RepublishOpeningDataQueryHookResult = ReturnType<typeof useRepublishOpeningDataQuery>;
export type RepublishOpeningDataLazyQueryHookResult = ReturnType<typeof useRepublishOpeningDataLazyQuery>;
export type RepublishOpeningDataSuspenseQueryHookResult = ReturnType<typeof useRepublishOpeningDataSuspenseQuery>;
export type RepublishOpeningDataQueryResult = Apollo.QueryResult<RepublishOpeningDataQuery, RepublishOpeningDataQueryVariables>;
export const CustomerDocument = gql`
    query customer {
  customer {
    id
    planType
    hidePaymentDetails
    hidePricingDetails
    planInfo {
      ... on SubscriptionPlanType {
        state
        hasOpeningsLimitReached
      }
    }
  }
}
    `;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerQuery(baseOptions?: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export function useCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerSuspenseQueryHookResult = ReturnType<typeof useCustomerSuspenseQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const CustomerForTrialsDocument = gql`
    query customerForTrials {
  customer {
    id
    planInfo {
      ... on SubscriptionPlanType {
        trialEndsAt
      }
    }
  }
}
    `;

/**
 * __useCustomerForTrialsQuery__
 *
 * To run a query within a React component, call `useCustomerForTrialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerForTrialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerForTrialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerForTrialsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerForTrialsQuery, CustomerForTrialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerForTrialsQuery, CustomerForTrialsQueryVariables>(CustomerForTrialsDocument, options);
      }
export function useCustomerForTrialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerForTrialsQuery, CustomerForTrialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerForTrialsQuery, CustomerForTrialsQueryVariables>(CustomerForTrialsDocument, options);
        }
export function useCustomerForTrialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerForTrialsQuery, CustomerForTrialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerForTrialsQuery, CustomerForTrialsQueryVariables>(CustomerForTrialsDocument, options);
        }
export type CustomerForTrialsQueryHookResult = ReturnType<typeof useCustomerForTrialsQuery>;
export type CustomerForTrialsLazyQueryHookResult = ReturnType<typeof useCustomerForTrialsLazyQuery>;
export type CustomerForTrialsSuspenseQueryHookResult = ReturnType<typeof useCustomerForTrialsSuspenseQuery>;
export type CustomerForTrialsQueryResult = Apollo.QueryResult<CustomerForTrialsQuery, CustomerForTrialsQueryVariables>;
export const CustomerForBillingHistoryDocument = gql`
    query customerForBillingHistory {
  customer {
    id
  }
}
    `;

/**
 * __useCustomerForBillingHistoryQuery__
 *
 * To run a query within a React component, call `useCustomerForBillingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerForBillingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerForBillingHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerForBillingHistoryQuery(baseOptions?: Apollo.QueryHookOptions<CustomerForBillingHistoryQuery, CustomerForBillingHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerForBillingHistoryQuery, CustomerForBillingHistoryQueryVariables>(CustomerForBillingHistoryDocument, options);
      }
export function useCustomerForBillingHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerForBillingHistoryQuery, CustomerForBillingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerForBillingHistoryQuery, CustomerForBillingHistoryQueryVariables>(CustomerForBillingHistoryDocument, options);
        }
export function useCustomerForBillingHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerForBillingHistoryQuery, CustomerForBillingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerForBillingHistoryQuery, CustomerForBillingHistoryQueryVariables>(CustomerForBillingHistoryDocument, options);
        }
export type CustomerForBillingHistoryQueryHookResult = ReturnType<typeof useCustomerForBillingHistoryQuery>;
export type CustomerForBillingHistoryLazyQueryHookResult = ReturnType<typeof useCustomerForBillingHistoryLazyQuery>;
export type CustomerForBillingHistorySuspenseQueryHookResult = ReturnType<typeof useCustomerForBillingHistorySuspenseQuery>;
export type CustomerForBillingHistoryQueryResult = Apollo.QueryResult<CustomerForBillingHistoryQuery, CustomerForBillingHistoryQueryVariables>;
export const CustomerForCardsDocument = gql`
    query customerForCards {
  customer {
    id
    paysByInvoice
    paymentMethods {
      id
      type
      default
      last4
      masked
      imageUrl
    }
  }
}
    `;

/**
 * __useCustomerForCardsQuery__
 *
 * To run a query within a React component, call `useCustomerForCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerForCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerForCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerForCardsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerForCardsQuery, CustomerForCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerForCardsQuery, CustomerForCardsQueryVariables>(CustomerForCardsDocument, options);
      }
export function useCustomerForCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerForCardsQuery, CustomerForCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerForCardsQuery, CustomerForCardsQueryVariables>(CustomerForCardsDocument, options);
        }
export function useCustomerForCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerForCardsQuery, CustomerForCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerForCardsQuery, CustomerForCardsQueryVariables>(CustomerForCardsDocument, options);
        }
export type CustomerForCardsQueryHookResult = ReturnType<typeof useCustomerForCardsQuery>;
export type CustomerForCardsLazyQueryHookResult = ReturnType<typeof useCustomerForCardsLazyQuery>;
export type CustomerForCardsSuspenseQueryHookResult = ReturnType<typeof useCustomerForCardsSuspenseQuery>;
export type CustomerForCardsQueryResult = Apollo.QueryResult<CustomerForCardsQuery, CustomerForCardsQueryVariables>;
export const UploadMediaDocument = gql`
    mutation uploadMedia($file: Upload!, $width: Int!, $height: Int!) {
  uploadImage(file: $file) {
    id
    fullUrl(width: $width, height: $height)
  }
}
    `;
export type UploadMediaMutationFn = Apollo.MutationFunction<UploadMediaMutation, UploadMediaMutationVariables>;

/**
 * __useUploadMediaMutation__
 *
 * To run a mutation, you first call `useUploadMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaMutation, { data, loading, error }] = useUploadMediaMutation({
 *   variables: {
 *      file: // value for 'file'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *   },
 * });
 */
export function useUploadMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadMediaMutation, UploadMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMediaMutation, UploadMediaMutationVariables>(UploadMediaDocument, options);
      }
export type UploadMediaMutationHookResult = ReturnType<typeof useUploadMediaMutation>;
export type UploadMediaMutationResult = Apollo.MutationResult<UploadMediaMutation>;
export type UploadMediaMutationOptions = Apollo.BaseMutationOptions<UploadMediaMutation, UploadMediaMutationVariables>;
export const IndustriesDocument = gql`
    query industries {
  industries {
    id
    name
  }
}
    `;

/**
 * __useIndustriesQuery__
 *
 * To run a query within a React component, call `useIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndustriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndustriesQuery(baseOptions?: Apollo.QueryHookOptions<IndustriesQuery, IndustriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndustriesQuery, IndustriesQueryVariables>(IndustriesDocument, options);
      }
export function useIndustriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndustriesQuery, IndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndustriesQuery, IndustriesQueryVariables>(IndustriesDocument, options);
        }
export function useIndustriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndustriesQuery, IndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndustriesQuery, IndustriesQueryVariables>(IndustriesDocument, options);
        }
export type IndustriesQueryHookResult = ReturnType<typeof useIndustriesQuery>;
export type IndustriesLazyQueryHookResult = ReturnType<typeof useIndustriesLazyQuery>;
export type IndustriesSuspenseQueryHookResult = ReturnType<typeof useIndustriesSuspenseQuery>;
export type IndustriesQueryResult = Apollo.QueryResult<IndustriesQuery, IndustriesQueryVariables>;
export const IpDetailsDocument = gql`
    query ipDetails {
  ipDetails {
    isRealUser
  }
}
    `;

/**
 * __useIpDetailsQuery__
 *
 * To run a query within a React component, call `useIpDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIpDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIpDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIpDetailsQuery(baseOptions?: Apollo.QueryHookOptions<IpDetailsQuery, IpDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IpDetailsQuery, IpDetailsQueryVariables>(IpDetailsDocument, options);
      }
export function useIpDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IpDetailsQuery, IpDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IpDetailsQuery, IpDetailsQueryVariables>(IpDetailsDocument, options);
        }
export function useIpDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IpDetailsQuery, IpDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IpDetailsQuery, IpDetailsQueryVariables>(IpDetailsDocument, options);
        }
export type IpDetailsQueryHookResult = ReturnType<typeof useIpDetailsQuery>;
export type IpDetailsLazyQueryHookResult = ReturnType<typeof useIpDetailsLazyQuery>;
export type IpDetailsSuspenseQueryHookResult = ReturnType<typeof useIpDetailsSuspenseQuery>;
export type IpDetailsQueryResult = Apollo.QueryResult<IpDetailsQuery, IpDetailsQueryVariables>;
export const SaveLinkForCompanyProfileDocument = gql`
    mutation saveLinkForCompanyProfile($url: String) {
  saveLink(url: $url) {
    id
    type
    url
    title
    description
    siteName
    image {
      url
      width
      height
    }
  }
}
    `;
export type SaveLinkForCompanyProfileMutationFn = Apollo.MutationFunction<SaveLinkForCompanyProfileMutation, SaveLinkForCompanyProfileMutationVariables>;

/**
 * __useSaveLinkForCompanyProfileMutation__
 *
 * To run a mutation, you first call `useSaveLinkForCompanyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLinkForCompanyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLinkForCompanyProfileMutation, { data, loading, error }] = useSaveLinkForCompanyProfileMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSaveLinkForCompanyProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveLinkForCompanyProfileMutation, SaveLinkForCompanyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLinkForCompanyProfileMutation, SaveLinkForCompanyProfileMutationVariables>(SaveLinkForCompanyProfileDocument, options);
      }
export type SaveLinkForCompanyProfileMutationHookResult = ReturnType<typeof useSaveLinkForCompanyProfileMutation>;
export type SaveLinkForCompanyProfileMutationResult = Apollo.MutationResult<SaveLinkForCompanyProfileMutation>;
export type SaveLinkForCompanyProfileMutationOptions = Apollo.BaseMutationOptions<SaveLinkForCompanyProfileMutation, SaveLinkForCompanyProfileMutationVariables>;
export const CreateMessageTemplateMutationDocument = gql`
    mutation createMessageTemplateMutation($createInput: CreateMessageTemplateInput!) {
  createMessageTemplate(createInput: $createInput) {
    id
    message
  }
}
    `;
export type CreateMessageTemplateMutationMutationFn = Apollo.MutationFunction<CreateMessageTemplateMutationMutation, CreateMessageTemplateMutationMutationVariables>;

/**
 * __useCreateMessageTemplateMutationMutation__
 *
 * To run a mutation, you first call `useCreateMessageTemplateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageTemplateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageTemplateMutationMutation, { data, loading, error }] = useCreateMessageTemplateMutationMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateMessageTemplateMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageTemplateMutationMutation, CreateMessageTemplateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageTemplateMutationMutation, CreateMessageTemplateMutationMutationVariables>(CreateMessageTemplateMutationDocument, options);
      }
export type CreateMessageTemplateMutationMutationHookResult = ReturnType<typeof useCreateMessageTemplateMutationMutation>;
export type CreateMessageTemplateMutationMutationResult = Apollo.MutationResult<CreateMessageTemplateMutationMutation>;
export type CreateMessageTemplateMutationMutationOptions = Apollo.BaseMutationOptions<CreateMessageTemplateMutationMutation, CreateMessageTemplateMutationMutationVariables>;
export const MarkInboxMessageThreadAsUnreadDocument = gql`
    mutation markInboxMessageThreadAsUnread($messageThreadId: ID!) {
  markMessageThreadAsUnread(messageThreadId: $messageThreadId) {
    ...InboxMessageThreadListItem
  }
}
    ${InboxMessageThreadListItemFragmentDoc}`;
export type MarkInboxMessageThreadAsUnreadMutationFn = Apollo.MutationFunction<MarkInboxMessageThreadAsUnreadMutation, MarkInboxMessageThreadAsUnreadMutationVariables>;

/**
 * __useMarkInboxMessageThreadAsUnreadMutation__
 *
 * To run a mutation, you first call `useMarkInboxMessageThreadAsUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInboxMessageThreadAsUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInboxMessageThreadAsUnreadMutation, { data, loading, error }] = useMarkInboxMessageThreadAsUnreadMutation({
 *   variables: {
 *      messageThreadId: // value for 'messageThreadId'
 *   },
 * });
 */
export function useMarkInboxMessageThreadAsUnreadMutation(baseOptions?: Apollo.MutationHookOptions<MarkInboxMessageThreadAsUnreadMutation, MarkInboxMessageThreadAsUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInboxMessageThreadAsUnreadMutation, MarkInboxMessageThreadAsUnreadMutationVariables>(MarkInboxMessageThreadAsUnreadDocument, options);
      }
export type MarkInboxMessageThreadAsUnreadMutationHookResult = ReturnType<typeof useMarkInboxMessageThreadAsUnreadMutation>;
export type MarkInboxMessageThreadAsUnreadMutationResult = Apollo.MutationResult<MarkInboxMessageThreadAsUnreadMutation>;
export type MarkInboxMessageThreadAsUnreadMutationOptions = Apollo.BaseMutationOptions<MarkInboxMessageThreadAsUnreadMutation, MarkInboxMessageThreadAsUnreadMutationVariables>;
export const UpdateInboxMessageThreadDocument = gql`
    mutation updateInboxMessageThread($messageThreadId: ID!, $updateInput: UpdateMessageThreadInput!) {
  updateMessageThread(
    messageThreadId: $messageThreadId
    updateInput: $updateInput
  ) {
    ...InboxMessageThreadListItem
  }
}
    ${InboxMessageThreadListItemFragmentDoc}`;
export type UpdateInboxMessageThreadMutationFn = Apollo.MutationFunction<UpdateInboxMessageThreadMutation, UpdateInboxMessageThreadMutationVariables>;

/**
 * __useUpdateInboxMessageThreadMutation__
 *
 * To run a mutation, you first call `useUpdateInboxMessageThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInboxMessageThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInboxMessageThreadMutation, { data, loading, error }] = useUpdateInboxMessageThreadMutation({
 *   variables: {
 *      messageThreadId: // value for 'messageThreadId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateInboxMessageThreadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInboxMessageThreadMutation, UpdateInboxMessageThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInboxMessageThreadMutation, UpdateInboxMessageThreadMutationVariables>(UpdateInboxMessageThreadDocument, options);
      }
export type UpdateInboxMessageThreadMutationHookResult = ReturnType<typeof useUpdateInboxMessageThreadMutation>;
export type UpdateInboxMessageThreadMutationResult = Apollo.MutationResult<UpdateInboxMessageThreadMutation>;
export type UpdateInboxMessageThreadMutationOptions = Apollo.BaseMutationOptions<UpdateInboxMessageThreadMutation, UpdateInboxMessageThreadMutationVariables>;
export const SendInboxMessageDocument = gql`
    mutation sendInboxMessage($messageThreadId: ID!, $messageInput: SendMessageInput!) {
  sendMessage(messageThreadId: $messageThreadId, messageInput: $messageInput) {
    ...InboxMessageThreadListItem
  }
}
    ${InboxMessageThreadListItemFragmentDoc}`;
export type SendInboxMessageMutationFn = Apollo.MutationFunction<SendInboxMessageMutation, SendInboxMessageMutationVariables>;

/**
 * __useSendInboxMessageMutation__
 *
 * To run a mutation, you first call `useSendInboxMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInboxMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInboxMessageMutation, { data, loading, error }] = useSendInboxMessageMutation({
 *   variables: {
 *      messageThreadId: // value for 'messageThreadId'
 *      messageInput: // value for 'messageInput'
 *   },
 * });
 */
export function useSendInboxMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendInboxMessageMutation, SendInboxMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInboxMessageMutation, SendInboxMessageMutationVariables>(SendInboxMessageDocument, options);
      }
export type SendInboxMessageMutationHookResult = ReturnType<typeof useSendInboxMessageMutation>;
export type SendInboxMessageMutationResult = Apollo.MutationResult<SendInboxMessageMutation>;
export type SendInboxMessageMutationOptions = Apollo.BaseMutationOptions<SendInboxMessageMutation, SendInboxMessageMutationVariables>;
export const MarkInboxMessageThreadAsReadDocument = gql`
    mutation markInboxMessageThreadAsRead($messageThreadId: ID!) {
  markMessageThreadAsRead(messageThreadId: $messageThreadId) {
    ...InboxMessageThreadListItem
  }
}
    ${InboxMessageThreadListItemFragmentDoc}`;
export type MarkInboxMessageThreadAsReadMutationFn = Apollo.MutationFunction<MarkInboxMessageThreadAsReadMutation, MarkInboxMessageThreadAsReadMutationVariables>;

/**
 * __useMarkInboxMessageThreadAsReadMutation__
 *
 * To run a mutation, you first call `useMarkInboxMessageThreadAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInboxMessageThreadAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInboxMessageThreadAsReadMutation, { data, loading, error }] = useMarkInboxMessageThreadAsReadMutation({
 *   variables: {
 *      messageThreadId: // value for 'messageThreadId'
 *   },
 * });
 */
export function useMarkInboxMessageThreadAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkInboxMessageThreadAsReadMutation, MarkInboxMessageThreadAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInboxMessageThreadAsReadMutation, MarkInboxMessageThreadAsReadMutationVariables>(MarkInboxMessageThreadAsReadDocument, options);
      }
export type MarkInboxMessageThreadAsReadMutationHookResult = ReturnType<typeof useMarkInboxMessageThreadAsReadMutation>;
export type MarkInboxMessageThreadAsReadMutationResult = Apollo.MutationResult<MarkInboxMessageThreadAsReadMutation>;
export type MarkInboxMessageThreadAsReadMutationOptions = Apollo.BaseMutationOptions<MarkInboxMessageThreadAsReadMutation, MarkInboxMessageThreadAsReadMutationVariables>;
export const GetInboxMessageThreadsDocument = gql`
    query getInboxMessageThreads($filterInput: MessageThreadFilterInput, $paginationOptions: PaginationOptionsInput) {
  messageThreads(filterInput: $filterInput, paginationOptions: $paginationOptions) {
    pagination {
      minCursor
      maxCursor
      totalCount
      limit
      hasMoreResults
    }
    result {
      ...InboxMessageThreadListItem
    }
  }
}
    ${InboxMessageThreadListItemFragmentDoc}`;

/**
 * __useGetInboxMessageThreadsQuery__
 *
 * To run a query within a React component, call `useGetInboxMessageThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboxMessageThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboxMessageThreadsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useGetInboxMessageThreadsQuery(baseOptions?: Apollo.QueryHookOptions<GetInboxMessageThreadsQuery, GetInboxMessageThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInboxMessageThreadsQuery, GetInboxMessageThreadsQueryVariables>(GetInboxMessageThreadsDocument, options);
      }
export function useGetInboxMessageThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInboxMessageThreadsQuery, GetInboxMessageThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInboxMessageThreadsQuery, GetInboxMessageThreadsQueryVariables>(GetInboxMessageThreadsDocument, options);
        }
export function useGetInboxMessageThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInboxMessageThreadsQuery, GetInboxMessageThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInboxMessageThreadsQuery, GetInboxMessageThreadsQueryVariables>(GetInboxMessageThreadsDocument, options);
        }
export type GetInboxMessageThreadsQueryHookResult = ReturnType<typeof useGetInboxMessageThreadsQuery>;
export type GetInboxMessageThreadsLazyQueryHookResult = ReturnType<typeof useGetInboxMessageThreadsLazyQuery>;
export type GetInboxMessageThreadsSuspenseQueryHookResult = ReturnType<typeof useGetInboxMessageThreadsSuspenseQuery>;
export type GetInboxMessageThreadsQueryResult = Apollo.QueryResult<GetInboxMessageThreadsQuery, GetInboxMessageThreadsQueryVariables>;
export const GetInboxMessageThreadDocument = gql`
    query getInboxMessageThread($messageThreadId: ID!, $messagesPaginationOptions: PaginationOptionsInput, $recruiterCurrencyCode: String!) {
  messageThread(messageThreadId: $messageThreadId) {
    ...InboxMessageThread
  }
}
    ${InboxMessageThreadFragmentDoc}`;

/**
 * __useGetInboxMessageThreadQuery__
 *
 * To run a query within a React component, call `useGetInboxMessageThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboxMessageThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboxMessageThreadQuery({
 *   variables: {
 *      messageThreadId: // value for 'messageThreadId'
 *      messagesPaginationOptions: // value for 'messagesPaginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetInboxMessageThreadQuery(baseOptions: Apollo.QueryHookOptions<GetInboxMessageThreadQuery, GetInboxMessageThreadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInboxMessageThreadQuery, GetInboxMessageThreadQueryVariables>(GetInboxMessageThreadDocument, options);
      }
export function useGetInboxMessageThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInboxMessageThreadQuery, GetInboxMessageThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInboxMessageThreadQuery, GetInboxMessageThreadQueryVariables>(GetInboxMessageThreadDocument, options);
        }
export function useGetInboxMessageThreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInboxMessageThreadQuery, GetInboxMessageThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInboxMessageThreadQuery, GetInboxMessageThreadQueryVariables>(GetInboxMessageThreadDocument, options);
        }
export type GetInboxMessageThreadQueryHookResult = ReturnType<typeof useGetInboxMessageThreadQuery>;
export type GetInboxMessageThreadLazyQueryHookResult = ReturnType<typeof useGetInboxMessageThreadLazyQuery>;
export type GetInboxMessageThreadSuspenseQueryHookResult = ReturnType<typeof useGetInboxMessageThreadSuspenseQuery>;
export type GetInboxMessageThreadQueryResult = Apollo.QueryResult<GetInboxMessageThreadQuery, GetInboxMessageThreadQueryVariables>;
export const InboxMessageAddedDocument = gql`
    subscription inboxMessageAdded($messageThreadId: ID!) {
  messageAdded(messageThreadId: $messageThreadId) {
    ...InboxMessageThreadMessagesItem
  }
}
    ${InboxMessageThreadMessagesItemFragmentDoc}`;

/**
 * __useInboxMessageAddedSubscription__
 *
 * To run a query within a React component, call `useInboxMessageAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInboxMessageAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxMessageAddedSubscription({
 *   variables: {
 *      messageThreadId: // value for 'messageThreadId'
 *   },
 * });
 */
export function useInboxMessageAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<InboxMessageAddedSubscription, InboxMessageAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InboxMessageAddedSubscription, InboxMessageAddedSubscriptionVariables>(InboxMessageAddedDocument, options);
      }
export type InboxMessageAddedSubscriptionHookResult = ReturnType<typeof useInboxMessageAddedSubscription>;
export type InboxMessageAddedSubscriptionResult = Apollo.SubscriptionResult<InboxMessageAddedSubscription>;
export const InboxMessageThreadUpdatedDocument = gql`
    subscription inboxMessageThreadUpdated {
  messageThreadUpdated {
    unreadCount
    updatedMessageThread {
      ...InboxMessageThreadListItem
    }
  }
}
    ${InboxMessageThreadListItemFragmentDoc}`;

/**
 * __useInboxMessageThreadUpdatedSubscription__
 *
 * To run a query within a React component, call `useInboxMessageThreadUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInboxMessageThreadUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxMessageThreadUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useInboxMessageThreadUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<InboxMessageThreadUpdatedSubscription, InboxMessageThreadUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InboxMessageThreadUpdatedSubscription, InboxMessageThreadUpdatedSubscriptionVariables>(InboxMessageThreadUpdatedDocument, options);
      }
export type InboxMessageThreadUpdatedSubscriptionHookResult = ReturnType<typeof useInboxMessageThreadUpdatedSubscription>;
export type InboxMessageThreadUpdatedSubscriptionResult = Apollo.SubscriptionResult<InboxMessageThreadUpdatedSubscription>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation markAllNotificationsAsRead {
  markAllNotificationsAsRead
}
    `;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation markNotificationAsRead($notificationId: ID!) {
  markNotificationAsRead(notificationId: $notificationId) {
    id
    readAt
  }
}
    `;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkNotificationCenterAsReadDocument = gql`
    mutation markNotificationCenterAsRead {
  markNotificationCenterAsRead
}
    `;
export type MarkNotificationCenterAsReadMutationFn = Apollo.MutationFunction<MarkNotificationCenterAsReadMutation, MarkNotificationCenterAsReadMutationVariables>;

/**
 * __useMarkNotificationCenterAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationCenterAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationCenterAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationCenterAsReadMutation, { data, loading, error }] = useMarkNotificationCenterAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkNotificationCenterAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationCenterAsReadMutation, MarkNotificationCenterAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationCenterAsReadMutation, MarkNotificationCenterAsReadMutationVariables>(MarkNotificationCenterAsReadDocument, options);
      }
export type MarkNotificationCenterAsReadMutationHookResult = ReturnType<typeof useMarkNotificationCenterAsReadMutation>;
export type MarkNotificationCenterAsReadMutationResult = Apollo.MutationResult<MarkNotificationCenterAsReadMutation>;
export type MarkNotificationCenterAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationCenterAsReadMutation, MarkNotificationCenterAsReadMutationVariables>;
export const NotificationGroupsDocument = gql`
    query notificationGroups($paginationOptions: PaginationOptionsInput) {
  notificationGroups(paginationOptions: $paginationOptions) @connection(key: "NOTIFICATIONS") {
    pagination {
      minCursor
      maxCursor
      sortOrder
      limit
      hasMoreResults
    }
    result {
      notifications {
        id
        type
        icons {
          primary {
            id
            fullUrl(width: 60, height: 60)
          }
          secondary {
            id
            fullUrl(width: 60, height: 60)
          }
        }
        message
        url
        sentAt
        readAt
        ... on ApplicationNotificationType {
          application {
            opening {
              id
            }
          }
        }
        ... on OpeningNotificationType {
          opening {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationGroupsQuery__
 *
 * To run a query within a React component, call `useNotificationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationGroupsQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useNotificationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationGroupsQuery, NotificationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationGroupsQuery, NotificationGroupsQueryVariables>(NotificationGroupsDocument, options);
      }
export function useNotificationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationGroupsQuery, NotificationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationGroupsQuery, NotificationGroupsQueryVariables>(NotificationGroupsDocument, options);
        }
export function useNotificationGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationGroupsQuery, NotificationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationGroupsQuery, NotificationGroupsQueryVariables>(NotificationGroupsDocument, options);
        }
export type NotificationGroupsQueryHookResult = ReturnType<typeof useNotificationGroupsQuery>;
export type NotificationGroupsLazyQueryHookResult = ReturnType<typeof useNotificationGroupsLazyQuery>;
export type NotificationGroupsSuspenseQueryHookResult = ReturnType<typeof useNotificationGroupsSuspenseQuery>;
export type NotificationGroupsQueryResult = Apollo.QueryResult<NotificationGroupsQuery, NotificationGroupsQueryVariables>;
export const CustomerForSubscriptionModalDocument = gql`
    query customerForSubscriptionModal {
  customer {
    id
    planType
    planInfo {
      ... on SubscriptionPlanType {
        occupiedOpeningSlots
        openingSlots
      }
    }
  }
}
    `;

/**
 * __useCustomerForSubscriptionModalQuery__
 *
 * To run a query within a React component, call `useCustomerForSubscriptionModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerForSubscriptionModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerForSubscriptionModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerForSubscriptionModalQuery(baseOptions?: Apollo.QueryHookOptions<CustomerForSubscriptionModalQuery, CustomerForSubscriptionModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerForSubscriptionModalQuery, CustomerForSubscriptionModalQueryVariables>(CustomerForSubscriptionModalDocument, options);
      }
export function useCustomerForSubscriptionModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerForSubscriptionModalQuery, CustomerForSubscriptionModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerForSubscriptionModalQuery, CustomerForSubscriptionModalQueryVariables>(CustomerForSubscriptionModalDocument, options);
        }
export function useCustomerForSubscriptionModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerForSubscriptionModalQuery, CustomerForSubscriptionModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerForSubscriptionModalQuery, CustomerForSubscriptionModalQueryVariables>(CustomerForSubscriptionModalDocument, options);
        }
export type CustomerForSubscriptionModalQueryHookResult = ReturnType<typeof useCustomerForSubscriptionModalQuery>;
export type CustomerForSubscriptionModalLazyQueryHookResult = ReturnType<typeof useCustomerForSubscriptionModalLazyQuery>;
export type CustomerForSubscriptionModalSuspenseQueryHookResult = ReturnType<typeof useCustomerForSubscriptionModalSuspenseQuery>;
export type CustomerForSubscriptionModalQueryResult = Apollo.QueryResult<CustomerForSubscriptionModalQuery, CustomerForSubscriptionModalQueryVariables>;
export const NotificationCenterDocument = gql`
    query notificationCenter {
  notificationCenter {
    totalNotificationsCount
    newNotificationsCount
    unreadNotificationsCount
    readNotificationsCount
  }
}
    `;

/**
 * __useNotificationCenterQuery__
 *
 * To run a query within a React component, call `useNotificationCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCenterQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationCenterQuery(baseOptions?: Apollo.QueryHookOptions<NotificationCenterQuery, NotificationCenterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationCenterQuery, NotificationCenterQueryVariables>(NotificationCenterDocument, options);
      }
export function useNotificationCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationCenterQuery, NotificationCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationCenterQuery, NotificationCenterQueryVariables>(NotificationCenterDocument, options);
        }
export function useNotificationCenterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationCenterQuery, NotificationCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationCenterQuery, NotificationCenterQueryVariables>(NotificationCenterDocument, options);
        }
export type NotificationCenterQueryHookResult = ReturnType<typeof useNotificationCenterQuery>;
export type NotificationCenterLazyQueryHookResult = ReturnType<typeof useNotificationCenterLazyQuery>;
export type NotificationCenterSuspenseQueryHookResult = ReturnType<typeof useNotificationCenterSuspenseQuery>;
export type NotificationCenterQueryResult = Apollo.QueryResult<NotificationCenterQuery, NotificationCenterQueryVariables>;
export const RepublishOpeningDocument = gql`
    mutation republishOpening($openingId: ID!) {
  republishOpening(openingId: $openingId) {
    id
  }
}
    `;
export type RepublishOpeningMutationFn = Apollo.MutationFunction<RepublishOpeningMutation, RepublishOpeningMutationVariables>;

/**
 * __useRepublishOpeningMutation__
 *
 * To run a mutation, you first call `useRepublishOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepublishOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [republishOpeningMutation, { data, loading, error }] = useRepublishOpeningMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useRepublishOpeningMutation(baseOptions?: Apollo.MutationHookOptions<RepublishOpeningMutation, RepublishOpeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepublishOpeningMutation, RepublishOpeningMutationVariables>(RepublishOpeningDocument, options);
      }
export type RepublishOpeningMutationHookResult = ReturnType<typeof useRepublishOpeningMutation>;
export type RepublishOpeningMutationResult = Apollo.MutationResult<RepublishOpeningMutation>;
export type RepublishOpeningMutationOptions = Apollo.BaseMutationOptions<RepublishOpeningMutation, RepublishOpeningMutationVariables>;
export const SaveOpeningDocument = gql`
    mutation saveOpening($openingInput: OpeningInput!, $openingId: String) {
  saveOpening(openingInput: $openingInput, openingId: $openingId) {
    ...FunnelOpening
  }
}
    ${FunnelOpeningFragmentDoc}`;
export type SaveOpeningMutationFn = Apollo.MutationFunction<SaveOpeningMutation, SaveOpeningMutationVariables>;

/**
 * __useSaveOpeningMutation__
 *
 * To run a mutation, you first call `useSaveOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOpeningMutation, { data, loading, error }] = useSaveOpeningMutation({
 *   variables: {
 *      openingInput: // value for 'openingInput'
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useSaveOpeningMutation(baseOptions?: Apollo.MutationHookOptions<SaveOpeningMutation, SaveOpeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOpeningMutation, SaveOpeningMutationVariables>(SaveOpeningDocument, options);
      }
export type SaveOpeningMutationHookResult = ReturnType<typeof useSaveOpeningMutation>;
export type SaveOpeningMutationResult = Apollo.MutationResult<SaveOpeningMutation>;
export type SaveOpeningMutationOptions = Apollo.BaseMutationOptions<SaveOpeningMutation, SaveOpeningMutationVariables>;
export const DuplicateOpeningDocument = gql`
    mutation duplicateOpening($openingId: ID!) {
  duplicateOpening(openingId: $openingId) {
    id
    state
    source
    title
  }
}
    `;
export type DuplicateOpeningMutationFn = Apollo.MutationFunction<DuplicateOpeningMutation, DuplicateOpeningMutationVariables>;

/**
 * __useDuplicateOpeningMutation__
 *
 * To run a mutation, you first call `useDuplicateOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOpeningMutation, { data, loading, error }] = useDuplicateOpeningMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useDuplicateOpeningMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateOpeningMutation, DuplicateOpeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateOpeningMutation, DuplicateOpeningMutationVariables>(DuplicateOpeningDocument, options);
      }
export type DuplicateOpeningMutationHookResult = ReturnType<typeof useDuplicateOpeningMutation>;
export type DuplicateOpeningMutationResult = Apollo.MutationResult<DuplicateOpeningMutation>;
export type DuplicateOpeningMutationOptions = Apollo.BaseMutationOptions<DuplicateOpeningMutation, DuplicateOpeningMutationVariables>;
export const PublishOpeningDocument = gql`
    mutation publishOpening($openingId: ID!) {
  publishOpening(openingId: $openingId) {
    id
    state
    source
    title
  }
}
    `;
export type PublishOpeningMutationFn = Apollo.MutationFunction<PublishOpeningMutation, PublishOpeningMutationVariables>;

/**
 * __usePublishOpeningMutation__
 *
 * To run a mutation, you first call `usePublishOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishOpeningMutation, { data, loading, error }] = usePublishOpeningMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function usePublishOpeningMutation(baseOptions?: Apollo.MutationHookOptions<PublishOpeningMutation, PublishOpeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishOpeningMutation, PublishOpeningMutationVariables>(PublishOpeningDocument, options);
      }
export type PublishOpeningMutationHookResult = ReturnType<typeof usePublishOpeningMutation>;
export type PublishOpeningMutationResult = Apollo.MutationResult<PublishOpeningMutation>;
export type PublishOpeningMutationOptions = Apollo.BaseMutationOptions<PublishOpeningMutation, PublishOpeningMutationVariables>;
export const ResumeOpeningDocument = gql`
    mutation resumeOpening($openingId: ID!) {
  resumeOpening(openingId: $openingId) {
    id
    state
    source
    title
  }
}
    `;
export type ResumeOpeningMutationFn = Apollo.MutationFunction<ResumeOpeningMutation, ResumeOpeningMutationVariables>;

/**
 * __useResumeOpeningMutation__
 *
 * To run a mutation, you first call `useResumeOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeOpeningMutation, { data, loading, error }] = useResumeOpeningMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useResumeOpeningMutation(baseOptions?: Apollo.MutationHookOptions<ResumeOpeningMutation, ResumeOpeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeOpeningMutation, ResumeOpeningMutationVariables>(ResumeOpeningDocument, options);
      }
export type ResumeOpeningMutationHookResult = ReturnType<typeof useResumeOpeningMutation>;
export type ResumeOpeningMutationResult = Apollo.MutationResult<ResumeOpeningMutation>;
export type ResumeOpeningMutationOptions = Apollo.BaseMutationOptions<ResumeOpeningMutation, ResumeOpeningMutationVariables>;
export const ArchiveOpeningDocument = gql`
    mutation archiveOpening($openingId: ID!) {
  archiveOpening(openingId: $openingId) {
    id
    state
    source
  }
}
    `;
export type ArchiveOpeningMutationFn = Apollo.MutationFunction<ArchiveOpeningMutation, ArchiveOpeningMutationVariables>;

/**
 * __useArchiveOpeningMutation__
 *
 * To run a mutation, you first call `useArchiveOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOpeningMutation, { data, loading, error }] = useArchiveOpeningMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useArchiveOpeningMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveOpeningMutation, ArchiveOpeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveOpeningMutation, ArchiveOpeningMutationVariables>(ArchiveOpeningDocument, options);
      }
export type ArchiveOpeningMutationHookResult = ReturnType<typeof useArchiveOpeningMutation>;
export type ArchiveOpeningMutationResult = Apollo.MutationResult<ArchiveOpeningMutation>;
export type ArchiveOpeningMutationOptions = Apollo.BaseMutationOptions<ArchiveOpeningMutation, ArchiveOpeningMutationVariables>;
export const PauseOpeningDocument = gql`
    mutation pauseOpening($openingId: ID!, $pauseOpeningInput: PauseOpeningInput!) {
  pauseOpening(openingId: $openingId, pauseOpeningInput: $pauseOpeningInput) {
    id
    state
    source
    title
  }
}
    `;
export type PauseOpeningMutationFn = Apollo.MutationFunction<PauseOpeningMutation, PauseOpeningMutationVariables>;

/**
 * __usePauseOpeningMutation__
 *
 * To run a mutation, you first call `usePauseOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseOpeningMutation, { data, loading, error }] = usePauseOpeningMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      pauseOpeningInput: // value for 'pauseOpeningInput'
 *   },
 * });
 */
export function usePauseOpeningMutation(baseOptions?: Apollo.MutationHookOptions<PauseOpeningMutation, PauseOpeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseOpeningMutation, PauseOpeningMutationVariables>(PauseOpeningDocument, options);
      }
export type PauseOpeningMutationHookResult = ReturnType<typeof usePauseOpeningMutation>;
export type PauseOpeningMutationResult = Apollo.MutationResult<PauseOpeningMutation>;
export type PauseOpeningMutationOptions = Apollo.BaseMutationOptions<PauseOpeningMutation, PauseOpeningMutationVariables>;
export const StopOpeningDocument = gql`
    mutation stopOpening($openingId: ID!, $stopOpeningInput: StopOpeningInput!) {
  stopOpening(openingId: $openingId, stopOpeningInput: $stopOpeningInput) {
    id
    state
    source
    title
  }
}
    `;
export type StopOpeningMutationFn = Apollo.MutationFunction<StopOpeningMutation, StopOpeningMutationVariables>;

/**
 * __useStopOpeningMutation__
 *
 * To run a mutation, you first call `useStopOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopOpeningMutation, { data, loading, error }] = useStopOpeningMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      stopOpeningInput: // value for 'stopOpeningInput'
 *   },
 * });
 */
export function useStopOpeningMutation(baseOptions?: Apollo.MutationHookOptions<StopOpeningMutation, StopOpeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopOpeningMutation, StopOpeningMutationVariables>(StopOpeningDocument, options);
      }
export type StopOpeningMutationHookResult = ReturnType<typeof useStopOpeningMutation>;
export type StopOpeningMutationResult = Apollo.MutationResult<StopOpeningMutation>;
export type StopOpeningMutationOptions = Apollo.BaseMutationOptions<StopOpeningMutation, StopOpeningMutationVariables>;
export const CreateVerifiedUserApplicantDocument = gql`
    mutation createVerifiedUserApplicant($userId: ID!, $message: String!, $openingId: ID) {
  createVerifiedUserApplicant(
    openingId: $openingId
    userId: $userId
    input: {message: $message, recruiterState: ACCEPTED}
  ) {
    application {
      id
    }
  }
}
    `;
export type CreateVerifiedUserApplicantMutationFn = Apollo.MutationFunction<CreateVerifiedUserApplicantMutation, CreateVerifiedUserApplicantMutationVariables>;

/**
 * __useCreateVerifiedUserApplicantMutation__
 *
 * To run a mutation, you first call `useCreateVerifiedUserApplicantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVerifiedUserApplicantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVerifiedUserApplicantMutation, { data, loading, error }] = useCreateVerifiedUserApplicantMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      message: // value for 'message'
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useCreateVerifiedUserApplicantMutation(baseOptions?: Apollo.MutationHookOptions<CreateVerifiedUserApplicantMutation, CreateVerifiedUserApplicantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVerifiedUserApplicantMutation, CreateVerifiedUserApplicantMutationVariables>(CreateVerifiedUserApplicantDocument, options);
      }
export type CreateVerifiedUserApplicantMutationHookResult = ReturnType<typeof useCreateVerifiedUserApplicantMutation>;
export type CreateVerifiedUserApplicantMutationResult = Apollo.MutationResult<CreateVerifiedUserApplicantMutation>;
export type CreateVerifiedUserApplicantMutationOptions = Apollo.BaseMutationOptions<CreateVerifiedUserApplicantMutation, CreateVerifiedUserApplicantMutationVariables>;
export const BulkCreateVerifiedUserApplicantsDocument = gql`
    mutation bulkCreateVerifiedUserApplicants($bulkCreateInputs: [BulkCreateVerifiedUserApplicantsInput!]!) {
  bulkCreateVerifiedUserApplicants(bulkCreateInputs: $bulkCreateInputs) {
    application {
      id
    }
  }
}
    `;
export type BulkCreateVerifiedUserApplicantsMutationFn = Apollo.MutationFunction<BulkCreateVerifiedUserApplicantsMutation, BulkCreateVerifiedUserApplicantsMutationVariables>;

/**
 * __useBulkCreateVerifiedUserApplicantsMutation__
 *
 * To run a mutation, you first call `useBulkCreateVerifiedUserApplicantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateVerifiedUserApplicantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateVerifiedUserApplicantsMutation, { data, loading, error }] = useBulkCreateVerifiedUserApplicantsMutation({
 *   variables: {
 *      bulkCreateInputs: // value for 'bulkCreateInputs'
 *   },
 * });
 */
export function useBulkCreateVerifiedUserApplicantsMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateVerifiedUserApplicantsMutation, BulkCreateVerifiedUserApplicantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateVerifiedUserApplicantsMutation, BulkCreateVerifiedUserApplicantsMutationVariables>(BulkCreateVerifiedUserApplicantsDocument, options);
      }
export type BulkCreateVerifiedUserApplicantsMutationHookResult = ReturnType<typeof useBulkCreateVerifiedUserApplicantsMutation>;
export type BulkCreateVerifiedUserApplicantsMutationResult = Apollo.MutationResult<BulkCreateVerifiedUserApplicantsMutation>;
export type BulkCreateVerifiedUserApplicantsMutationOptions = Apollo.BaseMutationOptions<BulkCreateVerifiedUserApplicantsMutation, BulkCreateVerifiedUserApplicantsMutationVariables>;
export const RejectVerifiedUserDocument = gql`
    mutation rejectVerifiedUser($openingId: ID, $userId: ID!) {
  createVerifiedUserApplicant(
    openingId: $openingId
    userId: $userId
    input: {recruiterState: REJECTED}
  ) {
    application {
      id
    }
  }
}
    `;
export type RejectVerifiedUserMutationFn = Apollo.MutationFunction<RejectVerifiedUserMutation, RejectVerifiedUserMutationVariables>;

/**
 * __useRejectVerifiedUserMutation__
 *
 * To run a mutation, you first call `useRejectVerifiedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectVerifiedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectVerifiedUserMutation, { data, loading, error }] = useRejectVerifiedUserMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRejectVerifiedUserMutation(baseOptions?: Apollo.MutationHookOptions<RejectVerifiedUserMutation, RejectVerifiedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectVerifiedUserMutation, RejectVerifiedUserMutationVariables>(RejectVerifiedUserDocument, options);
      }
export type RejectVerifiedUserMutationHookResult = ReturnType<typeof useRejectVerifiedUserMutation>;
export type RejectVerifiedUserMutationResult = Apollo.MutationResult<RejectVerifiedUserMutation>;
export type RejectVerifiedUserMutationOptions = Apollo.BaseMutationOptions<RejectVerifiedUserMutation, RejectVerifiedUserMutationVariables>;
export const GenerateOpeningCommentDocument = gql`
    mutation generateOpeningComment($openingId: ID!) {
  generateOpeningComment(openingId: $openingId)
}
    `;
export type GenerateOpeningCommentMutationFn = Apollo.MutationFunction<GenerateOpeningCommentMutation, GenerateOpeningCommentMutationVariables>;

/**
 * __useGenerateOpeningCommentMutation__
 *
 * To run a mutation, you first call `useGenerateOpeningCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOpeningCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOpeningCommentMutation, { data, loading, error }] = useGenerateOpeningCommentMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useGenerateOpeningCommentMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOpeningCommentMutation, GenerateOpeningCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOpeningCommentMutation, GenerateOpeningCommentMutationVariables>(GenerateOpeningCommentDocument, options);
      }
export type GenerateOpeningCommentMutationHookResult = ReturnType<typeof useGenerateOpeningCommentMutation>;
export type GenerateOpeningCommentMutationResult = Apollo.MutationResult<GenerateOpeningCommentMutation>;
export type GenerateOpeningCommentMutationOptions = Apollo.BaseMutationOptions<GenerateOpeningCommentMutation, GenerateOpeningCommentMutationVariables>;
export const GenerateOpeningMessageDocument = gql`
    mutation generateOpeningMessage($openingId: ID!) {
  generateOpeningMessage(openingId: $openingId)
}
    `;
export type GenerateOpeningMessageMutationFn = Apollo.MutationFunction<GenerateOpeningMessageMutation, GenerateOpeningMessageMutationVariables>;

/**
 * __useGenerateOpeningMessageMutation__
 *
 * To run a mutation, you first call `useGenerateOpeningMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOpeningMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOpeningMessageMutation, { data, loading, error }] = useGenerateOpeningMessageMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useGenerateOpeningMessageMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOpeningMessageMutation, GenerateOpeningMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOpeningMessageMutation, GenerateOpeningMessageMutationVariables>(GenerateOpeningMessageDocument, options);
      }
export type GenerateOpeningMessageMutationHookResult = ReturnType<typeof useGenerateOpeningMessageMutation>;
export type GenerateOpeningMessageMutationResult = Apollo.MutationResult<GenerateOpeningMessageMutation>;
export type GenerateOpeningMessageMutationOptions = Apollo.BaseMutationOptions<GenerateOpeningMessageMutation, GenerateOpeningMessageMutationVariables>;
export const GenerateOpeningAutomatedResponseDocument = gql`
    mutation generateOpeningAutomatedResponse($openingId: ID!) {
  generateOpeningAutomatedResponse(openingId: $openingId)
}
    `;
export type GenerateOpeningAutomatedResponseMutationFn = Apollo.MutationFunction<GenerateOpeningAutomatedResponseMutation, GenerateOpeningAutomatedResponseMutationVariables>;

/**
 * __useGenerateOpeningAutomatedResponseMutation__
 *
 * To run a mutation, you first call `useGenerateOpeningAutomatedResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOpeningAutomatedResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOpeningAutomatedResponseMutation, { data, loading, error }] = useGenerateOpeningAutomatedResponseMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useGenerateOpeningAutomatedResponseMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOpeningAutomatedResponseMutation, GenerateOpeningAutomatedResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOpeningAutomatedResponseMutation, GenerateOpeningAutomatedResponseMutationVariables>(GenerateOpeningAutomatedResponseDocument, options);
      }
export type GenerateOpeningAutomatedResponseMutationHookResult = ReturnType<typeof useGenerateOpeningAutomatedResponseMutation>;
export type GenerateOpeningAutomatedResponseMutationResult = Apollo.MutationResult<GenerateOpeningAutomatedResponseMutation>;
export type GenerateOpeningAutomatedResponseMutationOptions = Apollo.BaseMutationOptions<GenerateOpeningAutomatedResponseMutation, GenerateOpeningAutomatedResponseMutationVariables>;
export const GenerateOpeningPitchDocument = gql`
    mutation generateOpeningPitch($openingId: ID!) {
  generateOpeningPitch(openingId: $openingId)
}
    `;
export type GenerateOpeningPitchMutationFn = Apollo.MutationFunction<GenerateOpeningPitchMutation, GenerateOpeningPitchMutationVariables>;

/**
 * __useGenerateOpeningPitchMutation__
 *
 * To run a mutation, you first call `useGenerateOpeningPitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOpeningPitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOpeningPitchMutation, { data, loading, error }] = useGenerateOpeningPitchMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useGenerateOpeningPitchMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOpeningPitchMutation, GenerateOpeningPitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOpeningPitchMutation, GenerateOpeningPitchMutationVariables>(GenerateOpeningPitchDocument, options);
      }
export type GenerateOpeningPitchMutationHookResult = ReturnType<typeof useGenerateOpeningPitchMutation>;
export type GenerateOpeningPitchMutationResult = Apollo.MutationResult<GenerateOpeningPitchMutation>;
export type GenerateOpeningPitchMutationOptions = Apollo.BaseMutationOptions<GenerateOpeningPitchMutation, GenerateOpeningPitchMutationVariables>;
export const GetOpeningReachDocument = gql`
    query getOpeningReach($id: ID!) {
  opening(id: $id) {
    id
    reach {
      local
      global
      remote
    }
  }
}
    `;

/**
 * __useGetOpeningReachQuery__
 *
 * To run a query within a React component, call `useGetOpeningReachQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpeningReachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpeningReachQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOpeningReachQuery(baseOptions: Apollo.QueryHookOptions<GetOpeningReachQuery, GetOpeningReachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpeningReachQuery, GetOpeningReachQueryVariables>(GetOpeningReachDocument, options);
      }
export function useGetOpeningReachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpeningReachQuery, GetOpeningReachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpeningReachQuery, GetOpeningReachQueryVariables>(GetOpeningReachDocument, options);
        }
export function useGetOpeningReachSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOpeningReachQuery, GetOpeningReachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpeningReachQuery, GetOpeningReachQueryVariables>(GetOpeningReachDocument, options);
        }
export type GetOpeningReachQueryHookResult = ReturnType<typeof useGetOpeningReachQuery>;
export type GetOpeningReachLazyQueryHookResult = ReturnType<typeof useGetOpeningReachLazyQuery>;
export type GetOpeningReachSuspenseQueryHookResult = ReturnType<typeof useGetOpeningReachSuspenseQuery>;
export type GetOpeningReachQueryResult = Apollo.QueryResult<GetOpeningReachQuery, GetOpeningReachQueryVariables>;
export const OpeningQueryDocument = gql`
    query openingQuery($openingId: ID!) {
  opening(id: $openingId) {
    ...FunnelOpening
  }
}
    ${FunnelOpeningFragmentDoc}`;

/**
 * __useOpeningQueryQuery__
 *
 * To run a query within a React component, call `useOpeningQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningQueryQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useOpeningQueryQuery(baseOptions: Apollo.QueryHookOptions<OpeningQueryQuery, OpeningQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningQueryQuery, OpeningQueryQueryVariables>(OpeningQueryDocument, options);
      }
export function useOpeningQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningQueryQuery, OpeningQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningQueryQuery, OpeningQueryQueryVariables>(OpeningQueryDocument, options);
        }
export function useOpeningQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningQueryQuery, OpeningQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningQueryQuery, OpeningQueryQueryVariables>(OpeningQueryDocument, options);
        }
export type OpeningQueryQueryHookResult = ReturnType<typeof useOpeningQueryQuery>;
export type OpeningQueryLazyQueryHookResult = ReturnType<typeof useOpeningQueryLazyQuery>;
export type OpeningQuerySuspenseQueryHookResult = ReturnType<typeof useOpeningQuerySuspenseQuery>;
export type OpeningQueryQueryResult = Apollo.QueryResult<OpeningQueryQuery, OpeningQueryQueryVariables>;
export const PostStepOpeningDocument = gql`
    query postStepOpening($openingId: ID!) {
  opening(id: $openingId) {
    id
    paidAddons {
      type
      priceInEur
    }
    comment
  }
}
    `;

/**
 * __usePostStepOpeningQuery__
 *
 * To run a query within a React component, call `usePostStepOpeningQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostStepOpeningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostStepOpeningQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function usePostStepOpeningQuery(baseOptions: Apollo.QueryHookOptions<PostStepOpeningQuery, PostStepOpeningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostStepOpeningQuery, PostStepOpeningQueryVariables>(PostStepOpeningDocument, options);
      }
export function usePostStepOpeningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostStepOpeningQuery, PostStepOpeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostStepOpeningQuery, PostStepOpeningQueryVariables>(PostStepOpeningDocument, options);
        }
export function usePostStepOpeningSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostStepOpeningQuery, PostStepOpeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostStepOpeningQuery, PostStepOpeningQueryVariables>(PostStepOpeningDocument, options);
        }
export type PostStepOpeningQueryHookResult = ReturnType<typeof usePostStepOpeningQuery>;
export type PostStepOpeningLazyQueryHookResult = ReturnType<typeof usePostStepOpeningLazyQuery>;
export type PostStepOpeningSuspenseQueryHookResult = ReturnType<typeof usePostStepOpeningSuspenseQuery>;
export type PostStepOpeningQueryResult = Apollo.QueryResult<PostStepOpeningQuery, PostStepOpeningQueryVariables>;
export const OpeningMarketSalariesQueryDocument = gql`
    query openingMarketSalariesQuery($id: ID!) {
  opening(id: $id) {
    id
    marketSalaries(resolution: 15) {
      currency {
        id
        code
        symbol
      }
      userSalaries {
        ...SalaryDistributionDataPointType
      }
    }
  }
}
    ${SalaryDistributionDataPointTypeFragmentDoc}`;

/**
 * __useOpeningMarketSalariesQueryQuery__
 *
 * To run a query within a React component, call `useOpeningMarketSalariesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningMarketSalariesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningMarketSalariesQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpeningMarketSalariesQueryQuery(baseOptions: Apollo.QueryHookOptions<OpeningMarketSalariesQueryQuery, OpeningMarketSalariesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningMarketSalariesQueryQuery, OpeningMarketSalariesQueryQueryVariables>(OpeningMarketSalariesQueryDocument, options);
      }
export function useOpeningMarketSalariesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningMarketSalariesQueryQuery, OpeningMarketSalariesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningMarketSalariesQueryQuery, OpeningMarketSalariesQueryQueryVariables>(OpeningMarketSalariesQueryDocument, options);
        }
export function useOpeningMarketSalariesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningMarketSalariesQueryQuery, OpeningMarketSalariesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningMarketSalariesQueryQuery, OpeningMarketSalariesQueryQueryVariables>(OpeningMarketSalariesQueryDocument, options);
        }
export type OpeningMarketSalariesQueryQueryHookResult = ReturnType<typeof useOpeningMarketSalariesQueryQuery>;
export type OpeningMarketSalariesQueryLazyQueryHookResult = ReturnType<typeof useOpeningMarketSalariesQueryLazyQuery>;
export type OpeningMarketSalariesQuerySuspenseQueryHookResult = ReturnType<typeof useOpeningMarketSalariesQuerySuspenseQuery>;
export type OpeningMarketSalariesQueryQueryResult = Apollo.QueryResult<OpeningMarketSalariesQueryQuery, OpeningMarketSalariesQueryQueryVariables>;
export const OpeningForConnectButtonDocument = gql`
    query openingForConnectButton($id: ID!) {
  opening(id: $id) {
    id
    title
    pitch
  }
}
    `;

/**
 * __useOpeningForConnectButtonQuery__
 *
 * To run a query within a React component, call `useOpeningForConnectButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningForConnectButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningForConnectButtonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpeningForConnectButtonQuery(baseOptions: Apollo.QueryHookOptions<OpeningForConnectButtonQuery, OpeningForConnectButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningForConnectButtonQuery, OpeningForConnectButtonQueryVariables>(OpeningForConnectButtonDocument, options);
      }
export function useOpeningForConnectButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningForConnectButtonQuery, OpeningForConnectButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningForConnectButtonQuery, OpeningForConnectButtonQueryVariables>(OpeningForConnectButtonDocument, options);
        }
export function useOpeningForConnectButtonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningForConnectButtonQuery, OpeningForConnectButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningForConnectButtonQuery, OpeningForConnectButtonQueryVariables>(OpeningForConnectButtonDocument, options);
        }
export type OpeningForConnectButtonQueryHookResult = ReturnType<typeof useOpeningForConnectButtonQuery>;
export type OpeningForConnectButtonLazyQueryHookResult = ReturnType<typeof useOpeningForConnectButtonLazyQuery>;
export type OpeningForConnectButtonSuspenseQueryHookResult = ReturnType<typeof useOpeningForConnectButtonSuspenseQuery>;
export type OpeningForConnectButtonQueryResult = Apollo.QueryResult<OpeningForConnectButtonQuery, OpeningForConnectButtonQueryVariables>;
export const OpeningsDocument = gql`
    query openings($searchTags: [OpeningSearchTagType!], $searchPatterns: [OpeningSearchPatternInput!], $paginationOptions: PaginationOptionsInput, $recommendedUsersPagination: RecommendedUsersPaginationOptionsInput, $recommendedUsersFilter: RecommendedUsersFiltersInput) {
  openings(
    searchTags: $searchTags
    searchPatterns: $searchPatterns
    paginationOptions: $paginationOptions
  ) {
    pagination {
      maxCursor
      totalCount
      hasMoreResults
    }
    result {
      id
      title
      state
      employmentType
      publicUrl
      source
      visibility
      remote {
        type
      }
      candidateDestination {
        type
        ... on ExternalUrlOpeningCandidateDestinationType {
          url
        }
      }
      speciality {
        id
        name
      }
      signalCountsByTypes(
        signalTypes: [VIEW_DETAILS, VIEW_STORY_ITEM, DISCARD_OPENING, VIEW_FEED_ITEM]
      ) {
        total
      }
      paidAddons {
        type
        priceInEur
      }
      recruiter {
        id
        isFrankAgent
        fullName
        avatar {
          fullUrl(width: 100, height: 100)
        }
      }
      pendingApplicants: applicants(
        filterInput: {recruiterStates: [PENDING, ACCEPTED], userStates: [PENDING, REJECTED], sources: [USER_VERIFICATION]}
        paginationOptions: {limit: 1}
      ) {
        pagination {
          totalCount
        }
      }
      shortlistApplicants: applicants(
        filterInput: {recruiterMessageThreadStates: [OPEN], recruiterStates: [PENDING], sources: [OPENING, USER_VERIFICATION], userStates: [ACCEPTED]}
        paginationOptions: {limit: 1}
      ) {
        pagination {
          totalCount
        }
      }
      unreadShortlistApplicants: applicants(
        filterInput: {recruiterMessageThreadStates: [OPEN], recruiterStates: [PENDING], sources: [OPENING, USER_VERIFICATION], userStates: [ACCEPTED], hasUnreadMessages: true}
        paginationOptions: {limit: 1}
      ) {
        pagination {
          totalCount
        }
      }
      inConversationApplicants: applicants(
        filterInput: {recruiterMessageThreadStates: [OPEN], recruiterStates: [ACCEPTED], sources: [OPENING, USER_VERIFICATION], userStates: [ACCEPTED]}
        paginationOptions: {limit: 1}
      ) {
        pagination {
          totalCount
        }
      }
      unreadInConversationApplicants: applicants(
        filterInput: {recruiterMessageThreadStates: [OPEN], recruiterStates: [ACCEPTED], sources: [OPENING, USER_VERIFICATION], userStates: [ACCEPTED], hasUnreadMessages: true}
        paginationOptions: {limit: 1}
      ) {
        pagination {
          totalCount
        }
      }
      recommendedUsers(
        paginationOptions: $recommendedUsersPagination
        filterInput: $recommendedUsersFilter
      ) {
        pagination {
          hasMoreResults
          minCursor
          maxCursor
          limit
          totalCount
        }
      }
    }
  }
}
    `;

/**
 * __useOpeningsQuery__
 *
 * To run a query within a React component, call `useOpeningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningsQuery({
 *   variables: {
 *      searchTags: // value for 'searchTags'
 *      searchPatterns: // value for 'searchPatterns'
 *      paginationOptions: // value for 'paginationOptions'
 *      recommendedUsersPagination: // value for 'recommendedUsersPagination'
 *      recommendedUsersFilter: // value for 'recommendedUsersFilter'
 *   },
 * });
 */
export function useOpeningsQuery(baseOptions?: Apollo.QueryHookOptions<OpeningsQuery, OpeningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningsQuery, OpeningsQueryVariables>(OpeningsDocument, options);
      }
export function useOpeningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningsQuery, OpeningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningsQuery, OpeningsQueryVariables>(OpeningsDocument, options);
        }
export function useOpeningsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningsQuery, OpeningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningsQuery, OpeningsQueryVariables>(OpeningsDocument, options);
        }
export type OpeningsQueryHookResult = ReturnType<typeof useOpeningsQuery>;
export type OpeningsLazyQueryHookResult = ReturnType<typeof useOpeningsLazyQuery>;
export type OpeningsSuspenseQueryHookResult = ReturnType<typeof useOpeningsSuspenseQuery>;
export type OpeningsQueryResult = Apollo.QueryResult<OpeningsQuery, OpeningsQueryVariables>;
export const GetOpeningNamesDocument = gql`
    query getOpeningNames($searchTags: [OpeningSearchTagType!], $searchPatterns: [OpeningSearchPatternInput!], $paginationOptions: PaginationOptionsInput) {
  openings(
    searchTags: $searchTags
    searchPatterns: $searchPatterns
    paginationOptions: $paginationOptions
  ) {
    pagination {
      maxCursor
      totalCount
      hasMoreResults
    }
    result {
      id
      title
      pitch
      state
    }
  }
}
    `;

/**
 * __useGetOpeningNamesQuery__
 *
 * To run a query within a React component, call `useGetOpeningNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpeningNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpeningNamesQuery({
 *   variables: {
 *      searchTags: // value for 'searchTags'
 *      searchPatterns: // value for 'searchPatterns'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useGetOpeningNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetOpeningNamesQuery, GetOpeningNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpeningNamesQuery, GetOpeningNamesQueryVariables>(GetOpeningNamesDocument, options);
      }
export function useGetOpeningNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpeningNamesQuery, GetOpeningNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpeningNamesQuery, GetOpeningNamesQueryVariables>(GetOpeningNamesDocument, options);
        }
export function useGetOpeningNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOpeningNamesQuery, GetOpeningNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpeningNamesQuery, GetOpeningNamesQueryVariables>(GetOpeningNamesDocument, options);
        }
export type GetOpeningNamesQueryHookResult = ReturnType<typeof useGetOpeningNamesQuery>;
export type GetOpeningNamesLazyQueryHookResult = ReturnType<typeof useGetOpeningNamesLazyQuery>;
export type GetOpeningNamesSuspenseQueryHookResult = ReturnType<typeof useGetOpeningNamesSuspenseQuery>;
export type GetOpeningNamesQueryResult = Apollo.QueryResult<GetOpeningNamesQuery, GetOpeningNamesQueryVariables>;
export const GetInboxMessagedOpeningsDocument = gql`
    query getInboxMessagedOpenings($recruiterId: ID!, $paginationOptions: PaginationOptionsInput) {
  messagedOpenings(
    recruiterId: $recruiterId
    paginationOptions: $paginationOptions
  ) {
    result {
      id
      title
      state
    }
  }
}
    `;

/**
 * __useGetInboxMessagedOpeningsQuery__
 *
 * To run a query within a React component, call `useGetInboxMessagedOpeningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboxMessagedOpeningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboxMessagedOpeningsQuery({
 *   variables: {
 *      recruiterId: // value for 'recruiterId'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useGetInboxMessagedOpeningsQuery(baseOptions: Apollo.QueryHookOptions<GetInboxMessagedOpeningsQuery, GetInboxMessagedOpeningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInboxMessagedOpeningsQuery, GetInboxMessagedOpeningsQueryVariables>(GetInboxMessagedOpeningsDocument, options);
      }
export function useGetInboxMessagedOpeningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInboxMessagedOpeningsQuery, GetInboxMessagedOpeningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInboxMessagedOpeningsQuery, GetInboxMessagedOpeningsQueryVariables>(GetInboxMessagedOpeningsDocument, options);
        }
export function useGetInboxMessagedOpeningsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInboxMessagedOpeningsQuery, GetInboxMessagedOpeningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInboxMessagedOpeningsQuery, GetInboxMessagedOpeningsQueryVariables>(GetInboxMessagedOpeningsDocument, options);
        }
export type GetInboxMessagedOpeningsQueryHookResult = ReturnType<typeof useGetInboxMessagedOpeningsQuery>;
export type GetInboxMessagedOpeningsLazyQueryHookResult = ReturnType<typeof useGetInboxMessagedOpeningsLazyQuery>;
export type GetInboxMessagedOpeningsSuspenseQueryHookResult = ReturnType<typeof useGetInboxMessagedOpeningsSuspenseQuery>;
export type GetInboxMessagedOpeningsQueryResult = Apollo.QueryResult<GetInboxMessagedOpeningsQuery, GetInboxMessagedOpeningsQueryVariables>;
export const OpeningRecommendedUsersCountQueryDocument = gql`
    query openingRecommendedUsersCountQuery($id: ID!) {
  opening(id: $id) {
    recommendedUsers(paginationOptions: {limit: 1}) {
      pagination {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useOpeningRecommendedUsersCountQueryQuery__
 *
 * To run a query within a React component, call `useOpeningRecommendedUsersCountQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningRecommendedUsersCountQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningRecommendedUsersCountQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpeningRecommendedUsersCountQueryQuery(baseOptions: Apollo.QueryHookOptions<OpeningRecommendedUsersCountQueryQuery, OpeningRecommendedUsersCountQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningRecommendedUsersCountQueryQuery, OpeningRecommendedUsersCountQueryQueryVariables>(OpeningRecommendedUsersCountQueryDocument, options);
      }
export function useOpeningRecommendedUsersCountQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningRecommendedUsersCountQueryQuery, OpeningRecommendedUsersCountQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningRecommendedUsersCountQueryQuery, OpeningRecommendedUsersCountQueryQueryVariables>(OpeningRecommendedUsersCountQueryDocument, options);
        }
export function useOpeningRecommendedUsersCountQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningRecommendedUsersCountQueryQuery, OpeningRecommendedUsersCountQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningRecommendedUsersCountQueryQuery, OpeningRecommendedUsersCountQueryQueryVariables>(OpeningRecommendedUsersCountQueryDocument, options);
        }
export type OpeningRecommendedUsersCountQueryQueryHookResult = ReturnType<typeof useOpeningRecommendedUsersCountQueryQuery>;
export type OpeningRecommendedUsersCountQueryLazyQueryHookResult = ReturnType<typeof useOpeningRecommendedUsersCountQueryLazyQuery>;
export type OpeningRecommendedUsersCountQuerySuspenseQueryHookResult = ReturnType<typeof useOpeningRecommendedUsersCountQuerySuspenseQuery>;
export type OpeningRecommendedUsersCountQueryQueryResult = Apollo.QueryResult<OpeningRecommendedUsersCountQueryQuery, OpeningRecommendedUsersCountQueryQueryVariables>;
export const OpeningsCountDocument = gql`
    query openingsCount($searchTags: [OpeningSearchTagType!]) {
  openings(searchTags: $searchTags, paginationOptions: {limit: 1}) {
    pagination {
      totalCount
    }
  }
}
    `;

/**
 * __useOpeningsCountQuery__
 *
 * To run a query within a React component, call `useOpeningsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningsCountQuery({
 *   variables: {
 *      searchTags: // value for 'searchTags'
 *   },
 * });
 */
export function useOpeningsCountQuery(baseOptions?: Apollo.QueryHookOptions<OpeningsCountQuery, OpeningsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningsCountQuery, OpeningsCountQueryVariables>(OpeningsCountDocument, options);
      }
export function useOpeningsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningsCountQuery, OpeningsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningsCountQuery, OpeningsCountQueryVariables>(OpeningsCountDocument, options);
        }
export function useOpeningsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningsCountQuery, OpeningsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningsCountQuery, OpeningsCountQueryVariables>(OpeningsCountDocument, options);
        }
export type OpeningsCountQueryHookResult = ReturnType<typeof useOpeningsCountQuery>;
export type OpeningsCountLazyQueryHookResult = ReturnType<typeof useOpeningsCountLazyQuery>;
export type OpeningsCountSuspenseQueryHookResult = ReturnType<typeof useOpeningsCountSuspenseQuery>;
export type OpeningsCountQueryResult = Apollo.QueryResult<OpeningsCountQuery, OpeningsCountQueryVariables>;
export const OpeningOverviewQueryDocument = gql`
    query openingOverviewQuery($id: ID!) {
  opening(id: $id) {
    id
    state
    publicUrl
    title
    employmentType
    source
    isRemote
    isRelocation
    message
    comment
    isFeatured
    visibility
    company {
      id
      name
    }
    skills {
      skill {
        id
        name
        tags
      }
    }
    seniorities {
      id
      name
    }
    speciality {
      id
      name
    }
    targetLocations {
      id
      shortName
    }
    positionLocations {
      id
      shortName
    }
    workload {
      period
      hours
    }
    salaryRange {
      from
      to
      period
      currency {
        id
        code
      }
    }
    candidateDestination {
      type
      ... on ExternalUrlOpeningCandidateDestinationType {
        url
      }
    }
    recruiter {
      id
      isSiteAdmin
      rights {
        inviteCollaborator
      }
    }
    paidAddons {
      type
    }
  }
}
    `;

/**
 * __useOpeningOverviewQueryQuery__
 *
 * To run a query within a React component, call `useOpeningOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningOverviewQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpeningOverviewQueryQuery(baseOptions: Apollo.QueryHookOptions<OpeningOverviewQueryQuery, OpeningOverviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningOverviewQueryQuery, OpeningOverviewQueryQueryVariables>(OpeningOverviewQueryDocument, options);
      }
export function useOpeningOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningOverviewQueryQuery, OpeningOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningOverviewQueryQuery, OpeningOverviewQueryQueryVariables>(OpeningOverviewQueryDocument, options);
        }
export function useOpeningOverviewQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningOverviewQueryQuery, OpeningOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningOverviewQueryQuery, OpeningOverviewQueryQueryVariables>(OpeningOverviewQueryDocument, options);
        }
export type OpeningOverviewQueryQueryHookResult = ReturnType<typeof useOpeningOverviewQueryQuery>;
export type OpeningOverviewQueryLazyQueryHookResult = ReturnType<typeof useOpeningOverviewQueryLazyQuery>;
export type OpeningOverviewQuerySuspenseQueryHookResult = ReturnType<typeof useOpeningOverviewQuerySuspenseQuery>;
export type OpeningOverviewQueryQueryResult = Apollo.QueryResult<OpeningOverviewQueryQuery, OpeningOverviewQueryQueryVariables>;
export const OpeningPotentialCandidatesDocument = gql`
    query openingPotentialCandidates($openingId: ID!, $filters: RecommendedUsersFiltersInput, $paginationOptions: RecommendedUsersPaginationOptionsInput) {
  opening(id: $openingId) {
    id
    recommendedUsers(filterInput: $filters, paginationOptions: $paginationOptions) {
      pagination {
        hasMoreResults
        minCursor
        maxCursor
        limit
        totalCount
      }
      result {
        user {
          ...candidateUserFields
        }
        userVerification {
          id
          positionExpectations
        }
      }
    }
  }
}
    ${CandidateUserFieldsFragmentDoc}`;

/**
 * __useOpeningPotentialCandidatesQuery__
 *
 * To run a query within a React component, call `useOpeningPotentialCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningPotentialCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningPotentialCandidatesQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      filters: // value for 'filters'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useOpeningPotentialCandidatesQuery(baseOptions: Apollo.QueryHookOptions<OpeningPotentialCandidatesQuery, OpeningPotentialCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningPotentialCandidatesQuery, OpeningPotentialCandidatesQueryVariables>(OpeningPotentialCandidatesDocument, options);
      }
export function useOpeningPotentialCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningPotentialCandidatesQuery, OpeningPotentialCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningPotentialCandidatesQuery, OpeningPotentialCandidatesQueryVariables>(OpeningPotentialCandidatesDocument, options);
        }
export function useOpeningPotentialCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningPotentialCandidatesQuery, OpeningPotentialCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningPotentialCandidatesQuery, OpeningPotentialCandidatesQueryVariables>(OpeningPotentialCandidatesDocument, options);
        }
export type OpeningPotentialCandidatesQueryHookResult = ReturnType<typeof useOpeningPotentialCandidatesQuery>;
export type OpeningPotentialCandidatesLazyQueryHookResult = ReturnType<typeof useOpeningPotentialCandidatesLazyQuery>;
export type OpeningPotentialCandidatesSuspenseQueryHookResult = ReturnType<typeof useOpeningPotentialCandidatesSuspenseQuery>;
export type OpeningPotentialCandidatesQueryResult = Apollo.QueryResult<OpeningPotentialCandidatesQuery, OpeningPotentialCandidatesQueryVariables>;
export const OpeningActivePotentialCandidatesDocument = gql`
    query openingActivePotentialCandidates($openingId: ID!) {
  opening(id: $openingId) {
    id
    title
    state
    applicantCounts {
      totalUnanswered
    }
  }
}
    `;

/**
 * __useOpeningActivePotentialCandidatesQuery__
 *
 * To run a query within a React component, call `useOpeningActivePotentialCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningActivePotentialCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningActivePotentialCandidatesQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *   },
 * });
 */
export function useOpeningActivePotentialCandidatesQuery(baseOptions: Apollo.QueryHookOptions<OpeningActivePotentialCandidatesQuery, OpeningActivePotentialCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningActivePotentialCandidatesQuery, OpeningActivePotentialCandidatesQueryVariables>(OpeningActivePotentialCandidatesDocument, options);
      }
export function useOpeningActivePotentialCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningActivePotentialCandidatesQuery, OpeningActivePotentialCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningActivePotentialCandidatesQuery, OpeningActivePotentialCandidatesQueryVariables>(OpeningActivePotentialCandidatesDocument, options);
        }
export function useOpeningActivePotentialCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningActivePotentialCandidatesQuery, OpeningActivePotentialCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningActivePotentialCandidatesQuery, OpeningActivePotentialCandidatesQueryVariables>(OpeningActivePotentialCandidatesDocument, options);
        }
export type OpeningActivePotentialCandidatesQueryHookResult = ReturnType<typeof useOpeningActivePotentialCandidatesQuery>;
export type OpeningActivePotentialCandidatesLazyQueryHookResult = ReturnType<typeof useOpeningActivePotentialCandidatesLazyQuery>;
export type OpeningActivePotentialCandidatesSuspenseQueryHookResult = ReturnType<typeof useOpeningActivePotentialCandidatesSuspenseQuery>;
export type OpeningActivePotentialCandidatesQueryResult = Apollo.QueryResult<OpeningActivePotentialCandidatesQuery, OpeningActivePotentialCandidatesQueryVariables>;
export const GetRecentGroupedOpeningTalentsDocument = gql`
    query getRecentGroupedOpeningTalents($openingId: ID!, $excludedUserIds: [ID!], $filters: RecommendedUsersFiltersInput, $paginationOptions: RecommendedUsersPaginationOptionsInput, $recruiterCurrencyCode: String!) {
  opening(id: $openingId) {
    id
    sourcingStatistics {
      acceptedApplications
      rejectedApplications
    }
    recommendedUsers(
      excludedUserIds: $excludedUserIds
      filterInput: $filters
      paginationOptions: $paginationOptions
    ) {
      pagination {
        hasMoreResults
        minCursor
        maxCursor
        limit
        totalCount
      }
      result {
        ...groupedTalent
      }
    }
  }
}
    ${GroupedTalentFragmentDoc}`;

/**
 * __useGetRecentGroupedOpeningTalentsQuery__
 *
 * To run a query within a React component, call `useGetRecentGroupedOpeningTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentGroupedOpeningTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentGroupedOpeningTalentsQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      excludedUserIds: // value for 'excludedUserIds'
 *      filters: // value for 'filters'
 *      paginationOptions: // value for 'paginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetRecentGroupedOpeningTalentsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentGroupedOpeningTalentsQuery, GetRecentGroupedOpeningTalentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentGroupedOpeningTalentsQuery, GetRecentGroupedOpeningTalentsQueryVariables>(GetRecentGroupedOpeningTalentsDocument, options);
      }
export function useGetRecentGroupedOpeningTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentGroupedOpeningTalentsQuery, GetRecentGroupedOpeningTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentGroupedOpeningTalentsQuery, GetRecentGroupedOpeningTalentsQueryVariables>(GetRecentGroupedOpeningTalentsDocument, options);
        }
export function useGetRecentGroupedOpeningTalentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentGroupedOpeningTalentsQuery, GetRecentGroupedOpeningTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentGroupedOpeningTalentsQuery, GetRecentGroupedOpeningTalentsQueryVariables>(GetRecentGroupedOpeningTalentsDocument, options);
        }
export type GetRecentGroupedOpeningTalentsQueryHookResult = ReturnType<typeof useGetRecentGroupedOpeningTalentsQuery>;
export type GetRecentGroupedOpeningTalentsLazyQueryHookResult = ReturnType<typeof useGetRecentGroupedOpeningTalentsLazyQuery>;
export type GetRecentGroupedOpeningTalentsSuspenseQueryHookResult = ReturnType<typeof useGetRecentGroupedOpeningTalentsSuspenseQuery>;
export type GetRecentGroupedOpeningTalentsQueryResult = Apollo.QueryResult<GetRecentGroupedOpeningTalentsQuery, GetRecentGroupedOpeningTalentsQueryVariables>;
export const OpeningPotentialCandidatesForSourcePageCarouselDocument = gql`
    query openingPotentialCandidatesForSourcePageCarousel($openingId: ID!, $excludedUserIds: [ID!], $filters: RecommendedUsersFiltersInput, $paginationOptions: RecommendedUsersPaginationOptionsInput, $recruiterCurrencyCode: String!) {
  opening(id: $openingId) {
    id
    sourcingStatistics {
      acceptedApplications
      rejectedApplications
    }
    recommendedUsers(
      excludedUserIds: $excludedUserIds
      filterInput: $filters
      paginationOptions: $paginationOptions
    ) {
      pagination {
        hasMoreResults
        minCursor
        maxCursor
        limit
        totalCount
      }
      result {
        ...groupedTalent
      }
    }
  }
}
    ${GroupedTalentFragmentDoc}`;

/**
 * __useOpeningPotentialCandidatesForSourcePageCarouselQuery__
 *
 * To run a query within a React component, call `useOpeningPotentialCandidatesForSourcePageCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningPotentialCandidatesForSourcePageCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningPotentialCandidatesForSourcePageCarouselQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      excludedUserIds: // value for 'excludedUserIds'
 *      filters: // value for 'filters'
 *      paginationOptions: // value for 'paginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useOpeningPotentialCandidatesForSourcePageCarouselQuery(baseOptions: Apollo.QueryHookOptions<OpeningPotentialCandidatesForSourcePageCarouselQuery, OpeningPotentialCandidatesForSourcePageCarouselQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningPotentialCandidatesForSourcePageCarouselQuery, OpeningPotentialCandidatesForSourcePageCarouselQueryVariables>(OpeningPotentialCandidatesForSourcePageCarouselDocument, options);
      }
export function useOpeningPotentialCandidatesForSourcePageCarouselLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningPotentialCandidatesForSourcePageCarouselQuery, OpeningPotentialCandidatesForSourcePageCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningPotentialCandidatesForSourcePageCarouselQuery, OpeningPotentialCandidatesForSourcePageCarouselQueryVariables>(OpeningPotentialCandidatesForSourcePageCarouselDocument, options);
        }
export function useOpeningPotentialCandidatesForSourcePageCarouselSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningPotentialCandidatesForSourcePageCarouselQuery, OpeningPotentialCandidatesForSourcePageCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningPotentialCandidatesForSourcePageCarouselQuery, OpeningPotentialCandidatesForSourcePageCarouselQueryVariables>(OpeningPotentialCandidatesForSourcePageCarouselDocument, options);
        }
export type OpeningPotentialCandidatesForSourcePageCarouselQueryHookResult = ReturnType<typeof useOpeningPotentialCandidatesForSourcePageCarouselQuery>;
export type OpeningPotentialCandidatesForSourcePageCarouselLazyQueryHookResult = ReturnType<typeof useOpeningPotentialCandidatesForSourcePageCarouselLazyQuery>;
export type OpeningPotentialCandidatesForSourcePageCarouselSuspenseQueryHookResult = ReturnType<typeof useOpeningPotentialCandidatesForSourcePageCarouselSuspenseQuery>;
export type OpeningPotentialCandidatesForSourcePageCarouselQueryResult = Apollo.QueryResult<OpeningPotentialCandidatesForSourcePageCarouselQuery, OpeningPotentialCandidatesForSourcePageCarouselQueryVariables>;
export const PublishedOpeningCandidatesDocument = gql`
    query publishedOpeningCandidates($openingId: ID!, $excludedUserIds: [ID!], $filters: RecommendedUsersFiltersInput, $paginationOptions: RecommendedUsersPaginationOptionsInput, $recruiterCurrencyCode: String!) {
  opening(id: $openingId) {
    id
    recommendedUsers(
      excludedUserIds: $excludedUserIds
      filterInput: $filters
      paginationOptions: $paginationOptions
    ) {
      pagination {
        hasMoreResults
        minCursor
        maxCursor
        limit
        totalCount
      }
      result {
        ...featuredTalentCard
      }
    }
  }
}
    ${FeaturedTalentCardFragmentDoc}`;

/**
 * __usePublishedOpeningCandidatesQuery__
 *
 * To run a query within a React component, call `usePublishedOpeningCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedOpeningCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedOpeningCandidatesQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      excludedUserIds: // value for 'excludedUserIds'
 *      filters: // value for 'filters'
 *      paginationOptions: // value for 'paginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function usePublishedOpeningCandidatesQuery(baseOptions: Apollo.QueryHookOptions<PublishedOpeningCandidatesQuery, PublishedOpeningCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedOpeningCandidatesQuery, PublishedOpeningCandidatesQueryVariables>(PublishedOpeningCandidatesDocument, options);
      }
export function usePublishedOpeningCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedOpeningCandidatesQuery, PublishedOpeningCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedOpeningCandidatesQuery, PublishedOpeningCandidatesQueryVariables>(PublishedOpeningCandidatesDocument, options);
        }
export function usePublishedOpeningCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublishedOpeningCandidatesQuery, PublishedOpeningCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedOpeningCandidatesQuery, PublishedOpeningCandidatesQueryVariables>(PublishedOpeningCandidatesDocument, options);
        }
export type PublishedOpeningCandidatesQueryHookResult = ReturnType<typeof usePublishedOpeningCandidatesQuery>;
export type PublishedOpeningCandidatesLazyQueryHookResult = ReturnType<typeof usePublishedOpeningCandidatesLazyQuery>;
export type PublishedOpeningCandidatesSuspenseQueryHookResult = ReturnType<typeof usePublishedOpeningCandidatesSuspenseQuery>;
export type PublishedOpeningCandidatesQueryResult = Apollo.QueryResult<PublishedOpeningCandidatesQuery, PublishedOpeningCandidatesQueryVariables>;
export const OpeningsForTalentActivityFilterDocument = gql`
    query openingsForTalentActivityFilter($searchTags: [OpeningSearchTagType!], $paginationOptions: PaginationOptionsInput) {
  openings(searchTags: $searchTags, paginationOptions: $paginationOptions) {
    pagination {
      totalCount
      minCursor
      maxCursor
      hasMoreResults
    }
    result {
      id
      title
    }
  }
}
    `;

/**
 * __useOpeningsForTalentActivityFilterQuery__
 *
 * To run a query within a React component, call `useOpeningsForTalentActivityFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningsForTalentActivityFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningsForTalentActivityFilterQuery({
 *   variables: {
 *      searchTags: // value for 'searchTags'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useOpeningsForTalentActivityFilterQuery(baseOptions?: Apollo.QueryHookOptions<OpeningsForTalentActivityFilterQuery, OpeningsForTalentActivityFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningsForTalentActivityFilterQuery, OpeningsForTalentActivityFilterQueryVariables>(OpeningsForTalentActivityFilterDocument, options);
      }
export function useOpeningsForTalentActivityFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningsForTalentActivityFilterQuery, OpeningsForTalentActivityFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningsForTalentActivityFilterQuery, OpeningsForTalentActivityFilterQueryVariables>(OpeningsForTalentActivityFilterDocument, options);
        }
export function useOpeningsForTalentActivityFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningsForTalentActivityFilterQuery, OpeningsForTalentActivityFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningsForTalentActivityFilterQuery, OpeningsForTalentActivityFilterQueryVariables>(OpeningsForTalentActivityFilterDocument, options);
        }
export type OpeningsForTalentActivityFilterQueryHookResult = ReturnType<typeof useOpeningsForTalentActivityFilterQuery>;
export type OpeningsForTalentActivityFilterLazyQueryHookResult = ReturnType<typeof useOpeningsForTalentActivityFilterLazyQuery>;
export type OpeningsForTalentActivityFilterSuspenseQueryHookResult = ReturnType<typeof useOpeningsForTalentActivityFilterSuspenseQuery>;
export type OpeningsForTalentActivityFilterQueryResult = Apollo.QueryResult<OpeningsForTalentActivityFilterQuery, OpeningsForTalentActivityFilterQueryVariables>;
export const GetTaActiveOpeningDocument = gql`
    query getTaActiveOpening($id: ID!) {
  opening(id: $id) {
    id
    state
    title
    source
    pitch
    positionLocations {
      id
      shortName
    }
    sourcingStatistics {
      acceptedApplications
      rejectedApplications
    }
    applicants {
      pagination {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useGetTaActiveOpeningQuery__
 *
 * To run a query within a React component, call `useGetTaActiveOpeningQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaActiveOpeningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaActiveOpeningQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaActiveOpeningQuery(baseOptions: Apollo.QueryHookOptions<GetTaActiveOpeningQuery, GetTaActiveOpeningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaActiveOpeningQuery, GetTaActiveOpeningQueryVariables>(GetTaActiveOpeningDocument, options);
      }
export function useGetTaActiveOpeningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaActiveOpeningQuery, GetTaActiveOpeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaActiveOpeningQuery, GetTaActiveOpeningQueryVariables>(GetTaActiveOpeningDocument, options);
        }
export function useGetTaActiveOpeningSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaActiveOpeningQuery, GetTaActiveOpeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaActiveOpeningQuery, GetTaActiveOpeningQueryVariables>(GetTaActiveOpeningDocument, options);
        }
export type GetTaActiveOpeningQueryHookResult = ReturnType<typeof useGetTaActiveOpeningQuery>;
export type GetTaActiveOpeningLazyQueryHookResult = ReturnType<typeof useGetTaActiveOpeningLazyQuery>;
export type GetTaActiveOpeningSuspenseQueryHookResult = ReturnType<typeof useGetTaActiveOpeningSuspenseQuery>;
export type GetTaActiveOpeningQueryResult = Apollo.QueryResult<GetTaActiveOpeningQuery, GetTaActiveOpeningQueryVariables>;
export const GetOpeningApplicantCountsDocument = gql`
    query getOpeningApplicantCounts($id: ID!) {
  opening(id: $id) {
    id
    title
    pitch
    state
    pendingApplicants: applicants(
      filterInput: {recruiterStates: [PENDING, ACCEPTED], userStates: [PENDING, REJECTED], sources: [USER_VERIFICATION]}
      paginationOptions: {limit: 1}
    ) {
      pagination {
        totalCount
      }
    }
    shortlistApplicants: applicants(
      filterInput: {recruiterMessageThreadStates: [OPEN], recruiterStates: [PENDING], sources: [OPENING, USER_VERIFICATION], userStates: [ACCEPTED]}
      paginationOptions: {limit: 1}
    ) {
      pagination {
        totalCount
      }
    }
    unreadShortlistApplicants: applicants(
      filterInput: {recruiterMessageThreadStates: [OPEN], recruiterStates: [PENDING], sources: [OPENING, USER_VERIFICATION], userStates: [ACCEPTED], hasUnreadMessages: true}
      paginationOptions: {limit: 1}
    ) {
      pagination {
        totalCount
      }
    }
    inConversationApplicants: applicants(
      filterInput: {recruiterMessageThreadStates: [OPEN], recruiterStates: [ACCEPTED], sources: [OPENING, USER_VERIFICATION], userStates: [ACCEPTED]}
      paginationOptions: {limit: 1}
    ) {
      pagination {
        totalCount
      }
    }
    unreadInConversationApplicants: applicants(
      filterInput: {recruiterMessageThreadStates: [OPEN], recruiterStates: [ACCEPTED], sources: [OPENING, USER_VERIFICATION], userStates: [ACCEPTED], hasUnreadMessages: true}
      paginationOptions: {limit: 1}
    ) {
      pagination {
        totalCount
      }
    }
    recommendedUsers(paginationOptions: {limit: 1}) {
      pagination {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useGetOpeningApplicantCountsQuery__
 *
 * To run a query within a React component, call `useGetOpeningApplicantCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpeningApplicantCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpeningApplicantCountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOpeningApplicantCountsQuery(baseOptions: Apollo.QueryHookOptions<GetOpeningApplicantCountsQuery, GetOpeningApplicantCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpeningApplicantCountsQuery, GetOpeningApplicantCountsQueryVariables>(GetOpeningApplicantCountsDocument, options);
      }
export function useGetOpeningApplicantCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpeningApplicantCountsQuery, GetOpeningApplicantCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpeningApplicantCountsQuery, GetOpeningApplicantCountsQueryVariables>(GetOpeningApplicantCountsDocument, options);
        }
export function useGetOpeningApplicantCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOpeningApplicantCountsQuery, GetOpeningApplicantCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpeningApplicantCountsQuery, GetOpeningApplicantCountsQueryVariables>(GetOpeningApplicantCountsDocument, options);
        }
export type GetOpeningApplicantCountsQueryHookResult = ReturnType<typeof useGetOpeningApplicantCountsQuery>;
export type GetOpeningApplicantCountsLazyQueryHookResult = ReturnType<typeof useGetOpeningApplicantCountsLazyQuery>;
export type GetOpeningApplicantCountsSuspenseQueryHookResult = ReturnType<typeof useGetOpeningApplicantCountsSuspenseQuery>;
export type GetOpeningApplicantCountsQueryResult = Apollo.QueryResult<GetOpeningApplicantCountsQuery, GetOpeningApplicantCountsQueryVariables>;
export const GetOpeningRecommendedUserCardsDocument = gql`
    query getOpeningRecommendedUserCards($openingId: ID!, $excludedUserIds: [ID!], $filters: RecommendedUsersFiltersInput, $paginationOptions: RecommendedUsersPaginationOptionsInput, $recruiterCurrencyCode: String!) {
  opening(id: $openingId) {
    id
    state
    recommendedUsers(
      excludedUserIds: $excludedUserIds
      filterInput: $filters
      paginationOptions: $paginationOptions
    ) {
      pagination {
        hasMoreResults
        minCursor
        maxCursor
        limit
        totalCount
      }
      result {
        ...featuredTalentCard
      }
    }
  }
}
    ${FeaturedTalentCardFragmentDoc}`;

/**
 * __useGetOpeningRecommendedUserCardsQuery__
 *
 * To run a query within a React component, call `useGetOpeningRecommendedUserCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpeningRecommendedUserCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpeningRecommendedUserCardsQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      excludedUserIds: // value for 'excludedUserIds'
 *      filters: // value for 'filters'
 *      paginationOptions: // value for 'paginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetOpeningRecommendedUserCardsQuery(baseOptions: Apollo.QueryHookOptions<GetOpeningRecommendedUserCardsQuery, GetOpeningRecommendedUserCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpeningRecommendedUserCardsQuery, GetOpeningRecommendedUserCardsQueryVariables>(GetOpeningRecommendedUserCardsDocument, options);
      }
export function useGetOpeningRecommendedUserCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpeningRecommendedUserCardsQuery, GetOpeningRecommendedUserCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpeningRecommendedUserCardsQuery, GetOpeningRecommendedUserCardsQueryVariables>(GetOpeningRecommendedUserCardsDocument, options);
        }
export function useGetOpeningRecommendedUserCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOpeningRecommendedUserCardsQuery, GetOpeningRecommendedUserCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpeningRecommendedUserCardsQuery, GetOpeningRecommendedUserCardsQueryVariables>(GetOpeningRecommendedUserCardsDocument, options);
        }
export type GetOpeningRecommendedUserCardsQueryHookResult = ReturnType<typeof useGetOpeningRecommendedUserCardsQuery>;
export type GetOpeningRecommendedUserCardsLazyQueryHookResult = ReturnType<typeof useGetOpeningRecommendedUserCardsLazyQuery>;
export type GetOpeningRecommendedUserCardsSuspenseQueryHookResult = ReturnType<typeof useGetOpeningRecommendedUserCardsSuspenseQuery>;
export type GetOpeningRecommendedUserCardsQueryResult = Apollo.QueryResult<GetOpeningRecommendedUserCardsQuery, GetOpeningRecommendedUserCardsQueryVariables>;
export const GetOpeningApplicantCardsDocument = gql`
    query getOpeningApplicantCards($openingId: ID!, $filterInput: FilterOpeningApplicantsInput, $paginationOptions: ApplicantsPaginationOptionsInput, $recruiterCurrencyCode: String!) {
  opening(id: $openingId) {
    id
    applicants(filterInput: $filterInput, paginationOptions: $paginationOptions) {
      pagination {
        hasMoreResults
        minCursor
        maxCursor
        limit
        totalCount
      }
      result {
        ...openingApplicantCard
      }
    }
  }
}
    ${OpeningApplicantCardFragmentDoc}`;

/**
 * __useGetOpeningApplicantCardsQuery__
 *
 * To run a query within a React component, call `useGetOpeningApplicantCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpeningApplicantCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpeningApplicantCardsQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      filterInput: // value for 'filterInput'
 *      paginationOptions: // value for 'paginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetOpeningApplicantCardsQuery(baseOptions: Apollo.QueryHookOptions<GetOpeningApplicantCardsQuery, GetOpeningApplicantCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpeningApplicantCardsQuery, GetOpeningApplicantCardsQueryVariables>(GetOpeningApplicantCardsDocument, options);
      }
export function useGetOpeningApplicantCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpeningApplicantCardsQuery, GetOpeningApplicantCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpeningApplicantCardsQuery, GetOpeningApplicantCardsQueryVariables>(GetOpeningApplicantCardsDocument, options);
        }
export function useGetOpeningApplicantCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOpeningApplicantCardsQuery, GetOpeningApplicantCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpeningApplicantCardsQuery, GetOpeningApplicantCardsQueryVariables>(GetOpeningApplicantCardsDocument, options);
        }
export type GetOpeningApplicantCardsQueryHookResult = ReturnType<typeof useGetOpeningApplicantCardsQuery>;
export type GetOpeningApplicantCardsLazyQueryHookResult = ReturnType<typeof useGetOpeningApplicantCardsLazyQuery>;
export type GetOpeningApplicantCardsSuspenseQueryHookResult = ReturnType<typeof useGetOpeningApplicantCardsSuspenseQuery>;
export type GetOpeningApplicantCardsQueryResult = Apollo.QueryResult<GetOpeningApplicantCardsQuery, GetOpeningApplicantCardsQueryVariables>;
export const CreatePaymentMethodMutationDocument = gql`
    mutation createPaymentMethodMutation($paymentMethodInput: CreatePaymentMethodInput!) {
  createPaymentMethod(paymentMethodInput: $paymentMethodInput) {
    id
    planType
    paysByInvoice
    paymentMethods {
      id
      type
      default
      last4
      masked
      imageUrl
    }
    planInfo {
      price
      ... on SubscriptionPlanType {
        cycle
        state
        trialEndsAt
        nextPaymentDate
      }
    }
  }
}
    `;
export type CreatePaymentMethodMutationMutationFn = Apollo.MutationFunction<CreatePaymentMethodMutationMutation, CreatePaymentMethodMutationMutationVariables>;

/**
 * __useCreatePaymentMethodMutationMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMethodMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMethodMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMethodMutationMutation, { data, loading, error }] = useCreatePaymentMethodMutationMutation({
 *   variables: {
 *      paymentMethodInput: // value for 'paymentMethodInput'
 *   },
 * });
 */
export function useCreatePaymentMethodMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMethodMutationMutation, CreatePaymentMethodMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMethodMutationMutation, CreatePaymentMethodMutationMutationVariables>(CreatePaymentMethodMutationDocument, options);
      }
export type CreatePaymentMethodMutationMutationHookResult = ReturnType<typeof useCreatePaymentMethodMutationMutation>;
export type CreatePaymentMethodMutationMutationResult = Apollo.MutationResult<CreatePaymentMethodMutationMutation>;
export type CreatePaymentMethodMutationMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMethodMutationMutation, CreatePaymentMethodMutationMutationVariables>;
export const LogCreatePaymentMethodStatusMutationDocument = gql`
    mutation logCreatePaymentMethodStatusMutation($status: CreatePaymentMethodStatusEnum!, $additionalInfo: String) {
  logCreatePaymentMethodStatus(status: $status, additionalInfo: $additionalInfo)
}
    `;
export type LogCreatePaymentMethodStatusMutationMutationFn = Apollo.MutationFunction<LogCreatePaymentMethodStatusMutationMutation, LogCreatePaymentMethodStatusMutationMutationVariables>;

/**
 * __useLogCreatePaymentMethodStatusMutationMutation__
 *
 * To run a mutation, you first call `useLogCreatePaymentMethodStatusMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogCreatePaymentMethodStatusMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logCreatePaymentMethodStatusMutationMutation, { data, loading, error }] = useLogCreatePaymentMethodStatusMutationMutation({
 *   variables: {
 *      status: // value for 'status'
 *      additionalInfo: // value for 'additionalInfo'
 *   },
 * });
 */
export function useLogCreatePaymentMethodStatusMutationMutation(baseOptions?: Apollo.MutationHookOptions<LogCreatePaymentMethodStatusMutationMutation, LogCreatePaymentMethodStatusMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogCreatePaymentMethodStatusMutationMutation, LogCreatePaymentMethodStatusMutationMutationVariables>(LogCreatePaymentMethodStatusMutationDocument, options);
      }
export type LogCreatePaymentMethodStatusMutationMutationHookResult = ReturnType<typeof useLogCreatePaymentMethodStatusMutationMutation>;
export type LogCreatePaymentMethodStatusMutationMutationResult = Apollo.MutationResult<LogCreatePaymentMethodStatusMutationMutation>;
export type LogCreatePaymentMethodStatusMutationMutationOptions = Apollo.BaseMutationOptions<LogCreatePaymentMethodStatusMutationMutation, LogCreatePaymentMethodStatusMutationMutationVariables>;
export const GetPlacesDocument = gql`
    query getPlaces($searchPattern: String, $placeTypes: [PlaceTypeEnum!], $paginationOptions: PaginationOptionsInput) {
  places(
    searchPattern: $searchPattern
    placeTypes: $placeTypes
    paginationOptions: $paginationOptions
  ) {
    result {
      type
      entity {
        id
        ... on CountryType {
          id
          longName
          shortName
        }
        ... on LocationType {
          id
          longName
          country {
            id
            shortName
          }
        }
        ... on AreaType {
          id
          longName
        }
      }
    }
  }
}
    `;

/**
 * __useGetPlacesQuery__
 *
 * To run a query within a React component, call `useGetPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacesQuery({
 *   variables: {
 *      searchPattern: // value for 'searchPattern'
 *      placeTypes: // value for 'placeTypes'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useGetPlacesQuery(baseOptions?: Apollo.QueryHookOptions<GetPlacesQuery, GetPlacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlacesQuery, GetPlacesQueryVariables>(GetPlacesDocument, options);
      }
export function useGetPlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlacesQuery, GetPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlacesQuery, GetPlacesQueryVariables>(GetPlacesDocument, options);
        }
export function useGetPlacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlacesQuery, GetPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlacesQuery, GetPlacesQueryVariables>(GetPlacesDocument, options);
        }
export type GetPlacesQueryHookResult = ReturnType<typeof useGetPlacesQuery>;
export type GetPlacesLazyQueryHookResult = ReturnType<typeof useGetPlacesLazyQuery>;
export type GetPlacesSuspenseQueryHookResult = ReturnType<typeof useGetPlacesSuspenseQuery>;
export type GetPlacesQueryResult = Apollo.QueryResult<GetPlacesQuery, GetPlacesQueryVariables>;
export const GetGoogleLocationsDocument = gql`
    query getGoogleLocations($searchPattern: String!) {
  googleLocations(
    searchPattern: $searchPattern
    paginationOptions: {sortOrder: ASC}
  ) {
    result {
      id
      placeId
      longName
      shortName
    }
  }
}
    `;

/**
 * __useGetGoogleLocationsQuery__
 *
 * To run a query within a React component, call `useGetGoogleLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleLocationsQuery({
 *   variables: {
 *      searchPattern: // value for 'searchPattern'
 *   },
 * });
 */
export function useGetGoogleLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetGoogleLocationsQuery, GetGoogleLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoogleLocationsQuery, GetGoogleLocationsQueryVariables>(GetGoogleLocationsDocument, options);
      }
export function useGetGoogleLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoogleLocationsQuery, GetGoogleLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoogleLocationsQuery, GetGoogleLocationsQueryVariables>(GetGoogleLocationsDocument, options);
        }
export function useGetGoogleLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGoogleLocationsQuery, GetGoogleLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGoogleLocationsQuery, GetGoogleLocationsQueryVariables>(GetGoogleLocationsDocument, options);
        }
export type GetGoogleLocationsQueryHookResult = ReturnType<typeof useGetGoogleLocationsQuery>;
export type GetGoogleLocationsLazyQueryHookResult = ReturnType<typeof useGetGoogleLocationsLazyQuery>;
export type GetGoogleLocationsSuspenseQueryHookResult = ReturnType<typeof useGetGoogleLocationsSuspenseQuery>;
export type GetGoogleLocationsQueryResult = Apollo.QueryResult<GetGoogleLocationsQuery, GetGoogleLocationsQueryVariables>;
export const GetCountriesDocument = gql`
    query getCountries($searchPattern: String, $paginationOptions: PaginationOptionsInput) {
  countries(searchPattern: $searchPattern, paginationOptions: $paginationOptions) {
    result {
      id
      longName
      shortName
      dialCode
    }
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *      searchPattern: // value for 'searchPattern'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const RemoveCollaboratorDocument = gql`
    mutation removeCollaborator($openingId: ID!, $recruiterId: ID!) {
  removeCollaborator(openingId: $openingId, recruiterId: $recruiterId)
}
    `;
export type RemoveCollaboratorMutationFn = Apollo.MutationFunction<RemoveCollaboratorMutation, RemoveCollaboratorMutationVariables>;

/**
 * __useRemoveCollaboratorMutation__
 *
 * To run a mutation, you first call `useRemoveCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCollaboratorMutation, { data, loading, error }] = useRemoveCollaboratorMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      recruiterId: // value for 'recruiterId'
 *   },
 * });
 */
export function useRemoveCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCollaboratorMutation, RemoveCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCollaboratorMutation, RemoveCollaboratorMutationVariables>(RemoveCollaboratorDocument, options);
      }
export type RemoveCollaboratorMutationHookResult = ReturnType<typeof useRemoveCollaboratorMutation>;
export type RemoveCollaboratorMutationResult = Apollo.MutationResult<RemoveCollaboratorMutation>;
export type RemoveCollaboratorMutationOptions = Apollo.BaseMutationOptions<RemoveCollaboratorMutation, RemoveCollaboratorMutationVariables>;
export const UpdateRecruiterDocument = gql`
    mutation updateRecruiter($updateInput: UpdateRecruiterInput!) {
  updateRecruiter(updateInput: $updateInput) {
    id
    fullName
    phone
    title
    avatar {
      id
      fullUrl(width: 400, height: 400)
    }
    isDraft
  }
}
    `;
export type UpdateRecruiterMutationFn = Apollo.MutationFunction<UpdateRecruiterMutation, UpdateRecruiterMutationVariables>;

/**
 * __useUpdateRecruiterMutation__
 *
 * To run a mutation, you first call `useUpdateRecruiterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecruiterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecruiterMutation, { data, loading, error }] = useUpdateRecruiterMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateRecruiterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecruiterMutation, UpdateRecruiterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecruiterMutation, UpdateRecruiterMutationVariables>(UpdateRecruiterDocument, options);
      }
export type UpdateRecruiterMutationHookResult = ReturnType<typeof useUpdateRecruiterMutation>;
export type UpdateRecruiterMutationResult = Apollo.MutationResult<UpdateRecruiterMutation>;
export type UpdateRecruiterMutationOptions = Apollo.BaseMutationOptions<UpdateRecruiterMutation, UpdateRecruiterMutationVariables>;
export const UpdateRecruiterPasswordDocument = gql`
    mutation updateRecruiterPassword($oldPassword: String, $newPassword: String!) {
  updateRecruiterPassword(oldPassword: $oldPassword, newPassword: $newPassword)
}
    `;
export type UpdateRecruiterPasswordMutationFn = Apollo.MutationFunction<UpdateRecruiterPasswordMutation, UpdateRecruiterPasswordMutationVariables>;

/**
 * __useUpdateRecruiterPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateRecruiterPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecruiterPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecruiterPasswordMutation, { data, loading, error }] = useUpdateRecruiterPasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdateRecruiterPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecruiterPasswordMutation, UpdateRecruiterPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecruiterPasswordMutation, UpdateRecruiterPasswordMutationVariables>(UpdateRecruiterPasswordDocument, options);
      }
export type UpdateRecruiterPasswordMutationHookResult = ReturnType<typeof useUpdateRecruiterPasswordMutation>;
export type UpdateRecruiterPasswordMutationResult = Apollo.MutationResult<UpdateRecruiterPasswordMutation>;
export type UpdateRecruiterPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateRecruiterPasswordMutation, UpdateRecruiterPasswordMutationVariables>;
export const CurrentRecruiterForProfileFinishDocument = gql`
    query currentRecruiterForProfileFinish {
  currentRecruiter {
    id
    fullName
    email
    phone
    title
    country {
      id
      longName
      shortName
    }
    isDraft
    isIncomplete
  }
}
    `;

/**
 * __useCurrentRecruiterForProfileFinishQuery__
 *
 * To run a query within a React component, call `useCurrentRecruiterForProfileFinishQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentRecruiterForProfileFinishQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentRecruiterForProfileFinishQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentRecruiterForProfileFinishQuery(baseOptions?: Apollo.QueryHookOptions<CurrentRecruiterForProfileFinishQuery, CurrentRecruiterForProfileFinishQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentRecruiterForProfileFinishQuery, CurrentRecruiterForProfileFinishQueryVariables>(CurrentRecruiterForProfileFinishDocument, options);
      }
export function useCurrentRecruiterForProfileFinishLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentRecruiterForProfileFinishQuery, CurrentRecruiterForProfileFinishQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentRecruiterForProfileFinishQuery, CurrentRecruiterForProfileFinishQueryVariables>(CurrentRecruiterForProfileFinishDocument, options);
        }
export function useCurrentRecruiterForProfileFinishSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentRecruiterForProfileFinishQuery, CurrentRecruiterForProfileFinishQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentRecruiterForProfileFinishQuery, CurrentRecruiterForProfileFinishQueryVariables>(CurrentRecruiterForProfileFinishDocument, options);
        }
export type CurrentRecruiterForProfileFinishQueryHookResult = ReturnType<typeof useCurrentRecruiterForProfileFinishQuery>;
export type CurrentRecruiterForProfileFinishLazyQueryHookResult = ReturnType<typeof useCurrentRecruiterForProfileFinishLazyQuery>;
export type CurrentRecruiterForProfileFinishSuspenseQueryHookResult = ReturnType<typeof useCurrentRecruiterForProfileFinishSuspenseQuery>;
export type CurrentRecruiterForProfileFinishQueryResult = Apollo.QueryResult<CurrentRecruiterForProfileFinishQuery, CurrentRecruiterForProfileFinishQueryVariables>;
export const CurrentRecruiterForEditProfileDocument = gql`
    query currentRecruiterForEditProfile {
  currentRecruiter {
    id
    fullName
    phone
    title
    avatar {
      id
      fullUrl(width: 400, height: 400)
    }
  }
}
    `;

/**
 * __useCurrentRecruiterForEditProfileQuery__
 *
 * To run a query within a React component, call `useCurrentRecruiterForEditProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentRecruiterForEditProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentRecruiterForEditProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentRecruiterForEditProfileQuery(baseOptions?: Apollo.QueryHookOptions<CurrentRecruiterForEditProfileQuery, CurrentRecruiterForEditProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentRecruiterForEditProfileQuery, CurrentRecruiterForEditProfileQueryVariables>(CurrentRecruiterForEditProfileDocument, options);
      }
export function useCurrentRecruiterForEditProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentRecruiterForEditProfileQuery, CurrentRecruiterForEditProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentRecruiterForEditProfileQuery, CurrentRecruiterForEditProfileQueryVariables>(CurrentRecruiterForEditProfileDocument, options);
        }
export function useCurrentRecruiterForEditProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentRecruiterForEditProfileQuery, CurrentRecruiterForEditProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentRecruiterForEditProfileQuery, CurrentRecruiterForEditProfileQueryVariables>(CurrentRecruiterForEditProfileDocument, options);
        }
export type CurrentRecruiterForEditProfileQueryHookResult = ReturnType<typeof useCurrentRecruiterForEditProfileQuery>;
export type CurrentRecruiterForEditProfileLazyQueryHookResult = ReturnType<typeof useCurrentRecruiterForEditProfileLazyQuery>;
export type CurrentRecruiterForEditProfileSuspenseQueryHookResult = ReturnType<typeof useCurrentRecruiterForEditProfileSuspenseQuery>;
export type CurrentRecruiterForEditProfileQueryResult = Apollo.QueryResult<CurrentRecruiterForEditProfileQuery, CurrentRecruiterForEditProfileQueryVariables>;
export const CurrentRecruiterForOpeningDocument = gql`
    query currentRecruiterForOpening {
  currentRecruiter {
    id
    rights {
      inviteCollaborator
    }
  }
}
    `;

/**
 * __useCurrentRecruiterForOpeningQuery__
 *
 * To run a query within a React component, call `useCurrentRecruiterForOpeningQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentRecruiterForOpeningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentRecruiterForOpeningQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentRecruiterForOpeningQuery(baseOptions?: Apollo.QueryHookOptions<CurrentRecruiterForOpeningQuery, CurrentRecruiterForOpeningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentRecruiterForOpeningQuery, CurrentRecruiterForOpeningQueryVariables>(CurrentRecruiterForOpeningDocument, options);
      }
export function useCurrentRecruiterForOpeningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentRecruiterForOpeningQuery, CurrentRecruiterForOpeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentRecruiterForOpeningQuery, CurrentRecruiterForOpeningQueryVariables>(CurrentRecruiterForOpeningDocument, options);
        }
export function useCurrentRecruiterForOpeningSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentRecruiterForOpeningQuery, CurrentRecruiterForOpeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentRecruiterForOpeningQuery, CurrentRecruiterForOpeningQueryVariables>(CurrentRecruiterForOpeningDocument, options);
        }
export type CurrentRecruiterForOpeningQueryHookResult = ReturnType<typeof useCurrentRecruiterForOpeningQuery>;
export type CurrentRecruiterForOpeningLazyQueryHookResult = ReturnType<typeof useCurrentRecruiterForOpeningLazyQuery>;
export type CurrentRecruiterForOpeningSuspenseQueryHookResult = ReturnType<typeof useCurrentRecruiterForOpeningSuspenseQuery>;
export type CurrentRecruiterForOpeningQueryResult = Apollo.QueryResult<CurrentRecruiterForOpeningQuery, CurrentRecruiterForOpeningQueryVariables>;
export const CollaboratorsForOpeningDocument = gql`
    query collaboratorsForOpening($openingId: ID!, $paginationOptions: PaginationOptionsInput) {
  opening(id: $openingId) {
    collaborators(paginationOptions: $paginationOptions) {
      result {
        id
        email
        fullName
        avatarColor
      }
    }
  }
}
    `;

/**
 * __useCollaboratorsForOpeningQuery__
 *
 * To run a query within a React component, call `useCollaboratorsForOpeningQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaboratorsForOpeningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaboratorsForOpeningQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useCollaboratorsForOpeningQuery(baseOptions: Apollo.QueryHookOptions<CollaboratorsForOpeningQuery, CollaboratorsForOpeningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollaboratorsForOpeningQuery, CollaboratorsForOpeningQueryVariables>(CollaboratorsForOpeningDocument, options);
      }
export function useCollaboratorsForOpeningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollaboratorsForOpeningQuery, CollaboratorsForOpeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollaboratorsForOpeningQuery, CollaboratorsForOpeningQueryVariables>(CollaboratorsForOpeningDocument, options);
        }
export function useCollaboratorsForOpeningSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CollaboratorsForOpeningQuery, CollaboratorsForOpeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollaboratorsForOpeningQuery, CollaboratorsForOpeningQueryVariables>(CollaboratorsForOpeningDocument, options);
        }
export type CollaboratorsForOpeningQueryHookResult = ReturnType<typeof useCollaboratorsForOpeningQuery>;
export type CollaboratorsForOpeningLazyQueryHookResult = ReturnType<typeof useCollaboratorsForOpeningLazyQuery>;
export type CollaboratorsForOpeningSuspenseQueryHookResult = ReturnType<typeof useCollaboratorsForOpeningSuspenseQuery>;
export type CollaboratorsForOpeningQueryResult = Apollo.QueryResult<CollaboratorsForOpeningQuery, CollaboratorsForOpeningQueryVariables>;
export const GetRelocationBenefitsDocument = gql`
    query getRelocationBenefits {
  relocationBenefits {
    id
    key
    value
  }
}
    `;

/**
 * __useGetRelocationBenefitsQuery__
 *
 * To run a query within a React component, call `useGetRelocationBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelocationBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelocationBenefitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRelocationBenefitsQuery(baseOptions?: Apollo.QueryHookOptions<GetRelocationBenefitsQuery, GetRelocationBenefitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelocationBenefitsQuery, GetRelocationBenefitsQueryVariables>(GetRelocationBenefitsDocument, options);
      }
export function useGetRelocationBenefitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelocationBenefitsQuery, GetRelocationBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelocationBenefitsQuery, GetRelocationBenefitsQueryVariables>(GetRelocationBenefitsDocument, options);
        }
export function useGetRelocationBenefitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRelocationBenefitsQuery, GetRelocationBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRelocationBenefitsQuery, GetRelocationBenefitsQueryVariables>(GetRelocationBenefitsDocument, options);
        }
export type GetRelocationBenefitsQueryHookResult = ReturnType<typeof useGetRelocationBenefitsQuery>;
export type GetRelocationBenefitsLazyQueryHookResult = ReturnType<typeof useGetRelocationBenefitsLazyQuery>;
export type GetRelocationBenefitsSuspenseQueryHookResult = ReturnType<typeof useGetRelocationBenefitsSuspenseQuery>;
export type GetRelocationBenefitsQueryResult = Apollo.QueryResult<GetRelocationBenefitsQuery, GetRelocationBenefitsQueryVariables>;
export const GetSalaryPeriodsDocument = gql`
    query getSalaryPeriods {
  salaryPeriods {
    label
    value
  }
}
    `;

/**
 * __useGetSalaryPeriodsQuery__
 *
 * To run a query within a React component, call `useGetSalaryPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalaryPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalaryPeriodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalaryPeriodsQuery(baseOptions?: Apollo.QueryHookOptions<GetSalaryPeriodsQuery, GetSalaryPeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalaryPeriodsQuery, GetSalaryPeriodsQueryVariables>(GetSalaryPeriodsDocument, options);
      }
export function useGetSalaryPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalaryPeriodsQuery, GetSalaryPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalaryPeriodsQuery, GetSalaryPeriodsQueryVariables>(GetSalaryPeriodsDocument, options);
        }
export function useGetSalaryPeriodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSalaryPeriodsQuery, GetSalaryPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalaryPeriodsQuery, GetSalaryPeriodsQueryVariables>(GetSalaryPeriodsDocument, options);
        }
export type GetSalaryPeriodsQueryHookResult = ReturnType<typeof useGetSalaryPeriodsQuery>;
export type GetSalaryPeriodsLazyQueryHookResult = ReturnType<typeof useGetSalaryPeriodsLazyQuery>;
export type GetSalaryPeriodsSuspenseQueryHookResult = ReturnType<typeof useGetSalaryPeriodsSuspenseQuery>;
export type GetSalaryPeriodsQueryResult = Apollo.QueryResult<GetSalaryPeriodsQuery, GetSalaryPeriodsQueryVariables>;
export const SenioritiesQueryDocument = gql`
    query senioritiesQuery {
  seniorities {
    id
    name
    key
  }
}
    `;

/**
 * __useSenioritiesQueryQuery__
 *
 * To run a query within a React component, call `useSenioritiesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSenioritiesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSenioritiesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSenioritiesQueryQuery(baseOptions?: Apollo.QueryHookOptions<SenioritiesQueryQuery, SenioritiesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SenioritiesQueryQuery, SenioritiesQueryQueryVariables>(SenioritiesQueryDocument, options);
      }
export function useSenioritiesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SenioritiesQueryQuery, SenioritiesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SenioritiesQueryQuery, SenioritiesQueryQueryVariables>(SenioritiesQueryDocument, options);
        }
export function useSenioritiesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SenioritiesQueryQuery, SenioritiesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SenioritiesQueryQuery, SenioritiesQueryQueryVariables>(SenioritiesQueryDocument, options);
        }
export type SenioritiesQueryQueryHookResult = ReturnType<typeof useSenioritiesQueryQuery>;
export type SenioritiesQueryLazyQueryHookResult = ReturnType<typeof useSenioritiesQueryLazyQuery>;
export type SenioritiesQuerySuspenseQueryHookResult = ReturnType<typeof useSenioritiesQuerySuspenseQuery>;
export type SenioritiesQueryQueryResult = Apollo.QueryResult<SenioritiesQueryQuery, SenioritiesQueryQueryVariables>;
export const SessionDocument = gql`
    query session {
  company {
    id
    name
    operationsEmail
    profile {
      id
      name
      state
      isPublished
      isComplete
      logo {
        id
        fullUrl(width: 500, height: 500)
      }
      companySize {
        id
        name
      }
    }
    callBookingUrl
    country {
      id
      longName
      shortName
      currency
      continent {
        id
      }
    }
    featureFlags
  }
  currentRecruiter {
    id
    email
    phone
    title
    fullName
    firstName
    lastName
    nameInitials
    avatarColor
    avatarUrl
    intercomHash
    lastSeen
    avatar {
      id
      fullUrl(width: 400, height: 400)
    }
    isSiteAdmin
    isDraft
    isIncomplete
    rights {
      billing
      inviteTeam
      inviteCollaborator
      openings
      companyProfile
      company
      requests
      toggle2FA
    }
    availableCompanies {
      company {
        id
        name
        profile {
          id
          name
        }
      }
      isDefault
      isCurrent
      isVisible
    }
    country {
      id
      shortName
      longName
      currency
    }
  }
  customer {
    id
    planType
    paysByInvoice
    hidePaymentDetails
    hidePricingDetails
    hasActivePaymentMethod
    planInfo {
      price
      currency {
        id
        code
        symbol
      }
      ... on SubscriptionPlanType {
        trialEndsAt
        state
        cycle
        hasOpeningsLimitReached
        occupiedOpeningSlots
        nextPaymentDate
        nextPaymentDateMonthly: nextPaymentDate(subscriptionCycle: MONTHLY)
        nextPaymentDateHalfYearly: nextPaymentDate(subscriptionCycle: HALF_YEARLY)
        nextPaymentDateYearly: nextPaymentDate(subscriptionCycle: YEARLY)
      }
    }
  }
  subscriptionPlans {
    name
    planType
    openingSlots
    isAvailable
    variants {
      cycle
      price
      savings
      freeMonths
      openingRepublishingPrice
      currency
    }
  }
}
    `;

/**
 * __useSessionQuery__
 *
 * To run a query within a React component, call `useSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionQuery(baseOptions?: Apollo.QueryHookOptions<SessionQuery, SessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
      }
export function useSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionQuery, SessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
        }
export function useSessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SessionQuery, SessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
        }
export type SessionQueryHookResult = ReturnType<typeof useSessionQuery>;
export type SessionLazyQueryHookResult = ReturnType<typeof useSessionLazyQuery>;
export type SessionSuspenseQueryHookResult = ReturnType<typeof useSessionSuspenseQuery>;
export type SessionQueryResult = Apollo.QueryResult<SessionQuery, SessionQueryVariables>;
export const RecordSignalsDocument = gql`
    mutation recordSignals($signals: [RecordSignalInput!]!) {
  recordSignals(signals: $signals)
}
    `;
export type RecordSignalsMutationFn = Apollo.MutationFunction<RecordSignalsMutation, RecordSignalsMutationVariables>;

/**
 * __useRecordSignalsMutation__
 *
 * To run a mutation, you first call `useRecordSignalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSignalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSignalsMutation, { data, loading, error }] = useRecordSignalsMutation({
 *   variables: {
 *      signals: // value for 'signals'
 *   },
 * });
 */
export function useRecordSignalsMutation(baseOptions?: Apollo.MutationHookOptions<RecordSignalsMutation, RecordSignalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordSignalsMutation, RecordSignalsMutationVariables>(RecordSignalsDocument, options);
      }
export type RecordSignalsMutationHookResult = ReturnType<typeof useRecordSignalsMutation>;
export type RecordSignalsMutationResult = Apollo.MutationResult<RecordSignalsMutation>;
export type RecordSignalsMutationOptions = Apollo.BaseMutationOptions<RecordSignalsMutation, RecordSignalsMutationVariables>;
export const GetSpecialitiesDocument = gql`
    query getSpecialities {
  specialities {
    id
    name
    key
    skillTags
    sort
  }
}
    `;

/**
 * __useGetSpecialitiesQuery__
 *
 * To run a query within a React component, call `useGetSpecialitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSpecialitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>(GetSpecialitiesDocument, options);
      }
export function useGetSpecialitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>(GetSpecialitiesDocument, options);
        }
export function useGetSpecialitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>(GetSpecialitiesDocument, options);
        }
export type GetSpecialitiesQueryHookResult = ReturnType<typeof useGetSpecialitiesQuery>;
export type GetSpecialitiesLazyQueryHookResult = ReturnType<typeof useGetSpecialitiesLazyQuery>;
export type GetSpecialitiesSuspenseQueryHookResult = ReturnType<typeof useGetSpecialitiesSuspenseQuery>;
export type GetSpecialitiesQueryResult = Apollo.QueryResult<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>;
export const ActivateSubscriptionDocument = gql`
    mutation activateSubscription($planType: CustomerPlanEnum!, $subscriptionCycle: CustomerSubscriptionCycleEnum!) {
  activateSubscription(planType: $planType, subscriptionCycle: $subscriptionCycle) {
    id
    planType
    paysByInvoice
    planInfo {
      price
      currency {
        id
        code
        symbol
      }
      ... on SubscriptionPlanType {
        trialEndsAt
        state
        occupiedOpeningSlots
        hasOpeningsLimitReached
        nextPaymentDate(subscriptionCycle: $subscriptionCycle)
        nextPaymentDateMonthly: nextPaymentDate(subscriptionCycle: MONTHLY)
        nextPaymentDateHalfYearly: nextPaymentDate(subscriptionCycle: HALF_YEARLY)
        nextPaymentDateYearly: nextPaymentDate(subscriptionCycle: YEARLY)
      }
    }
  }
}
    `;
export type ActivateSubscriptionMutationFn = Apollo.MutationFunction<ActivateSubscriptionMutation, ActivateSubscriptionMutationVariables>;

/**
 * __useActivateSubscriptionMutation__
 *
 * To run a mutation, you first call `useActivateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSubscriptionMutation, { data, loading, error }] = useActivateSubscriptionMutation({
 *   variables: {
 *      planType: // value for 'planType'
 *      subscriptionCycle: // value for 'subscriptionCycle'
 *   },
 * });
 */
export function useActivateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ActivateSubscriptionMutation, ActivateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSubscriptionMutation, ActivateSubscriptionMutationVariables>(ActivateSubscriptionDocument, options);
      }
export type ActivateSubscriptionMutationHookResult = ReturnType<typeof useActivateSubscriptionMutation>;
export type ActivateSubscriptionMutationResult = Apollo.MutationResult<ActivateSubscriptionMutation>;
export type ActivateSubscriptionMutationOptions = Apollo.BaseMutationOptions<ActivateSubscriptionMutation, ActivateSubscriptionMutationVariables>;
export const UpdateInvoicingDetailsDocument = gql`
    mutation updateInvoicingDetails($customerId: ID!, $invoicingDetailsInput: InvoicingDetailsInput!) {
  updateInvoicingDetails(
    customerId: $customerId
    invoicingDetailsInput: $invoicingDetailsInput
  ) {
    id
    vatId
    region
    postalCode
    city
    addressLine1
    businessName
    countryName
  }
}
    `;
export type UpdateInvoicingDetailsMutationFn = Apollo.MutationFunction<UpdateInvoicingDetailsMutation, UpdateInvoicingDetailsMutationVariables>;

/**
 * __useUpdateInvoicingDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateInvoicingDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoicingDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoicingDetailsMutation, { data, loading, error }] = useUpdateInvoicingDetailsMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      invoicingDetailsInput: // value for 'invoicingDetailsInput'
 *   },
 * });
 */
export function useUpdateInvoicingDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoicingDetailsMutation, UpdateInvoicingDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoicingDetailsMutation, UpdateInvoicingDetailsMutationVariables>(UpdateInvoicingDetailsDocument, options);
      }
export type UpdateInvoicingDetailsMutationHookResult = ReturnType<typeof useUpdateInvoicingDetailsMutation>;
export type UpdateInvoicingDetailsMutationResult = Apollo.MutationResult<UpdateInvoicingDetailsMutation>;
export type UpdateInvoicingDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateInvoicingDetailsMutation, UpdateInvoicingDetailsMutationVariables>;
export const SetTotalSlotsCountDocument = gql`
    mutation setTotalSlotsCount($totalSlotsCount: Int!) {
  setTotalSlotsCount(totalSlotsCount: $totalSlotsCount) {
    id
    planInfo {
      ... on SubscriptionPlanType {
        openingSlots
      }
    }
  }
}
    `;
export type SetTotalSlotsCountMutationFn = Apollo.MutationFunction<SetTotalSlotsCountMutation, SetTotalSlotsCountMutationVariables>;

/**
 * __useSetTotalSlotsCountMutation__
 *
 * To run a mutation, you first call `useSetTotalSlotsCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTotalSlotsCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTotalSlotsCountMutation, { data, loading, error }] = useSetTotalSlotsCountMutation({
 *   variables: {
 *      totalSlotsCount: // value for 'totalSlotsCount'
 *   },
 * });
 */
export function useSetTotalSlotsCountMutation(baseOptions?: Apollo.MutationHookOptions<SetTotalSlotsCountMutation, SetTotalSlotsCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTotalSlotsCountMutation, SetTotalSlotsCountMutationVariables>(SetTotalSlotsCountDocument, options);
      }
export type SetTotalSlotsCountMutationHookResult = ReturnType<typeof useSetTotalSlotsCountMutation>;
export type SetTotalSlotsCountMutationResult = Apollo.MutationResult<SetTotalSlotsCountMutation>;
export type SetTotalSlotsCountMutationOptions = Apollo.BaseMutationOptions<SetTotalSlotsCountMutation, SetTotalSlotsCountMutationVariables>;
export const UpgradeSubscriptionDocument = gql`
    mutation upgradeSubscription($planType: CustomerPlanEnum!, $subscriptionCycle: CustomerSubscriptionCycleEnum!) {
  upgradeSubscription(planType: $planType, subscriptionCycle: $subscriptionCycle) {
    id
    planType
    planInfo {
      price
      ... on SubscriptionPlanType {
        cycle
        nextPaymentDate
        hasOpeningsLimitReached
        occupiedOpeningSlots
      }
    }
  }
}
    `;
export type UpgradeSubscriptionMutationFn = Apollo.MutationFunction<UpgradeSubscriptionMutation, UpgradeSubscriptionMutationVariables>;

/**
 * __useUpgradeSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpgradeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeSubscriptionMutation, { data, loading, error }] = useUpgradeSubscriptionMutation({
 *   variables: {
 *      planType: // value for 'planType'
 *      subscriptionCycle: // value for 'subscriptionCycle'
 *   },
 * });
 */
export function useUpgradeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeSubscriptionMutation, UpgradeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeSubscriptionMutation, UpgradeSubscriptionMutationVariables>(UpgradeSubscriptionDocument, options);
      }
export type UpgradeSubscriptionMutationHookResult = ReturnType<typeof useUpgradeSubscriptionMutation>;
export type UpgradeSubscriptionMutationResult = Apollo.MutationResult<UpgradeSubscriptionMutation>;
export type UpgradeSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpgradeSubscriptionMutation, UpgradeSubscriptionMutationVariables>;
export const SetDefaultPaymentMethodMutationDocument = gql`
    mutation setDefaultPaymentMethodMutation($paymentMethodId: ID!) {
  setDefaultPaymentMethod(paymentMethodId: $paymentMethodId) {
    id
    planType
    paysByInvoice
    paymentMethods {
      id
      type
      default
      last4
      masked
      imageUrl
    }
    planInfo {
      price
      ... on SubscriptionPlanType {
        cycle
        state
        trialEndsAt
        nextPaymentDate
      }
    }
  }
}
    `;
export type SetDefaultPaymentMethodMutationMutationFn = Apollo.MutationFunction<SetDefaultPaymentMethodMutationMutation, SetDefaultPaymentMethodMutationMutationVariables>;

/**
 * __useSetDefaultPaymentMethodMutationMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentMethodMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentMethodMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentMethodMutationMutation, { data, loading, error }] = useSetDefaultPaymentMethodMutationMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useSetDefaultPaymentMethodMutationMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentMethodMutationMutation, SetDefaultPaymentMethodMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentMethodMutationMutation, SetDefaultPaymentMethodMutationMutationVariables>(SetDefaultPaymentMethodMutationDocument, options);
      }
export type SetDefaultPaymentMethodMutationMutationHookResult = ReturnType<typeof useSetDefaultPaymentMethodMutationMutation>;
export type SetDefaultPaymentMethodMutationMutationResult = Apollo.MutationResult<SetDefaultPaymentMethodMutationMutation>;
export type SetDefaultPaymentMethodMutationMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentMethodMutationMutation, SetDefaultPaymentMethodMutationMutationVariables>;
export const RemovePaymentMethodDocument = gql`
    mutation removePaymentMethod($paymentMethodId: ID!) {
  removePaymentMethod(paymentMethodId: $paymentMethodId) {
    id
    planType
    paysByInvoice
    paymentMethods {
      id
      type
      default
      last4
      masked
      imageUrl
    }
    planInfo {
      price
      ... on SubscriptionPlanType {
        cycle
        state
        trialEndsAt
        nextPaymentDate
      }
    }
  }
}
    `;
export type RemovePaymentMethodMutationFn = Apollo.MutationFunction<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMethodMutation, { data, loading, error }] = useRemovePaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(RemovePaymentMethodDocument, options);
      }
export type RemovePaymentMethodMutationHookResult = ReturnType<typeof useRemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationResult = Apollo.MutationResult<RemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const ActivateSubscriptionForPlansDocument = gql`
    mutation activateSubscriptionForPlans($planType: CustomerPlanEnum!, $subscriptionCycle: CustomerSubscriptionCycleEnum!) {
  activateSubscription(planType: $planType, subscriptionCycle: $subscriptionCycle) {
    id
    planType
    planInfo {
      price
      currency {
        id
        symbol
      }
      ... on SubscriptionPlanType {
        trialEndsAt
        state
        cycle
        hasOpeningsLimitReached
        occupiedOpeningSlots
        nextPaymentDate
      }
    }
  }
}
    `;
export type ActivateSubscriptionForPlansMutationFn = Apollo.MutationFunction<ActivateSubscriptionForPlansMutation, ActivateSubscriptionForPlansMutationVariables>;

/**
 * __useActivateSubscriptionForPlansMutation__
 *
 * To run a mutation, you first call `useActivateSubscriptionForPlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSubscriptionForPlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSubscriptionForPlansMutation, { data, loading, error }] = useActivateSubscriptionForPlansMutation({
 *   variables: {
 *      planType: // value for 'planType'
 *      subscriptionCycle: // value for 'subscriptionCycle'
 *   },
 * });
 */
export function useActivateSubscriptionForPlansMutation(baseOptions?: Apollo.MutationHookOptions<ActivateSubscriptionForPlansMutation, ActivateSubscriptionForPlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSubscriptionForPlansMutation, ActivateSubscriptionForPlansMutationVariables>(ActivateSubscriptionForPlansDocument, options);
      }
export type ActivateSubscriptionForPlansMutationHookResult = ReturnType<typeof useActivateSubscriptionForPlansMutation>;
export type ActivateSubscriptionForPlansMutationResult = Apollo.MutationResult<ActivateSubscriptionForPlansMutation>;
export type ActivateSubscriptionForPlansMutationOptions = Apollo.BaseMutationOptions<ActivateSubscriptionForPlansMutation, ActivateSubscriptionForPlansMutationVariables>;
export const SubscriptionAndCurrenciesQueryDocument = gql`
    query subscriptionAndCurrenciesQuery {
  subscriptionPlans(excludeArchived: true) {
    name
    planType
    openingSlots
    isAvailable
    variants {
      openingActivationPrice
      openingRepublishingPrice
      cycle
      price
      currency
      openingSlots
      savings
      freeMonths
    }
  }
  availableCurrencies {
    id
    code
    symbol
  }
}
    `;

/**
 * __useSubscriptionAndCurrenciesQueryQuery__
 *
 * To run a query within a React component, call `useSubscriptionAndCurrenciesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionAndCurrenciesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionAndCurrenciesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionAndCurrenciesQueryQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionAndCurrenciesQueryQuery, SubscriptionAndCurrenciesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionAndCurrenciesQueryQuery, SubscriptionAndCurrenciesQueryQueryVariables>(SubscriptionAndCurrenciesQueryDocument, options);
      }
export function useSubscriptionAndCurrenciesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionAndCurrenciesQueryQuery, SubscriptionAndCurrenciesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionAndCurrenciesQueryQuery, SubscriptionAndCurrenciesQueryQueryVariables>(SubscriptionAndCurrenciesQueryDocument, options);
        }
export function useSubscriptionAndCurrenciesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionAndCurrenciesQueryQuery, SubscriptionAndCurrenciesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionAndCurrenciesQueryQuery, SubscriptionAndCurrenciesQueryQueryVariables>(SubscriptionAndCurrenciesQueryDocument, options);
        }
export type SubscriptionAndCurrenciesQueryQueryHookResult = ReturnType<typeof useSubscriptionAndCurrenciesQueryQuery>;
export type SubscriptionAndCurrenciesQueryLazyQueryHookResult = ReturnType<typeof useSubscriptionAndCurrenciesQueryLazyQuery>;
export type SubscriptionAndCurrenciesQuerySuspenseQueryHookResult = ReturnType<typeof useSubscriptionAndCurrenciesQuerySuspenseQuery>;
export type SubscriptionAndCurrenciesQueryQueryResult = Apollo.QueryResult<SubscriptionAndCurrenciesQueryQuery, SubscriptionAndCurrenciesQueryQueryVariables>;
export const SetPaymentMethodTypeDocument = gql`
    mutation setPaymentMethodType($methodType: PaymentMethodTypeEnum!) {
  setPaymentMethodType(methodType: $methodType)
}
    `;
export type SetPaymentMethodTypeMutationFn = Apollo.MutationFunction<SetPaymentMethodTypeMutation, SetPaymentMethodTypeMutationVariables>;

/**
 * __useSetPaymentMethodTypeMutation__
 *
 * To run a mutation, you first call `useSetPaymentMethodTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentMethodTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentMethodTypeMutation, { data, loading, error }] = useSetPaymentMethodTypeMutation({
 *   variables: {
 *      methodType: // value for 'methodType'
 *   },
 * });
 */
export function useSetPaymentMethodTypeMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentMethodTypeMutation, SetPaymentMethodTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPaymentMethodTypeMutation, SetPaymentMethodTypeMutationVariables>(SetPaymentMethodTypeDocument, options);
      }
export type SetPaymentMethodTypeMutationHookResult = ReturnType<typeof useSetPaymentMethodTypeMutation>;
export type SetPaymentMethodTypeMutationResult = Apollo.MutationResult<SetPaymentMethodTypeMutation>;
export type SetPaymentMethodTypeMutationOptions = Apollo.BaseMutationOptions<SetPaymentMethodTypeMutation, SetPaymentMethodTypeMutationVariables>;
export const InvoicingDetailsDocument = gql`
    query invoicingDetails {
  customer {
    id
  }
  company {
    id
    invoicingDetails {
      id
      vatId
      region
      postalCode
      city
      addressLine1
      businessName
      billingEmail
      countryName
    }
  }
}
    `;

/**
 * __useInvoicingDetailsQuery__
 *
 * To run a query within a React component, call `useInvoicingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicingDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoicingDetailsQuery(baseOptions?: Apollo.QueryHookOptions<InvoicingDetailsQuery, InvoicingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicingDetailsQuery, InvoicingDetailsQueryVariables>(InvoicingDetailsDocument, options);
      }
export function useInvoicingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicingDetailsQuery, InvoicingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicingDetailsQuery, InvoicingDetailsQueryVariables>(InvoicingDetailsDocument, options);
        }
export function useInvoicingDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicingDetailsQuery, InvoicingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoicingDetailsQuery, InvoicingDetailsQueryVariables>(InvoicingDetailsDocument, options);
        }
export type InvoicingDetailsQueryHookResult = ReturnType<typeof useInvoicingDetailsQuery>;
export type InvoicingDetailsLazyQueryHookResult = ReturnType<typeof useInvoicingDetailsLazyQuery>;
export type InvoicingDetailsSuspenseQueryHookResult = ReturnType<typeof useInvoicingDetailsSuspenseQuery>;
export type InvoicingDetailsQueryResult = Apollo.QueryResult<InvoicingDetailsQuery, InvoicingDetailsQueryVariables>;
export const UpgradeSubscriptionDataDocument = gql`
    query upgradeSubscriptionData {
  customer {
    id
    planType
    planInfo {
      ... on SubscriptionPlanType {
        price
        occupiedOpeningSlots
        openingSlots
        slotPrice
        currency {
          id
          symbol
        }
        cycle
        nextPaymentDate
        trialEndsAt
      }
    }
  }
  subscriptionPlans {
    planType
    name
    variants {
      cycle
      price
      freeMonths
      savings
      freeMonths
      currency
      openingActivationPrice
    }
    isAvailable
  }
  availableCurrencies {
    id
    code
    symbol
  }
}
    `;

/**
 * __useUpgradeSubscriptionDataQuery__
 *
 * To run a query within a React component, call `useUpgradeSubscriptionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpgradeSubscriptionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpgradeSubscriptionDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpgradeSubscriptionDataQuery(baseOptions?: Apollo.QueryHookOptions<UpgradeSubscriptionDataQuery, UpgradeSubscriptionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpgradeSubscriptionDataQuery, UpgradeSubscriptionDataQueryVariables>(UpgradeSubscriptionDataDocument, options);
      }
export function useUpgradeSubscriptionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpgradeSubscriptionDataQuery, UpgradeSubscriptionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpgradeSubscriptionDataQuery, UpgradeSubscriptionDataQueryVariables>(UpgradeSubscriptionDataDocument, options);
        }
export function useUpgradeSubscriptionDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpgradeSubscriptionDataQuery, UpgradeSubscriptionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpgradeSubscriptionDataQuery, UpgradeSubscriptionDataQueryVariables>(UpgradeSubscriptionDataDocument, options);
        }
export type UpgradeSubscriptionDataQueryHookResult = ReturnType<typeof useUpgradeSubscriptionDataQuery>;
export type UpgradeSubscriptionDataLazyQueryHookResult = ReturnType<typeof useUpgradeSubscriptionDataLazyQuery>;
export type UpgradeSubscriptionDataSuspenseQueryHookResult = ReturnType<typeof useUpgradeSubscriptionDataSuspenseQuery>;
export type UpgradeSubscriptionDataQueryResult = Apollo.QueryResult<UpgradeSubscriptionDataQuery, UpgradeSubscriptionDataQueryVariables>;
export const BillingPricingAndNextPaymentDocument = gql`
    query billingPricingAndNextPayment {
  customer {
    id
    planType
    planInfo {
      ... on SubscriptionPlanType {
        cycle
        nextPaymentDate
      }
    }
  }
  subscriptionPlans {
    planType
    variants {
      cycle
      price
      currency
      savings
    }
  }
  availableCurrencies {
    id
    code
    symbol
  }
}
    `;

/**
 * __useBillingPricingAndNextPaymentQuery__
 *
 * To run a query within a React component, call `useBillingPricingAndNextPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPricingAndNextPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPricingAndNextPaymentQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingPricingAndNextPaymentQuery(baseOptions?: Apollo.QueryHookOptions<BillingPricingAndNextPaymentQuery, BillingPricingAndNextPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingPricingAndNextPaymentQuery, BillingPricingAndNextPaymentQueryVariables>(BillingPricingAndNextPaymentDocument, options);
      }
export function useBillingPricingAndNextPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingPricingAndNextPaymentQuery, BillingPricingAndNextPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingPricingAndNextPaymentQuery, BillingPricingAndNextPaymentQueryVariables>(BillingPricingAndNextPaymentDocument, options);
        }
export function useBillingPricingAndNextPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingPricingAndNextPaymentQuery, BillingPricingAndNextPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingPricingAndNextPaymentQuery, BillingPricingAndNextPaymentQueryVariables>(BillingPricingAndNextPaymentDocument, options);
        }
export type BillingPricingAndNextPaymentQueryHookResult = ReturnType<typeof useBillingPricingAndNextPaymentQuery>;
export type BillingPricingAndNextPaymentLazyQueryHookResult = ReturnType<typeof useBillingPricingAndNextPaymentLazyQuery>;
export type BillingPricingAndNextPaymentSuspenseQueryHookResult = ReturnType<typeof useBillingPricingAndNextPaymentSuspenseQuery>;
export type BillingPricingAndNextPaymentQueryResult = Apollo.QueryResult<BillingPricingAndNextPaymentQuery, BillingPricingAndNextPaymentQueryVariables>;
export const BillingSettingsSubscriptionPlansDocument = gql`
    query billingSettingsSubscriptionPlans {
  customer {
    id
    planType
    planInfo {
      price
      currency {
        id
        symbol
      }
      ... on SubscriptionPlanType {
        slotPrice
        openingSlots
        trialEndsAt
        state
        cycle
        occupiedOpeningSlots
        openingActivationPrice
        nextPaymentDate
      }
    }
  }
  subscriptionPlans {
    name
    planType
    openingSlots
    isAvailable
    variants {
      cycle
      price
      currency
      freeMonths
    }
  }
  availableCurrencies {
    id
    code
    symbol
  }
}
    `;

/**
 * __useBillingSettingsSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useBillingSettingsSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingSettingsSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingSettingsSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingSettingsSubscriptionPlansQuery(baseOptions?: Apollo.QueryHookOptions<BillingSettingsSubscriptionPlansQuery, BillingSettingsSubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingSettingsSubscriptionPlansQuery, BillingSettingsSubscriptionPlansQueryVariables>(BillingSettingsSubscriptionPlansDocument, options);
      }
export function useBillingSettingsSubscriptionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingSettingsSubscriptionPlansQuery, BillingSettingsSubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingSettingsSubscriptionPlansQuery, BillingSettingsSubscriptionPlansQueryVariables>(BillingSettingsSubscriptionPlansDocument, options);
        }
export function useBillingSettingsSubscriptionPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingSettingsSubscriptionPlansQuery, BillingSettingsSubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingSettingsSubscriptionPlansQuery, BillingSettingsSubscriptionPlansQueryVariables>(BillingSettingsSubscriptionPlansDocument, options);
        }
export type BillingSettingsSubscriptionPlansQueryHookResult = ReturnType<typeof useBillingSettingsSubscriptionPlansQuery>;
export type BillingSettingsSubscriptionPlansLazyQueryHookResult = ReturnType<typeof useBillingSettingsSubscriptionPlansLazyQuery>;
export type BillingSettingsSubscriptionPlansSuspenseQueryHookResult = ReturnType<typeof useBillingSettingsSubscriptionPlansSuspenseQuery>;
export type BillingSettingsSubscriptionPlansQueryResult = Apollo.QueryResult<BillingSettingsSubscriptionPlansQuery, BillingSettingsSubscriptionPlansQueryVariables>;
export const CancelTeamInviteDocument = gql`
    mutation cancelTeamInvite($teamInviteId: ID!) {
  cancelTeamInvite(teamInviteId: $teamInviteId)
}
    `;
export type CancelTeamInviteMutationFn = Apollo.MutationFunction<CancelTeamInviteMutation, CancelTeamInviteMutationVariables>;

/**
 * __useCancelTeamInviteMutation__
 *
 * To run a mutation, you first call `useCancelTeamInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTeamInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTeamInviteMutation, { data, loading, error }] = useCancelTeamInviteMutation({
 *   variables: {
 *      teamInviteId: // value for 'teamInviteId'
 *   },
 * });
 */
export function useCancelTeamInviteMutation(baseOptions?: Apollo.MutationHookOptions<CancelTeamInviteMutation, CancelTeamInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTeamInviteMutation, CancelTeamInviteMutationVariables>(CancelTeamInviteDocument, options);
      }
export type CancelTeamInviteMutationHookResult = ReturnType<typeof useCancelTeamInviteMutation>;
export type CancelTeamInviteMutationResult = Apollo.MutationResult<CancelTeamInviteMutation>;
export type CancelTeamInviteMutationOptions = Apollo.BaseMutationOptions<CancelTeamInviteMutation, CancelTeamInviteMutationVariables>;
export const GetSearchVerifiedUsersDocument = gql`
    query getSearchVerifiedUsers($searchParams: UserSearchEntitySearchParamsInput, $paginationOptions: PaginationOptionsInput, $sortedPaginationOptions: SearchVerifiedUsersPaginationOptionsInput, $recruiterCurrencyCode: String!) {
  searchVerifiedUsers(
    searchParams: $searchParams
    paginationOptions: $paginationOptions
    sortedPaginationOptions: $sortedPaginationOptions
  ) {
    pagination {
      hasMoreResults
      minCursor
      maxCursor
      limit
      totalCount
    }
    result {
      ...verifiedUserFeed
    }
  }
}
    ${VerifiedUserFeedFragmentDoc}`;

/**
 * __useGetSearchVerifiedUsersQuery__
 *
 * To run a query within a React component, call `useGetSearchVerifiedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchVerifiedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchVerifiedUsersQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      paginationOptions: // value for 'paginationOptions'
 *      sortedPaginationOptions: // value for 'sortedPaginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetSearchVerifiedUsersQuery(baseOptions: Apollo.QueryHookOptions<GetSearchVerifiedUsersQuery, GetSearchVerifiedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchVerifiedUsersQuery, GetSearchVerifiedUsersQueryVariables>(GetSearchVerifiedUsersDocument, options);
      }
export function useGetSearchVerifiedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchVerifiedUsersQuery, GetSearchVerifiedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchVerifiedUsersQuery, GetSearchVerifiedUsersQueryVariables>(GetSearchVerifiedUsersDocument, options);
        }
export function useGetSearchVerifiedUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchVerifiedUsersQuery, GetSearchVerifiedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchVerifiedUsersQuery, GetSearchVerifiedUsersQueryVariables>(GetSearchVerifiedUsersDocument, options);
        }
export type GetSearchVerifiedUsersQueryHookResult = ReturnType<typeof useGetSearchVerifiedUsersQuery>;
export type GetSearchVerifiedUsersLazyQueryHookResult = ReturnType<typeof useGetSearchVerifiedUsersLazyQuery>;
export type GetSearchVerifiedUsersSuspenseQueryHookResult = ReturnType<typeof useGetSearchVerifiedUsersSuspenseQuery>;
export type GetSearchVerifiedUsersQueryResult = Apollo.QueryResult<GetSearchVerifiedUsersQuery, GetSearchVerifiedUsersQueryVariables>;
export const GetVerifiedUserDocument = gql`
    query getVerifiedUser($userId: ID!, $recruiterCurrencyCode: String!) {
  verifiedUser(userId: $userId) {
    ...verifiedUserCarouselCard
  }
}
    ${VerifiedUserCarouselCardFragmentDoc}`;

/**
 * __useGetVerifiedUserQuery__
 *
 * To run a query within a React component, call `useGetVerifiedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifiedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifiedUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetVerifiedUserQuery(baseOptions: Apollo.QueryHookOptions<GetVerifiedUserQuery, GetVerifiedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVerifiedUserQuery, GetVerifiedUserQueryVariables>(GetVerifiedUserDocument, options);
      }
export function useGetVerifiedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVerifiedUserQuery, GetVerifiedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVerifiedUserQuery, GetVerifiedUserQueryVariables>(GetVerifiedUserDocument, options);
        }
export function useGetVerifiedUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVerifiedUserQuery, GetVerifiedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVerifiedUserQuery, GetVerifiedUserQueryVariables>(GetVerifiedUserDocument, options);
        }
export type GetVerifiedUserQueryHookResult = ReturnType<typeof useGetVerifiedUserQuery>;
export type GetVerifiedUserLazyQueryHookResult = ReturnType<typeof useGetVerifiedUserLazyQuery>;
export type GetVerifiedUserSuspenseQueryHookResult = ReturnType<typeof useGetVerifiedUserSuspenseQuery>;
export type GetVerifiedUserQueryResult = Apollo.QueryResult<GetVerifiedUserQuery, GetVerifiedUserQueryVariables>;
export const GetVerifiedUserAvailableOpeningsForApplicationDocument = gql`
    query getVerifiedUserAvailableOpeningsForApplication($userId: ID!, $openingSearchParams: OpeningSearchEntitySearchParamsInput, $openingPaginationOptions: PaginationOptionsInput) {
  verifiedUser(userId: $userId) {
    user {
      id
    }
    availableOpeningsForApplication(
      searchParams: $openingSearchParams
      paginationOptions: $openingPaginationOptions
    ) {
      pagination {
        hasMoreResults
        minCursor
        maxCursor
        limit
        totalCount
      }
      result {
        id
        title
        publishedAt
        pitch
        company {
          id
          profile {
            id
            name
            logo {
              id
              fullUrl(width: 400, height: 400)
            }
          }
        }
        positionLocations {
          id
          shortName
          country {
            id
            shortName
          }
        }
        salaryRange {
          period
          currency {
            id
            symbol
          }
          offerSalary
          from
          to
        }
      }
    }
  }
}
    `;

/**
 * __useGetVerifiedUserAvailableOpeningsForApplicationQuery__
 *
 * To run a query within a React component, call `useGetVerifiedUserAvailableOpeningsForApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifiedUserAvailableOpeningsForApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifiedUserAvailableOpeningsForApplicationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      openingSearchParams: // value for 'openingSearchParams'
 *      openingPaginationOptions: // value for 'openingPaginationOptions'
 *   },
 * });
 */
export function useGetVerifiedUserAvailableOpeningsForApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetVerifiedUserAvailableOpeningsForApplicationQuery, GetVerifiedUserAvailableOpeningsForApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVerifiedUserAvailableOpeningsForApplicationQuery, GetVerifiedUserAvailableOpeningsForApplicationQueryVariables>(GetVerifiedUserAvailableOpeningsForApplicationDocument, options);
      }
export function useGetVerifiedUserAvailableOpeningsForApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVerifiedUserAvailableOpeningsForApplicationQuery, GetVerifiedUserAvailableOpeningsForApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVerifiedUserAvailableOpeningsForApplicationQuery, GetVerifiedUserAvailableOpeningsForApplicationQueryVariables>(GetVerifiedUserAvailableOpeningsForApplicationDocument, options);
        }
export function useGetVerifiedUserAvailableOpeningsForApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVerifiedUserAvailableOpeningsForApplicationQuery, GetVerifiedUserAvailableOpeningsForApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVerifiedUserAvailableOpeningsForApplicationQuery, GetVerifiedUserAvailableOpeningsForApplicationQueryVariables>(GetVerifiedUserAvailableOpeningsForApplicationDocument, options);
        }
export type GetVerifiedUserAvailableOpeningsForApplicationQueryHookResult = ReturnType<typeof useGetVerifiedUserAvailableOpeningsForApplicationQuery>;
export type GetVerifiedUserAvailableOpeningsForApplicationLazyQueryHookResult = ReturnType<typeof useGetVerifiedUserAvailableOpeningsForApplicationLazyQuery>;
export type GetVerifiedUserAvailableOpeningsForApplicationSuspenseQueryHookResult = ReturnType<typeof useGetVerifiedUserAvailableOpeningsForApplicationSuspenseQuery>;
export type GetVerifiedUserAvailableOpeningsForApplicationQueryResult = Apollo.QueryResult<GetVerifiedUserAvailableOpeningsForApplicationQuery, GetVerifiedUserAvailableOpeningsForApplicationQueryVariables>;
export const GetSearchVerifiedUsersForSourceDocument = gql`
    query getSearchVerifiedUsersForSource($searchParams: UserSearchEntitySearchParamsInput, $paginationOptions: PaginationOptionsInput, $sortedPaginationOptions: SearchVerifiedUsersPaginationOptionsInput, $excludedUserIds: [ID!], $recruiterCurrencyCode: String!) {
  searchVerifiedUsers(
    searchParams: $searchParams
    paginationOptions: $paginationOptions
    sortedPaginationOptions: $sortedPaginationOptions
    excludedUserIds: $excludedUserIds
  ) {
    pagination {
      hasMoreResults
      minCursor
      maxCursor
      limit
      totalCount
    }
    result {
      ...groupedTalent
    }
  }
}
    ${GroupedTalentFragmentDoc}`;

/**
 * __useGetSearchVerifiedUsersForSourceQuery__
 *
 * To run a query within a React component, call `useGetSearchVerifiedUsersForSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchVerifiedUsersForSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchVerifiedUsersForSourceQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      paginationOptions: // value for 'paginationOptions'
 *      sortedPaginationOptions: // value for 'sortedPaginationOptions'
 *      excludedUserIds: // value for 'excludedUserIds'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetSearchVerifiedUsersForSourceQuery(baseOptions: Apollo.QueryHookOptions<GetSearchVerifiedUsersForSourceQuery, GetSearchVerifiedUsersForSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchVerifiedUsersForSourceQuery, GetSearchVerifiedUsersForSourceQueryVariables>(GetSearchVerifiedUsersForSourceDocument, options);
      }
export function useGetSearchVerifiedUsersForSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchVerifiedUsersForSourceQuery, GetSearchVerifiedUsersForSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchVerifiedUsersForSourceQuery, GetSearchVerifiedUsersForSourceQueryVariables>(GetSearchVerifiedUsersForSourceDocument, options);
        }
export function useGetSearchVerifiedUsersForSourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchVerifiedUsersForSourceQuery, GetSearchVerifiedUsersForSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchVerifiedUsersForSourceQuery, GetSearchVerifiedUsersForSourceQueryVariables>(GetSearchVerifiedUsersForSourceDocument, options);
        }
export type GetSearchVerifiedUsersForSourceQueryHookResult = ReturnType<typeof useGetSearchVerifiedUsersForSourceQuery>;
export type GetSearchVerifiedUsersForSourceLazyQueryHookResult = ReturnType<typeof useGetSearchVerifiedUsersForSourceLazyQuery>;
export type GetSearchVerifiedUsersForSourceSuspenseQueryHookResult = ReturnType<typeof useGetSearchVerifiedUsersForSourceSuspenseQuery>;
export type GetSearchVerifiedUsersForSourceQueryResult = Apollo.QueryResult<GetSearchVerifiedUsersForSourceQuery, GetSearchVerifiedUsersForSourceQueryVariables>;
export const GetBookmarkedVerifiedUsersDocument = gql`
    query getBookmarkedVerifiedUsers($paginationOptions: PaginationOptionsInput, $recruiterCurrencyCode: String!) {
  bookmarkedVerifiedUsers(paginationOptions: $paginationOptions) {
    pagination {
      hasMoreResults
      minCursor
      maxCursor
      limit
      totalCount
    }
    result {
      ...groupedTalent
    }
  }
}
    ${GroupedTalentFragmentDoc}`;

/**
 * __useGetBookmarkedVerifiedUsersQuery__
 *
 * To run a query within a React component, call `useGetBookmarkedVerifiedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarkedVerifiedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarkedVerifiedUsersQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetBookmarkedVerifiedUsersQuery(baseOptions: Apollo.QueryHookOptions<GetBookmarkedVerifiedUsersQuery, GetBookmarkedVerifiedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookmarkedVerifiedUsersQuery, GetBookmarkedVerifiedUsersQueryVariables>(GetBookmarkedVerifiedUsersDocument, options);
      }
export function useGetBookmarkedVerifiedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookmarkedVerifiedUsersQuery, GetBookmarkedVerifiedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookmarkedVerifiedUsersQuery, GetBookmarkedVerifiedUsersQueryVariables>(GetBookmarkedVerifiedUsersDocument, options);
        }
export function useGetBookmarkedVerifiedUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookmarkedVerifiedUsersQuery, GetBookmarkedVerifiedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookmarkedVerifiedUsersQuery, GetBookmarkedVerifiedUsersQueryVariables>(GetBookmarkedVerifiedUsersDocument, options);
        }
export type GetBookmarkedVerifiedUsersQueryHookResult = ReturnType<typeof useGetBookmarkedVerifiedUsersQuery>;
export type GetBookmarkedVerifiedUsersLazyQueryHookResult = ReturnType<typeof useGetBookmarkedVerifiedUsersLazyQuery>;
export type GetBookmarkedVerifiedUsersSuspenseQueryHookResult = ReturnType<typeof useGetBookmarkedVerifiedUsersSuspenseQuery>;
export type GetBookmarkedVerifiedUsersQueryResult = Apollo.QueryResult<GetBookmarkedVerifiedUsersQuery, GetBookmarkedVerifiedUsersQueryVariables>;
export const GetRejectedSearchVerifiedUsersForSourceDocument = gql`
    query getRejectedSearchVerifiedUsersForSource($openingId: ID, $dateRangeInput: DateRangeInput, $paginationOptions: PaginationOptionsInput, $recruiterCurrencyCode: String!) {
  rejectedVerifiedUsers(
    openingId: $openingId
    dateRangeInput: $dateRangeInput
    paginationOptions: $paginationOptions
  ) {
    pagination {
      hasMoreResults
      minCursor
      maxCursor
      limit
      totalCount
    }
    result {
      ...groupedTalent
    }
  }
}
    ${GroupedTalentFragmentDoc}`;

/**
 * __useGetRejectedSearchVerifiedUsersForSourceQuery__
 *
 * To run a query within a React component, call `useGetRejectedSearchVerifiedUsersForSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRejectedSearchVerifiedUsersForSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRejectedSearchVerifiedUsersForSourceQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      dateRangeInput: // value for 'dateRangeInput'
 *      paginationOptions: // value for 'paginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetRejectedSearchVerifiedUsersForSourceQuery(baseOptions: Apollo.QueryHookOptions<GetRejectedSearchVerifiedUsersForSourceQuery, GetRejectedSearchVerifiedUsersForSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRejectedSearchVerifiedUsersForSourceQuery, GetRejectedSearchVerifiedUsersForSourceQueryVariables>(GetRejectedSearchVerifiedUsersForSourceDocument, options);
      }
export function useGetRejectedSearchVerifiedUsersForSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRejectedSearchVerifiedUsersForSourceQuery, GetRejectedSearchVerifiedUsersForSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRejectedSearchVerifiedUsersForSourceQuery, GetRejectedSearchVerifiedUsersForSourceQueryVariables>(GetRejectedSearchVerifiedUsersForSourceDocument, options);
        }
export function useGetRejectedSearchVerifiedUsersForSourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRejectedSearchVerifiedUsersForSourceQuery, GetRejectedSearchVerifiedUsersForSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRejectedSearchVerifiedUsersForSourceQuery, GetRejectedSearchVerifiedUsersForSourceQueryVariables>(GetRejectedSearchVerifiedUsersForSourceDocument, options);
        }
export type GetRejectedSearchVerifiedUsersForSourceQueryHookResult = ReturnType<typeof useGetRejectedSearchVerifiedUsersForSourceQuery>;
export type GetRejectedSearchVerifiedUsersForSourceLazyQueryHookResult = ReturnType<typeof useGetRejectedSearchVerifiedUsersForSourceLazyQuery>;
export type GetRejectedSearchVerifiedUsersForSourceSuspenseQueryHookResult = ReturnType<typeof useGetRejectedSearchVerifiedUsersForSourceSuspenseQuery>;
export type GetRejectedSearchVerifiedUsersForSourceQueryResult = Apollo.QueryResult<GetRejectedSearchVerifiedUsersForSourceQuery, GetRejectedSearchVerifiedUsersForSourceQueryVariables>;
export const GetVerifiedUserForSourceDocument = gql`
    query getVerifiedUserForSource($userId: ID!, $recruiterCurrencyCode: String!) {
  verifiedUser(userId: $userId) {
    ...verifiedUserCarouselCard
  }
}
    ${VerifiedUserCarouselCardFragmentDoc}`;

/**
 * __useGetVerifiedUserForSourceQuery__
 *
 * To run a query within a React component, call `useGetVerifiedUserForSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifiedUserForSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifiedUserForSourceQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetVerifiedUserForSourceQuery(baseOptions: Apollo.QueryHookOptions<GetVerifiedUserForSourceQuery, GetVerifiedUserForSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVerifiedUserForSourceQuery, GetVerifiedUserForSourceQueryVariables>(GetVerifiedUserForSourceDocument, options);
      }
export function useGetVerifiedUserForSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVerifiedUserForSourceQuery, GetVerifiedUserForSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVerifiedUserForSourceQuery, GetVerifiedUserForSourceQueryVariables>(GetVerifiedUserForSourceDocument, options);
        }
export function useGetVerifiedUserForSourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVerifiedUserForSourceQuery, GetVerifiedUserForSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVerifiedUserForSourceQuery, GetVerifiedUserForSourceQueryVariables>(GetVerifiedUserForSourceDocument, options);
        }
export type GetVerifiedUserForSourceQueryHookResult = ReturnType<typeof useGetVerifiedUserForSourceQuery>;
export type GetVerifiedUserForSourceLazyQueryHookResult = ReturnType<typeof useGetVerifiedUserForSourceLazyQuery>;
export type GetVerifiedUserForSourceSuspenseQueryHookResult = ReturnType<typeof useGetVerifiedUserForSourceSuspenseQuery>;
export type GetVerifiedUserForSourceQueryResult = Apollo.QueryResult<GetVerifiedUserForSourceQuery, GetVerifiedUserForSourceQueryVariables>;
export const GetVerifiedUserForChatPageDocument = gql`
    query getVerifiedUserForChatPage($userId: ID!, $recruiterCurrencyCode: String!) {
  verifiedUser(userId: $userId) {
    ...verifiedUserCarouselCard
  }
}
    ${VerifiedUserCarouselCardFragmentDoc}`;

/**
 * __useGetVerifiedUserForChatPageQuery__
 *
 * To run a query within a React component, call `useGetVerifiedUserForChatPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifiedUserForChatPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifiedUserForChatPageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetVerifiedUserForChatPageQuery(baseOptions: Apollo.QueryHookOptions<GetVerifiedUserForChatPageQuery, GetVerifiedUserForChatPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVerifiedUserForChatPageQuery, GetVerifiedUserForChatPageQueryVariables>(GetVerifiedUserForChatPageDocument, options);
      }
export function useGetVerifiedUserForChatPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVerifiedUserForChatPageQuery, GetVerifiedUserForChatPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVerifiedUserForChatPageQuery, GetVerifiedUserForChatPageQueryVariables>(GetVerifiedUserForChatPageDocument, options);
        }
export function useGetVerifiedUserForChatPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVerifiedUserForChatPageQuery, GetVerifiedUserForChatPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVerifiedUserForChatPageQuery, GetVerifiedUserForChatPageQueryVariables>(GetVerifiedUserForChatPageDocument, options);
        }
export type GetVerifiedUserForChatPageQueryHookResult = ReturnType<typeof useGetVerifiedUserForChatPageQuery>;
export type GetVerifiedUserForChatPageLazyQueryHookResult = ReturnType<typeof useGetVerifiedUserForChatPageLazyQuery>;
export type GetVerifiedUserForChatPageSuspenseQueryHookResult = ReturnType<typeof useGetVerifiedUserForChatPageSuspenseQuery>;
export type GetVerifiedUserForChatPageQueryResult = Apollo.QueryResult<GetVerifiedUserForChatPageQuery, GetVerifiedUserForChatPageQueryVariables>;
export const GetRecentGroupedTalentsDocument = gql`
    query getRecentGroupedTalents($searchParams: UserSearchEntitySearchParamsInput, $paginationOptions: PaginationOptionsInput, $sortedPaginationOptions: SearchVerifiedUsersPaginationOptionsInput, $excludedUserIds: [ID!], $recruiterCurrencyCode: String!) {
  searchVerifiedUsers(
    searchParams: $searchParams
    paginationOptions: $paginationOptions
    sortedPaginationOptions: $sortedPaginationOptions
    excludedUserIds: $excludedUserIds
  ) {
    pagination {
      hasMoreResults
      minCursor
      maxCursor
      limit
      totalCount
    }
    result {
      ...groupedTalent
    }
  }
}
    ${GroupedTalentFragmentDoc}`;

/**
 * __useGetRecentGroupedTalentsQuery__
 *
 * To run a query within a React component, call `useGetRecentGroupedTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentGroupedTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentGroupedTalentsQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      paginationOptions: // value for 'paginationOptions'
 *      sortedPaginationOptions: // value for 'sortedPaginationOptions'
 *      excludedUserIds: // value for 'excludedUserIds'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetRecentGroupedTalentsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentGroupedTalentsQuery, GetRecentGroupedTalentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentGroupedTalentsQuery, GetRecentGroupedTalentsQueryVariables>(GetRecentGroupedTalentsDocument, options);
      }
export function useGetRecentGroupedTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentGroupedTalentsQuery, GetRecentGroupedTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentGroupedTalentsQuery, GetRecentGroupedTalentsQueryVariables>(GetRecentGroupedTalentsDocument, options);
        }
export function useGetRecentGroupedTalentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentGroupedTalentsQuery, GetRecentGroupedTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentGroupedTalentsQuery, GetRecentGroupedTalentsQueryVariables>(GetRecentGroupedTalentsDocument, options);
        }
export type GetRecentGroupedTalentsQueryHookResult = ReturnType<typeof useGetRecentGroupedTalentsQuery>;
export type GetRecentGroupedTalentsLazyQueryHookResult = ReturnType<typeof useGetRecentGroupedTalentsLazyQuery>;
export type GetRecentGroupedTalentsSuspenseQueryHookResult = ReturnType<typeof useGetRecentGroupedTalentsSuspenseQuery>;
export type GetRecentGroupedTalentsQueryResult = Apollo.QueryResult<GetRecentGroupedTalentsQuery, GetRecentGroupedTalentsQueryVariables>;
export const GetRejectedGroupedTalentsDocument = gql`
    query getRejectedGroupedTalents($openingId: ID, $dateRangeInput: DateRangeInput, $paginationOptions: PaginationOptionsInput, $recruiterCurrencyCode: String!) {
  rejectedVerifiedUsers(
    openingId: $openingId
    dateRangeInput: $dateRangeInput
    paginationOptions: $paginationOptions
  ) {
    pagination {
      hasMoreResults
      minCursor
      maxCursor
      limit
      totalCount
    }
    result {
      ...groupedTalent
    }
  }
}
    ${GroupedTalentFragmentDoc}`;

/**
 * __useGetRejectedGroupedTalentsQuery__
 *
 * To run a query within a React component, call `useGetRejectedGroupedTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRejectedGroupedTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRejectedGroupedTalentsQuery({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      dateRangeInput: // value for 'dateRangeInput'
 *      paginationOptions: // value for 'paginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetRejectedGroupedTalentsQuery(baseOptions: Apollo.QueryHookOptions<GetRejectedGroupedTalentsQuery, GetRejectedGroupedTalentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRejectedGroupedTalentsQuery, GetRejectedGroupedTalentsQueryVariables>(GetRejectedGroupedTalentsDocument, options);
      }
export function useGetRejectedGroupedTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRejectedGroupedTalentsQuery, GetRejectedGroupedTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRejectedGroupedTalentsQuery, GetRejectedGroupedTalentsQueryVariables>(GetRejectedGroupedTalentsDocument, options);
        }
export function useGetRejectedGroupedTalentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRejectedGroupedTalentsQuery, GetRejectedGroupedTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRejectedGroupedTalentsQuery, GetRejectedGroupedTalentsQueryVariables>(GetRejectedGroupedTalentsDocument, options);
        }
export type GetRejectedGroupedTalentsQueryHookResult = ReturnType<typeof useGetRejectedGroupedTalentsQuery>;
export type GetRejectedGroupedTalentsLazyQueryHookResult = ReturnType<typeof useGetRejectedGroupedTalentsLazyQuery>;
export type GetRejectedGroupedTalentsSuspenseQueryHookResult = ReturnType<typeof useGetRejectedGroupedTalentsSuspenseQuery>;
export type GetRejectedGroupedTalentsQueryResult = Apollo.QueryResult<GetRejectedGroupedTalentsQuery, GetRejectedGroupedTalentsQueryVariables>;
export const GetSearchVerifiedUsersForFeaturedTalentsFeedDocument = gql`
    query getSearchVerifiedUsersForFeaturedTalentsFeed($searchParams: UserSearchEntitySearchParamsInput, $paginationOptions: PaginationOptionsInput, $sortedPaginationOptions: SearchVerifiedUsersPaginationOptionsInput, $recruiterCurrencyCode: String!) {
  searchVerifiedUsers(
    searchParams: $searchParams
    paginationOptions: $paginationOptions
    sortedPaginationOptions: $sortedPaginationOptions
  ) {
    pagination {
      hasMoreResults
      minCursor
      maxCursor
      limit
      totalCount
    }
    result {
      ...featuredTalentCard
    }
  }
}
    ${FeaturedTalentCardFragmentDoc}`;

/**
 * __useGetSearchVerifiedUsersForFeaturedTalentsFeedQuery__
 *
 * To run a query within a React component, call `useGetSearchVerifiedUsersForFeaturedTalentsFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchVerifiedUsersForFeaturedTalentsFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchVerifiedUsersForFeaturedTalentsFeedQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      paginationOptions: // value for 'paginationOptions'
 *      sortedPaginationOptions: // value for 'sortedPaginationOptions'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetSearchVerifiedUsersForFeaturedTalentsFeedQuery(baseOptions: Apollo.QueryHookOptions<GetSearchVerifiedUsersForFeaturedTalentsFeedQuery, GetSearchVerifiedUsersForFeaturedTalentsFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchVerifiedUsersForFeaturedTalentsFeedQuery, GetSearchVerifiedUsersForFeaturedTalentsFeedQueryVariables>(GetSearchVerifiedUsersForFeaturedTalentsFeedDocument, options);
      }
export function useGetSearchVerifiedUsersForFeaturedTalentsFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchVerifiedUsersForFeaturedTalentsFeedQuery, GetSearchVerifiedUsersForFeaturedTalentsFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchVerifiedUsersForFeaturedTalentsFeedQuery, GetSearchVerifiedUsersForFeaturedTalentsFeedQueryVariables>(GetSearchVerifiedUsersForFeaturedTalentsFeedDocument, options);
        }
export function useGetSearchVerifiedUsersForFeaturedTalentsFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchVerifiedUsersForFeaturedTalentsFeedQuery, GetSearchVerifiedUsersForFeaturedTalentsFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchVerifiedUsersForFeaturedTalentsFeedQuery, GetSearchVerifiedUsersForFeaturedTalentsFeedQueryVariables>(GetSearchVerifiedUsersForFeaturedTalentsFeedDocument, options);
        }
export type GetSearchVerifiedUsersForFeaturedTalentsFeedQueryHookResult = ReturnType<typeof useGetSearchVerifiedUsersForFeaturedTalentsFeedQuery>;
export type GetSearchVerifiedUsersForFeaturedTalentsFeedLazyQueryHookResult = ReturnType<typeof useGetSearchVerifiedUsersForFeaturedTalentsFeedLazyQuery>;
export type GetSearchVerifiedUsersForFeaturedTalentsFeedSuspenseQueryHookResult = ReturnType<typeof useGetSearchVerifiedUsersForFeaturedTalentsFeedSuspenseQuery>;
export type GetSearchVerifiedUsersForFeaturedTalentsFeedQueryResult = Apollo.QueryResult<GetSearchVerifiedUsersForFeaturedTalentsFeedQuery, GetSearchVerifiedUsersForFeaturedTalentsFeedQueryVariables>;
export const GetVerifiedUserForFeaturedTalentDocument = gql`
    query getVerifiedUserForFeaturedTalent($userId: ID!, $recruiterCurrencyCode: String!) {
  verifiedUser(userId: $userId) {
    ...featuredTalentCard
  }
}
    ${FeaturedTalentCardFragmentDoc}`;

/**
 * __useGetVerifiedUserForFeaturedTalentQuery__
 *
 * To run a query within a React component, call `useGetVerifiedUserForFeaturedTalentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifiedUserForFeaturedTalentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifiedUserForFeaturedTalentQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      recruiterCurrencyCode: // value for 'recruiterCurrencyCode'
 *   },
 * });
 */
export function useGetVerifiedUserForFeaturedTalentQuery(baseOptions: Apollo.QueryHookOptions<GetVerifiedUserForFeaturedTalentQuery, GetVerifiedUserForFeaturedTalentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVerifiedUserForFeaturedTalentQuery, GetVerifiedUserForFeaturedTalentQueryVariables>(GetVerifiedUserForFeaturedTalentDocument, options);
      }
export function useGetVerifiedUserForFeaturedTalentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVerifiedUserForFeaturedTalentQuery, GetVerifiedUserForFeaturedTalentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVerifiedUserForFeaturedTalentQuery, GetVerifiedUserForFeaturedTalentQueryVariables>(GetVerifiedUserForFeaturedTalentDocument, options);
        }
export function useGetVerifiedUserForFeaturedTalentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVerifiedUserForFeaturedTalentQuery, GetVerifiedUserForFeaturedTalentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVerifiedUserForFeaturedTalentQuery, GetVerifiedUserForFeaturedTalentQueryVariables>(GetVerifiedUserForFeaturedTalentDocument, options);
        }
export type GetVerifiedUserForFeaturedTalentQueryHookResult = ReturnType<typeof useGetVerifiedUserForFeaturedTalentQuery>;
export type GetVerifiedUserForFeaturedTalentLazyQueryHookResult = ReturnType<typeof useGetVerifiedUserForFeaturedTalentLazyQuery>;
export type GetVerifiedUserForFeaturedTalentSuspenseQueryHookResult = ReturnType<typeof useGetVerifiedUserForFeaturedTalentSuspenseQuery>;
export type GetVerifiedUserForFeaturedTalentQueryResult = Apollo.QueryResult<GetVerifiedUserForFeaturedTalentQuery, GetVerifiedUserForFeaturedTalentQueryVariables>;
export const SwitchedWorkspaceDocument = gql`
    subscription switchedWorkspace {
  switchedWorkspace {
    fromCompany {
      id
      profile {
        id
        name
      }
    }
    toCompany {
      id
      profile {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSwitchedWorkspaceSubscription__
 *
 * To run a query within a React component, call `useSwitchedWorkspaceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSwitchedWorkspaceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwitchedWorkspaceSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSwitchedWorkspaceSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SwitchedWorkspaceSubscription, SwitchedWorkspaceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SwitchedWorkspaceSubscription, SwitchedWorkspaceSubscriptionVariables>(SwitchedWorkspaceDocument, options);
      }
export type SwitchedWorkspaceSubscriptionHookResult = ReturnType<typeof useSwitchedWorkspaceSubscription>;
export type SwitchedWorkspaceSubscriptionResult = Apollo.SubscriptionResult<SwitchedWorkspaceSubscription>;
export const OpeningDocument = gql`
    query opening($id: ID!) {
  opening(id: $id) {
    id
    reach {
      local
      global
      remote
    }
  }
}
    `;

/**
 * __useOpeningQuery__
 *
 * To run a query within a React component, call `useOpeningQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpeningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpeningQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpeningQuery(baseOptions: Apollo.QueryHookOptions<OpeningQuery, OpeningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpeningQuery, OpeningQueryVariables>(OpeningDocument, options);
      }
export function useOpeningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpeningQuery, OpeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpeningQuery, OpeningQueryVariables>(OpeningDocument, options);
        }
export function useOpeningSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpeningQuery, OpeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpeningQuery, OpeningQueryVariables>(OpeningDocument, options);
        }
export type OpeningQueryHookResult = ReturnType<typeof useOpeningQuery>;
export type OpeningLazyQueryHookResult = ReturnType<typeof useOpeningLazyQuery>;
export type OpeningSuspenseQueryHookResult = ReturnType<typeof useOpeningSuspenseQuery>;
export type OpeningQueryResult = Apollo.QueryResult<OpeningQuery, OpeningQueryVariables>;
export const UpgradeSubscriptionForPlansDocument = gql`
    mutation upgradeSubscriptionForPlans($planType: CustomerPlanEnum!, $subscriptionCycle: CustomerSubscriptionCycleEnum!) {
  upgradeSubscription(planType: $planType, subscriptionCycle: $subscriptionCycle) {
    id
    planType
    planInfo {
      price
      currency {
        id
        symbol
      }
      ... on SubscriptionPlanType {
        trialEndsAt
        state
        cycle
        hasOpeningsLimitReached
        occupiedOpeningSlots
        nextPaymentDate
      }
    }
  }
}
    `;
export type UpgradeSubscriptionForPlansMutationFn = Apollo.MutationFunction<UpgradeSubscriptionForPlansMutation, UpgradeSubscriptionForPlansMutationVariables>;

/**
 * __useUpgradeSubscriptionForPlansMutation__
 *
 * To run a mutation, you first call `useUpgradeSubscriptionForPlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeSubscriptionForPlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeSubscriptionForPlansMutation, { data, loading, error }] = useUpgradeSubscriptionForPlansMutation({
 *   variables: {
 *      planType: // value for 'planType'
 *      subscriptionCycle: // value for 'subscriptionCycle'
 *   },
 * });
 */
export function useUpgradeSubscriptionForPlansMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeSubscriptionForPlansMutation, UpgradeSubscriptionForPlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeSubscriptionForPlansMutation, UpgradeSubscriptionForPlansMutationVariables>(UpgradeSubscriptionForPlansDocument, options);
      }
export type UpgradeSubscriptionForPlansMutationHookResult = ReturnType<typeof useUpgradeSubscriptionForPlansMutation>;
export type UpgradeSubscriptionForPlansMutationResult = Apollo.MutationResult<UpgradeSubscriptionForPlansMutation>;
export type UpgradeSubscriptionForPlansMutationOptions = Apollo.BaseMutationOptions<UpgradeSubscriptionForPlansMutation, UpgradeSubscriptionForPlansMutationVariables>;